var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res, err) => function __init() {
  if (err) throw err[0];
  try {
    return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
  } catch (e) {
    throw err = [e], e;
  }
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// site/config.js
function ringDimensions(model = "L") {
  if (typeof model !== "string" || !Object.hasOwn(RING_MODELS, model)) throw new Error("Modèle de ring invalide.");
  return RING_MODELS[model];
}
function dimensionsDescription(model) {
  const d = ringDimensions(model), outside = formatMetres(d.outside), inside = formatMetres(d.inside);
  return `Ring ${model} : extérieur ${outside} × ${outside} m ; ${inside} × ${inside} m entre les cordes ; hauteur des totems ${Math.round(d.height * 100)} cm ; section des totems et des boudins ${Math.round(d.baseHeight * 100)} cm.`;
}
function freshConfig() {
  return structuredClone(DEFAULTS);
}
function validatePatch(input) {
  if (!input || typeof input !== "object" || Array.isArray(input)) throw new Error("Configuration invalide.");
  const out = {};
  const color = /^#[\da-f]{6}$/i;
  for (const [key, value] of Object.entries(input)) {
    if (!Object.hasOwn(DEFAULTS, key)) throw new Error("Option inconnue : " + key);
    if (key === "model") {
      ringDimensions(value);
      out[key] = value;
    } else if (key === "markingPositions") {
      if (!value || typeof value !== "object" || Array.isArray(value)) throw new Error("Positions invalides.");
      out[key] = {};
      for (const [surface, elements] of Object.entries(value)) {
        if (!/^(?:(?:side|post)-[0-3]|floor-0)$/.test(surface) || !elements || typeof elements !== "object" || Array.isArray(elements)) throw new Error("Surface de marquage invalide.");
        out[key][surface] = {};
        for (const [element, position] of Object.entries(elements)) {
          if (!["logo", "text"].includes(element) || !position || typeof position !== "object" || Array.isArray(position) || Object.keys(position).length !== 2 || !["x", "y"].every((axis) => Number.isFinite(position[axis]) && position[axis] >= 0 && position[axis] <= 1)) throw new Error("Position de marquage invalide.");
          out[key][surface][element] = { x: position.x, y: position.y };
        }
      }
    } else if (key === "cornerColors" || key === "ropeColors") {
      const count = key === "cornerColors" ? 4 : 3;
      if (!Array.isArray(value) || value.length !== count || !value.every((v) => typeof v === "string" && color.test(v))) throw new Error(key === "cornerColors" ? "Quatre couleurs de poteaux sont nécessaires." : "Trois couleurs de cordes sont nécessaires.");
      out[key] = [...value];
    } else if (key.endsWith("Color")) {
      if (typeof value !== "string" || !color.test(value)) throw new Error("Couleur invalide.");
      out[key] = value;
    } else if (typeof DEFAULTS[key] === "boolean") {
      if (typeof value !== "boolean") throw new Error("Choix invalide.");
      out[key] = value;
    } else if (key === "font") {
      if (!["sport", "classic", "condensed"].includes(value)) throw new Error("Style invalide.");
      out[key] = value;
    } else if (key === "text" || key === "subtext") {
      if (typeof value !== "string" || value.length > (key === "text" ? 40 : 60)) throw new Error("Le texte est trop long.");
      out[key] = value;
    } else {
      if (!Number.isFinite(value) || value < 40 || value > 140) throw new Error("Taille invalide.");
      out[key] = value;
    }
  }
  return out;
}
var RING_MODELS, DIMENSIONS, formatMetres, CORNERS, STANDARD_COLORS, DEFAULTS;
var init_config = __esm({
  "site/config.js"() {
    RING_MODELS = Object.freeze({
      Enfant: Object.freeze({ outside: 4.32, inside: 3, height: 1.7, baseHeight: 0.5, postDiameter: 0.5 }),
      L: Object.freeze({ outside: 5.75, inside: 4, height: 1.7, baseHeight: 0.65, postDiameter: 0.65 }),
      XL: Object.freeze({ outside: 6.25, inside: 4, height: 1.7, baseHeight: 0.9, postDiameter: 0.9 })
    });
    DIMENSIONS = RING_MODELS.L;
    formatMetres = (value) => value.toLocaleString("fr-FR", { maximumFractionDigits: 3 });
    CORNERS = [
      { label: "Avant gauche", x: -1, z: 1 },
      { label: "Arrière gauche", x: -1, z: -1 },
      { label: "Arrière droit", x: 1, z: -1 },
      { label: "Avant droit", x: 1, z: 1 }
    ];
    STANDARD_COLORS = Object.freeze([
      { name: "Blanc", value: "#ebecec" },
      { name: "Gris", value: "#626973" },
      { name: "Noir", value: "#111419" },
      { name: "Bleu", value: "#102b78" },
      { name: "Rouge", value: "#b51f2e" },
      { name: "Orange", value: "#d86812" },
      { name: "Jaune", value: "#dab819" },
      { name: "Vert", value: "#17693e" },
      { name: "Rose", value: "#bc376e" },
      { name: "Violet", value: "#552984" }
    ]);
    DEFAULTS = Object.freeze({
      model: "L",
      baseColor: "#111419",
      floorColor: "#e9e9e5",
      floorVisible: false,
      cornerColors: ["#ebecec", "#b51f2e", "#ebecec", "#102b78"],
      totemStripes: false,
      ropeColors: ["#111419", "#111419", "#111419"],
      spacerColor: "#111419",
      text: "VOTRE TEXTE",
      subtext: "",
      textColor: "#ffffff",
      font: "sport",
      textSize: 100,
      textSides: true,
      textFloor: false,
      textPosts: false,
      logoSize: 100,
      logoSides: true,
      logoFloor: false,
      logoPosts: false,
      markingPositions: {},
      dimensionsVisible: false
    });
  }
});

// site/post-finish.js
function hasPostStripes(config2, index) {
  return config2.totemStripes && ![STRIPE_WHITE, "#ffffff"].includes(config2.cornerColors[index].toLowerCase());
}
function postStripeBands(dimensions = DIMENSIONS) {
  const step = (dimensions.height - dimensions.baseHeight) / 4;
  return [0, 2].map((index) => ({ bottom: dimensions.baseHeight + index * step, top: dimensions.baseHeight + (index + 1) * step }));
}
function paintPost(canvas2, config2, index, dimensions = DIMENSIONS) {
  const ctx = canvas2.getContext("2d"), color = config2.cornerColors[index];
  ctx.fillStyle = config2.totemStripes ? STRIPE_WHITE : color;
  ctx.fillRect(0, 0, canvas2.width, canvas2.height);
  if (!config2.totemStripes) return;
  const fillHeight = (bottom, top, color2) => {
    ctx.fillStyle = color2;
    const start = Math.round((1 - top / dimensions.height) * canvas2.height);
    const end = Math.round((1 - bottom / dimensions.height) * canvas2.height);
    ctx.fillRect(0, start, canvas2.width, end - start);
  };
  fillHeight(0, dimensions.baseHeight, config2.baseColor);
  if (hasPostStripes(config2, index)) for (const band of postStripeBands(dimensions)) fillHeight(band.bottom, band.top, color);
}
var STRIPE_WHITE;
var init_post_finish = __esm({
  "site/post-finish.js"() {
    init_config();
    STRIPE_WHITE = "#ebecec";
  }
});

// site/vendor/three.core.js
function generateUUID() {
  const d0 = Math.random() * 4294967295 | 0;
  const d1 = Math.random() * 4294967295 | 0;
  const d2 = Math.random() * 4294967295 | 0;
  const d3 = Math.random() * 4294967295 | 0;
  const uuid = _lut[d0 & 255] + _lut[d0 >> 8 & 255] + _lut[d0 >> 16 & 255] + _lut[d0 >> 24 & 255] + "-" + _lut[d1 & 255] + _lut[d1 >> 8 & 255] + "-" + _lut[d1 >> 16 & 15 | 64] + _lut[d1 >> 24 & 255] + "-" + _lut[d2 & 63 | 128] + _lut[d2 >> 8 & 255] + "-" + _lut[d2 >> 16 & 255] + _lut[d2 >> 24 & 255] + _lut[d3 & 255] + _lut[d3 >> 8 & 255] + _lut[d3 >> 16 & 255] + _lut[d3 >> 24 & 255];
  return uuid.toLowerCase();
}
function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
function euclideanModulo(n, m) {
  return (n % m + m) % m;
}
function mapLinear(x, a1, a2, b1, b2) {
  return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
function inverseLerp(x, y, value) {
  if (x !== y) {
    return (value - x) / (y - x);
  } else {
    return 0;
  }
}
function lerp(x, y, t) {
  return (1 - t) * x + t * y;
}
function damp(x, y, lambda, dt) {
  return lerp(x, y, 1 - Math.exp(-lambda * dt));
}
function pingpong(x, length = 1) {
  return length - Math.abs(euclideanModulo(x, length * 2) - length);
}
function smoothstep(x, min, max) {
  if (x <= min) return 0;
  if (x >= max) return 1;
  x = (x - min) / (max - min);
  return x * x * (3 - 2 * x);
}
function smootherstep(x, min, max) {
  if (x <= min) return 0;
  if (x >= max) return 1;
  x = (x - min) / (max - min);
  return x * x * x * (x * (x * 6 - 15) + 10);
}
function randInt(low, high) {
  return low + Math.floor(Math.random() * (high - low + 1));
}
function randFloat(low, high) {
  return low + Math.random() * (high - low);
}
function randFloatSpread(range) {
  return range * (0.5 - Math.random());
}
function seededRandom(s) {
  if (s !== void 0) _seed = s;
  let t = _seed += 1831565813;
  t = Math.imul(t ^ t >>> 15, t | 1);
  t ^= t + Math.imul(t ^ t >>> 7, t | 61);
  return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function degToRad(degrees) {
  return degrees * DEG2RAD;
}
function radToDeg(radians) {
  return radians * RAD2DEG;
}
function isPowerOfTwo(value) {
  return (value & value - 1) === 0 && value !== 0;
}
function ceilPowerOfTwo(value) {
  return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function floorPowerOfTwo(value) {
  return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function setQuaternionFromProperEuler(q, a, b, c, order) {
  const cos = Math.cos;
  const sin = Math.sin;
  const c2 = cos(b / 2);
  const s2 = sin(b / 2);
  const c13 = cos((a + c) / 2);
  const s13 = sin((a + c) / 2);
  const c1_3 = cos((a - c) / 2);
  const s1_3 = sin((a - c) / 2);
  const c3_1 = cos((c - a) / 2);
  const s3_1 = sin((c - a) / 2);
  switch (order) {
    case "XYX":
      q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
      break;
    case "YZY":
      q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
      break;
    case "ZXZ":
      q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
      break;
    case "XZX":
      q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
      break;
    case "YXY":
      q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
      break;
    case "ZYZ":
      q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
  }
}
function denormalize(value, array) {
  switch (array.constructor) {
    case Float32Array:
      return value;
    case Uint32Array:
      return value / 4294967295;
    case Uint16Array:
      return value / 65535;
    case Uint8Array:
      return value / 255;
    case Int32Array:
      return Math.max(value / 2147483647, -1);
    case Int16Array:
      return Math.max(value / 32767, -1);
    case Int8Array:
      return Math.max(value / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function normalize(value, array) {
  switch (array.constructor) {
    case Float32Array:
      return value;
    case Uint32Array:
      return Math.round(value * 4294967295);
    case Uint16Array:
      return Math.round(value * 65535);
    case Uint8Array:
      return Math.round(value * 255);
    case Int32Array:
      return Math.round(value * 2147483647);
    case Int16Array:
      return Math.round(value * 32767);
    case Int8Array:
      return Math.round(value * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
function arrayNeedsUint32(array) {
  for (let i = array.length - 1; i >= 0; --i) {
    if (array[i] >= 65535) return true;
  }
  return false;
}
function createElementNS(name) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
function createCanvasElement() {
  const canvas2 = createElementNS("canvas");
  canvas2.style.display = "block";
  return canvas2;
}
function warnOnce(message) {
  if (message in _cache) return;
  _cache[message] = true;
  console.warn(message);
}
function probeAsync(gl, sync, interval) {
  return new Promise(function(resolve, reject) {
    function probe() {
      switch (gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case gl.WAIT_FAILED:
          reject();
          break;
        case gl.TIMEOUT_EXPIRED:
          setTimeout(probe, interval);
          break;
        default:
          resolve();
      }
    }
    setTimeout(probe, interval);
  });
}
function createColorManagement() {
  const ColorManagement2 = {
    enabled: true,
    workingColorSpace: LinearSRGBColorSpace,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace, toneMappingMode: 'extended' | 'standard' }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(color, sourceColorSpace, targetColorSpace) {
      if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) {
        return color;
      }
      if (this.spaces[sourceColorSpace].transfer === SRGBTransfer) {
        color.r = SRGBToLinear(color.r);
        color.g = SRGBToLinear(color.g);
        color.b = SRGBToLinear(color.b);
      }
      if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
        color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
        color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
      }
      if (this.spaces[targetColorSpace].transfer === SRGBTransfer) {
        color.r = LinearToSRGB(color.r);
        color.g = LinearToSRGB(color.g);
        color.b = LinearToSRGB(color.b);
      }
      return color;
    },
    workingToColorSpace: function(color, targetColorSpace) {
      return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    colorSpaceToWorking: function(color, sourceColorSpace) {
      return this.convert(color, sourceColorSpace, this.workingColorSpace);
    },
    getPrimaries: function(colorSpace) {
      return this.spaces[colorSpace].primaries;
    },
    getTransfer: function(colorSpace) {
      if (colorSpace === NoColorSpace) return LinearTransfer;
      return this.spaces[colorSpace].transfer;
    },
    getToneMappingMode: function(colorSpace) {
      return this.spaces[colorSpace].outputColorSpaceConfig.toneMappingMode || "standard";
    },
    getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
      return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
    },
    define: function(colorSpaces) {
      Object.assign(this.spaces, colorSpaces);
    },
    // Internal APIs
    _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
      return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(colorSpace) {
      return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
      return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
    },
    // Deprecated
    fromWorkingColorSpace: function(color, targetColorSpace) {
      warnOnce("THREE.ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().");
      return ColorManagement2.workingToColorSpace(color, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
      warnOnce("THREE.ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().");
      return ColorManagement2.colorSpaceToWorking(color, sourceColorSpace);
    }
  };
  const REC709_PRIMARIES = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06];
  const REC709_LUMINANCE_COEFFICIENTS = [0.2126, 0.7152, 0.0722];
  const D65 = [0.3127, 0.329];
  ColorManagement2.define({
    [LinearSRGBColorSpace]: {
      primaries: REC709_PRIMARIES,
      whitePoint: D65,
      transfer: LinearTransfer,
      toXYZ: LINEAR_REC709_TO_XYZ,
      fromXYZ: XYZ_TO_LINEAR_REC709,
      luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
      workingColorSpaceConfig: { unpackColorSpace: SRGBColorSpace },
      outputColorSpaceConfig: { drawingBufferColorSpace: SRGBColorSpace }
    },
    [SRGBColorSpace]: {
      primaries: REC709_PRIMARIES,
      whitePoint: D65,
      transfer: SRGBTransfer,
      toXYZ: LINEAR_REC709_TO_XYZ,
      fromXYZ: XYZ_TO_LINEAR_REC709,
      luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
      outputColorSpaceConfig: { drawingBufferColorSpace: SRGBColorSpace }
    }
  });
  return ColorManagement2;
}
function SRGBToLinear(c) {
  return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB(c) {
  return c < 31308e-7 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
function serializeImage(image) {
  if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
    return ImageUtils.getDataURL(image);
  } else {
    if (image.data) {
      return {
        data: Array.from(image.data),
        width: image.width,
        height: image.height,
        type: image.data.constructor.name
      };
    } else {
      console.warn("THREE.Texture: Unable to serialize Texture.");
      return {};
    }
  }
}
function satForAxes(axes, v0, v1, v2, extents) {
  for (let i = 0, j = axes.length - 3; i <= j; i += 3) {
    _testAxis.fromArray(axes, i);
    const r = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z);
    const p0 = v0.dot(_testAxis);
    const p1 = v1.dot(_testAxis);
    const p2 = v2.dot(_testAxis);
    if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) {
      return false;
    }
  }
  return true;
}
function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
  return p;
}
function checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
  let intersect2;
  if (material.side === BackSide) {
    intersect2 = ray.intersectTriangle(pC, pB, pA, true, point);
  } else {
    intersect2 = ray.intersectTriangle(pA, pB, pC, material.side === FrontSide, point);
  }
  if (intersect2 === null) return null;
  _intersectionPointWorld.copy(point);
  _intersectionPointWorld.applyMatrix4(object.matrixWorld);
  const distance = raycaster.ray.origin.distanceTo(_intersectionPointWorld);
  if (distance < raycaster.near || distance > raycaster.far) return null;
  return {
    distance,
    point: _intersectionPointWorld.clone(),
    object
  };
}
function checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
  object.getVertexPosition(a, _vA$1);
  object.getVertexPosition(b, _vB$1);
  object.getVertexPosition(c, _vC$1);
  const intersection = checkIntersection$1(object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint);
  if (intersection) {
    const barycoord = new Vector3();
    Triangle.getBarycoord(_intersectionPoint, _vA$1, _vB$1, _vC$1, barycoord);
    if (uv) {
      intersection.uv = Triangle.getInterpolatedAttribute(uv, a, b, c, barycoord, new Vector2());
    }
    if (uv1) {
      intersection.uv1 = Triangle.getInterpolatedAttribute(uv1, a, b, c, barycoord, new Vector2());
    }
    if (normal) {
      intersection.normal = Triangle.getInterpolatedAttribute(normal, a, b, c, barycoord, new Vector3());
      if (intersection.normal.dot(ray.direction) > 0) {
        intersection.normal.multiplyScalar(-1);
      }
    }
    const face = {
      a,
      b,
      c,
      normal: new Vector3(),
      materialIndex: 0
    };
    Triangle.getNormal(_vA$1, _vB$1, _vC$1, face.normal);
    intersection.face = face;
    intersection.barycoord = barycoord;
  }
  return intersection;
}
function cloneUniforms(src) {
  const dst = {};
  for (const u in src) {
    dst[u] = {};
    for (const p in src[u]) {
      const property = src[u][p];
      if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
        if (property.isRenderTargetTexture) {
          console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
          dst[u][p] = null;
        } else {
          dst[u][p] = property.clone();
        }
      } else if (Array.isArray(property)) {
        dst[u][p] = property.slice();
      } else {
        dst[u][p] = property;
      }
    }
  }
  return dst;
}
function mergeUniforms(uniforms) {
  const merged = {};
  for (let u = 0; u < uniforms.length; u++) {
    const tmp2 = cloneUniforms(uniforms[u]);
    for (const p in tmp2) {
      merged[p] = tmp2[p];
    }
  }
  return merged;
}
function cloneUniformsGroups(src) {
  const dst = [];
  for (let u = 0; u < src.length; u++) {
    dst.push(src[u].clone());
  }
  return dst;
}
function getUnlitUniformColorSpace(renderer) {
  const currentRenderTarget = renderer.getRenderTarget();
  if (currentRenderTarget === null) {
    return renderer.outputColorSpace;
  }
  if (currentRenderTarget.isXRRenderTarget === true) {
    return currentRenderTarget.texture.colorSpace;
  }
  return ColorManagement.workingColorSpace;
}
function transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
  _alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
  if (sin !== void 0) {
    _rotatedPosition.x = cos * _alignedPosition.x - sin * _alignedPosition.y;
    _rotatedPosition.y = sin * _alignedPosition.x + cos * _alignedPosition.y;
  } else {
    _rotatedPosition.copy(_alignedPosition);
  }
  vertexPosition.copy(mvPosition);
  vertexPosition.x += _rotatedPosition.x;
  vertexPosition.y += _rotatedPosition.y;
  vertexPosition.applyMatrix4(_viewWorldMatrix);
}
function checkIntersection(object, raycaster, ray, thresholdSq, a, b, i) {
  const positionAttribute = object.geometry.attributes.position;
  _vStart.fromBufferAttribute(positionAttribute, a);
  _vEnd.fromBufferAttribute(positionAttribute, b);
  const distSq = ray.distanceSqToSegment(_vStart, _vEnd, _intersectPointOnRay, _intersectPointOnSegment);
  if (distSq > thresholdSq) return;
  _intersectPointOnRay.applyMatrix4(object.matrixWorld);
  const distance = raycaster.ray.origin.distanceTo(_intersectPointOnRay);
  if (distance < raycaster.near || distance > raycaster.far) return;
  return {
    distance,
    // What do we want? intersection point on the ray or on the segment??
    // point: raycaster.ray.at( distance ),
    point: _intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
    index: i,
    face: null,
    faceIndex: null,
    barycoord: null,
    object
  };
}
function CubicPoly() {
  let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
  function init(x0, x1, t0, t1) {
    c0 = x0;
    c1 = t0;
    c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
    c3 = 2 * x0 - 2 * x1 + t0 + t1;
  }
  return {
    initCatmullRom: function(x0, x1, x2, x3, tension) {
      init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
    },
    initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
      let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
      let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
      t1 *= dt1;
      t2 *= dt1;
      init(x1, x2, t1, t2);
    },
    calc: function(t) {
      const t2 = t * t;
      const t3 = t2 * t;
      return c0 + c1 * t + c2 * t2 + c3 * t3;
    }
  };
}
function convertArray(array, type) {
  if (!array || array.constructor === type) return array;
  if (typeof type.BYTES_PER_ELEMENT === "number") {
    return new type(array);
  }
  return Array.prototype.slice.call(array);
}
function isTypedArray(object) {
  return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
function ascSort(a, b) {
  return a.distance - b.distance;
}
function intersect(object, raycaster, intersects, recursive) {
  let propagate = true;
  if (object.layers.test(raycaster.layers)) {
    const result = object.raycast(raycaster, intersects);
    if (result === false) propagate = false;
  }
  if (propagate === true && recursive === true) {
    const children = object.children;
    for (let i = 0, l = children.length; i < l; i++) {
      intersect(children[i], raycaster, intersects, true);
    }
  }
}
function getByteLength(width, height, format, type) {
  const typeByteLength = getTextureTypeByteLength(type);
  switch (format) {
    // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
    case AlphaFormat:
      return width * height;
    case RedFormat:
      return width * height / typeByteLength.components * typeByteLength.byteLength;
    case RedIntegerFormat:
      return width * height / typeByteLength.components * typeByteLength.byteLength;
    case RGFormat:
      return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
    case RGIntegerFormat:
      return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
    case RGBFormat:
      return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
    case RGBAFormat:
      return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
    case RGBAIntegerFormat:
      return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
    case RGB_S3TC_DXT1_Format:
    case RGBA_S3TC_DXT1_Format:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
    case RGBA_S3TC_DXT3_Format:
    case RGBA_S3TC_DXT5_Format:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
    case RGB_PVRTC_2BPPV1_Format:
    case RGBA_PVRTC_2BPPV1_Format:
      return Math.max(width, 16) * Math.max(height, 8) / 4;
    case RGB_PVRTC_4BPPV1_Format:
    case RGBA_PVRTC_4BPPV1_Format:
      return Math.max(width, 8) * Math.max(height, 8) / 2;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
    case RGB_ETC1_Format:
    case RGB_ETC2_Format:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
    case RGBA_ETC2_EAC_Format:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
    case RGBA_ASTC_4x4_Format:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
    case RGBA_ASTC_5x4_Format:
      return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
    case RGBA_ASTC_5x5_Format:
      return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_6x5_Format:
      return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_6x6_Format:
      return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
    case RGBA_ASTC_8x5_Format:
      return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_8x6_Format:
      return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
    case RGBA_ASTC_8x8_Format:
      return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
    case RGBA_ASTC_10x5_Format:
      return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_10x6_Format:
      return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
    case RGBA_ASTC_10x8_Format:
      return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
    case RGBA_ASTC_10x10_Format:
      return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
    case RGBA_ASTC_12x10_Format:
      return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
    case RGBA_ASTC_12x12_Format:
      return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
    case RGBA_BPTC_Format:
    case RGB_BPTC_SIGNED_Format:
    case RGB_BPTC_UNSIGNED_Format:
      return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
    case RED_RGTC1_Format:
    case SIGNED_RED_RGTC1_Format:
      return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
    case RED_GREEN_RGTC2_Format:
    case SIGNED_RED_GREEN_RGTC2_Format:
      return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
  }
  throw new Error(
    `Unable to determine texture byte length for ${format} format.`
  );
}
function getTextureTypeByteLength(type) {
  switch (type) {
    case UnsignedByteType:
    case ByteType:
      return { byteLength: 1, components: 1 };
    case UnsignedShortType:
    case ShortType:
    case HalfFloatType:
      return { byteLength: 2, components: 1 };
    case UnsignedShort4444Type:
    case UnsignedShort5551Type:
      return { byteLength: 2, components: 4 };
    case UnsignedIntType:
    case IntType:
    case FloatType:
      return { byteLength: 4, components: 1 };
    case UnsignedInt5999Type:
    case UnsignedInt101111Type:
      return { byteLength: 4, components: 3 };
  }
  throw new Error(`Unknown texture type ${type}.`);
}
var REVISION, MOUSE, TOUCH, CullFaceNone, CullFaceBack, CullFaceFront, PCFShadowMap, PCFSoftShadowMap, VSMShadowMap, FrontSide, BackSide, DoubleSide, NoBlending, NormalBlending, AdditiveBlending, SubtractiveBlending, MultiplyBlending, CustomBlending, AddEquation, SubtractEquation, ReverseSubtractEquation, MinEquation, MaxEquation, ZeroFactor, OneFactor, SrcColorFactor, OneMinusSrcColorFactor, SrcAlphaFactor, OneMinusSrcAlphaFactor, DstAlphaFactor, OneMinusDstAlphaFactor, DstColorFactor, OneMinusDstColorFactor, SrcAlphaSaturateFactor, ConstantColorFactor, OneMinusConstantColorFactor, ConstantAlphaFactor, OneMinusConstantAlphaFactor, NeverDepth, AlwaysDepth, LessDepth, LessEqualDepth, EqualDepth, GreaterEqualDepth, GreaterDepth, NotEqualDepth, MultiplyOperation, MixOperation, AddOperation, NoToneMapping, LinearToneMapping, ReinhardToneMapping, CineonToneMapping, ACESFilmicToneMapping, CustomToneMapping, AgXToneMapping, NeutralToneMapping, UVMapping, CubeReflectionMapping, CubeRefractionMapping, EquirectangularReflectionMapping, EquirectangularRefractionMapping, CubeUVReflectionMapping, RepeatWrapping, ClampToEdgeWrapping, MirroredRepeatWrapping, NearestFilter, NearestMipmapNearestFilter, NearestMipmapLinearFilter, LinearFilter, LinearMipmapNearestFilter, LinearMipmapLinearFilter, UnsignedByteType, ByteType, ShortType, UnsignedShortType, IntType, UnsignedIntType, FloatType, HalfFloatType, UnsignedShort4444Type, UnsignedShort5551Type, UnsignedInt248Type, UnsignedInt5999Type, UnsignedInt101111Type, AlphaFormat, RGBFormat, RGBAFormat, DepthFormat, DepthStencilFormat, RedFormat, RedIntegerFormat, RGFormat, RGIntegerFormat, RGBAIntegerFormat, RGB_S3TC_DXT1_Format, RGBA_S3TC_DXT1_Format, RGBA_S3TC_DXT3_Format, RGBA_S3TC_DXT5_Format, RGB_PVRTC_4BPPV1_Format, RGB_PVRTC_2BPPV1_Format, RGBA_PVRTC_4BPPV1_Format, RGBA_PVRTC_2BPPV1_Format, RGB_ETC1_Format, RGB_ETC2_Format, RGBA_ETC2_EAC_Format, RGBA_ASTC_4x4_Format, RGBA_ASTC_5x4_Format, RGBA_ASTC_5x5_Format, RGBA_ASTC_6x5_Format, RGBA_ASTC_6x6_Format, RGBA_ASTC_8x5_Format, RGBA_ASTC_8x6_Format, RGBA_ASTC_8x8_Format, RGBA_ASTC_10x5_Format, RGBA_ASTC_10x6_Format, RGBA_ASTC_10x8_Format, RGBA_ASTC_10x10_Format, RGBA_ASTC_12x10_Format, RGBA_ASTC_12x12_Format, RGBA_BPTC_Format, RGB_BPTC_SIGNED_Format, RGB_BPTC_UNSIGNED_Format, RED_RGTC1_Format, SIGNED_RED_RGTC1_Format, RED_GREEN_RGTC2_Format, SIGNED_RED_GREEN_RGTC2_Format, InterpolateDiscrete, InterpolateLinear, InterpolateSmooth, ZeroCurvatureEnding, ZeroSlopeEnding, WrapAroundEnding, BasicDepthPacking, RGBADepthPacking, TangentSpaceNormalMap, ObjectSpaceNormalMap, NoColorSpace, SRGBColorSpace, LinearSRGBColorSpace, LinearTransfer, SRGBTransfer, KeepStencilOp, AlwaysStencilFunc, NeverCompare, LessCompare, EqualCompare, LessEqualCompare, GreaterCompare, NotEqualCompare, GreaterEqualCompare, AlwaysCompare, StaticDrawUsage, GLSL3, WebGLCoordinateSystem, WebGPUCoordinateSystem, EventDispatcher, _lut, _seed, DEG2RAD, RAD2DEG, MathUtils, Vector2, Quaternion, Vector3, _vector$c, _quaternion$4, Matrix3, _m3, _cache, LINEAR_REC709_TO_XYZ, XYZ_TO_LINEAR_REC709, ColorManagement, _canvas, ImageUtils, _sourceId, Source, _textureId, _tempVec3, Texture, Vector4, RenderTarget, WebGLRenderTarget, DataArrayTexture, Data3DTexture, Box3, _points, _vector$b, _box$4, _v0$2, _v1$7, _v2$4, _f0, _f1, _f2, _center, _extents, _triangleNormal, _testAxis, _box$3, _v1$6, _v2$3, Sphere, _vector$a, _segCenter, _segDir, _diff, _edge1, _edge2, _normal$1, Ray, Matrix4, _v1$5, _m1$2, _zero, _one, _x, _y, _z, _matrix$2, _quaternion$3, Euler, Layers, _object3DId, _v1$4, _q1, _m1$1, _target, _position$3, _scale$2, _quaternion$2, _xAxis, _yAxis, _zAxis, _addedEvent, _removedEvent, _childaddedEvent, _childremovedEvent, Object3D, _v0$1, _v1$3, _v2$2, _v3$2, _vab, _vac, _vbc, _vap, _vbp, _vcp, _v40, _v41, _v42, Triangle, _colorKeywords, _hslA, _hslB, Color, _color, _materialId, Material, MeshBasicMaterial, _vector$9, _vector2$1, _id$2, BufferAttribute, Uint16BufferAttribute, Uint32BufferAttribute, Float32BufferAttribute, _id$1, _m1, _obj, _offset, _box$2, _boxMorphTargets, _vector$8, BufferGeometry, _inverseMatrix$3, _ray$3, _sphere$6, _sphereHitAt, _vA$1, _vB$1, _vC$1, _tempA, _morphA, _intersectionPoint, _intersectionPointWorld, Mesh, BoxGeometry, UniformsUtils, default_vertex, default_fragment, ShaderMaterial, Camera, _v3$1, _minTarget, _maxTarget, PerspectiveCamera, fov, aspect, CubeCamera, CubeTexture, WebGLCubeRenderTarget, Group, _moveEvent, WebXRController, Scene, InterleavedBuffer, _vector$7, InterleavedBufferAttribute, SpriteMaterial, _geometry, _intersectPoint, _worldScale, _mvPosition, _alignedPosition, _rotatedPosition, _viewWorldMatrix, _vA, _vB, _vC, _uvA, _uvB, _uvC, Sprite, DataTexture, InstancedBufferAttribute, _instanceLocalMatrix, _instanceWorldMatrix, _instanceIntersects, _box3, _identity, _mesh$1, _sphere$4, InstancedMesh, _vector1, _vector2, _normalMatrix, Plane, _sphere$3, _defaultSpriteCenter, _vector$6, Frustum, LineBasicMaterial, _vStart, _vEnd, _inverseMatrix$1, _ray$1, _sphere$1, _intersectPointOnRay, _intersectPointOnSegment, Line, _start, _end, LineSegments, CanvasTexture, DepthTexture, ExternalTexture, CylinderGeometry, Curve, tmp, px, py, pz, CatmullRomCurve3, PlaneGeometry, MeshStandardMaterial, MeshPhysicalMaterial, MeshLambertMaterial, MeshDepthMaterial, MeshDistanceMaterial, Interpolant, CubicInterpolant, LinearInterpolant, DiscreteInterpolant, KeyframeTrack, BooleanKeyframeTrack, ColorKeyframeTrack, NumberKeyframeTrack, QuaternionLinearInterpolant, QuaternionKeyframeTrack, StringKeyframeTrack, VectorKeyframeTrack, LoadingManager, DefaultLoadingManager, Loader, Light, HemisphereLight, _projScreenMatrix$1, _lightPositionWorld$1, _lookTarget$1, LightShadow, _projScreenMatrix, _lightPositionWorld, _lookTarget, PointLightShadow, PointLight, OrthographicCamera, DirectionalLightShadow, DirectionalLight, ArrayCamera, Clock, _RESERVED_CHARS_RE, _reservedRe, _wordChar, _wordCharOrDot, _directoryRe, _nodeRe, _objectRe, _propertyRe, _trackRe, _supportedObjectNames, Composite, PropertyBinding, _controlInterpolantsResultBuffer, _matrix, Raycaster, Spherical, Controls;
var init_three_core = __esm({
  "site/vendor/three.core.js"() {
    REVISION = "180";
    MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 };
    TOUCH = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 };
    CullFaceNone = 0;
    CullFaceBack = 1;
    CullFaceFront = 2;
    PCFShadowMap = 1;
    PCFSoftShadowMap = 2;
    VSMShadowMap = 3;
    FrontSide = 0;
    BackSide = 1;
    DoubleSide = 2;
    NoBlending = 0;
    NormalBlending = 1;
    AdditiveBlending = 2;
    SubtractiveBlending = 3;
    MultiplyBlending = 4;
    CustomBlending = 5;
    AddEquation = 100;
    SubtractEquation = 101;
    ReverseSubtractEquation = 102;
    MinEquation = 103;
    MaxEquation = 104;
    ZeroFactor = 200;
    OneFactor = 201;
    SrcColorFactor = 202;
    OneMinusSrcColorFactor = 203;
    SrcAlphaFactor = 204;
    OneMinusSrcAlphaFactor = 205;
    DstAlphaFactor = 206;
    OneMinusDstAlphaFactor = 207;
    DstColorFactor = 208;
    OneMinusDstColorFactor = 209;
    SrcAlphaSaturateFactor = 210;
    ConstantColorFactor = 211;
    OneMinusConstantColorFactor = 212;
    ConstantAlphaFactor = 213;
    OneMinusConstantAlphaFactor = 214;
    NeverDepth = 0;
    AlwaysDepth = 1;
    LessDepth = 2;
    LessEqualDepth = 3;
    EqualDepth = 4;
    GreaterEqualDepth = 5;
    GreaterDepth = 6;
    NotEqualDepth = 7;
    MultiplyOperation = 0;
    MixOperation = 1;
    AddOperation = 2;
    NoToneMapping = 0;
    LinearToneMapping = 1;
    ReinhardToneMapping = 2;
    CineonToneMapping = 3;
    ACESFilmicToneMapping = 4;
    CustomToneMapping = 5;
    AgXToneMapping = 6;
    NeutralToneMapping = 7;
    UVMapping = 300;
    CubeReflectionMapping = 301;
    CubeRefractionMapping = 302;
    EquirectangularReflectionMapping = 303;
    EquirectangularRefractionMapping = 304;
    CubeUVReflectionMapping = 306;
    RepeatWrapping = 1e3;
    ClampToEdgeWrapping = 1001;
    MirroredRepeatWrapping = 1002;
    NearestFilter = 1003;
    NearestMipmapNearestFilter = 1004;
    NearestMipmapLinearFilter = 1005;
    LinearFilter = 1006;
    LinearMipmapNearestFilter = 1007;
    LinearMipmapLinearFilter = 1008;
    UnsignedByteType = 1009;
    ByteType = 1010;
    ShortType = 1011;
    UnsignedShortType = 1012;
    IntType = 1013;
    UnsignedIntType = 1014;
    FloatType = 1015;
    HalfFloatType = 1016;
    UnsignedShort4444Type = 1017;
    UnsignedShort5551Type = 1018;
    UnsignedInt248Type = 1020;
    UnsignedInt5999Type = 35902;
    UnsignedInt101111Type = 35899;
    AlphaFormat = 1021;
    RGBFormat = 1022;
    RGBAFormat = 1023;
    DepthFormat = 1026;
    DepthStencilFormat = 1027;
    RedFormat = 1028;
    RedIntegerFormat = 1029;
    RGFormat = 1030;
    RGIntegerFormat = 1031;
    RGBAIntegerFormat = 1033;
    RGB_S3TC_DXT1_Format = 33776;
    RGBA_S3TC_DXT1_Format = 33777;
    RGBA_S3TC_DXT3_Format = 33778;
    RGBA_S3TC_DXT5_Format = 33779;
    RGB_PVRTC_4BPPV1_Format = 35840;
    RGB_PVRTC_2BPPV1_Format = 35841;
    RGBA_PVRTC_4BPPV1_Format = 35842;
    RGBA_PVRTC_2BPPV1_Format = 35843;
    RGB_ETC1_Format = 36196;
    RGB_ETC2_Format = 37492;
    RGBA_ETC2_EAC_Format = 37496;
    RGBA_ASTC_4x4_Format = 37808;
    RGBA_ASTC_5x4_Format = 37809;
    RGBA_ASTC_5x5_Format = 37810;
    RGBA_ASTC_6x5_Format = 37811;
    RGBA_ASTC_6x6_Format = 37812;
    RGBA_ASTC_8x5_Format = 37813;
    RGBA_ASTC_8x6_Format = 37814;
    RGBA_ASTC_8x8_Format = 37815;
    RGBA_ASTC_10x5_Format = 37816;
    RGBA_ASTC_10x6_Format = 37817;
    RGBA_ASTC_10x8_Format = 37818;
    RGBA_ASTC_10x10_Format = 37819;
    RGBA_ASTC_12x10_Format = 37820;
    RGBA_ASTC_12x12_Format = 37821;
    RGBA_BPTC_Format = 36492;
    RGB_BPTC_SIGNED_Format = 36494;
    RGB_BPTC_UNSIGNED_Format = 36495;
    RED_RGTC1_Format = 36283;
    SIGNED_RED_RGTC1_Format = 36284;
    RED_GREEN_RGTC2_Format = 36285;
    SIGNED_RED_GREEN_RGTC2_Format = 36286;
    InterpolateDiscrete = 2300;
    InterpolateLinear = 2301;
    InterpolateSmooth = 2302;
    ZeroCurvatureEnding = 2400;
    ZeroSlopeEnding = 2401;
    WrapAroundEnding = 2402;
    BasicDepthPacking = 3200;
    RGBADepthPacking = 3201;
    TangentSpaceNormalMap = 0;
    ObjectSpaceNormalMap = 1;
    NoColorSpace = "";
    SRGBColorSpace = "srgb";
    LinearSRGBColorSpace = "srgb-linear";
    LinearTransfer = "linear";
    SRGBTransfer = "srgb";
    KeepStencilOp = 7680;
    AlwaysStencilFunc = 519;
    NeverCompare = 512;
    LessCompare = 513;
    EqualCompare = 514;
    LessEqualCompare = 515;
    GreaterCompare = 516;
    NotEqualCompare = 517;
    GreaterEqualCompare = 518;
    AlwaysCompare = 519;
    StaticDrawUsage = 35044;
    GLSL3 = "300 es";
    WebGLCoordinateSystem = 2e3;
    WebGPUCoordinateSystem = 2001;
    EventDispatcher = class {
      /**
       * Adds the given event listener to the given event type.
       *
       * @param {string} type - The type of event to listen to.
       * @param {Function} listener - The function that gets called when the event is fired.
       */
      addEventListener(type, listener) {
        if (this._listeners === void 0) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === void 0) {
          listeners[type] = [];
        }
        if (listeners[type].indexOf(listener) === -1) {
          listeners[type].push(listener);
        }
      }
      /**
       * Returns `true` if the given event listener has been added to the given event type.
       *
       * @param {string} type - The type of event.
       * @param {Function} listener - The listener to check.
       * @return {boolean} Whether the given event listener has been added to the given event type.
       */
      hasEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === void 0) return false;
        return listeners[type] !== void 0 && listeners[type].indexOf(listener) !== -1;
      }
      /**
       * Removes the given event listener from the given event type.
       *
       * @param {string} type - The type of event.
       * @param {Function} listener - The listener to remove.
       */
      removeEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === void 0) return;
        const listenerArray = listeners[type];
        if (listenerArray !== void 0) {
          const index = listenerArray.indexOf(listener);
          if (index !== -1) {
            listenerArray.splice(index, 1);
          }
        }
      }
      /**
       * Dispatches an event object.
       *
       * @param {Object} event - The event that gets fired.
       */
      dispatchEvent(event) {
        const listeners = this._listeners;
        if (listeners === void 0) return;
        const listenerArray = listeners[event.type];
        if (listenerArray !== void 0) {
          event.target = this;
          const array = listenerArray.slice(0);
          for (let i = 0, l = array.length; i < l; i++) {
            array[i].call(this, event);
          }
          event.target = null;
        }
      }
    };
    _lut = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
    _seed = 1234567;
    DEG2RAD = Math.PI / 180;
    RAD2DEG = 180 / Math.PI;
    MathUtils = {
      DEG2RAD,
      RAD2DEG,
      /**
       * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
       * (universally unique identifier).
       *
       * @static
       * @method
       * @return {string} The UUID.
       */
      generateUUID,
      /**
       * Clamps the given value between min and max.
       *
       * @static
       * @method
       * @param {number} value - The value to clamp.
       * @param {number} min - The min value.
       * @param {number} max - The max value.
       * @return {number} The clamped value.
       */
      clamp,
      /**
       * Computes the Euclidean modulo of the given parameters that
       * is `( ( n % m ) + m ) % m`.
       *
       * @static
       * @method
       * @param {number} n - The first parameter.
       * @param {number} m - The second parameter.
       * @return {number} The Euclidean modulo.
       */
      euclideanModulo,
      /**
       * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
       * for the given value.
       *
       * @static
       * @method
       * @param {number} x - The value to be mapped.
       * @param {number} a1 - Minimum value for range A.
       * @param {number} a2 - Maximum value for range A.
       * @param {number} b1 - Minimum value for range B.
       * @param {number} b2 - Maximum value for range B.
       * @return {number} The mapped value.
       */
      mapLinear,
      /**
       * Returns the percentage in the closed interval `[0, 1]` of the given value
       * between the start and end point.
       *
       * @static
       * @method
       * @param {number} x - The start point
       * @param {number} y - The end point.
       * @param {number} value - A value between start and end.
       * @return {number} The interpolation factor.
       */
      inverseLerp,
      /**
       * Returns a value linearly interpolated from two known points based on the given interval -
       * `t = 0` will return `x` and `t = 1` will return `y`.
       *
       * @static
       * @method
       * @param {number} x - The start point
       * @param {number} y - The end point.
       * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
       * @return {number} The interpolated value.
       */
      lerp,
      /**
       * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
       * time to maintain frame rate independent movement. For details, see
       * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
       *
       * @static
       * @method
       * @param {number} x - The current point.
       * @param {number} y - The target point.
       * @param {number} lambda - A higher lambda value will make the movement more sudden,
       * and a lower value will make the movement more gradual.
       * @param {number} dt - Delta time in seconds.
       * @return {number} The interpolated value.
       */
      damp,
      /**
       * Returns a value that alternates between `0` and the given `length` parameter.
       *
       * @static
       * @method
       * @param {number} x - The value to pingpong.
       * @param {number} [length=1] - The positive value the function will pingpong to.
       * @return {number} The alternated value.
       */
      pingpong,
      /**
       * Returns a value in the range `[0,1]` that represents the percentage that `x` has
       * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
       * the `min` and `max`.
       *
       * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
       *
       * @static
       * @method
       * @param {number} x - The value to evaluate based on its position between min and max.
       * @param {number} min - The min value. Any x value below min will be `0`.
       * @param {number} max - The max value. Any x value above max will be `1`.
       * @return {number} The alternated value.
       */
      smoothstep,
      /**
       * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
       * that has zero 1st and 2nd order derivatives at x=0 and x=1.
       *
       * @static
       * @method
       * @param {number} x - The value to evaluate based on its position between min and max.
       * @param {number} min - The min value. Any x value below min will be `0`.
       * @param {number} max - The max value. Any x value above max will be `1`.
       * @return {number} The alternated value.
       */
      smootherstep,
      /**
       * Returns a random integer from `<low, high>` interval.
       *
       * @static
       * @method
       * @param {number} low - The lower value boundary.
       * @param {number} high - The upper value boundary
       * @return {number} A random integer.
       */
      randInt,
      /**
       * Returns a random float from `<low, high>` interval.
       *
       * @static
       * @method
       * @param {number} low - The lower value boundary.
       * @param {number} high - The upper value boundary
       * @return {number} A random float.
       */
      randFloat,
      /**
       * Returns a random integer from `<-range/2, range/2>` interval.
       *
       * @static
       * @method
       * @param {number} range - Defines the value range.
       * @return {number} A random float.
       */
      randFloatSpread,
      /**
       * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
       *
       * @static
       * @method
       * @param {number} [s] - The integer seed.
       * @return {number} A random float.
       */
      seededRandom,
      /**
       * Converts degrees to radians.
       *
       * @static
       * @method
       * @param {number} degrees - A value in degrees.
       * @return {number} The converted value in radians.
       */
      degToRad,
      /**
       * Converts radians to degrees.
       *
       * @static
       * @method
       * @param {number} radians - A value in radians.
       * @return {number} The converted value in degrees.
       */
      radToDeg,
      /**
       * Returns `true` if the given number is a power of two.
       *
       * @static
       * @method
       * @param {number} value - The value to check.
       * @return {boolean} Whether the given number is a power of two or not.
       */
      isPowerOfTwo,
      /**
       * Returns the smallest power of two that is greater than or equal to the given number.
       *
       * @static
       * @method
       * @param {number} value - The value to find a POT for.
       * @return {number} The smallest power of two that is greater than or equal to the given number.
       */
      ceilPowerOfTwo,
      /**
       * Returns the largest power of two that is less than or equal to the given number.
       *
       * @static
       * @method
       * @param {number} value - The value to find a POT for.
       * @return {number} The largest power of two that is less than or equal to the given number.
       */
      floorPowerOfTwo,
      /**
       * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
       * defined by the given angles and order.
       *
       * Rotations are applied to the axes in the order specified by order:
       * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
       *
       * @static
       * @method
       * @param {Quaternion} q - The quaternion to set.
       * @param {number} a - The rotation applied to the first axis, in radians.
       * @param {number} b - The rotation applied to the second axis, in radians.
       * @param {number} c - The rotation applied to the third axis, in radians.
       * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
       */
      setQuaternionFromProperEuler,
      /**
       * Normalizes the given value according to the given typed array.
       *
       * @static
       * @method
       * @param {number} value - The float value in the range `[0,1]` to normalize.
       * @param {TypedArray} array - The typed array that defines the data type of the value.
       * @return {number} The normalize value.
       */
      normalize,
      /**
       * Denormalizes the given value according to the given typed array.
       *
       * @static
       * @method
       * @param {number} value - The value to denormalize.
       * @param {TypedArray} array - The typed array that defines the data type of the value.
       * @return {number} The denormalize (float) value in the range `[0,1]`.
       */
      denormalize
    };
    Vector2 = class _Vector2 {
      /**
       * Constructs a new 2D vector.
       *
       * @param {number} [x=0] - The x value of this vector.
       * @param {number} [y=0] - The y value of this vector.
       */
      constructor(x = 0, y = 0) {
        _Vector2.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
      }
      /**
       * Alias for {@link Vector2#x}.
       *
       * @type {number}
       */
      get width() {
        return this.x;
      }
      set width(value) {
        this.x = value;
      }
      /**
       * Alias for {@link Vector2#y}.
       *
       * @type {number}
       */
      get height() {
        return this.y;
      }
      set height(value) {
        this.y = value;
      }
      /**
       * Sets the vector components.
       *
       * @param {number} x - The value of the x component.
       * @param {number} y - The value of the y component.
       * @return {Vector2} A reference to this vector.
       */
      set(x, y) {
        this.x = x;
        this.y = y;
        return this;
      }
      /**
       * Sets the vector components to the same value.
       *
       * @param {number} scalar - The value to set for all vector components.
       * @return {Vector2} A reference to this vector.
       */
      setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
      }
      /**
       * Sets the vector's x component to the given value
       *
       * @param {number} x - The value to set.
       * @return {Vector2} A reference to this vector.
       */
      setX(x) {
        this.x = x;
        return this;
      }
      /**
       * Sets the vector's y component to the given value
       *
       * @param {number} y - The value to set.
       * @return {Vector2} A reference to this vector.
       */
      setY(y) {
        this.y = y;
        return this;
      }
      /**
       * Allows to set a vector component with an index.
       *
       * @param {number} index - The component index. `0` equals to x, `1` equals to y.
       * @param {number} value - The value to set.
       * @return {Vector2} A reference to this vector.
       */
      setComponent(index, value) {
        switch (index) {
          case 0:
            this.x = value;
            break;
          case 1:
            this.y = value;
            break;
          default:
            throw new Error("index is out of range: " + index);
        }
        return this;
      }
      /**
       * Returns the value of the vector component which matches the given index.
       *
       * @param {number} index - The component index. `0` equals to x, `1` equals to y.
       * @return {number} A vector component value.
       */
      getComponent(index) {
        switch (index) {
          case 0:
            return this.x;
          case 1:
            return this.y;
          default:
            throw new Error("index is out of range: " + index);
        }
      }
      /**
       * Returns a new vector with copied values from this instance.
       *
       * @return {Vector2} A clone of this instance.
       */
      clone() {
        return new this.constructor(this.x, this.y);
      }
      /**
       * Copies the values of the given vector to this instance.
       *
       * @param {Vector2} v - The vector to copy.
       * @return {Vector2} A reference to this vector.
       */
      copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
      }
      /**
       * Adds the given vector to this instance.
       *
       * @param {Vector2} v - The vector to add.
       * @return {Vector2} A reference to this vector.
       */
      add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
      }
      /**
       * Adds the given scalar value to all components of this instance.
       *
       * @param {number} s - The scalar to add.
       * @return {Vector2} A reference to this vector.
       */
      addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
      }
      /**
       * Adds the given vectors and stores the result in this instance.
       *
       * @param {Vector2} a - The first vector.
       * @param {Vector2} b - The second vector.
       * @return {Vector2} A reference to this vector.
       */
      addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
      }
      /**
       * Adds the given vector scaled by the given factor to this instance.
       *
       * @param {Vector2} v - The vector.
       * @param {number} s - The factor that scales `v`.
       * @return {Vector2} A reference to this vector.
       */
      addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
      }
      /**
       * Subtracts the given vector from this instance.
       *
       * @param {Vector2} v - The vector to subtract.
       * @return {Vector2} A reference to this vector.
       */
      sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
      }
      /**
       * Subtracts the given scalar value from all components of this instance.
       *
       * @param {number} s - The scalar to subtract.
       * @return {Vector2} A reference to this vector.
       */
      subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
      }
      /**
       * Subtracts the given vectors and stores the result in this instance.
       *
       * @param {Vector2} a - The first vector.
       * @param {Vector2} b - The second vector.
       * @return {Vector2} A reference to this vector.
       */
      subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
      }
      /**
       * Multiplies the given vector with this instance.
       *
       * @param {Vector2} v - The vector to multiply.
       * @return {Vector2} A reference to this vector.
       */
      multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
      }
      /**
       * Multiplies the given scalar value with all components of this instance.
       *
       * @param {number} scalar - The scalar to multiply.
       * @return {Vector2} A reference to this vector.
       */
      multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
      }
      /**
       * Divides this instance by the given vector.
       *
       * @param {Vector2} v - The vector to divide.
       * @return {Vector2} A reference to this vector.
       */
      divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
      }
      /**
       * Divides this vector by the given scalar.
       *
       * @param {number} scalar - The scalar to divide.
       * @return {Vector2} A reference to this vector.
       */
      divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
      }
      /**
       * Multiplies this vector (with an implicit 1 as the 3rd component) by
       * the given 3x3 matrix.
       *
       * @param {Matrix3} m - The matrix to apply.
       * @return {Vector2} A reference to this vector.
       */
      applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
      }
      /**
       * If this vector's x or y value is greater than the given vector's x or y
       * value, replace that value with the corresponding min value.
       *
       * @param {Vector2} v - The vector.
       * @return {Vector2} A reference to this vector.
       */
      min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
      }
      /**
       * If this vector's x or y value is less than the given vector's x or y
       * value, replace that value with the corresponding max value.
       *
       * @param {Vector2} v - The vector.
       * @return {Vector2} A reference to this vector.
       */
      max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
      }
      /**
       * If this vector's x or y value is greater than the max vector's x or y
       * value, it is replaced by the corresponding value.
       * If this vector's x or y value is less than the min vector's x or y value,
       * it is replaced by the corresponding value.
       *
       * @param {Vector2} min - The minimum x and y values.
       * @param {Vector2} max - The maximum x and y values in the desired range.
       * @return {Vector2} A reference to this vector.
       */
      clamp(min, max) {
        this.x = clamp(this.x, min.x, max.x);
        this.y = clamp(this.y, min.y, max.y);
        return this;
      }
      /**
       * If this vector's x or y values are greater than the max value, they are
       * replaced by the max value.
       * If this vector's x or y values are less than the min value, they are
       * replaced by the min value.
       *
       * @param {number} minVal - The minimum value the components will be clamped to.
       * @param {number} maxVal - The maximum value the components will be clamped to.
       * @return {Vector2} A reference to this vector.
       */
      clampScalar(minVal, maxVal) {
        this.x = clamp(this.x, minVal, maxVal);
        this.y = clamp(this.y, minVal, maxVal);
        return this;
      }
      /**
       * If this vector's length is greater than the max value, it is replaced by
       * the max value.
       * If this vector's length is less than the min value, it is replaced by the
       * min value.
       *
       * @param {number} min - The minimum value the vector length will be clamped to.
       * @param {number} max - The maximum value the vector length will be clamped to.
       * @return {Vector2} A reference to this vector.
       */
      clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(clamp(length, min, max));
      }
      /**
       * The components of this vector are rounded down to the nearest integer value.
       *
       * @return {Vector2} A reference to this vector.
       */
      floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
      }
      /**
       * The components of this vector are rounded up to the nearest integer value.
       *
       * @return {Vector2} A reference to this vector.
       */
      ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
      }
      /**
       * The components of this vector are rounded to the nearest integer value
       *
       * @return {Vector2} A reference to this vector.
       */
      round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
      }
      /**
       * The components of this vector are rounded towards zero (up if negative,
       * down if positive) to an integer value.
       *
       * @return {Vector2} A reference to this vector.
       */
      roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
      }
      /**
       * Inverts this vector - i.e. sets x = -x and y = -y.
       *
       * @return {Vector2} A reference to this vector.
       */
      negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
      }
      /**
       * Calculates the dot product of the given vector with this instance.
       *
       * @param {Vector2} v - The vector to compute the dot product with.
       * @return {number} The result of the dot product.
       */
      dot(v) {
        return this.x * v.x + this.y * v.y;
      }
      /**
       * Calculates the cross product of the given vector with this instance.
       *
       * @param {Vector2} v - The vector to compute the cross product with.
       * @return {number} The result of the cross product.
       */
      cross(v) {
        return this.x * v.y - this.y * v.x;
      }
      /**
       * Computes the square of the Euclidean length (straight-line length) from
       * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
       * compare the length squared instead as it is slightly more efficient to calculate.
       *
       * @return {number} The square length of this vector.
       */
      lengthSq() {
        return this.x * this.x + this.y * this.y;
      }
      /**
       * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
       *
       * @return {number} The length of this vector.
       */
      length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      }
      /**
       * Computes the Manhattan length of this vector.
       *
       * @return {number} The length of this vector.
       */
      manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
      }
      /**
       * Converts this vector to a unit vector - that is, sets it equal to a vector
       * with the same direction as this one, but with a vector length of `1`.
       *
       * @return {Vector2} A reference to this vector.
       */
      normalize() {
        return this.divideScalar(this.length() || 1);
      }
      /**
       * Computes the angle in radians of this vector with respect to the positive x-axis.
       *
       * @return {number} The angle in radians.
       */
      angle() {
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
      }
      /**
       * Returns the angle between the given vector and this instance in radians.
       *
       * @param {Vector2} v - The vector to compute the angle with.
       * @return {number} The angle in radians.
       */
      angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        return Math.acos(clamp(theta, -1, 1));
      }
      /**
       * Computes the distance from the given vector to this instance.
       *
       * @param {Vector2} v - The vector to compute the distance to.
       * @return {number} The distance.
       */
      distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
      }
      /**
       * Computes the squared distance from the given vector to this instance.
       * If you are just comparing the distance with another distance, you should compare
       * the distance squared instead as it is slightly more efficient to calculate.
       *
       * @param {Vector2} v - The vector to compute the squared distance to.
       * @return {number} The squared distance.
       */
      distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
      }
      /**
       * Computes the Manhattan distance from the given vector to this instance.
       *
       * @param {Vector2} v - The vector to compute the Manhattan distance to.
       * @return {number} The Manhattan distance.
       */
      manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
      }
      /**
       * Sets this vector to a vector with the same direction as this one, but
       * with the specified length.
       *
       * @param {number} length - The new length of this vector.
       * @return {Vector2} A reference to this vector.
       */
      setLength(length) {
        return this.normalize().multiplyScalar(length);
      }
      /**
       * Linearly interpolates between the given vector and this instance, where
       * alpha is the percent distance along the line - alpha = 0 will be this
       * vector, and alpha = 1 will be the given one.
       *
       * @param {Vector2} v - The vector to interpolate towards.
       * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
       * @return {Vector2} A reference to this vector.
       */
      lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
      }
      /**
       * Linearly interpolates between the given vectors, where alpha is the percent
       * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
       * be the second one. The result is stored in this instance.
       *
       * @param {Vector2} v1 - The first vector.
       * @param {Vector2} v2 - The second vector.
       * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
       * @return {Vector2} A reference to this vector.
       */
      lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
      }
      /**
       * Returns `true` if this vector is equal with the given one.
       *
       * @param {Vector2} v - The vector to test for equality.
       * @return {boolean} Whether this vector is equal with the given one.
       */
      equals(v) {
        return v.x === this.x && v.y === this.y;
      }
      /**
       * Sets this vector's x value to be `array[ offset ]` and y
       * value to be `array[ offset + 1 ]`.
       *
       * @param {Array<number>} array - An array holding the vector component values.
       * @param {number} [offset=0] - The offset into the array.
       * @return {Vector2} A reference to this vector.
       */
      fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
      }
      /**
       * Writes the components of this vector to the given array. If no array is provided,
       * the method returns a new instance.
       *
       * @param {Array<number>} [array=[]] - The target array holding the vector components.
       * @param {number} [offset=0] - Index of the first element in the array.
       * @return {Array<number>} The vector components.
       */
      toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
      }
      /**
       * Sets the components of this vector from the given buffer attribute.
       *
       * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
       * @param {number} index - The index into the attribute.
       * @return {Vector2} A reference to this vector.
       */
      fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
      }
      /**
       * Rotates this vector around the given center by the given angle.
       *
       * @param {Vector2} center - The point around which to rotate.
       * @param {number} angle - The angle to rotate, in radians.
       * @return {Vector2} A reference to this vector.
       */
      rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
      }
      /**
       * Sets each component of this vector to a pseudo-random value between `0` and
       * `1`, excluding `1`.
       *
       * @return {Vector2} A reference to this vector.
       */
      random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
      }
      *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
      }
    };
    Quaternion = class {
      /**
       * Constructs a new quaternion.
       *
       * @param {number} [x=0] - The x value of this quaternion.
       * @param {number} [y=0] - The y value of this quaternion.
       * @param {number} [z=0] - The z value of this quaternion.
       * @param {number} [w=1] - The w value of this quaternion.
       */
      constructor(x = 0, y = 0, z = 0, w = 1) {
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
      }
      /**
       * Interpolates between two quaternions via SLERP. This implementation assumes the
       * quaternion data are managed  in flat arrays.
       *
       * @param {Array<number>} dst - The destination array.
       * @param {number} dstOffset - An offset into the destination array.
       * @param {Array<number>} src0 - The source array of the first quaternion.
       * @param {number} srcOffset0 - An offset into the first source array.
       * @param {Array<number>} src1 -  The source array of the second quaternion.
       * @param {number} srcOffset1 - An offset into the second source array.
       * @param {number} t - The interpolation factor in the range `[0,1]`.
       * @see {@link Quaternion#slerp}
       */
      static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
          dst[dstOffset + 0] = x0;
          dst[dstOffset + 1] = y0;
          dst[dstOffset + 2] = z0;
          dst[dstOffset + 3] = w0;
          return;
        }
        if (t === 1) {
          dst[dstOffset + 0] = x1;
          dst[dstOffset + 1] = y1;
          dst[dstOffset + 2] = z1;
          dst[dstOffset + 3] = w1;
          return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
          let s = 1 - t;
          const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
          if (sqrSin > Number.EPSILON) {
            const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
            s = Math.sin(s * len) / sin;
            t = Math.sin(t * len) / sin;
          }
          const tDir = t * dir;
          x0 = x0 * s + x1 * tDir;
          y0 = y0 * s + y1 * tDir;
          z0 = z0 * s + z1 * tDir;
          w0 = w0 * s + w1 * tDir;
          if (s === 1 - t) {
            const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
            x0 *= f;
            y0 *= f;
            z0 *= f;
            w0 *= f;
          }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
      }
      /**
       * Multiplies two quaternions. This implementation assumes the quaternion data are managed
       * in flat arrays.
       *
       * @param {Array<number>} dst - The destination array.
       * @param {number} dstOffset - An offset into the destination array.
       * @param {Array<number>} src0 - The source array of the first quaternion.
       * @param {number} srcOffset0 - An offset into the first source array.
       * @param {Array<number>} src1 -  The source array of the second quaternion.
       * @param {number} srcOffset1 - An offset into the second source array.
       * @return {Array<number>} The destination array.
       * @see {@link Quaternion#multiplyQuaternions}.
       */
      static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
      }
      /**
       * The x value of this quaternion.
       *
       * @type {number}
       * @default 0
       */
      get x() {
        return this._x;
      }
      set x(value) {
        this._x = value;
        this._onChangeCallback();
      }
      /**
       * The y value of this quaternion.
       *
       * @type {number}
       * @default 0
       */
      get y() {
        return this._y;
      }
      set y(value) {
        this._y = value;
        this._onChangeCallback();
      }
      /**
       * The z value of this quaternion.
       *
       * @type {number}
       * @default 0
       */
      get z() {
        return this._z;
      }
      set z(value) {
        this._z = value;
        this._onChangeCallback();
      }
      /**
       * The w value of this quaternion.
       *
       * @type {number}
       * @default 1
       */
      get w() {
        return this._w;
      }
      set w(value) {
        this._w = value;
        this._onChangeCallback();
      }
      /**
       * Sets the quaternion components.
       *
       * @param {number} x - The x value of this quaternion.
       * @param {number} y - The y value of this quaternion.
       * @param {number} z - The z value of this quaternion.
       * @param {number} w - The w value of this quaternion.
       * @return {Quaternion} A reference to this quaternion.
       */
      set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
      }
      /**
       * Returns a new quaternion with copied values from this instance.
       *
       * @return {Quaternion} A clone of this instance.
       */
      clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
      }
      /**
       * Copies the values of the given quaternion to this instance.
       *
       * @param {Quaternion} quaternion - The quaternion to copy.
       * @return {Quaternion} A reference to this quaternion.
       */
      copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
      }
      /**
       * Sets this quaternion from the rotation specified by the given
       * Euler angles.
       *
       * @param {Euler} euler - The Euler angles.
       * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
       * @return {Quaternion} A reference to this quaternion.
       */
      setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch (order) {
          case "XYZ":
            this._x = s1 * c2 * c3 + c1 * s2 * s3;
            this._y = c1 * s2 * c3 - s1 * c2 * s3;
            this._z = c1 * c2 * s3 + s1 * s2 * c3;
            this._w = c1 * c2 * c3 - s1 * s2 * s3;
            break;
          case "YXZ":
            this._x = s1 * c2 * c3 + c1 * s2 * s3;
            this._y = c1 * s2 * c3 - s1 * c2 * s3;
            this._z = c1 * c2 * s3 - s1 * s2 * c3;
            this._w = c1 * c2 * c3 + s1 * s2 * s3;
            break;
          case "ZXY":
            this._x = s1 * c2 * c3 - c1 * s2 * s3;
            this._y = c1 * s2 * c3 + s1 * c2 * s3;
            this._z = c1 * c2 * s3 + s1 * s2 * c3;
            this._w = c1 * c2 * c3 - s1 * s2 * s3;
            break;
          case "ZYX":
            this._x = s1 * c2 * c3 - c1 * s2 * s3;
            this._y = c1 * s2 * c3 + s1 * c2 * s3;
            this._z = c1 * c2 * s3 - s1 * s2 * c3;
            this._w = c1 * c2 * c3 + s1 * s2 * s3;
            break;
          case "YZX":
            this._x = s1 * c2 * c3 + c1 * s2 * s3;
            this._y = c1 * s2 * c3 + s1 * c2 * s3;
            this._z = c1 * c2 * s3 - s1 * s2 * c3;
            this._w = c1 * c2 * c3 - s1 * s2 * s3;
            break;
          case "XZY":
            this._x = s1 * c2 * c3 - c1 * s2 * s3;
            this._y = c1 * s2 * c3 - s1 * c2 * s3;
            this._z = c1 * c2 * s3 + s1 * s2 * c3;
            this._w = c1 * c2 * c3 + s1 * s2 * s3;
            break;
          default:
            console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
      }
      /**
       * Sets this quaternion from the given axis and angle.
       *
       * @param {Vector3} axis - The normalized axis.
       * @param {number} angle - The angle in radians.
       * @return {Quaternion} A reference to this quaternion.
       */
      setFromAxisAngle(axis, angle) {
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
      }
      /**
       * Sets this quaternion from the given rotation matrix.
       *
       * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
       * @return {Quaternion} A reference to this quaternion.
       */
      setFromRotationMatrix(m) {
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
          const s = 0.5 / Math.sqrt(trace + 1);
          this._w = 0.25 / s;
          this._x = (m32 - m23) * s;
          this._y = (m13 - m31) * s;
          this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
          const s = 2 * Math.sqrt(1 + m11 - m22 - m33);
          this._w = (m32 - m23) / s;
          this._x = 0.25 * s;
          this._y = (m12 + m21) / s;
          this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
          const s = 2 * Math.sqrt(1 + m22 - m11 - m33);
          this._w = (m13 - m31) / s;
          this._x = (m12 + m21) / s;
          this._y = 0.25 * s;
          this._z = (m23 + m32) / s;
        } else {
          const s = 2 * Math.sqrt(1 + m33 - m11 - m22);
          this._w = (m21 - m12) / s;
          this._x = (m13 + m31) / s;
          this._y = (m23 + m32) / s;
          this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
      }
      /**
       * Sets this quaternion to the rotation required to rotate the direction vector
       * `vFrom` to the direction vector `vTo`.
       *
       * @param {Vector3} vFrom - The first (normalized) direction vector.
       * @param {Vector3} vTo - The second (normalized) direction vector.
       * @return {Quaternion} A reference to this quaternion.
       */
      setFromUnitVectors(vFrom, vTo) {
        let r = vFrom.dot(vTo) + 1;
        if (r < 1e-8) {
          r = 0;
          if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
            this._x = -vFrom.y;
            this._y = vFrom.x;
            this._z = 0;
            this._w = r;
          } else {
            this._x = 0;
            this._y = -vFrom.z;
            this._z = vFrom.y;
            this._w = r;
          }
        } else {
          this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
          this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
          this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
          this._w = r;
        }
        return this.normalize();
      }
      /**
       * Returns the angle between this quaternion and the given one in radians.
       *
       * @param {Quaternion} q - The quaternion to compute the angle with.
       * @return {number} The angle in radians.
       */
      angleTo(q) {
        return 2 * Math.acos(Math.abs(clamp(this.dot(q), -1, 1)));
      }
      /**
       * Rotates this quaternion by a given angular step to the given quaternion.
       * The method ensures that the final quaternion will not overshoot `q`.
       *
       * @param {Quaternion} q - The target quaternion.
       * @param {number} step - The angular step in radians.
       * @return {Quaternion} A reference to this quaternion.
       */
      rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
      }
      /**
       * Sets this quaternion to the identity quaternion; that is, to the
       * quaternion that represents "no rotation".
       *
       * @return {Quaternion} A reference to this quaternion.
       */
      identity() {
        return this.set(0, 0, 0, 1);
      }
      /**
       * Inverts this quaternion via {@link Quaternion#conjugate}. The
       * quaternion is assumed to have unit length.
       *
       * @return {Quaternion} A reference to this quaternion.
       */
      invert() {
        return this.conjugate();
      }
      /**
       * Returns the rotational conjugate of this quaternion. The conjugate of a
       * quaternion represents the same rotation in the opposite direction about
       * the rotational axis.
       *
       * @return {Quaternion} A reference to this quaternion.
       */
      conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
      }
      /**
       * Calculates the dot product of this quaternion and the given one.
       *
       * @param {Quaternion} v - The quaternion to compute the dot product with.
       * @return {number} The result of the dot product.
       */
      dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
      }
      /**
       * Computes the squared Euclidean length (straight-line length) of this quaternion,
       * considered as a 4 dimensional vector. This can be useful if you are comparing the
       * lengths of two quaternions, as this is a slightly more efficient calculation than
       * {@link Quaternion#length}.
       *
       * @return {number} The squared Euclidean length.
       */
      lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
      }
      /**
       * Computes the Euclidean length (straight-line length) of this quaternion,
       * considered as a 4 dimensional vector.
       *
       * @return {number} The Euclidean length.
       */
      length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
      }
      /**
       * Normalizes this quaternion - that is, calculated the quaternion that performs
       * the same rotation as this one, but has a length equal to `1`.
       *
       * @return {Quaternion} A reference to this quaternion.
       */
      normalize() {
        let l = this.length();
        if (l === 0) {
          this._x = 0;
          this._y = 0;
          this._z = 0;
          this._w = 1;
        } else {
          l = 1 / l;
          this._x = this._x * l;
          this._y = this._y * l;
          this._z = this._z * l;
          this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
      }
      /**
       * Multiplies this quaternion by the given one.
       *
       * @param {Quaternion} q - The quaternion.
       * @return {Quaternion} A reference to this quaternion.
       */
      multiply(q) {
        return this.multiplyQuaternions(this, q);
      }
      /**
       * Pre-multiplies this quaternion by the given one.
       *
       * @param {Quaternion} q - The quaternion.
       * @return {Quaternion} A reference to this quaternion.
       */
      premultiply(q) {
        return this.multiplyQuaternions(q, this);
      }
      /**
       * Multiplies the given quaternions and stores the result in this instance.
       *
       * @param {Quaternion} a - The first quaternion.
       * @param {Quaternion} b - The second quaternion.
       * @return {Quaternion} A reference to this quaternion.
       */
      multiplyQuaternions(a, b) {
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
      }
      /**
       * Performs a spherical linear interpolation between quaternions.
       *
       * @param {Quaternion} qb - The target quaternion.
       * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
       * @return {Quaternion} A reference to this quaternion.
       */
      slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
          this._w = -qb._w;
          this._x = -qb._x;
          this._y = -qb._y;
          this._z = -qb._z;
          cosHalfTheta = -cosHalfTheta;
        } else {
          this.copy(qb);
        }
        if (cosHalfTheta >= 1) {
          this._w = w;
          this._x = x;
          this._y = y;
          this._z = z;
          return this;
        }
        const sqrSinHalfTheta = 1 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
          const s = 1 - t;
          this._w = s * w + t * this._w;
          this._x = s * x + t * this._x;
          this._y = s * y + t * this._y;
          this._z = s * z + t * this._z;
          this.normalize();
          return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
      }
      /**
       * Performs a spherical linear interpolation between the given quaternions
       * and stores the result in this quaternion.
       *
       * @param {Quaternion} qa - The source quaternion.
       * @param {Quaternion} qb - The target quaternion.
       * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
       * @return {Quaternion} A reference to this quaternion.
       */
      slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
      }
      /**
       * Sets this quaternion to a uniformly random, normalized quaternion.
       *
       * @return {Quaternion} A reference to this quaternion.
       */
      random() {
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(
          r1 * Math.sin(theta1),
          r1 * Math.cos(theta1),
          r2 * Math.sin(theta2),
          r2 * Math.cos(theta2)
        );
      }
      /**
       * Returns `true` if this quaternion is equal with the given one.
       *
       * @param {Quaternion} quaternion - The quaternion to test for equality.
       * @return {boolean} Whether this quaternion is equal with the given one.
       */
      equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
      }
      /**
       * Sets this quaternion's components from the given array.
       *
       * @param {Array<number>} array - An array holding the quaternion component values.
       * @param {number} [offset=0] - The offset into the array.
       * @return {Quaternion} A reference to this quaternion.
       */
      fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
      }
      /**
       * Writes the components of this quaternion to the given array. If no array is provided,
       * the method returns a new instance.
       *
       * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
       * @param {number} [offset=0] - Index of the first element in the array.
       * @return {Array<number>} The quaternion components.
       */
      toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
      }
      /**
       * Sets the components of this quaternion from the given buffer attribute.
       *
       * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
       * @param {number} index - The index into the attribute.
       * @return {Quaternion} A reference to this quaternion.
       */
      fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
      }
      /**
       * This methods defines the serialization result of this class. Returns the
       * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
       *
       * @return {Array<number>} The serialized quaternion.
       */
      toJSON() {
        return this.toArray();
      }
      _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
      }
      _onChangeCallback() {
      }
      *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
      }
    };
    Vector3 = class _Vector3 {
      /**
       * Constructs a new 3D vector.
       *
       * @param {number} [x=0] - The x value of this vector.
       * @param {number} [y=0] - The y value of this vector.
       * @param {number} [z=0] - The z value of this vector.
       */
      constructor(x = 0, y = 0, z = 0) {
        _Vector3.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
      }
      /**
       * Sets the vector components.
       *
       * @param {number} x - The value of the x component.
       * @param {number} y - The value of the y component.
       * @param {number} z - The value of the z component.
       * @return {Vector3} A reference to this vector.
       */
      set(x, y, z) {
        if (z === void 0) z = this.z;
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
      }
      /**
       * Sets the vector components to the same value.
       *
       * @param {number} scalar - The value to set for all vector components.
       * @return {Vector3} A reference to this vector.
       */
      setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
      }
      /**
       * Sets the vector's x component to the given value
       *
       * @param {number} x - The value to set.
       * @return {Vector3} A reference to this vector.
       */
      setX(x) {
        this.x = x;
        return this;
      }
      /**
       * Sets the vector's y component to the given value
       *
       * @param {number} y - The value to set.
       * @return {Vector3} A reference to this vector.
       */
      setY(y) {
        this.y = y;
        return this;
      }
      /**
       * Sets the vector's z component to the given value
       *
       * @param {number} z - The value to set.
       * @return {Vector3} A reference to this vector.
       */
      setZ(z) {
        this.z = z;
        return this;
      }
      /**
       * Allows to set a vector component with an index.
       *
       * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
       * @param {number} value - The value to set.
       * @return {Vector3} A reference to this vector.
       */
      setComponent(index, value) {
        switch (index) {
          case 0:
            this.x = value;
            break;
          case 1:
            this.y = value;
            break;
          case 2:
            this.z = value;
            break;
          default:
            throw new Error("index is out of range: " + index);
        }
        return this;
      }
      /**
       * Returns the value of the vector component which matches the given index.
       *
       * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
       * @return {number} A vector component value.
       */
      getComponent(index) {
        switch (index) {
          case 0:
            return this.x;
          case 1:
            return this.y;
          case 2:
            return this.z;
          default:
            throw new Error("index is out of range: " + index);
        }
      }
      /**
       * Returns a new vector with copied values from this instance.
       *
       * @return {Vector3} A clone of this instance.
       */
      clone() {
        return new this.constructor(this.x, this.y, this.z);
      }
      /**
       * Copies the values of the given vector to this instance.
       *
       * @param {Vector3} v - The vector to copy.
       * @return {Vector3} A reference to this vector.
       */
      copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
      }
      /**
       * Adds the given vector to this instance.
       *
       * @param {Vector3} v - The vector to add.
       * @return {Vector3} A reference to this vector.
       */
      add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
      }
      /**
       * Adds the given scalar value to all components of this instance.
       *
       * @param {number} s - The scalar to add.
       * @return {Vector3} A reference to this vector.
       */
      addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
      }
      /**
       * Adds the given vectors and stores the result in this instance.
       *
       * @param {Vector3} a - The first vector.
       * @param {Vector3} b - The second vector.
       * @return {Vector3} A reference to this vector.
       */
      addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
      }
      /**
       * Adds the given vector scaled by the given factor to this instance.
       *
       * @param {Vector3|Vector4} v - The vector.
       * @param {number} s - The factor that scales `v`.
       * @return {Vector3} A reference to this vector.
       */
      addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
      }
      /**
       * Subtracts the given vector from this instance.
       *
       * @param {Vector3} v - The vector to subtract.
       * @return {Vector3} A reference to this vector.
       */
      sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
      }
      /**
       * Subtracts the given scalar value from all components of this instance.
       *
       * @param {number} s - The scalar to subtract.
       * @return {Vector3} A reference to this vector.
       */
      subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
      }
      /**
       * Subtracts the given vectors and stores the result in this instance.
       *
       * @param {Vector3} a - The first vector.
       * @param {Vector3} b - The second vector.
       * @return {Vector3} A reference to this vector.
       */
      subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
      }
      /**
       * Multiplies the given vector with this instance.
       *
       * @param {Vector3} v - The vector to multiply.
       * @return {Vector3} A reference to this vector.
       */
      multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
      }
      /**
       * Multiplies the given scalar value with all components of this instance.
       *
       * @param {number} scalar - The scalar to multiply.
       * @return {Vector3} A reference to this vector.
       */
      multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
      }
      /**
       * Multiplies the given vectors and stores the result in this instance.
       *
       * @param {Vector3} a - The first vector.
       * @param {Vector3} b - The second vector.
       * @return {Vector3} A reference to this vector.
       */
      multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
      }
      /**
       * Applies the given Euler rotation to this vector.
       *
       * @param {Euler} euler - The Euler angles.
       * @return {Vector3} A reference to this vector.
       */
      applyEuler(euler) {
        return this.applyQuaternion(_quaternion$4.setFromEuler(euler));
      }
      /**
       * Applies a rotation specified by an axis and an angle to this vector.
       *
       * @param {Vector3} axis - A normalized vector representing the rotation axis.
       * @param {number} angle - The angle in radians.
       * @return {Vector3} A reference to this vector.
       */
      applyAxisAngle(axis, angle) {
        return this.applyQuaternion(_quaternion$4.setFromAxisAngle(axis, angle));
      }
      /**
       * Multiplies this vector with the given 3x3 matrix.
       *
       * @param {Matrix3} m - The 3x3 matrix.
       * @return {Vector3} A reference to this vector.
       */
      applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
      }
      /**
       * Multiplies this vector by the given normal matrix and normalizes
       * the result.
       *
       * @param {Matrix3} m - The normal matrix.
       * @return {Vector3} A reference to this vector.
       */
      applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
      }
      /**
       * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
       * divides by perspective.
       *
       * @param {Matrix4} m - The matrix to apply.
       * @return {Vector3} A reference to this vector.
       */
      applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
      }
      /**
       * Applies the given Quaternion to this vector.
       *
       * @param {Quaternion} q - The Quaternion.
       * @return {Vector3} A reference to this vector.
       */
      applyQuaternion(q) {
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
      }
      /**
       * Projects this vector from world space into the camera's normalized
       * device coordinate (NDC) space.
       *
       * @param {Camera} camera - The camera.
       * @return {Vector3} A reference to this vector.
       */
      project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
      }
      /**
       * Unprojects this vector from the camera's normalized device coordinate (NDC)
       * space into world space.
       *
       * @param {Camera} camera - The camera.
       * @return {Vector3} A reference to this vector.
       */
      unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
      }
      /**
       * Transforms the direction of this vector by a matrix (the upper left 3 x 3
       * subset of the given 4x4 matrix and then normalizes the result.
       *
       * @param {Matrix4} m - The matrix.
       * @return {Vector3} A reference to this vector.
       */
      transformDirection(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
      }
      /**
       * Divides this instance by the given vector.
       *
       * @param {Vector3} v - The vector to divide.
       * @return {Vector3} A reference to this vector.
       */
      divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
      }
      /**
       * Divides this vector by the given scalar.
       *
       * @param {number} scalar - The scalar to divide.
       * @return {Vector3} A reference to this vector.
       */
      divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
      }
      /**
       * If this vector's x, y or z value is greater than the given vector's x, y or z
       * value, replace that value with the corresponding min value.
       *
       * @param {Vector3} v - The vector.
       * @return {Vector3} A reference to this vector.
       */
      min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
      }
      /**
       * If this vector's x, y or z value is less than the given vector's x, y or z
       * value, replace that value with the corresponding max value.
       *
       * @param {Vector3} v - The vector.
       * @return {Vector3} A reference to this vector.
       */
      max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
      }
      /**
       * If this vector's x, y or z value is greater than the max vector's x, y or z
       * value, it is replaced by the corresponding value.
       * If this vector's x, y or z value is less than the min vector's x, y or z value,
       * it is replaced by the corresponding value.
       *
       * @param {Vector3} min - The minimum x, y and z values.
       * @param {Vector3} max - The maximum x, y and z values in the desired range.
       * @return {Vector3} A reference to this vector.
       */
      clamp(min, max) {
        this.x = clamp(this.x, min.x, max.x);
        this.y = clamp(this.y, min.y, max.y);
        this.z = clamp(this.z, min.z, max.z);
        return this;
      }
      /**
       * If this vector's x, y or z values are greater than the max value, they are
       * replaced by the max value.
       * If this vector's x, y or z values are less than the min value, they are
       * replaced by the min value.
       *
       * @param {number} minVal - The minimum value the components will be clamped to.
       * @param {number} maxVal - The maximum value the components will be clamped to.
       * @return {Vector3} A reference to this vector.
       */
      clampScalar(minVal, maxVal) {
        this.x = clamp(this.x, minVal, maxVal);
        this.y = clamp(this.y, minVal, maxVal);
        this.z = clamp(this.z, minVal, maxVal);
        return this;
      }
      /**
       * If this vector's length is greater than the max value, it is replaced by
       * the max value.
       * If this vector's length is less than the min value, it is replaced by the
       * min value.
       *
       * @param {number} min - The minimum value the vector length will be clamped to.
       * @param {number} max - The maximum value the vector length will be clamped to.
       * @return {Vector3} A reference to this vector.
       */
      clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(clamp(length, min, max));
      }
      /**
       * The components of this vector are rounded down to the nearest integer value.
       *
       * @return {Vector3} A reference to this vector.
       */
      floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
      }
      /**
       * The components of this vector are rounded up to the nearest integer value.
       *
       * @return {Vector3} A reference to this vector.
       */
      ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
      }
      /**
       * The components of this vector are rounded to the nearest integer value
       *
       * @return {Vector3} A reference to this vector.
       */
      round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
      }
      /**
       * The components of this vector are rounded towards zero (up if negative,
       * down if positive) to an integer value.
       *
       * @return {Vector3} A reference to this vector.
       */
      roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
      }
      /**
       * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
       *
       * @return {Vector3} A reference to this vector.
       */
      negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
      }
      /**
       * Calculates the dot product of the given vector with this instance.
       *
       * @param {Vector3} v - The vector to compute the dot product with.
       * @return {number} The result of the dot product.
       */
      dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
      }
      // TODO lengthSquared?
      /**
       * Computes the square of the Euclidean length (straight-line length) from
       * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
       * compare the length squared instead as it is slightly more efficient to calculate.
       *
       * @return {number} The square length of this vector.
       */
      lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
      }
      /**
       * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
       *
       * @return {number} The length of this vector.
       */
      length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
      }
      /**
       * Computes the Manhattan length of this vector.
       *
       * @return {number} The length of this vector.
       */
      manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
      }
      /**
       * Converts this vector to a unit vector - that is, sets it equal to a vector
       * with the same direction as this one, but with a vector length of `1`.
       *
       * @return {Vector3} A reference to this vector.
       */
      normalize() {
        return this.divideScalar(this.length() || 1);
      }
      /**
       * Sets this vector to a vector with the same direction as this one, but
       * with the specified length.
       *
       * @param {number} length - The new length of this vector.
       * @return {Vector3} A reference to this vector.
       */
      setLength(length) {
        return this.normalize().multiplyScalar(length);
      }
      /**
       * Linearly interpolates between the given vector and this instance, where
       * alpha is the percent distance along the line - alpha = 0 will be this
       * vector, and alpha = 1 will be the given one.
       *
       * @param {Vector3} v - The vector to interpolate towards.
       * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
       * @return {Vector3} A reference to this vector.
       */
      lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
      }
      /**
       * Linearly interpolates between the given vectors, where alpha is the percent
       * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
       * be the second one. The result is stored in this instance.
       *
       * @param {Vector3} v1 - The first vector.
       * @param {Vector3} v2 - The second vector.
       * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
       * @return {Vector3} A reference to this vector.
       */
      lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
      }
      /**
       * Calculates the cross product of the given vector with this instance.
       *
       * @param {Vector3} v - The vector to compute the cross product with.
       * @return {Vector3} The result of the cross product.
       */
      cross(v) {
        return this.crossVectors(this, v);
      }
      /**
       * Calculates the cross product of the given vectors and stores the result
       * in this instance.
       *
       * @param {Vector3} a - The first vector.
       * @param {Vector3} b - The second vector.
       * @return {Vector3} A reference to this vector.
       */
      crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
      }
      /**
       * Projects this vector onto the given one.
       *
       * @param {Vector3} v - The vector to project to.
       * @return {Vector3} A reference to this vector.
       */
      projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
      }
      /**
       * Projects this vector onto a plane by subtracting this
       * vector projected onto the plane's normal from this vector.
       *
       * @param {Vector3} planeNormal - The plane normal.
       * @return {Vector3} A reference to this vector.
       */
      projectOnPlane(planeNormal) {
        _vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub(_vector$c);
      }
      /**
       * Reflects this vector off a plane orthogonal to the given normal vector.
       *
       * @param {Vector3} normal - The (normalized) normal vector.
       * @return {Vector3} A reference to this vector.
       */
      reflect(normal) {
        return this.sub(_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
      }
      /**
       * Returns the angle between the given vector and this instance in radians.
       *
       * @param {Vector3} v - The vector to compute the angle with.
       * @return {number} The angle in radians.
       */
      angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        return Math.acos(clamp(theta, -1, 1));
      }
      /**
       * Computes the distance from the given vector to this instance.
       *
       * @param {Vector3} v - The vector to compute the distance to.
       * @return {number} The distance.
       */
      distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
      }
      /**
       * Computes the squared distance from the given vector to this instance.
       * If you are just comparing the distance with another distance, you should compare
       * the distance squared instead as it is slightly more efficient to calculate.
       *
       * @param {Vector3} v - The vector to compute the squared distance to.
       * @return {number} The squared distance.
       */
      distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
      }
      /**
       * Computes the Manhattan distance from the given vector to this instance.
       *
       * @param {Vector3} v - The vector to compute the Manhattan distance to.
       * @return {number} The Manhattan distance.
       */
      manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
      }
      /**
       * Sets the vector components from the given spherical coordinates.
       *
       * @param {Spherical} s - The spherical coordinates.
       * @return {Vector3} A reference to this vector.
       */
      setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
      }
      /**
       * Sets the vector components from the given spherical coordinates.
       *
       * @param {number} radius - The radius.
       * @param {number} phi - The phi angle in radians.
       * @param {number} theta - The theta angle in radians.
       * @return {Vector3} A reference to this vector.
       */
      setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
      }
      /**
       * Sets the vector components from the given cylindrical coordinates.
       *
       * @param {Cylindrical} c - The cylindrical coordinates.
       * @return {Vector3} A reference to this vector.
       */
      setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
      }
      /**
       * Sets the vector components from the given cylindrical coordinates.
       *
       * @param {number} radius - The radius.
       * @param {number} theta - The theta angle in radians.
       * @param {number} y - The y value.
       * @return {Vector3} A reference to this vector.
       */
      setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
      }
      /**
       * Sets the vector components to the position elements of the
       * given transformation matrix.
       *
       * @param {Matrix4} m - The 4x4 matrix.
       * @return {Vector3} A reference to this vector.
       */
      setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
      }
      /**
       * Sets the vector components to the scale elements of the
       * given transformation matrix.
       *
       * @param {Matrix4} m - The 4x4 matrix.
       * @return {Vector3} A reference to this vector.
       */
      setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
      }
      /**
       * Sets the vector components from the specified matrix column.
       *
       * @param {Matrix4} m - The 4x4 matrix.
       * @param {number} index - The column index.
       * @return {Vector3} A reference to this vector.
       */
      setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
      }
      /**
       * Sets the vector components from the specified matrix column.
       *
       * @param {Matrix3} m - The 3x3 matrix.
       * @param {number} index - The column index.
       * @return {Vector3} A reference to this vector.
       */
      setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
      }
      /**
       * Sets the vector components from the given Euler angles.
       *
       * @param {Euler} e - The Euler angles to set.
       * @return {Vector3} A reference to this vector.
       */
      setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
      }
      /**
       * Sets the vector components from the RGB components of the
       * given color.
       *
       * @param {Color} c - The color to set.
       * @return {Vector3} A reference to this vector.
       */
      setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
      }
      /**
       * Returns `true` if this vector is equal with the given one.
       *
       * @param {Vector3} v - The vector to test for equality.
       * @return {boolean} Whether this vector is equal with the given one.
       */
      equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
      }
      /**
       * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
       * and z value to be `array[ offset + 2 ]`.
       *
       * @param {Array<number>} array - An array holding the vector component values.
       * @param {number} [offset=0] - The offset into the array.
       * @return {Vector3} A reference to this vector.
       */
      fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
      }
      /**
       * Writes the components of this vector to the given array. If no array is provided,
       * the method returns a new instance.
       *
       * @param {Array<number>} [array=[]] - The target array holding the vector components.
       * @param {number} [offset=0] - Index of the first element in the array.
       * @return {Array<number>} The vector components.
       */
      toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
      }
      /**
       * Sets the components of this vector from the given buffer attribute.
       *
       * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
       * @param {number} index - The index into the attribute.
       * @return {Vector3} A reference to this vector.
       */
      fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
      }
      /**
       * Sets each component of this vector to a pseudo-random value between `0` and
       * `1`, excluding `1`.
       *
       * @return {Vector3} A reference to this vector.
       */
      random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
      }
      /**
       * Sets this vector to a uniformly random point on a unit sphere.
       *
       * @return {Vector3} A reference to this vector.
       */
      randomDirection() {
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
      }
      *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
      }
    };
    _vector$c = /* @__PURE__ */ new Vector3();
    _quaternion$4 = /* @__PURE__ */ new Quaternion();
    Matrix3 = class _Matrix3 {
      /**
       * Constructs a new 3x3 matrix. The arguments are supposed to be
       * in row-major order. If no arguments are provided, the constructor
       * initializes the matrix as an identity matrix.
       *
       * @param {number} [n11] - 1-1 matrix element.
       * @param {number} [n12] - 1-2 matrix element.
       * @param {number} [n13] - 1-3 matrix element.
       * @param {number} [n21] - 2-1 matrix element.
       * @param {number} [n22] - 2-2 matrix element.
       * @param {number} [n23] - 2-3 matrix element.
       * @param {number} [n31] - 3-1 matrix element.
       * @param {number} [n32] - 3-2 matrix element.
       * @param {number} [n33] - 3-3 matrix element.
       */
      constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        _Matrix3.prototype.isMatrix3 = true;
        this.elements = [
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1
        ];
        if (n11 !== void 0) {
          this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
        }
      }
      /**
       * Sets the elements of the matrix.The arguments are supposed to be
       * in row-major order.
       *
       * @param {number} [n11] - 1-1 matrix element.
       * @param {number} [n12] - 1-2 matrix element.
       * @param {number} [n13] - 1-3 matrix element.
       * @param {number} [n21] - 2-1 matrix element.
       * @param {number} [n22] - 2-2 matrix element.
       * @param {number} [n23] - 2-3 matrix element.
       * @param {number} [n31] - 3-1 matrix element.
       * @param {number} [n32] - 3-2 matrix element.
       * @param {number} [n33] - 3-3 matrix element.
       * @return {Matrix3} A reference to this matrix.
       */
      set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
      }
      /**
       * Sets this matrix to the 3x3 identity matrix.
       *
       * @return {Matrix3} A reference to this matrix.
       */
      identity() {
        this.set(
          1,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Copies the values of the given matrix to this instance.
       *
       * @param {Matrix3} m - The matrix to copy.
       * @return {Matrix3} A reference to this matrix.
       */
      copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
      }
      /**
       * Extracts the basis of this matrix into the three axis vectors provided.
       *
       * @param {Vector3} xAxis - The basis's x axis.
       * @param {Vector3} yAxis - The basis's y axis.
       * @param {Vector3} zAxis - The basis's z axis.
       * @return {Matrix3} A reference to this matrix.
       */
      extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
      }
      /**
       * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
       *
       * @param {Matrix4} m - The 4x4 matrix.
       * @return {Matrix3} A reference to this matrix.
       */
      setFromMatrix4(m) {
        const me = m.elements;
        this.set(
          me[0],
          me[4],
          me[8],
          me[1],
          me[5],
          me[9],
          me[2],
          me[6],
          me[10]
        );
        return this;
      }
      /**
       * Post-multiplies this matrix by the given 3x3 matrix.
       *
       * @param {Matrix3} m - The matrix to multiply with.
       * @return {Matrix3} A reference to this matrix.
       */
      multiply(m) {
        return this.multiplyMatrices(this, m);
      }
      /**
       * Pre-multiplies this matrix by the given 3x3 matrix.
       *
       * @param {Matrix3} m - The matrix to multiply with.
       * @return {Matrix3} A reference to this matrix.
       */
      premultiply(m) {
        return this.multiplyMatrices(m, this);
      }
      /**
       * Multiples the given 3x3 matrices and stores the result
       * in this matrix.
       *
       * @param {Matrix3} a - The first matrix.
       * @param {Matrix3} b - The second matrix.
       * @return {Matrix3} A reference to this matrix.
       */
      multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
      }
      /**
       * Multiplies every component of the matrix by the given scalar.
       *
       * @param {number} s - The scalar.
       * @return {Matrix3} A reference to this matrix.
       */
      multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
      }
      /**
       * Computes and returns the determinant of this matrix.
       *
       * @return {number} The determinant.
       */
      determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
      }
      /**
       * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
       * You can not invert with a determinant of zero. If you attempt this, the method produces
       * a zero matrix instead.
       *
       * @return {Matrix3} A reference to this matrix.
       */
      invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
      }
      /**
       * Transposes this matrix in place.
       *
       * @return {Matrix3} A reference to this matrix.
       */
      transpose() {
        let tmp2;
        const m = this.elements;
        tmp2 = m[1];
        m[1] = m[3];
        m[3] = tmp2;
        tmp2 = m[2];
        m[2] = m[6];
        m[6] = tmp2;
        tmp2 = m[5];
        m[5] = m[7];
        m[7] = tmp2;
        return this;
      }
      /**
       * Computes the normal matrix which is the inverse transpose of the upper
       * left 3x3 portion of the given 4x4 matrix.
       *
       * @param {Matrix4} matrix4 - The 4x4 matrix.
       * @return {Matrix3} A reference to this matrix.
       */
      getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
      }
      /**
       * Transposes this matrix into the supplied array, and returns itself unchanged.
       *
       * @param {Array<number>} r - An array to store the transposed matrix elements.
       * @return {Matrix3} A reference to this matrix.
       */
      transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
      }
      /**
       * Sets the UV transform matrix from offset, repeat, rotation, and center.
       *
       * @param {number} tx - Offset x.
       * @param {number} ty - Offset y.
       * @param {number} sx - Repeat x.
       * @param {number} sy - Repeat y.
       * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
       * @param {number} cx - Center x of rotation.
       * @param {number} cy - Center y of rotation
       * @return {Matrix3} A reference to this matrix.
       */
      setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(
          sx * c,
          sx * s,
          -sx * (c * cx + s * cy) + cx + tx,
          -sy * s,
          sy * c,
          -sy * (-s * cx + c * cy) + cy + ty,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Scales this matrix with the given scalar values.
       *
       * @param {number} sx - The amount to scale in the X axis.
       * @param {number} sy - The amount to scale in the Y axis.
       * @return {Matrix3} A reference to this matrix.
       */
      scale(sx, sy) {
        this.premultiply(_m3.makeScale(sx, sy));
        return this;
      }
      /**
       * Rotates this matrix by the given angle.
       *
       * @param {number} theta - The rotation in radians.
       * @return {Matrix3} A reference to this matrix.
       */
      rotate(theta) {
        this.premultiply(_m3.makeRotation(-theta));
        return this;
      }
      /**
       * Translates this matrix by the given scalar values.
       *
       * @param {number} tx - The amount to translate in the X axis.
       * @param {number} ty - The amount to translate in the Y axis.
       * @return {Matrix3} A reference to this matrix.
       */
      translate(tx, ty) {
        this.premultiply(_m3.makeTranslation(tx, ty));
        return this;
      }
      // for 2D Transforms
      /**
       * Sets this matrix as a 2D translation transform.
       *
       * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
       * @param {number} y - The amount to translate in the Y axis.
       * @return {Matrix3} A reference to this matrix.
       */
      makeTranslation(x, y) {
        if (x.isVector2) {
          this.set(
            1,
            0,
            x.x,
            0,
            1,
            x.y,
            0,
            0,
            1
          );
        } else {
          this.set(
            1,
            0,
            x,
            0,
            1,
            y,
            0,
            0,
            1
          );
        }
        return this;
      }
      /**
       * Sets this matrix as a 2D rotational transformation.
       *
       * @param {number} theta - The rotation in radians.
       * @return {Matrix3} A reference to this matrix.
       */
      makeRotation(theta) {
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(
          c,
          -s,
          0,
          s,
          c,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Sets this matrix as a 2D scale transform.
       *
       * @param {number} x - The amount to scale in the X axis.
       * @param {number} y - The amount to scale in the Y axis.
       * @return {Matrix3} A reference to this matrix.
       */
      makeScale(x, y) {
        this.set(
          x,
          0,
          0,
          0,
          y,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Returns `true` if this matrix is equal with the given one.
       *
       * @param {Matrix3} matrix - The matrix to test for equality.
       * @return {boolean} Whether this matrix is equal with the given one.
       */
      equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for (let i = 0; i < 9; i++) {
          if (te[i] !== me[i]) return false;
        }
        return true;
      }
      /**
       * Sets the elements of the matrix from the given array.
       *
       * @param {Array<number>} array - The matrix elements in column-major order.
       * @param {number} [offset=0] - Index of the first element in the array.
       * @return {Matrix3} A reference to this matrix.
       */
      fromArray(array, offset = 0) {
        for (let i = 0; i < 9; i++) {
          this.elements[i] = array[i + offset];
        }
        return this;
      }
      /**
       * Writes the elements of this matrix to the given array. If no array is provided,
       * the method returns a new instance.
       *
       * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
       * @param {number} [offset=0] - Index of the first element in the array.
       * @return {Array<number>} The matrix elements in column-major order.
       */
      toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
      }
      /**
       * Returns a matrix with copied values from this instance.
       *
       * @return {Matrix3} A clone of this instance.
       */
      clone() {
        return new this.constructor().fromArray(this.elements);
      }
    };
    _m3 = /* @__PURE__ */ new Matrix3();
    _cache = {};
    LINEAR_REC709_TO_XYZ = /* @__PURE__ */ new Matrix3().set(
      0.4123908,
      0.3575843,
      0.1804808,
      0.212639,
      0.7151687,
      0.0721923,
      0.0193308,
      0.1191948,
      0.9505322
    );
    XYZ_TO_LINEAR_REC709 = /* @__PURE__ */ new Matrix3().set(
      3.2409699,
      -1.5373832,
      -0.4986108,
      -0.9692436,
      1.8759675,
      0.0415551,
      0.0556301,
      -0.203977,
      1.0569715
    );
    ColorManagement = /* @__PURE__ */ createColorManagement();
    ImageUtils = class {
      /**
       * Returns a data URI containing a representation of the given image.
       *
       * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
       * @param {string} [type='image/png'] - Indicates the image format.
       * @return {string} The data URI.
       */
      static getDataURL(image, type = "image/png") {
        if (/^data:/i.test(image.src)) {
          return image.src;
        }
        if (typeof HTMLCanvasElement === "undefined") {
          return image.src;
        }
        let canvas2;
        if (image instanceof HTMLCanvasElement) {
          canvas2 = image;
        } else {
          if (_canvas === void 0) _canvas = createElementNS("canvas");
          _canvas.width = image.width;
          _canvas.height = image.height;
          const context = _canvas.getContext("2d");
          if (image instanceof ImageData) {
            context.putImageData(image, 0, 0);
          } else {
            context.drawImage(image, 0, 0, image.width, image.height);
          }
          canvas2 = _canvas;
        }
        return canvas2.toDataURL(type);
      }
      /**
       * Converts the given sRGB image data to linear color space.
       *
       * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
       * @return {HTMLCanvasElement|Object} The converted image.
       */
      static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
          const canvas2 = createElementNS("canvas");
          canvas2.width = image.width;
          canvas2.height = image.height;
          const context = canvas2.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          const imageData = context.getImageData(0, 0, image.width, image.height);
          const data = imageData.data;
          for (let i = 0; i < data.length; i++) {
            data[i] = SRGBToLinear(data[i] / 255) * 255;
          }
          context.putImageData(imageData, 0, 0);
          return canvas2;
        } else if (image.data) {
          const data = image.data.slice(0);
          for (let i = 0; i < data.length; i++) {
            if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) {
              data[i] = Math.floor(SRGBToLinear(data[i] / 255) * 255);
            } else {
              data[i] = SRGBToLinear(data[i]);
            }
          }
          return {
            data,
            width: image.width,
            height: image.height
          };
        } else {
          console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
          return image;
        }
      }
    };
    _sourceId = 0;
    Source = class {
      /**
       * Constructs a new video texture.
       *
       * @param {any} [data=null] - The data definition of a texture.
       */
      constructor(data = null) {
        this.isSource = true;
        Object.defineProperty(this, "id", { value: _sourceId++ });
        this.uuid = generateUUID();
        this.data = data;
        this.dataReady = true;
        this.version = 0;
      }
      /**
       * Returns the dimensions of the source into the given target vector.
       *
       * @param {(Vector2|Vector3)} target - The target object the result is written into.
       * @return {(Vector2|Vector3)} The dimensions of the source.
       */
      getSize(target) {
        const data = this.data;
        if (typeof HTMLVideoElement !== "undefined" && data instanceof HTMLVideoElement) {
          target.set(data.videoWidth, data.videoHeight, 0);
        } else if (data instanceof VideoFrame) {
          target.set(data.displayHeight, data.displayWidth, 0);
        } else if (data !== null) {
          target.set(data.width, data.height, data.depth || 0);
        } else {
          target.set(0, 0, 0);
        }
        return target;
      }
      /**
       * When the property is set to `true`, the engine allocates the memory
       * for the texture (if necessary) and triggers the actual texture upload
       * to the GPU next time the source is used.
       *
       * @type {boolean}
       * @default false
       * @param {boolean} value
       */
      set needsUpdate(value) {
        if (value === true) this.version++;
      }
      /**
       * Serializes the source into JSON.
       *
       * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
       * @return {Object} A JSON object representing the serialized source.
       * @see {@link ObjectLoader#parse}
       */
      toJSON(meta) {
        const isRootObject = meta === void 0 || typeof meta === "string";
        if (!isRootObject && meta.images[this.uuid] !== void 0) {
          return meta.images[this.uuid];
        }
        const output = {
          uuid: this.uuid,
          url: ""
        };
        const data = this.data;
        if (data !== null) {
          let url;
          if (Array.isArray(data)) {
            url = [];
            for (let i = 0, l = data.length; i < l; i++) {
              if (data[i].isDataTexture) {
                url.push(serializeImage(data[i].image));
              } else {
                url.push(serializeImage(data[i]));
              }
            }
          } else {
            url = serializeImage(data);
          }
          output.url = url;
        }
        if (!isRootObject) {
          meta.images[this.uuid] = output;
        }
        return output;
      }
    };
    _textureId = 0;
    _tempVec3 = /* @__PURE__ */ new Vector3();
    Texture = class _Texture extends EventDispatcher {
      /**
       * Constructs a new texture.
       *
       * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
       * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
       * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
       * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
       * @param {number} [magFilter=LinearFilter] - The mag filter value.
       * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
       * @param {number} [format=RGBAFormat] - The texture format.
       * @param {number} [type=UnsignedByteType] - The texture type.
       * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
       * @param {string} [colorSpace=NoColorSpace] - The color space.
       */
      constructor(image = _Texture.DEFAULT_IMAGE, mapping = _Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = _Texture.DEFAULT_ANISOTROPY, colorSpace = NoColorSpace) {
        super();
        this.isTexture = true;
        Object.defineProperty(this, "id", { value: _textureId++ });
        this.uuid = generateUUID();
        this.name = "";
        this.source = new Source(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new Vector2(0, 0);
        this.repeat = new Vector2(1, 1);
        this.center = new Vector2(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new Matrix3();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4;
        this.colorSpace = colorSpace;
        this.userData = {};
        this.updateRanges = [];
        this.version = 0;
        this.onUpdate = null;
        this.renderTarget = null;
        this.isRenderTargetTexture = false;
        this.isArrayTexture = image && image.depth && image.depth > 1 ? true : false;
        this.pmremVersion = 0;
      }
      /**
       * The width of the texture in pixels.
       */
      get width() {
        return this.source.getSize(_tempVec3).x;
      }
      /**
       * The height of the texture in pixels.
       */
      get height() {
        return this.source.getSize(_tempVec3).y;
      }
      /**
       * The depth of the texture in pixels.
       */
      get depth() {
        return this.source.getSize(_tempVec3).z;
      }
      /**
       * The image object holding the texture data.
       *
       * @type {?Object}
       */
      get image() {
        return this.source.data;
      }
      set image(value = null) {
        this.source.data = value;
      }
      /**
       * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
       * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
       */
      updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
      }
      /**
       * Adds a range of data in the data texture to be updated on the GPU.
       *
       * @param {number} start - Position at which to start update.
       * @param {number} count - The number of components to update.
       */
      addUpdateRange(start, count) {
        this.updateRanges.push({ start, count });
      }
      /**
       * Clears the update ranges.
       */
      clearUpdateRanges() {
        this.updateRanges.length = 0;
      }
      /**
       * Returns a new texture with copied values from this instance.
       *
       * @return {Texture} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
      /**
       * Copies the values of the given texture to this instance.
       *
       * @param {Texture} source - The texture to copy.
       * @return {Texture} A reference to this instance.
       */
      copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.renderTarget = source.renderTarget;
        this.isRenderTargetTexture = source.isRenderTargetTexture;
        this.isArrayTexture = source.isArrayTexture;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
      }
      /**
       * Sets this texture's properties based on `values`.
       * @param {Object} values - A container with texture parameters.
       */
      setValues(values) {
        for (const key in values) {
          const newValue = values[key];
          if (newValue === void 0) {
            console.warn(`THREE.Texture.setValues(): parameter '${key}' has value of undefined.`);
            continue;
          }
          const currentValue = this[key];
          if (currentValue === void 0) {
            console.warn(`THREE.Texture.setValues(): property '${key}' does not exist.`);
            continue;
          }
          if (currentValue && newValue && (currentValue.isVector2 && newValue.isVector2)) {
            currentValue.copy(newValue);
          } else if (currentValue && newValue && (currentValue.isVector3 && newValue.isVector3)) {
            currentValue.copy(newValue);
          } else if (currentValue && newValue && (currentValue.isMatrix3 && newValue.isMatrix3)) {
            currentValue.copy(newValue);
          } else {
            this[key] = newValue;
          }
        }
      }
      /**
       * Serializes the texture into JSON.
       *
       * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
       * @return {Object} A JSON object representing the serialized texture.
       * @see {@link ObjectLoader#parse}
       */
      toJSON(meta) {
        const isRootObject = meta === void 0 || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== void 0) {
          return meta.textures[this.uuid];
        }
        const output = {
          metadata: {
            version: 4.7,
            type: "Texture",
            generator: "Texture.toJSON"
          },
          uuid: this.uuid,
          name: this.name,
          image: this.source.toJSON(meta).uuid,
          mapping: this.mapping,
          channel: this.channel,
          repeat: [this.repeat.x, this.repeat.y],
          offset: [this.offset.x, this.offset.y],
          center: [this.center.x, this.center.y],
          rotation: this.rotation,
          wrap: [this.wrapS, this.wrapT],
          format: this.format,
          internalFormat: this.internalFormat,
          type: this.type,
          colorSpace: this.colorSpace,
          minFilter: this.minFilter,
          magFilter: this.magFilter,
          anisotropy: this.anisotropy,
          flipY: this.flipY,
          generateMipmaps: this.generateMipmaps,
          premultiplyAlpha: this.premultiplyAlpha,
          unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) {
          meta.textures[this.uuid] = output;
        }
        return output;
      }
      /**
       * Frees the GPU-related resources allocated by this instance. Call this
       * method whenever this instance is no longer used in your app.
       *
       * @fires Texture#dispose
       */
      dispose() {
        this.dispatchEvent({ type: "dispose" });
      }
      /**
       * Transforms the given uv vector with the textures uv transformation matrix.
       *
       * @param {Vector2} uv - The uv vector.
       * @return {Vector2} The transformed uv vector.
       */
      transformUv(uv) {
        if (this.mapping !== UVMapping) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) {
          switch (this.wrapS) {
            case RepeatWrapping:
              uv.x = uv.x - Math.floor(uv.x);
              break;
            case ClampToEdgeWrapping:
              uv.x = uv.x < 0 ? 0 : 1;
              break;
            case MirroredRepeatWrapping:
              if (Math.abs(Math.floor(uv.x) % 2) === 1) {
                uv.x = Math.ceil(uv.x) - uv.x;
              } else {
                uv.x = uv.x - Math.floor(uv.x);
              }
              break;
          }
        }
        if (uv.y < 0 || uv.y > 1) {
          switch (this.wrapT) {
            case RepeatWrapping:
              uv.y = uv.y - Math.floor(uv.y);
              break;
            case ClampToEdgeWrapping:
              uv.y = uv.y < 0 ? 0 : 1;
              break;
            case MirroredRepeatWrapping:
              if (Math.abs(Math.floor(uv.y) % 2) === 1) {
                uv.y = Math.ceil(uv.y) - uv.y;
              } else {
                uv.y = uv.y - Math.floor(uv.y);
              }
              break;
          }
        }
        if (this.flipY) {
          uv.y = 1 - uv.y;
        }
        return uv;
      }
      /**
       * Setting this property to `true` indicates the engine the texture
       * must be updated in the next render. This triggers a texture upload
       * to the GPU and ensures correct texture parameter configuration.
       *
       * @type {boolean}
       * @default false
       * @param {boolean} value
       */
      set needsUpdate(value) {
        if (value === true) {
          this.version++;
          this.source.needsUpdate = true;
        }
      }
      /**
       * Setting this property to `true` indicates the engine the PMREM
       * must be regenerated.
       *
       * @type {boolean}
       * @default false
       * @param {boolean} value
       */
      set needsPMREMUpdate(value) {
        if (value === true) {
          this.pmremVersion++;
        }
      }
    };
    Texture.DEFAULT_IMAGE = null;
    Texture.DEFAULT_MAPPING = UVMapping;
    Texture.DEFAULT_ANISOTROPY = 1;
    Vector4 = class _Vector4 {
      /**
       * Constructs a new 4D vector.
       *
       * @param {number} [x=0] - The x value of this vector.
       * @param {number} [y=0] - The y value of this vector.
       * @param {number} [z=0] - The z value of this vector.
       * @param {number} [w=1] - The w value of this vector.
       */
      constructor(x = 0, y = 0, z = 0, w = 1) {
        _Vector4.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
      }
      /**
       * Alias for {@link Vector4#z}.
       *
       * @type {number}
       */
      get width() {
        return this.z;
      }
      set width(value) {
        this.z = value;
      }
      /**
       * Alias for {@link Vector4#w}.
       *
       * @type {number}
       */
      get height() {
        return this.w;
      }
      set height(value) {
        this.w = value;
      }
      /**
       * Sets the vector components.
       *
       * @param {number} x - The value of the x component.
       * @param {number} y - The value of the y component.
       * @param {number} z - The value of the z component.
       * @param {number} w - The value of the w component.
       * @return {Vector4} A reference to this vector.
       */
      set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
      }
      /**
       * Sets the vector components to the same value.
       *
       * @param {number} scalar - The value to set for all vector components.
       * @return {Vector4} A reference to this vector.
       */
      setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
      }
      /**
       * Sets the vector's x component to the given value
       *
       * @param {number} x - The value to set.
       * @return {Vector4} A reference to this vector.
       */
      setX(x) {
        this.x = x;
        return this;
      }
      /**
       * Sets the vector's y component to the given value
       *
       * @param {number} y - The value to set.
       * @return {Vector4} A reference to this vector.
       */
      setY(y) {
        this.y = y;
        return this;
      }
      /**
       * Sets the vector's z component to the given value
       *
       * @param {number} z - The value to set.
       * @return {Vector4} A reference to this vector.
       */
      setZ(z) {
        this.z = z;
        return this;
      }
      /**
       * Sets the vector's w component to the given value
       *
       * @param {number} w - The value to set.
       * @return {Vector4} A reference to this vector.
       */
      setW(w) {
        this.w = w;
        return this;
      }
      /**
       * Allows to set a vector component with an index.
       *
       * @param {number} index - The component index. `0` equals to x, `1` equals to y,
       * `2` equals to z, `3` equals to w.
       * @param {number} value - The value to set.
       * @return {Vector4} A reference to this vector.
       */
      setComponent(index, value) {
        switch (index) {
          case 0:
            this.x = value;
            break;
          case 1:
            this.y = value;
            break;
          case 2:
            this.z = value;
            break;
          case 3:
            this.w = value;
            break;
          default:
            throw new Error("index is out of range: " + index);
        }
        return this;
      }
      /**
       * Returns the value of the vector component which matches the given index.
       *
       * @param {number} index - The component index. `0` equals to x, `1` equals to y,
       * `2` equals to z, `3` equals to w.
       * @return {number} A vector component value.
       */
      getComponent(index) {
        switch (index) {
          case 0:
            return this.x;
          case 1:
            return this.y;
          case 2:
            return this.z;
          case 3:
            return this.w;
          default:
            throw new Error("index is out of range: " + index);
        }
      }
      /**
       * Returns a new vector with copied values from this instance.
       *
       * @return {Vector4} A clone of this instance.
       */
      clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
      }
      /**
       * Copies the values of the given vector to this instance.
       *
       * @param {Vector3|Vector4} v - The vector to copy.
       * @return {Vector4} A reference to this vector.
       */
      copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== void 0 ? v.w : 1;
        return this;
      }
      /**
       * Adds the given vector to this instance.
       *
       * @param {Vector4} v - The vector to add.
       * @return {Vector4} A reference to this vector.
       */
      add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
      }
      /**
       * Adds the given scalar value to all components of this instance.
       *
       * @param {number} s - The scalar to add.
       * @return {Vector4} A reference to this vector.
       */
      addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
      }
      /**
       * Adds the given vectors and stores the result in this instance.
       *
       * @param {Vector4} a - The first vector.
       * @param {Vector4} b - The second vector.
       * @return {Vector4} A reference to this vector.
       */
      addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
      }
      /**
       * Adds the given vector scaled by the given factor to this instance.
       *
       * @param {Vector4} v - The vector.
       * @param {number} s - The factor that scales `v`.
       * @return {Vector4} A reference to this vector.
       */
      addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
      }
      /**
       * Subtracts the given vector from this instance.
       *
       * @param {Vector4} v - The vector to subtract.
       * @return {Vector4} A reference to this vector.
       */
      sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
      }
      /**
       * Subtracts the given scalar value from all components of this instance.
       *
       * @param {number} s - The scalar to subtract.
       * @return {Vector4} A reference to this vector.
       */
      subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
      }
      /**
       * Subtracts the given vectors and stores the result in this instance.
       *
       * @param {Vector4} a - The first vector.
       * @param {Vector4} b - The second vector.
       * @return {Vector4} A reference to this vector.
       */
      subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
      }
      /**
       * Multiplies the given vector with this instance.
       *
       * @param {Vector4} v - The vector to multiply.
       * @return {Vector4} A reference to this vector.
       */
      multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
      }
      /**
       * Multiplies the given scalar value with all components of this instance.
       *
       * @param {number} scalar - The scalar to multiply.
       * @return {Vector4} A reference to this vector.
       */
      multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
      }
      /**
       * Multiplies this vector with the given 4x4 matrix.
       *
       * @param {Matrix4} m - The 4x4 matrix.
       * @return {Vector4} A reference to this vector.
       */
      applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
      }
      /**
       * Divides this instance by the given vector.
       *
       * @param {Vector4} v - The vector to divide.
       * @return {Vector4} A reference to this vector.
       */
      divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
      }
      /**
       * Divides this vector by the given scalar.
       *
       * @param {number} scalar - The scalar to divide.
       * @return {Vector4} A reference to this vector.
       */
      divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
      }
      /**
       * Sets the x, y and z components of this
       * vector to the quaternion's axis and w to the angle.
       *
       * @param {Quaternion} q - The Quaternion to set.
       * @return {Vector4} A reference to this vector.
       */
      setAxisAngleFromQuaternion(q) {
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 1e-4) {
          this.x = 1;
          this.y = 0;
          this.z = 0;
        } else {
          this.x = q.x / s;
          this.y = q.y / s;
          this.z = q.z / s;
        }
        return this;
      }
      /**
       * Sets the x, y and z components of this
       * vector to the axis of rotation and w to the angle.
       *
       * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
       * @return {Vector4} A reference to this vector.
       */
      setAxisAngleFromRotationMatrix(m) {
        let angle, x, y, z;
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
          if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
            this.set(1, 0, 0, 0);
            return this;
          }
          angle = Math.PI;
          const xx = (m11 + 1) / 2;
          const yy = (m22 + 1) / 2;
          const zz = (m33 + 1) / 2;
          const xy = (m12 + m21) / 4;
          const xz = (m13 + m31) / 4;
          const yz = (m23 + m32) / 4;
          if (xx > yy && xx > zz) {
            if (xx < epsilon) {
              x = 0;
              y = 0.707106781;
              z = 0.707106781;
            } else {
              x = Math.sqrt(xx);
              y = xy / x;
              z = xz / x;
            }
          } else if (yy > zz) {
            if (yy < epsilon) {
              x = 0.707106781;
              y = 0;
              z = 0.707106781;
            } else {
              y = Math.sqrt(yy);
              x = xy / y;
              z = yz / y;
            }
          } else {
            if (zz < epsilon) {
              x = 0.707106781;
              y = 0.707106781;
              z = 0;
            } else {
              z = Math.sqrt(zz);
              x = xz / z;
              y = yz / z;
            }
          }
          this.set(x, y, z, angle);
          return this;
        }
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12));
        if (Math.abs(s) < 1e-3) s = 1;
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
      }
      /**
       * Sets the vector components to the position elements of the
       * given transformation matrix.
       *
       * @param {Matrix4} m - The 4x4 matrix.
       * @return {Vector4} A reference to this vector.
       */
      setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
      }
      /**
       * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
       * value, replace that value with the corresponding min value.
       *
       * @param {Vector4} v - The vector.
       * @return {Vector4} A reference to this vector.
       */
      min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
      }
      /**
       * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
       * value, replace that value with the corresponding max value.
       *
       * @param {Vector4} v - The vector.
       * @return {Vector4} A reference to this vector.
       */
      max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
      }
      /**
       * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
       * value, it is replaced by the corresponding value.
       * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
       * it is replaced by the corresponding value.
       *
       * @param {Vector4} min - The minimum x, y and z values.
       * @param {Vector4} max - The maximum x, y and z values in the desired range.
       * @return {Vector4} A reference to this vector.
       */
      clamp(min, max) {
        this.x = clamp(this.x, min.x, max.x);
        this.y = clamp(this.y, min.y, max.y);
        this.z = clamp(this.z, min.z, max.z);
        this.w = clamp(this.w, min.w, max.w);
        return this;
      }
      /**
       * If this vector's x, y, z or w values are greater than the max value, they are
       * replaced by the max value.
       * If this vector's x, y, z or w values are less than the min value, they are
       * replaced by the min value.
       *
       * @param {number} minVal - The minimum value the components will be clamped to.
       * @param {number} maxVal - The maximum value the components will be clamped to.
       * @return {Vector4} A reference to this vector.
       */
      clampScalar(minVal, maxVal) {
        this.x = clamp(this.x, minVal, maxVal);
        this.y = clamp(this.y, minVal, maxVal);
        this.z = clamp(this.z, minVal, maxVal);
        this.w = clamp(this.w, minVal, maxVal);
        return this;
      }
      /**
       * If this vector's length is greater than the max value, it is replaced by
       * the max value.
       * If this vector's length is less than the min value, it is replaced by the
       * min value.
       *
       * @param {number} min - The minimum value the vector length will be clamped to.
       * @param {number} max - The maximum value the vector length will be clamped to.
       * @return {Vector4} A reference to this vector.
       */
      clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(clamp(length, min, max));
      }
      /**
       * The components of this vector are rounded down to the nearest integer value.
       *
       * @return {Vector4} A reference to this vector.
       */
      floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
      }
      /**
       * The components of this vector are rounded up to the nearest integer value.
       *
       * @return {Vector4} A reference to this vector.
       */
      ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
      }
      /**
       * The components of this vector are rounded to the nearest integer value
       *
       * @return {Vector4} A reference to this vector.
       */
      round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
      }
      /**
       * The components of this vector are rounded towards zero (up if negative,
       * down if positive) to an integer value.
       *
       * @return {Vector4} A reference to this vector.
       */
      roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
      }
      /**
       * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
       *
       * @return {Vector4} A reference to this vector.
       */
      negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
      }
      /**
       * Calculates the dot product of the given vector with this instance.
       *
       * @param {Vector4} v - The vector to compute the dot product with.
       * @return {number} The result of the dot product.
       */
      dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
      }
      /**
       * Computes the square of the Euclidean length (straight-line length) from
       * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
       * compare the length squared instead as it is slightly more efficient to calculate.
       *
       * @return {number} The square length of this vector.
       */
      lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
      }
      /**
       * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
       *
       * @return {number} The length of this vector.
       */
      length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
      }
      /**
       * Computes the Manhattan length of this vector.
       *
       * @return {number} The length of this vector.
       */
      manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
      }
      /**
       * Converts this vector to a unit vector - that is, sets it equal to a vector
       * with the same direction as this one, but with a vector length of `1`.
       *
       * @return {Vector4} A reference to this vector.
       */
      normalize() {
        return this.divideScalar(this.length() || 1);
      }
      /**
       * Sets this vector to a vector with the same direction as this one, but
       * with the specified length.
       *
       * @param {number} length - The new length of this vector.
       * @return {Vector4} A reference to this vector.
       */
      setLength(length) {
        return this.normalize().multiplyScalar(length);
      }
      /**
       * Linearly interpolates between the given vector and this instance, where
       * alpha is the percent distance along the line - alpha = 0 will be this
       * vector, and alpha = 1 will be the given one.
       *
       * @param {Vector4} v - The vector to interpolate towards.
       * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
       * @return {Vector4} A reference to this vector.
       */
      lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
      }
      /**
       * Linearly interpolates between the given vectors, where alpha is the percent
       * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
       * be the second one. The result is stored in this instance.
       *
       * @param {Vector4} v1 - The first vector.
       * @param {Vector4} v2 - The second vector.
       * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
       * @return {Vector4} A reference to this vector.
       */
      lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
      }
      /**
       * Returns `true` if this vector is equal with the given one.
       *
       * @param {Vector4} v - The vector to test for equality.
       * @return {boolean} Whether this vector is equal with the given one.
       */
      equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
      }
      /**
       * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
       * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
       *
       * @param {Array<number>} array - An array holding the vector component values.
       * @param {number} [offset=0] - The offset into the array.
       * @return {Vector4} A reference to this vector.
       */
      fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
      }
      /**
       * Writes the components of this vector to the given array. If no array is provided,
       * the method returns a new instance.
       *
       * @param {Array<number>} [array=[]] - The target array holding the vector components.
       * @param {number} [offset=0] - Index of the first element in the array.
       * @return {Array<number>} The vector components.
       */
      toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
      }
      /**
       * Sets the components of this vector from the given buffer attribute.
       *
       * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
       * @param {number} index - The index into the attribute.
       * @return {Vector4} A reference to this vector.
       */
      fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
      }
      /**
       * Sets each component of this vector to a pseudo-random value between `0` and
       * `1`, excluding `1`.
       *
       * @return {Vector4} A reference to this vector.
       */
      random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
      }
      *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
      }
    };
    RenderTarget = class extends EventDispatcher {
      /**
       * Render target options.
       *
       * @typedef {Object} RenderTarget~Options
       * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
       * @property {number} [magFilter=LinearFilter] - The mag filter.
       * @property {number} [minFilter=LinearFilter] - The min filter.
       * @property {number} [format=RGBAFormat] - The texture format.
       * @property {number} [type=UnsignedByteType] - The texture type.
       * @property {?string} [internalFormat=null] - The texture's internal format.
       * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
       * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
       * @property {number} [anisotropy=1] - The texture's anisotropy value.
       * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
       * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
       * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
       * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
       * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
       * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
       * @property {number} [samples=0] - The MSAA samples count.
       * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
       * @property {number} [depth=1] - The texture depth.
       * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
       */
      /**
       * Constructs a new render target.
       *
       * @param {number} [width=1] - The width of the render target.
       * @param {number} [height=1] - The height of the render target.
       * @param {RenderTarget~Options} [options] - The configuration object.
       */
      constructor(width = 1, height = 1, options = {}) {
        super();
        options = Object.assign({
          generateMipmaps: false,
          internalFormat: null,
          minFilter: LinearFilter,
          depthBuffer: true,
          stencilBuffer: false,
          resolveDepthBuffer: true,
          resolveStencilBuffer: true,
          depthTexture: null,
          samples: 0,
          count: 1,
          depth: 1,
          multiview: false
        }, options);
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = options.depth;
        this.scissor = new Vector4(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new Vector4(0, 0, width, height);
        const image = { width, height, depth: options.depth };
        const texture = new Texture(image);
        this.textures = [];
        const count = options.count;
        for (let i = 0; i < count; i++) {
          this.textures[i] = texture.clone();
          this.textures[i].isRenderTargetTexture = true;
          this.textures[i].renderTarget = this;
        }
        this._setTextureOptions(options);
        this.depthBuffer = options.depthBuffer;
        this.stencilBuffer = options.stencilBuffer;
        this.resolveDepthBuffer = options.resolveDepthBuffer;
        this.resolveStencilBuffer = options.resolveStencilBuffer;
        this._depthTexture = null;
        this.depthTexture = options.depthTexture;
        this.samples = options.samples;
        this.multiview = options.multiview;
      }
      _setTextureOptions(options = {}) {
        const values = {
          minFilter: LinearFilter,
          generateMipmaps: false,
          flipY: false,
          internalFormat: null
        };
        if (options.mapping !== void 0) values.mapping = options.mapping;
        if (options.wrapS !== void 0) values.wrapS = options.wrapS;
        if (options.wrapT !== void 0) values.wrapT = options.wrapT;
        if (options.wrapR !== void 0) values.wrapR = options.wrapR;
        if (options.magFilter !== void 0) values.magFilter = options.magFilter;
        if (options.minFilter !== void 0) values.minFilter = options.minFilter;
        if (options.format !== void 0) values.format = options.format;
        if (options.type !== void 0) values.type = options.type;
        if (options.anisotropy !== void 0) values.anisotropy = options.anisotropy;
        if (options.colorSpace !== void 0) values.colorSpace = options.colorSpace;
        if (options.flipY !== void 0) values.flipY = options.flipY;
        if (options.generateMipmaps !== void 0) values.generateMipmaps = options.generateMipmaps;
        if (options.internalFormat !== void 0) values.internalFormat = options.internalFormat;
        for (let i = 0; i < this.textures.length; i++) {
          const texture = this.textures[i];
          texture.setValues(values);
        }
      }
      /**
       * The texture representing the default color attachment.
       *
       * @type {Texture}
       */
      get texture() {
        return this.textures[0];
      }
      set texture(value) {
        this.textures[0] = value;
      }
      set depthTexture(current) {
        if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
        if (current !== null) current.renderTarget = this;
        this._depthTexture = current;
      }
      /**
       * Instead of saving the depth in a renderbuffer, a texture
       * can be used instead which is useful for further processing
       * e.g. in context of post-processing.
       *
       * @type {?DepthTexture}
       * @default null
       */
      get depthTexture() {
        return this._depthTexture;
      }
      /**
       * Sets the size of this render target.
       *
       * @param {number} width - The width.
       * @param {number} height - The height.
       * @param {number} [depth=1] - The depth.
       */
      setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
          this.width = width;
          this.height = height;
          this.depth = depth;
          for (let i = 0, il = this.textures.length; i < il; i++) {
            this.textures[i].image.width = width;
            this.textures[i].image.height = height;
            this.textures[i].image.depth = depth;
            this.textures[i].isArrayTexture = this.textures[i].image.depth > 1;
          }
          this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
      }
      /**
       * Returns a new render target with copied values from this instance.
       *
       * @return {RenderTarget} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
      /**
       * Copies the settings of the given render target. This is a structural copy so
       * no resources are shared between render targets after the copy. That includes
       * all MRT textures and the depth texture.
       *
       * @param {RenderTarget} source - The render target to copy.
       * @return {RenderTarget} A reference to this instance.
       */
      copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for (let i = 0, il = source.textures.length; i < il; i++) {
          this.textures[i] = source.textures[i].clone();
          this.textures[i].isRenderTargetTexture = true;
          this.textures[i].renderTarget = this;
          const image = Object.assign({}, source.textures[i].image);
          this.textures[i].source = new Source(image);
        }
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
      }
      /**
       * Frees the GPU-related resources allocated by this instance. Call this
       * method whenever this instance is no longer used in your app.
       *
       * @fires RenderTarget#dispose
       */
      dispose() {
        this.dispatchEvent({ type: "dispose" });
      }
    };
    WebGLRenderTarget = class extends RenderTarget {
      /**
       * Constructs a new 3D render target.
       *
       * @param {number} [width=1] - The width of the render target.
       * @param {number} [height=1] - The height of the render target.
       * @param {RenderTarget~Options} [options] - The configuration object.
       */
      constructor(width = 1, height = 1, options = {}) {
        super(width, height, options);
        this.isWebGLRenderTarget = true;
      }
    };
    DataArrayTexture = class extends Texture {
      /**
       * Constructs a new data array texture.
       *
       * @param {?TypedArray} [data=null] - The buffer data.
       * @param {number} [width=1] - The width of the texture.
       * @param {number} [height=1] - The height of the texture.
       * @param {number} [depth=1] - The depth of the texture.
       */
      constructor(data = null, width = 1, height = 1, depth = 1) {
        super(null);
        this.isDataArrayTexture = true;
        this.image = { data, width, height, depth };
        this.magFilter = NearestFilter;
        this.minFilter = NearestFilter;
        this.wrapR = ClampToEdgeWrapping;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.layerUpdates = /* @__PURE__ */ new Set();
      }
      /**
       * Describes that a specific layer of the texture needs to be updated.
       * Normally when {@link Texture#needsUpdate} is set to `true`, the
       * entire data texture array is sent to the GPU. Marking specific
       * layers will only transmit subsets of all mipmaps associated with a
       * specific depth in the array which is often much more performant.
       *
       * @param {number} layerIndex - The layer index that should be updated.
       */
      addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
      }
      /**
       * Resets the layer updates registry.
       */
      clearLayerUpdates() {
        this.layerUpdates.clear();
      }
    };
    Data3DTexture = class extends Texture {
      /**
       * Constructs a new data array texture.
       *
       * @param {?TypedArray} [data=null] - The buffer data.
       * @param {number} [width=1] - The width of the texture.
       * @param {number} [height=1] - The height of the texture.
       * @param {number} [depth=1] - The depth of the texture.
       */
      constructor(data = null, width = 1, height = 1, depth = 1) {
        super(null);
        this.isData3DTexture = true;
        this.image = { data, width, height, depth };
        this.magFilter = NearestFilter;
        this.minFilter = NearestFilter;
        this.wrapR = ClampToEdgeWrapping;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
      }
    };
    Box3 = class {
      /**
       * Constructs a new bounding box.
       *
       * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
       * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
       */
      constructor(min = new Vector3(Infinity, Infinity, Infinity), max = new Vector3(-Infinity, -Infinity, -Infinity)) {
        this.isBox3 = true;
        this.min = min;
        this.max = max;
      }
      /**
       * Sets the lower and upper boundaries of this box.
       * Please note that this method only copies the values from the given objects.
       *
       * @param {Vector3} min - The lower boundary of the box.
       * @param {Vector3} max - The upper boundary of the box.
       * @return {Box3} A reference to this bounding box.
       */
      set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
      }
      /**
       * Sets the upper and lower bounds of this box so it encloses the position data
       * in the given array.
       *
       * @param {Array<number>} array - An array holding 3D position data.
       * @return {Box3} A reference to this bounding box.
       */
      setFromArray(array) {
        this.makeEmpty();
        for (let i = 0, il = array.length; i < il; i += 3) {
          this.expandByPoint(_vector$b.fromArray(array, i));
        }
        return this;
      }
      /**
       * Sets the upper and lower bounds of this box so it encloses the position data
       * in the given buffer attribute.
       *
       * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
       * @return {Box3} A reference to this bounding box.
       */
      setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for (let i = 0, il = attribute.count; i < il; i++) {
          this.expandByPoint(_vector$b.fromBufferAttribute(attribute, i));
        }
        return this;
      }
      /**
       * Sets the upper and lower bounds of this box so it encloses the position data
       * in the given array.
       *
       * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
       * @return {Box3} A reference to this bounding box.
       */
      setFromPoints(points) {
        this.makeEmpty();
        for (let i = 0, il = points.length; i < il; i++) {
          this.expandByPoint(points[i]);
        }
        return this;
      }
      /**
       * Centers this box on the given center vector and sets this box's width, height and
       * depth to the given size values.
       *
       * @param {Vector3} center - The center of the box.
       * @param {Vector3} size - The x, y and z dimensions of the box.
       * @return {Box3} A reference to this bounding box.
       */
      setFromCenterAndSize(center, size) {
        const halfSize = _vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
      }
      /**
       * Computes the world-axis-aligned bounding box for the given 3D object
       * (including its children), accounting for the object's, and children's,
       * world transforms. The function may result in a larger box than strictly necessary.
       *
       * @param {Object3D} object - The 3D object to compute the bounding box for.
       * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
       * world-axis-aligned bounding box at the expense of more computation.
       * @return {Box3} A reference to this bounding box.
       */
      setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
      }
      /**
       * Returns a new box with copied values from this instance.
       *
       * @return {Box3} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
      /**
       * Copies the values of the given box to this instance.
       *
       * @param {Box3} box - The box to copy.
       * @return {Box3} A reference to this bounding box.
       */
      copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
      }
      /**
       * Makes this box empty which means in encloses a zero space in 3D.
       *
       * @return {Box3} A reference to this bounding box.
       */
      makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
      }
      /**
       * Returns true if this box includes zero points within its bounds.
       * Note that a box with equal lower and upper bounds still includes one
       * point, the one both bounds share.
       *
       * @return {boolean} Whether this box is empty or not.
       */
      isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
      }
      /**
       * Returns the center point of this box.
       *
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The center point.
       */
      getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
      }
      /**
       * Returns the dimensions of this box.
       *
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The size.
       */
      getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
      }
      /**
       * Expands the boundaries of this box to include the given point.
       *
       * @param {Vector3} point - The point that should be included by the bounding box.
       * @return {Box3} A reference to this bounding box.
       */
      expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
      }
      /**
       * Expands this box equilaterally by the given vector. The width of this
       * box will be expanded by the x component of the vector in both
       * directions. The height of this box will be expanded by the y component of
       * the vector in both directions. The depth of this box will be
       * expanded by the z component of the vector in both directions.
       *
       * @param {Vector3} vector - The vector that should expand the bounding box.
       * @return {Box3} A reference to this bounding box.
       */
      expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
      }
      /**
       * Expands each dimension of the box by the given scalar. If negative, the
       * dimensions of the box will be contracted.
       *
       * @param {number} scalar - The scalar value that should expand the bounding box.
       * @return {Box3} A reference to this bounding box.
       */
      expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
      }
      /**
       * Expands the boundaries of this box to include the given 3D object and
       * its children, accounting for the object's, and children's, world
       * transforms. The function may result in a larger box than strictly
       * necessary (unless the precise parameter is set to true).
       *
       * @param {Object3D} object - The 3D object that should expand the bounding box.
       * @param {boolean} precise - If set to `true`, the method expands the bounding box
       * as little as necessary at the expense of more computation.
       * @return {Box3} A reference to this bounding box.
       */
      expandByObject(object, precise = false) {
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== void 0) {
          const positionAttribute = geometry.getAttribute("position");
          if (precise === true && positionAttribute !== void 0 && object.isInstancedMesh !== true) {
            for (let i = 0, l = positionAttribute.count; i < l; i++) {
              if (object.isMesh === true) {
                object.getVertexPosition(i, _vector$b);
              } else {
                _vector$b.fromBufferAttribute(positionAttribute, i);
              }
              _vector$b.applyMatrix4(object.matrixWorld);
              this.expandByPoint(_vector$b);
            }
          } else {
            if (object.boundingBox !== void 0) {
              if (object.boundingBox === null) {
                object.computeBoundingBox();
              }
              _box$4.copy(object.boundingBox);
            } else {
              if (geometry.boundingBox === null) {
                geometry.computeBoundingBox();
              }
              _box$4.copy(geometry.boundingBox);
            }
            _box$4.applyMatrix4(object.matrixWorld);
            this.union(_box$4);
          }
        }
        const children = object.children;
        for (let i = 0, l = children.length; i < l; i++) {
          this.expandByObject(children[i], precise);
        }
        return this;
      }
      /**
       * Returns `true` if the given point lies within or on the boundaries of this box.
       *
       * @param {Vector3} point - The point to test.
       * @return {boolean} Whether the bounding box contains the given point or not.
       */
      containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
      }
      /**
       * Returns `true` if this bounding box includes the entirety of the given bounding box.
       * If this box and the given one are identical, this function also returns `true`.
       *
       * @param {Box3} box - The bounding box to test.
       * @return {boolean} Whether the bounding box contains the given bounding box or not.
       */
      containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
      }
      /**
       * Returns a point as a proportion of this box's width, height and depth.
       *
       * @param {Vector3} point - A point in 3D space.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} A point as a proportion of this box's width, height and depth.
       */
      getParameter(point, target) {
        return target.set(
          (point.x - this.min.x) / (this.max.x - this.min.x),
          (point.y - this.min.y) / (this.max.y - this.min.y),
          (point.z - this.min.z) / (this.max.z - this.min.z)
        );
      }
      /**
       * Returns `true` if the given bounding box intersects with this bounding box.
       *
       * @param {Box3} box - The bounding box to test.
       * @return {boolean} Whether the given bounding box intersects with this bounding box.
       */
      intersectsBox(box) {
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
      }
      /**
       * Returns `true` if the given bounding sphere intersects with this bounding box.
       *
       * @param {Sphere} sphere - The bounding sphere to test.
       * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
       */
      intersectsSphere(sphere) {
        this.clampPoint(sphere.center, _vector$b);
        return _vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
      }
      /**
       * Returns `true` if the given plane intersects with this bounding box.
       *
       * @param {Plane} plane - The plane to test.
       * @return {boolean} Whether the given plane intersects with this bounding box.
       */
      intersectsPlane(plane) {
        let min, max;
        if (plane.normal.x > 0) {
          min = plane.normal.x * this.min.x;
          max = plane.normal.x * this.max.x;
        } else {
          min = plane.normal.x * this.max.x;
          max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
          min += plane.normal.y * this.min.y;
          max += plane.normal.y * this.max.y;
        } else {
          min += plane.normal.y * this.max.y;
          max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
          min += plane.normal.z * this.min.z;
          max += plane.normal.z * this.max.z;
        } else {
          min += plane.normal.z * this.max.z;
          max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
      }
      /**
       * Returns `true` if the given triangle intersects with this bounding box.
       *
       * @param {Triangle} triangle - The triangle to test.
       * @return {boolean} Whether the given triangle intersects with this bounding box.
       */
      intersectsTriangle(triangle) {
        if (this.isEmpty()) {
          return false;
        }
        this.getCenter(_center);
        _extents.subVectors(this.max, _center);
        _v0$2.subVectors(triangle.a, _center);
        _v1$7.subVectors(triangle.b, _center);
        _v2$4.subVectors(triangle.c, _center);
        _f0.subVectors(_v1$7, _v0$2);
        _f1.subVectors(_v2$4, _v1$7);
        _f2.subVectors(_v0$2, _v2$4);
        let axes = [
          0,
          -_f0.z,
          _f0.y,
          0,
          -_f1.z,
          _f1.y,
          0,
          -_f2.z,
          _f2.y,
          _f0.z,
          0,
          -_f0.x,
          _f1.z,
          0,
          -_f1.x,
          _f2.z,
          0,
          -_f2.x,
          -_f0.y,
          _f0.x,
          0,
          -_f1.y,
          _f1.x,
          0,
          -_f2.y,
          _f2.x,
          0
        ];
        if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {
          return false;
        }
        axes = [1, 0, 0, 0, 1, 0, 0, 0, 1];
        if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {
          return false;
        }
        _triangleNormal.crossVectors(_f0, _f1);
        axes = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z];
        return satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents);
      }
      /**
       * Clamps the given point within the bounds of this box.
       *
       * @param {Vector3} point - The point to clamp.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The clamped point.
       */
      clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
      }
      /**
       * Returns the euclidean distance from any edge of this box to the specified point. If
       * the given point lies inside of this box, the distance will be `0`.
       *
       * @param {Vector3} point - The point to compute the distance to.
       * @return {number} The euclidean distance.
       */
      distanceToPoint(point) {
        return this.clampPoint(point, _vector$b).distanceTo(point);
      }
      /**
       * Returns a bounding sphere that encloses this bounding box.
       *
       * @param {Sphere} target - The target sphere that is used to store the method's result.
       * @return {Sphere} The bounding sphere that encloses this bounding box.
       */
      getBoundingSphere(target) {
        if (this.isEmpty()) {
          target.makeEmpty();
        } else {
          this.getCenter(target.center);
          target.radius = this.getSize(_vector$b).length() * 0.5;
        }
        return target;
      }
      /**
       * Computes the intersection of this bounding box and the given one, setting the upper
       * bound of this box to the lesser of the two boxes' upper bounds and the
       * lower bound of this box to the greater of the two boxes' lower bounds. If
       * there's no overlap, makes this box empty.
       *
       * @param {Box3} box - The bounding box to intersect with.
       * @return {Box3} A reference to this bounding box.
       */
      intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
      }
      /**
       * Computes the union of this box and another and the given one, setting the upper
       * bound of this box to the greater of the two boxes' upper bounds and the
       * lower bound of this box to the lesser of the two boxes' lower bounds.
       *
       * @param {Box3} box - The bounding box that will be unioned with this instance.
       * @return {Box3} A reference to this bounding box.
       */
      union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
      }
      /**
       * Transforms this bounding box by the given 4x4 transformation matrix.
       *
       * @param {Matrix4} matrix - The transformation matrix.
       * @return {Box3} A reference to this bounding box.
       */
      applyMatrix4(matrix) {
        if (this.isEmpty()) return this;
        _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix);
        _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix);
        _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix);
        _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix);
        _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix);
        _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix);
        _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix);
        _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix);
        this.setFromPoints(_points);
        return this;
      }
      /**
       * Adds the given offset to both the upper and lower bounds of this bounding box,
       * effectively moving it in 3D space.
       *
       * @param {Vector3} offset - The offset that should be used to translate the bounding box.
       * @return {Box3} A reference to this bounding box.
       */
      translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
      }
      /**
       * Returns `true` if this bounding box is equal with the given one.
       *
       * @param {Box3} box - The box to test for equality.
       * @return {boolean} Whether this bounding box is equal with the given one.
       */
      equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
      }
      /**
       * Returns a serialized structure of the bounding box.
       *
       * @return {Object} Serialized structure with fields representing the object state.
       */
      toJSON() {
        return {
          min: this.min.toArray(),
          max: this.max.toArray()
        };
      }
      /**
       * Returns a serialized structure of the bounding box.
       *
       * @param {Object} json - The serialized json to set the box from.
       * @return {Box3} A reference to this bounding box.
       */
      fromJSON(json) {
        this.min.fromArray(json.min);
        this.max.fromArray(json.max);
        return this;
      }
    };
    _points = [
      /* @__PURE__ */ new Vector3(),
      /* @__PURE__ */ new Vector3(),
      /* @__PURE__ */ new Vector3(),
      /* @__PURE__ */ new Vector3(),
      /* @__PURE__ */ new Vector3(),
      /* @__PURE__ */ new Vector3(),
      /* @__PURE__ */ new Vector3(),
      /* @__PURE__ */ new Vector3()
    ];
    _vector$b = /* @__PURE__ */ new Vector3();
    _box$4 = /* @__PURE__ */ new Box3();
    _v0$2 = /* @__PURE__ */ new Vector3();
    _v1$7 = /* @__PURE__ */ new Vector3();
    _v2$4 = /* @__PURE__ */ new Vector3();
    _f0 = /* @__PURE__ */ new Vector3();
    _f1 = /* @__PURE__ */ new Vector3();
    _f2 = /* @__PURE__ */ new Vector3();
    _center = /* @__PURE__ */ new Vector3();
    _extents = /* @__PURE__ */ new Vector3();
    _triangleNormal = /* @__PURE__ */ new Vector3();
    _testAxis = /* @__PURE__ */ new Vector3();
    _box$3 = /* @__PURE__ */ new Box3();
    _v1$6 = /* @__PURE__ */ new Vector3();
    _v2$3 = /* @__PURE__ */ new Vector3();
    Sphere = class {
      /**
       * Constructs a new sphere.
       *
       * @param {Vector3} [center=(0,0,0)] - The center of the sphere
       * @param {number} [radius=-1] - The radius of the sphere.
       */
      constructor(center = new Vector3(), radius = -1) {
        this.isSphere = true;
        this.center = center;
        this.radius = radius;
      }
      /**
       * Sets the sphere's components by copying the given values.
       *
       * @param {Vector3} center - The center.
       * @param {number} radius - The radius.
       * @return {Sphere} A reference to this sphere.
       */
      set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
      }
      /**
       * Computes the minimum bounding sphere for list of points.
       * If the optional center point is given, it is used as the sphere's
       * center. Otherwise, the center of the axis-aligned bounding box
       * encompassing the points is calculated.
       *
       * @param {Array<Vector3>} points - A list of points in 3D space.
       * @param {Vector3} [optionalCenter] - The center of the sphere.
       * @return {Sphere} A reference to this sphere.
       */
      setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== void 0) {
          center.copy(optionalCenter);
        } else {
          _box$3.setFromPoints(points).getCenter(center);
        }
        let maxRadiusSq = 0;
        for (let i = 0, il = points.length; i < il; i++) {
          maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        }
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
      }
      /**
       * Copies the values of the given sphere to this instance.
       *
       * @param {Sphere} sphere - The sphere to copy.
       * @return {Sphere} A reference to this sphere.
       */
      copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
      }
      /**
       * Returns `true` if the sphere is empty (the radius set to a negative number).
       *
       * Spheres with a radius of `0` contain only their center point and are not
       * considered to be empty.
       *
       * @return {boolean} Whether this sphere is empty or not.
       */
      isEmpty() {
        return this.radius < 0;
      }
      /**
       * Makes this sphere empty which means in encloses a zero space in 3D.
       *
       * @return {Sphere} A reference to this sphere.
       */
      makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
      }
      /**
       * Returns `true` if this sphere contains the given point inclusive of
       * the surface of the sphere.
       *
       * @param {Vector3} point - The point to check.
       * @return {boolean} Whether this sphere contains the given point or not.
       */
      containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
      }
      /**
       * Returns the closest distance from the boundary of the sphere to the
       * given point. If the sphere contains the point, the distance will
       * be negative.
       *
       * @param {Vector3} point - The point to compute the distance to.
       * @return {number} The distance to the point.
       */
      distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
      }
      /**
       * Returns `true` if this sphere intersects with the given one.
       *
       * @param {Sphere} sphere - The sphere to test.
       * @return {boolean} Whether this sphere intersects with the given one or not.
       */
      intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
      }
      /**
       * Returns `true` if this sphere intersects with the given box.
       *
       * @param {Box3} box - The box to test.
       * @return {boolean} Whether this sphere intersects with the given box or not.
       */
      intersectsBox(box) {
        return box.intersectsSphere(this);
      }
      /**
       * Returns `true` if this sphere intersects with the given plane.
       *
       * @param {Plane} plane - The plane to test.
       * @return {boolean} Whether this sphere intersects with the given plane or not.
       */
      intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
      }
      /**
       * Clamps a point within the sphere. If the point is outside the sphere, it
       * will clamp it to the closest point on the edge of the sphere. Points
       * already inside the sphere will not be affected.
       *
       * @param {Vector3} point - The plane to clamp.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The clamped point.
       */
      clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
          target.sub(this.center).normalize();
          target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
      }
      /**
       * Returns a bounding box that encloses this sphere.
       *
       * @param {Box3} target - The target box that is used to store the method's result.
       * @return {Box3} The bounding box that encloses this sphere.
       */
      getBoundingBox(target) {
        if (this.isEmpty()) {
          target.makeEmpty();
          return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
      }
      /**
       * Transforms this sphere with the given 4x4 transformation matrix.
       *
       * @param {Matrix4} matrix - The transformation matrix.
       * @return {Sphere} A reference to this sphere.
       */
      applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
      }
      /**
       * Translates the sphere's center by the given offset.
       *
       * @param {Vector3} offset - The offset.
       * @return {Sphere} A reference to this sphere.
       */
      translate(offset) {
        this.center.add(offset);
        return this;
      }
      /**
       * Expands the boundaries of this sphere to include the given point.
       *
       * @param {Vector3} point - The point to include.
       * @return {Sphere} A reference to this sphere.
       */
      expandByPoint(point) {
        if (this.isEmpty()) {
          this.center.copy(point);
          this.radius = 0;
          return this;
        }
        _v1$6.subVectors(point, this.center);
        const lengthSq = _v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
          const length = Math.sqrt(lengthSq);
          const delta = (length - this.radius) * 0.5;
          this.center.addScaledVector(_v1$6, delta / length);
          this.radius += delta;
        }
        return this;
      }
      /**
       * Expands this sphere to enclose both the original sphere and the given sphere.
       *
       * @param {Sphere} sphere - The sphere to include.
       * @return {Sphere} A reference to this sphere.
       */
      union(sphere) {
        if (sphere.isEmpty()) {
          return this;
        }
        if (this.isEmpty()) {
          this.copy(sphere);
          return this;
        }
        if (this.center.equals(sphere.center) === true) {
          this.radius = Math.max(this.radius, sphere.radius);
        } else {
          _v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
          this.expandByPoint(_v1$6.copy(sphere.center).add(_v2$3));
          this.expandByPoint(_v1$6.copy(sphere.center).sub(_v2$3));
        }
        return this;
      }
      /**
       * Returns `true` if this sphere is equal with the given one.
       *
       * @param {Sphere} sphere - The sphere to test for equality.
       * @return {boolean} Whether this bounding sphere is equal with the given one.
       */
      equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
      }
      /**
       * Returns a new sphere with copied values from this instance.
       *
       * @return {Sphere} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
      /**
       * Returns a serialized structure of the bounding sphere.
       *
       * @return {Object} Serialized structure with fields representing the object state.
       */
      toJSON() {
        return {
          radius: this.radius,
          center: this.center.toArray()
        };
      }
      /**
       * Returns a serialized structure of the bounding sphere.
       *
       * @param {Object} json - The serialized json to set the sphere from.
       * @return {Box3} A reference to this bounding sphere.
       */
      fromJSON(json) {
        this.radius = json.radius;
        this.center.fromArray(json.center);
        return this;
      }
    };
    _vector$a = /* @__PURE__ */ new Vector3();
    _segCenter = /* @__PURE__ */ new Vector3();
    _segDir = /* @__PURE__ */ new Vector3();
    _diff = /* @__PURE__ */ new Vector3();
    _edge1 = /* @__PURE__ */ new Vector3();
    _edge2 = /* @__PURE__ */ new Vector3();
    _normal$1 = /* @__PURE__ */ new Vector3();
    Ray = class {
      /**
       * Constructs a new ray.
       *
       * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
       * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
       */
      constructor(origin = new Vector3(), direction = new Vector3(0, 0, -1)) {
        this.origin = origin;
        this.direction = direction;
      }
      /**
       * Sets the ray's components by copying the given values.
       *
       * @param {Vector3} origin - The origin.
       * @param {Vector3} direction - The direction.
       * @return {Ray} A reference to this ray.
       */
      set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
      }
      /**
       * Copies the values of the given ray to this instance.
       *
       * @param {Ray} ray - The ray to copy.
       * @return {Ray} A reference to this ray.
       */
      copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
      }
      /**
       * Returns a vector that is located at a given distance along this ray.
       *
       * @param {number} t - The distance along the ray to retrieve a position for.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} A position on the ray.
       */
      at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
      }
      /**
       * Adjusts the direction of the ray to point at the given vector in world space.
       *
       * @param {Vector3} v - The target position.
       * @return {Ray} A reference to this ray.
       */
      lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
      }
      /**
       * Shift the origin of this ray along its direction by the given distance.
       *
       * @param {number} t - The distance along the ray to interpolate.
       * @return {Ray} A reference to this ray.
       */
      recast(t) {
        this.origin.copy(this.at(t, _vector$a));
        return this;
      }
      /**
       * Returns the point along this ray that is closest to the given point.
       *
       * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The closest point on this ray.
       */
      closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) {
          return target.copy(this.origin);
        }
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
      }
      /**
       * Returns the distance of the closest approach between this ray and the given point.
       *
       * @param {Vector3} point - A point in 3D space to compute the distance to.
       * @return {number} The distance.
       */
      distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
      }
      /**
       * Returns the squared distance of the closest approach between this ray and the given point.
       *
       * @param {Vector3} point - A point in 3D space to compute the distance to.
       * @return {number} The squared distance.
       */
      distanceSqToPoint(point) {
        const directionDistance = _vector$a.subVectors(point, this.origin).dot(this.direction);
        if (directionDistance < 0) {
          return this.origin.distanceToSquared(point);
        }
        _vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return _vector$a.distanceToSquared(point);
      }
      /**
       * Returns the squared distance between this ray and the given line segment.
       *
       * @param {Vector3} v0 - The start point of the line segment.
       * @param {Vector3} v1 - The end point of the line segment.
       * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
       * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
       * @return {number} The squared distance.
       */
      distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        _segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        _segDir.copy(v1).sub(v0).normalize();
        _diff.copy(this.origin).sub(_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot(_segDir);
        const b0 = _diff.dot(this.direction);
        const b1 = -_diff.dot(_segDir);
        const c = _diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
          s0 = a01 * b1 - b0;
          s1 = a01 * b0 - b1;
          extDet = segExtent * det;
          if (s0 >= 0) {
            if (s1 >= -extDet) {
              if (s1 <= extDet) {
                const invDet = 1 / det;
                s0 *= invDet;
                s1 *= invDet;
                sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
              } else {
                s1 = segExtent;
                s0 = Math.max(0, -(a01 * s1 + b0));
                sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
              }
            } else {
              s1 = -segExtent;
              s0 = Math.max(0, -(a01 * s1 + b0));
              sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
            }
          } else {
            if (s1 <= -extDet) {
              s0 = Math.max(0, -(-a01 * segExtent + b0));
              s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
              sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
            } else if (s1 <= extDet) {
              s0 = 0;
              s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
              sqrDist = s1 * (s1 + 2 * b1) + c;
            } else {
              s0 = Math.max(0, -(a01 * segExtent + b0));
              s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
              sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
            }
          }
        } else {
          s1 = a01 > 0 ? -segExtent : segExtent;
          s0 = Math.max(0, -(a01 * s1 + b0));
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) {
          optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        }
        if (optionalPointOnSegment) {
          optionalPointOnSegment.copy(_segCenter).addScaledVector(_segDir, s1);
        }
        return sqrDist;
      }
      /**
       * Intersects this ray with the given sphere, returning the intersection
       * point or `null` if there is no intersection.
       *
       * @param {Sphere} sphere - The sphere to intersect.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {?Vector3} The intersection point.
       */
      intersectSphere(sphere, target) {
        _vector$a.subVectors(sphere.center, this.origin);
        const tca = _vector$a.dot(this.direction);
        const d2 = _vector$a.dot(_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        const t0 = tca - thc;
        const t1 = tca + thc;
        if (t1 < 0) return null;
        if (t0 < 0) return this.at(t1, target);
        return this.at(t0, target);
      }
      /**
       * Returns `true` if this ray intersects with the given sphere.
       *
       * @param {Sphere} sphere - The sphere to intersect.
       * @return {boolean} Whether this ray intersects with the given sphere or not.
       */
      intersectsSphere(sphere) {
        if (sphere.radius < 0) return false;
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
      }
      /**
       * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
       * does not intersect with the plane.
       *
       * @param {Plane} plane - The plane to compute the distance to.
       * @return {?number} Whether this ray intersects with the given sphere or not.
       */
      distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
          if (plane.distanceToPoint(this.origin) === 0) {
            return 0;
          }
          return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        return t >= 0 ? t : null;
      }
      /**
       * Intersects this ray with the given plane, returning the intersection
       * point or `null` if there is no intersection.
       *
       * @param {Plane} plane - The plane to intersect.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {?Vector3} The intersection point.
       */
      intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) {
          return null;
        }
        return this.at(t, target);
      }
      /**
       * Returns `true` if this ray intersects with the given plane.
       *
       * @param {Plane} plane - The plane to intersect.
       * @return {boolean} Whether this ray intersects with the given plane or not.
       */
      intersectsPlane(plane) {
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) {
          return true;
        }
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) {
          return true;
        }
        return false;
      }
      /**
       * Intersects this ray with the given bounding box, returning the intersection
       * point or `null` if there is no intersection.
       *
       * @param {Box3} box - The box to intersect.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {?Vector3} The intersection point.
       */
      intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
          tmin = (box.min.x - origin.x) * invdirx;
          tmax = (box.max.x - origin.x) * invdirx;
        } else {
          tmin = (box.max.x - origin.x) * invdirx;
          tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
          tymin = (box.min.y - origin.y) * invdiry;
          tymax = (box.max.y - origin.y) * invdiry;
        } else {
          tymin = (box.max.y - origin.y) * invdiry;
          tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
          tzmin = (box.min.z - origin.z) * invdirz;
          tzmax = (box.max.z - origin.z) * invdirz;
        } else {
          tzmin = (box.max.z - origin.z) * invdirz;
          tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
      }
      /**
       * Returns `true` if this ray intersects with the given box.
       *
       * @param {Box3} box - The box to intersect.
       * @return {boolean} Whether this ray intersects with the given box or not.
       */
      intersectsBox(box) {
        return this.intersectBox(box, _vector$a) !== null;
      }
      /**
       * Intersects this ray with the given triangle, returning the intersection
       * point or `null` if there is no intersection.
       *
       * @param {Vector3} a - The first vertex of the triangle.
       * @param {Vector3} b - The second vertex of the triangle.
       * @param {Vector3} c - The third vertex of the triangle.
       * @param {boolean} backfaceCulling - Whether to use backface culling or not.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {?Vector3} The intersection point.
       */
      intersectTriangle(a, b, c, backfaceCulling, target) {
        _edge1.subVectors(b, a);
        _edge2.subVectors(c, a);
        _normal$1.crossVectors(_edge1, _edge2);
        let DdN = this.direction.dot(_normal$1);
        let sign;
        if (DdN > 0) {
          if (backfaceCulling) return null;
          sign = 1;
        } else if (DdN < 0) {
          sign = -1;
          DdN = -DdN;
        } else {
          return null;
        }
        _diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
        if (DdQxE2 < 0) {
          return null;
        }
        const DdE1xQ = sign * this.direction.dot(_edge1.cross(_diff));
        if (DdE1xQ < 0) {
          return null;
        }
        if (DdQxE2 + DdE1xQ > DdN) {
          return null;
        }
        const QdN = -sign * _diff.dot(_normal$1);
        if (QdN < 0) {
          return null;
        }
        return this.at(QdN / DdN, target);
      }
      /**
       * Transforms this ray with the given 4x4 transformation matrix.
       *
       * @param {Matrix4} matrix4 - The transformation matrix.
       * @return {Ray} A reference to this ray.
       */
      applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
      }
      /**
       * Returns `true` if this ray is equal with the given one.
       *
       * @param {Ray} ray - The ray to test for equality.
       * @return {boolean} Whether this ray is equal with the given one.
       */
      equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
      }
      /**
       * Returns a new ray with copied values from this instance.
       *
       * @return {Ray} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
    };
    Matrix4 = class _Matrix4 {
      /**
       * Constructs a new 4x4 matrix. The arguments are supposed to be
       * in row-major order. If no arguments are provided, the constructor
       * initializes the matrix as an identity matrix.
       *
       * @param {number} [n11] - 1-1 matrix element.
       * @param {number} [n12] - 1-2 matrix element.
       * @param {number} [n13] - 1-3 matrix element.
       * @param {number} [n14] - 1-4 matrix element.
       * @param {number} [n21] - 2-1 matrix element.
       * @param {number} [n22] - 2-2 matrix element.
       * @param {number} [n23] - 2-3 matrix element.
       * @param {number} [n24] - 2-4 matrix element.
       * @param {number} [n31] - 3-1 matrix element.
       * @param {number} [n32] - 3-2 matrix element.
       * @param {number} [n33] - 3-3 matrix element.
       * @param {number} [n34] - 3-4 matrix element.
       * @param {number} [n41] - 4-1 matrix element.
       * @param {number} [n42] - 4-2 matrix element.
       * @param {number} [n43] - 4-3 matrix element.
       * @param {number} [n44] - 4-4 matrix element.
       */
      constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        _Matrix4.prototype.isMatrix4 = true;
        this.elements = [
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1
        ];
        if (n11 !== void 0) {
          this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
        }
      }
      /**
       * Sets the elements of the matrix.The arguments are supposed to be
       * in row-major order.
       *
       * @param {number} [n11] - 1-1 matrix element.
       * @param {number} [n12] - 1-2 matrix element.
       * @param {number} [n13] - 1-3 matrix element.
       * @param {number} [n14] - 1-4 matrix element.
       * @param {number} [n21] - 2-1 matrix element.
       * @param {number} [n22] - 2-2 matrix element.
       * @param {number} [n23] - 2-3 matrix element.
       * @param {number} [n24] - 2-4 matrix element.
       * @param {number} [n31] - 3-1 matrix element.
       * @param {number} [n32] - 3-2 matrix element.
       * @param {number} [n33] - 3-3 matrix element.
       * @param {number} [n34] - 3-4 matrix element.
       * @param {number} [n41] - 4-1 matrix element.
       * @param {number} [n42] - 4-2 matrix element.
       * @param {number} [n43] - 4-3 matrix element.
       * @param {number} [n44] - 4-4 matrix element.
       * @return {Matrix4} A reference to this matrix.
       */
      set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
      }
      /**
       * Sets this matrix to the 4x4 identity matrix.
       *
       * @return {Matrix4} A reference to this matrix.
       */
      identity() {
        this.set(
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Returns a matrix with copied values from this instance.
       *
       * @return {Matrix4} A clone of this instance.
       */
      clone() {
        return new _Matrix4().fromArray(this.elements);
      }
      /**
       * Copies the values of the given matrix to this instance.
       *
       * @param {Matrix4} m - The matrix to copy.
       * @return {Matrix4} A reference to this matrix.
       */
      copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
      }
      /**
       * Copies the translation component of the given matrix
       * into this matrix's translation component.
       *
       * @param {Matrix4} m - The matrix to copy the translation component.
       * @return {Matrix4} A reference to this matrix.
       */
      copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
      }
      /**
       * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
       *
       * @param {Matrix3} m - The 3x3 matrix.
       * @return {Matrix4} A reference to this matrix.
       */
      setFromMatrix3(m) {
        const me = m.elements;
        this.set(
          me[0],
          me[3],
          me[6],
          0,
          me[1],
          me[4],
          me[7],
          0,
          me[2],
          me[5],
          me[8],
          0,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Extracts the basis of this matrix into the three axis vectors provided.
       *
       * @param {Vector3} xAxis - The basis's x axis.
       * @param {Vector3} yAxis - The basis's y axis.
       * @param {Vector3} zAxis - The basis's z axis.
       * @return {Matrix4} A reference to this matrix.
       */
      extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
      }
      /**
       * Sets the given basis vectors to this matrix.
       *
       * @param {Vector3} xAxis - The basis's x axis.
       * @param {Vector3} yAxis - The basis's y axis.
       * @param {Vector3} zAxis - The basis's z axis.
       * @return {Matrix4} A reference to this matrix.
       */
      makeBasis(xAxis, yAxis, zAxis) {
        this.set(
          xAxis.x,
          yAxis.x,
          zAxis.x,
          0,
          xAxis.y,
          yAxis.y,
          zAxis.y,
          0,
          xAxis.z,
          yAxis.z,
          zAxis.z,
          0,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Extracts the rotation component of the given matrix
       * into this matrix's rotation component.
       *
       * Note: This method does not support reflection matrices.
       *
       * @param {Matrix4} m - The matrix.
       * @return {Matrix4} A reference to this matrix.
       */
      extractRotation(m) {
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / _v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / _v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / _v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
      }
      /**
       * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
       * the rotation specified by the given Euler angles. The rest of
       * the matrix is set to the identity. Depending on the {@link Euler#order},
       * there are six possible outcomes. See [this page]{@link https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix}
       * for a complete list.
       *
       * @param {Euler} euler - The Euler angles.
       * @return {Matrix4} A reference to this matrix.
       */
      makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
          const ae = a * e, af = a * f, be = b * e, bf = b * f;
          te[0] = c * e;
          te[4] = -c * f;
          te[8] = d;
          te[1] = af + be * d;
          te[5] = ae - bf * d;
          te[9] = -b * c;
          te[2] = bf - ae * d;
          te[6] = be + af * d;
          te[10] = a * c;
        } else if (euler.order === "YXZ") {
          const ce = c * e, cf = c * f, de = d * e, df = d * f;
          te[0] = ce + df * b;
          te[4] = de * b - cf;
          te[8] = a * d;
          te[1] = a * f;
          te[5] = a * e;
          te[9] = -b;
          te[2] = cf * b - de;
          te[6] = df + ce * b;
          te[10] = a * c;
        } else if (euler.order === "ZXY") {
          const ce = c * e, cf = c * f, de = d * e, df = d * f;
          te[0] = ce - df * b;
          te[4] = -a * f;
          te[8] = de + cf * b;
          te[1] = cf + de * b;
          te[5] = a * e;
          te[9] = df - ce * b;
          te[2] = -a * d;
          te[6] = b;
          te[10] = a * c;
        } else if (euler.order === "ZYX") {
          const ae = a * e, af = a * f, be = b * e, bf = b * f;
          te[0] = c * e;
          te[4] = be * d - af;
          te[8] = ae * d + bf;
          te[1] = c * f;
          te[5] = bf * d + ae;
          te[9] = af * d - be;
          te[2] = -d;
          te[6] = b * c;
          te[10] = a * c;
        } else if (euler.order === "YZX") {
          const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
          te[0] = c * e;
          te[4] = bd - ac * f;
          te[8] = bc * f + ad;
          te[1] = f;
          te[5] = a * e;
          te[9] = -b * e;
          te[2] = -d * e;
          te[6] = ad * f + bc;
          te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
          const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
          te[0] = c * e;
          te[4] = -f;
          te[8] = d * e;
          te[1] = ac * f + bd;
          te[5] = a * e;
          te[9] = ad * f - bc;
          te[2] = bc * f - ad;
          te[6] = b * e;
          te[10] = bd * f + ac;
        }
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
      }
      /**
       * Sets the rotation component of this matrix to the rotation specified by
       * the given Quaternion as outlined [here]{@link https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion}
       * The rest of the matrix is set to the identity.
       *
       * @param {Quaternion} q - The Quaternion.
       * @return {Matrix4} A reference to this matrix.
       */
      makeRotationFromQuaternion(q) {
        return this.compose(_zero, q, _one);
      }
      /**
       * Sets the rotation component of the transformation matrix, looking from `eye` towards
       * `target`, and oriented by the up-direction.
       *
       * @param {Vector3} eye - The eye vector.
       * @param {Vector3} target - The target vector.
       * @param {Vector3} up - The up vector.
       * @return {Matrix4} A reference to this matrix.
       */
      lookAt(eye, target, up) {
        const te = this.elements;
        _z.subVectors(eye, target);
        if (_z.lengthSq() === 0) {
          _z.z = 1;
        }
        _z.normalize();
        _x.crossVectors(up, _z);
        if (_x.lengthSq() === 0) {
          if (Math.abs(up.z) === 1) {
            _z.x += 1e-4;
          } else {
            _z.z += 1e-4;
          }
          _z.normalize();
          _x.crossVectors(up, _z);
        }
        _x.normalize();
        _y.crossVectors(_z, _x);
        te[0] = _x.x;
        te[4] = _y.x;
        te[8] = _z.x;
        te[1] = _x.y;
        te[5] = _y.y;
        te[9] = _z.y;
        te[2] = _x.z;
        te[6] = _y.z;
        te[10] = _z.z;
        return this;
      }
      /**
       * Post-multiplies this matrix by the given 4x4 matrix.
       *
       * @param {Matrix4} m - The matrix to multiply with.
       * @return {Matrix4} A reference to this matrix.
       */
      multiply(m) {
        return this.multiplyMatrices(this, m);
      }
      /**
       * Pre-multiplies this matrix by the given 4x4 matrix.
       *
       * @param {Matrix4} m - The matrix to multiply with.
       * @return {Matrix4} A reference to this matrix.
       */
      premultiply(m) {
        return this.multiplyMatrices(m, this);
      }
      /**
       * Multiples the given 4x4 matrices and stores the result
       * in this matrix.
       *
       * @param {Matrix4} a - The first matrix.
       * @param {Matrix4} b - The second matrix.
       * @return {Matrix4} A reference to this matrix.
       */
      multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
      }
      /**
       * Multiplies every component of the matrix by the given scalar.
       *
       * @param {number} s - The scalar.
       * @return {Matrix4} A reference to this matrix.
       */
      multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
      }
      /**
       * Computes and returns the determinant of this matrix.
       *
       * Based on the method outlined [here]{@link http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html}.
       *
       * @return {number} The determinant.
       */
      determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
      }
      /**
       * Transposes this matrix in place.
       *
       * @return {Matrix4} A reference to this matrix.
       */
      transpose() {
        const te = this.elements;
        let tmp2;
        tmp2 = te[1];
        te[1] = te[4];
        te[4] = tmp2;
        tmp2 = te[2];
        te[2] = te[8];
        te[8] = tmp2;
        tmp2 = te[6];
        te[6] = te[9];
        te[9] = tmp2;
        tmp2 = te[3];
        te[3] = te[12];
        te[12] = tmp2;
        tmp2 = te[7];
        te[7] = te[13];
        te[13] = tmp2;
        tmp2 = te[11];
        te[11] = te[14];
        te[14] = tmp2;
        return this;
      }
      /**
       * Sets the position component for this matrix from the given vector,
       * without affecting the rest of the matrix.
       *
       * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
       * @param {number} y - The y component of the vector.
       * @param {number} z - The z component of the vector.
       * @return {Matrix4} A reference to this matrix.
       */
      setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
          te[12] = x.x;
          te[13] = x.y;
          te[14] = x.z;
        } else {
          te[12] = x;
          te[13] = y;
          te[14] = z;
        }
        return this;
      }
      /**
       * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
       * You can not invert with a determinant of zero. If you attempt this, the method produces
       * a zero matrix instead.
       *
       * @return {Matrix4} A reference to this matrix.
       */
      invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
      }
      /**
       * Multiplies the columns of this matrix by the given vector.
       *
       * @param {Vector3} v - The scale vector.
       * @return {Matrix4} A reference to this matrix.
       */
      scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
      }
      /**
       * Gets the maximum scale value of the three axes.
       *
       * @return {number} The maximum scale.
       */
      getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
      }
      /**
       * Sets this matrix as a translation transform from the given vector.
       *
       * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
       * @param {number} y - The amount to translate in the Y axis.
       * @param {number} z - The amount to translate in the z axis.
       * @return {Matrix4} A reference to this matrix.
       */
      makeTranslation(x, y, z) {
        if (x.isVector3) {
          this.set(
            1,
            0,
            0,
            x.x,
            0,
            1,
            0,
            x.y,
            0,
            0,
            1,
            x.z,
            0,
            0,
            0,
            1
          );
        } else {
          this.set(
            1,
            0,
            0,
            x,
            0,
            1,
            0,
            y,
            0,
            0,
            1,
            z,
            0,
            0,
            0,
            1
          );
        }
        return this;
      }
      /**
       * Sets this matrix as a rotational transformation around the X axis by
       * the given angle.
       *
       * @param {number} theta - The rotation in radians.
       * @return {Matrix4} A reference to this matrix.
       */
      makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(
          1,
          0,
          0,
          0,
          0,
          c,
          -s,
          0,
          0,
          s,
          c,
          0,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Sets this matrix as a rotational transformation around the Y axis by
       * the given angle.
       *
       * @param {number} theta - The rotation in radians.
       * @return {Matrix4} A reference to this matrix.
       */
      makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(
          c,
          0,
          s,
          0,
          0,
          1,
          0,
          0,
          -s,
          0,
          c,
          0,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Sets this matrix as a rotational transformation around the Z axis by
       * the given angle.
       *
       * @param {number} theta - The rotation in radians.
       * @return {Matrix4} A reference to this matrix.
       */
      makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(
          c,
          -s,
          0,
          0,
          s,
          c,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Sets this matrix as a rotational transformation around the given axis by
       * the given angle.
       *
       * This is a somewhat controversial but mathematically sound alternative to
       * rotating via Quaternions. See the discussion [here]{@link https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199}.
       *
       * @param {Vector3} axis - The normalized rotation axis.
       * @param {number} angle - The rotation in radians.
       * @return {Matrix4} A reference to this matrix.
       */
      makeRotationAxis(axis, angle) {
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(
          tx * x + c,
          tx * y - s * z,
          tx * z + s * y,
          0,
          tx * y + s * z,
          ty * y + c,
          ty * z - s * x,
          0,
          tx * z - s * y,
          ty * z + s * x,
          t * z * z + c,
          0,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Sets this matrix as a scale transformation.
       *
       * @param {number} x - The amount to scale in the X axis.
       * @param {number} y - The amount to scale in the Y axis.
       * @param {number} z - The amount to scale in the Z axis.
       * @return {Matrix4} A reference to this matrix.
       */
      makeScale(x, y, z) {
        this.set(
          x,
          0,
          0,
          0,
          0,
          y,
          0,
          0,
          0,
          0,
          z,
          0,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Sets this matrix as a shear transformation.
       *
       * @param {number} xy - The amount to shear X by Y.
       * @param {number} xz - The amount to shear X by Z.
       * @param {number} yx - The amount to shear Y by X.
       * @param {number} yz - The amount to shear Y by Z.
       * @param {number} zx - The amount to shear Z by X.
       * @param {number} zy - The amount to shear Z by Y.
       * @return {Matrix4} A reference to this matrix.
       */
      makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(
          1,
          yx,
          zx,
          0,
          xy,
          1,
          zy,
          0,
          xz,
          yz,
          1,
          0,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Sets this matrix to the transformation composed of the given position,
       * rotation (Quaternion) and scale.
       *
       * @param {Vector3} position - The position vector.
       * @param {Quaternion} quaternion - The rotation as a Quaternion.
       * @param {Vector3} scale - The scale vector.
       * @return {Matrix4} A reference to this matrix.
       */
      compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
      }
      /**
       * Decomposes this matrix into its position, rotation and scale components
       * and provides the result in the given objects.
       *
       * Note: Not all matrices are decomposable in this way. For example, if an
       * object has a non-uniformly scaled parent, then the object's world matrix
       * may not be decomposable, and this method may not be appropriate.
       *
       * @param {Vector3} position - The position vector.
       * @param {Quaternion} quaternion - The rotation as a Quaternion.
       * @param {Vector3} scale - The scale vector.
       * @return {Matrix4} A reference to this matrix.
       */
      decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = _v1$5.set(te[0], te[1], te[2]).length();
        const sy = _v1$5.set(te[4], te[5], te[6]).length();
        const sz = _v1$5.set(te[8], te[9], te[10]).length();
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        _m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        _m1$2.elements[0] *= invSX;
        _m1$2.elements[1] *= invSX;
        _m1$2.elements[2] *= invSX;
        _m1$2.elements[4] *= invSY;
        _m1$2.elements[5] *= invSY;
        _m1$2.elements[6] *= invSY;
        _m1$2.elements[8] *= invSZ;
        _m1$2.elements[9] *= invSZ;
        _m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix(_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
      }
      /**
      	 * Creates a perspective projection matrix. This is used internally by
      	 * {@link PerspectiveCamera#updateProjectionMatrix}.
      
      	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
      	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
      	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
      	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
      	 * @param {number} near - The distance from the camera to the near plane.
      	 * @param {number} far - The distance from the camera to the far plane.
      	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
      	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
      	 * @return {Matrix4} A reference to this matrix.
      	 */
      makePerspective(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem, reversedDepth = false) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
          c = near / (far - near);
          d = far * near / (far - near);
        } else {
          if (coordinateSystem === WebGLCoordinateSystem) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
          } else if (coordinateSystem === WebGPUCoordinateSystem) {
            c = -far / (far - near);
            d = -far * near / (far - near);
          } else {
            throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + coordinateSystem);
          }
        }
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
      }
      /**
      	 * Creates a orthographic projection matrix. This is used internally by
      	 * {@link OrthographicCamera#updateProjectionMatrix}.
      
      	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
      	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
      	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
      	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
      	 * @param {number} near - The distance from the camera to the near plane.
      	 * @param {number} far - The distance from the camera to the far plane.
      	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
      	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
      	 * @return {Matrix4} A reference to this matrix.
      	 */
      makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem, reversedDepth = false) {
        const te = this.elements;
        const x = 2 / (right - left);
        const y = 2 / (top - bottom);
        const a = -(right + left) / (right - left);
        const b = -(top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
          c = 1 / (far - near);
          d = far / (far - near);
        } else {
          if (coordinateSystem === WebGLCoordinateSystem) {
            c = -2 / (far - near);
            d = -(far + near) / (far - near);
          } else if (coordinateSystem === WebGPUCoordinateSystem) {
            c = -1 / (far - near);
            d = -near / (far - near);
          } else {
            throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + coordinateSystem);
          }
        }
        te[0] = x;
        te[4] = 0;
        te[8] = 0;
        te[12] = a;
        te[1] = 0;
        te[5] = y;
        te[9] = 0;
        te[13] = b;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
      }
      /**
       * Returns `true` if this matrix is equal with the given one.
       *
       * @param {Matrix4} matrix - The matrix to test for equality.
       * @return {boolean} Whether this matrix is equal with the given one.
       */
      equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for (let i = 0; i < 16; i++) {
          if (te[i] !== me[i]) return false;
        }
        return true;
      }
      /**
       * Sets the elements of the matrix from the given array.
       *
       * @param {Array<number>} array - The matrix elements in column-major order.
       * @param {number} [offset=0] - Index of the first element in the array.
       * @return {Matrix4} A reference to this matrix.
       */
      fromArray(array, offset = 0) {
        for (let i = 0; i < 16; i++) {
          this.elements[i] = array[i + offset];
        }
        return this;
      }
      /**
       * Writes the elements of this matrix to the given array. If no array is provided,
       * the method returns a new instance.
       *
       * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
       * @param {number} [offset=0] - Index of the first element in the array.
       * @return {Array<number>} The matrix elements in column-major order.
       */
      toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
      }
    };
    _v1$5 = /* @__PURE__ */ new Vector3();
    _m1$2 = /* @__PURE__ */ new Matrix4();
    _zero = /* @__PURE__ */ new Vector3(0, 0, 0);
    _one = /* @__PURE__ */ new Vector3(1, 1, 1);
    _x = /* @__PURE__ */ new Vector3();
    _y = /* @__PURE__ */ new Vector3();
    _z = /* @__PURE__ */ new Vector3();
    _matrix$2 = /* @__PURE__ */ new Matrix4();
    _quaternion$3 = /* @__PURE__ */ new Quaternion();
    Euler = class _Euler {
      /**
       * Constructs a new euler instance.
       *
       * @param {number} [x=0] - The angle of the x axis in radians.
       * @param {number} [y=0] - The angle of the y axis in radians.
       * @param {number} [z=0] - The angle of the z axis in radians.
       * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
       */
      constructor(x = 0, y = 0, z = 0, order = _Euler.DEFAULT_ORDER) {
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
      }
      /**
       * The angle of the x axis in radians.
       *
       * @type {number}
       * @default 0
       */
      get x() {
        return this._x;
      }
      set x(value) {
        this._x = value;
        this._onChangeCallback();
      }
      /**
       * The angle of the y axis in radians.
       *
       * @type {number}
       * @default 0
       */
      get y() {
        return this._y;
      }
      set y(value) {
        this._y = value;
        this._onChangeCallback();
      }
      /**
       * The angle of the z axis in radians.
       *
       * @type {number}
       * @default 0
       */
      get z() {
        return this._z;
      }
      set z(value) {
        this._z = value;
        this._onChangeCallback();
      }
      /**
       * A string representing the order that the rotations are applied.
       *
       * @type {string}
       * @default 'XYZ'
       */
      get order() {
        return this._order;
      }
      set order(value) {
        this._order = value;
        this._onChangeCallback();
      }
      /**
       * Sets the Euler components.
       *
       * @param {number} x - The angle of the x axis in radians.
       * @param {number} y - The angle of the y axis in radians.
       * @param {number} z - The angle of the z axis in radians.
       * @param {string} [order] - A string representing the order that the rotations are applied.
       * @return {Euler} A reference to this Euler instance.
       */
      set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
      }
      /**
       * Returns a new Euler instance with copied values from this instance.
       *
       * @return {Euler} A clone of this instance.
       */
      clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
      }
      /**
       * Copies the values of the given Euler instance to this instance.
       *
       * @param {Euler} euler - The Euler instance to copy.
       * @return {Euler} A reference to this Euler instance.
       */
      copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
      }
      /**
       * Sets the angles of this Euler instance from a pure rotation matrix.
       *
       * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
       * @param {string} [order] - A string representing the order that the rotations are applied.
       * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
       * @return {Euler} A reference to this Euler instance.
       */
      setFromRotationMatrix(m, order = this._order, update = true) {
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch (order) {
          case "XYZ":
            this._y = Math.asin(clamp(m13, -1, 1));
            if (Math.abs(m13) < 0.9999999) {
              this._x = Math.atan2(-m23, m33);
              this._z = Math.atan2(-m12, m11);
            } else {
              this._x = Math.atan2(m32, m22);
              this._z = 0;
            }
            break;
          case "YXZ":
            this._x = Math.asin(-clamp(m23, -1, 1));
            if (Math.abs(m23) < 0.9999999) {
              this._y = Math.atan2(m13, m33);
              this._z = Math.atan2(m21, m22);
            } else {
              this._y = Math.atan2(-m31, m11);
              this._z = 0;
            }
            break;
          case "ZXY":
            this._x = Math.asin(clamp(m32, -1, 1));
            if (Math.abs(m32) < 0.9999999) {
              this._y = Math.atan2(-m31, m33);
              this._z = Math.atan2(-m12, m22);
            } else {
              this._y = 0;
              this._z = Math.atan2(m21, m11);
            }
            break;
          case "ZYX":
            this._y = Math.asin(-clamp(m31, -1, 1));
            if (Math.abs(m31) < 0.9999999) {
              this._x = Math.atan2(m32, m33);
              this._z = Math.atan2(m21, m11);
            } else {
              this._x = 0;
              this._z = Math.atan2(-m12, m22);
            }
            break;
          case "YZX":
            this._z = Math.asin(clamp(m21, -1, 1));
            if (Math.abs(m21) < 0.9999999) {
              this._x = Math.atan2(-m23, m22);
              this._y = Math.atan2(-m31, m11);
            } else {
              this._x = 0;
              this._y = Math.atan2(m13, m33);
            }
            break;
          case "XZY":
            this._z = Math.asin(-clamp(m12, -1, 1));
            if (Math.abs(m12) < 0.9999999) {
              this._x = Math.atan2(m32, m22);
              this._y = Math.atan2(m13, m11);
            } else {
              this._x = Math.atan2(-m23, m33);
              this._y = 0;
            }
            break;
          default:
            console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
      }
      /**
       * Sets the angles of this Euler instance from a normalized quaternion.
       *
       * @param {Quaternion} q - A normalized Quaternion.
       * @param {string} [order] - A string representing the order that the rotations are applied.
       * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
       * @return {Euler} A reference to this Euler instance.
       */
      setFromQuaternion(q, order, update) {
        _matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix(_matrix$2, order, update);
      }
      /**
       * Sets the angles of this Euler instance from the given vector.
       *
       * @param {Vector3} v - The vector.
       * @param {string} [order] - A string representing the order that the rotations are applied.
       * @return {Euler} A reference to this Euler instance.
       */
      setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
      }
      /**
       * Resets the euler angle with a new order by creating a quaternion from this
       * euler angle and then setting this euler angle with the quaternion and the
       * new order.
       *
       * Warning: This discards revolution information.
       *
       * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
       * @return {Euler} A reference to this Euler instance.
       */
      reorder(newOrder) {
        _quaternion$3.setFromEuler(this);
        return this.setFromQuaternion(_quaternion$3, newOrder);
      }
      /**
       * Returns `true` if this Euler instance is equal with the given one.
       *
       * @param {Euler} euler - The Euler instance to test for equality.
       * @return {boolean} Whether this Euler instance is equal with the given one.
       */
      equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
      }
      /**
       * Sets this Euler instance's components to values from the given array. The first three
       * entries of the array are assign to the x,y and z components. An optional fourth entry
       * defines the Euler order.
       *
       * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
       * @return {Euler} A reference to this Euler instance.
       */
      fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== void 0) this._order = array[3];
        this._onChangeCallback();
        return this;
      }
      /**
       * Writes the components of this Euler instance to the given array. If no array is provided,
       * the method returns a new instance.
       *
       * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
       * @param {number} [offset=0] - Index of the first element in the array.
       * @return {Array<number,number,number,string>} The Euler components.
       */
      toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
      }
      _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
      }
      _onChangeCallback() {
      }
      *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
      }
    };
    Euler.DEFAULT_ORDER = "XYZ";
    Layers = class {
      /**
       * Constructs a new layers instance, with membership
       * initially set to layer `0`.
       */
      constructor() {
        this.mask = 1 | 0;
      }
      /**
       * Sets membership to the given layer, and remove membership all other layers.
       *
       * @param {number} layer - The layer to set.
       */
      set(layer) {
        this.mask = (1 << layer | 0) >>> 0;
      }
      /**
       * Adds membership of the given layer.
       *
       * @param {number} layer - The layer to enable.
       */
      enable(layer) {
        this.mask |= 1 << layer | 0;
      }
      /**
       * Adds membership to all layers.
       */
      enableAll() {
        this.mask = 4294967295 | 0;
      }
      /**
       * Toggles the membership of the given layer.
       *
       * @param {number} layer - The layer to toggle.
       */
      toggle(layer) {
        this.mask ^= 1 << layer | 0;
      }
      /**
       * Removes membership of the given layer.
       *
       * @param {number} layer - The layer to enable.
       */
      disable(layer) {
        this.mask &= ~(1 << layer | 0);
      }
      /**
       * Removes the membership from all layers.
       */
      disableAll() {
        this.mask = 0;
      }
      /**
       * Returns `true` if this and the given layers object have at least one
       * layer in common.
       *
       * @param {Layers} layers - The layers to test.
       * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
       */
      test(layers) {
        return (this.mask & layers.mask) !== 0;
      }
      /**
       * Returns `true` if the given layer is enabled.
       *
       * @param {number} layer - The layer to test.
       * @return {boolean } Whether the given layer is enabled or not.
       */
      isEnabled(layer) {
        return (this.mask & (1 << layer | 0)) !== 0;
      }
    };
    _object3DId = 0;
    _v1$4 = /* @__PURE__ */ new Vector3();
    _q1 = /* @__PURE__ */ new Quaternion();
    _m1$1 = /* @__PURE__ */ new Matrix4();
    _target = /* @__PURE__ */ new Vector3();
    _position$3 = /* @__PURE__ */ new Vector3();
    _scale$2 = /* @__PURE__ */ new Vector3();
    _quaternion$2 = /* @__PURE__ */ new Quaternion();
    _xAxis = /* @__PURE__ */ new Vector3(1, 0, 0);
    _yAxis = /* @__PURE__ */ new Vector3(0, 1, 0);
    _zAxis = /* @__PURE__ */ new Vector3(0, 0, 1);
    _addedEvent = { type: "added" };
    _removedEvent = { type: "removed" };
    _childaddedEvent = { type: "childadded", child: null };
    _childremovedEvent = { type: "childremoved", child: null };
    Object3D = class _Object3D extends EventDispatcher {
      /**
       * Constructs a new 3D object.
       */
      constructor() {
        super();
        this.isObject3D = true;
        Object.defineProperty(this, "id", { value: _object3DId++ });
        this.uuid = generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = _Object3D.DEFAULT_UP.clone();
        const position = new Vector3();
        const rotation = new Euler();
        const quaternion = new Quaternion();
        const scale = new Vector3(1, 1, 1);
        function onRotationChange() {
          quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
          rotation.setFromQuaternion(quaternion, void 0, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
          /**
           * Represents the object's local position.
           *
           * @name Object3D#position
           * @type {Vector3}
           * @default (0,0,0)
           */
          position: {
            configurable: true,
            enumerable: true,
            value: position
          },
          /**
           * Represents the object's local rotation as Euler angles, in radians.
           *
           * @name Object3D#rotation
           * @type {Euler}
           * @default (0,0,0)
           */
          rotation: {
            configurable: true,
            enumerable: true,
            value: rotation
          },
          /**
           * Represents the object's local rotation as Quaternions.
           *
           * @name Object3D#quaternion
           * @type {Quaternion}
           */
          quaternion: {
            configurable: true,
            enumerable: true,
            value: quaternion
          },
          /**
           * Represents the object's local scale.
           *
           * @name Object3D#scale
           * @type {Vector3}
           * @default (1,1,1)
           */
          scale: {
            configurable: true,
            enumerable: true,
            value: scale
          },
          /**
           * Represents the object's model-view matrix.
           *
           * @name Object3D#modelViewMatrix
           * @type {Matrix4}
           */
          modelViewMatrix: {
            value: new Matrix4()
          },
          /**
           * Represents the object's normal matrix.
           *
           * @name Object3D#normalMatrix
           * @type {Matrix3}
           */
          normalMatrix: {
            value: new Matrix3()
          }
        });
        this.matrix = new Matrix4();
        this.matrixWorld = new Matrix4();
        this.matrixAutoUpdate = _Object3D.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldAutoUpdate = _Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE;
        this.matrixWorldNeedsUpdate = false;
        this.layers = new Layers();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.customDepthMaterial = void 0;
        this.customDistanceMaterial = void 0;
        this.userData = {};
      }
      /**
       * A callback that is executed immediately before a 3D object is rendered to a shadow map.
       *
       * @param {Renderer|WebGLRenderer} renderer - The renderer.
       * @param {Object3D} object - The 3D object.
       * @param {Camera} camera - The camera that is used to render the scene.
       * @param {Camera} shadowCamera - The shadow camera.
       * @param {BufferGeometry} geometry - The 3D object's geometry.
       * @param {Material} depthMaterial - The depth material.
       * @param {Object} group - The geometry group data.
       */
      onBeforeShadow() {
      }
      /**
       * A callback that is executed immediately after a 3D object is rendered to a shadow map.
       *
       * @param {Renderer|WebGLRenderer} renderer - The renderer.
       * @param {Object3D} object - The 3D object.
       * @param {Camera} camera - The camera that is used to render the scene.
       * @param {Camera} shadowCamera - The shadow camera.
       * @param {BufferGeometry} geometry - The 3D object's geometry.
       * @param {Material} depthMaterial - The depth material.
       * @param {Object} group - The geometry group data.
       */
      onAfterShadow() {
      }
      /**
       * A callback that is executed immediately before a 3D object is rendered.
       *
       * @param {Renderer|WebGLRenderer} renderer - The renderer.
       * @param {Object3D} object - The 3D object.
       * @param {Camera} camera - The camera that is used to render the scene.
       * @param {BufferGeometry} geometry - The 3D object's geometry.
       * @param {Material} material - The 3D object's material.
       * @param {Object} group - The geometry group data.
       */
      onBeforeRender() {
      }
      /**
       * A callback that is executed immediately after a 3D object is rendered.
       *
       * @param {Renderer|WebGLRenderer} renderer - The renderer.
       * @param {Object3D} object - The 3D object.
       * @param {Camera} camera - The camera that is used to render the scene.
       * @param {BufferGeometry} geometry - The 3D object's geometry.
       * @param {Material} material - The 3D object's material.
       * @param {Object} group - The geometry group data.
       */
      onAfterRender() {
      }
      /**
       * Applies the given transformation matrix to the object and updates the object's position,
       * rotation and scale.
       *
       * @param {Matrix4} matrix - The transformation matrix.
       */
      applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
      }
      /**
       * Applies a rotation represented by given the quaternion to the 3D object.
       *
       * @param {Quaternion} q - The quaternion.
       * @return {Object3D} A reference to this instance.
       */
      applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
      }
      /**
       * Sets the given rotation represented as an axis/angle couple to the 3D object.
       *
       * @param {Vector3} axis - The (normalized) axis vector.
       * @param {number} angle - The angle in radians.
       */
      setRotationFromAxisAngle(axis, angle) {
        this.quaternion.setFromAxisAngle(axis, angle);
      }
      /**
       * Sets the given rotation represented as Euler angles to the 3D object.
       *
       * @param {Euler} euler - The Euler angles.
       */
      setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
      }
      /**
       * Sets the given rotation represented as rotation matrix to the 3D object.
       *
       * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
       * a pure rotation matrix (i.e, unscaled).
       */
      setRotationFromMatrix(m) {
        this.quaternion.setFromRotationMatrix(m);
      }
      /**
       * Sets the given rotation represented as a Quaternion to the 3D object.
       *
       * @param {Quaternion} q - The Quaternion
       */
      setRotationFromQuaternion(q) {
        this.quaternion.copy(q);
      }
      /**
       * Rotates the 3D object along an axis in local space.
       *
       * @param {Vector3} axis - The (normalized) axis vector.
       * @param {number} angle - The angle in radians.
       * @return {Object3D} A reference to this instance.
       */
      rotateOnAxis(axis, angle) {
        _q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply(_q1);
        return this;
      }
      /**
       * Rotates the 3D object along an axis in world space.
       *
       * @param {Vector3} axis - The (normalized) axis vector.
       * @param {number} angle - The angle in radians.
       * @return {Object3D} A reference to this instance.
       */
      rotateOnWorldAxis(axis, angle) {
        _q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply(_q1);
        return this;
      }
      /**
       * Rotates the 3D object around its X axis in local space.
       *
       * @param {number} angle - The angle in radians.
       * @return {Object3D} A reference to this instance.
       */
      rotateX(angle) {
        return this.rotateOnAxis(_xAxis, angle);
      }
      /**
       * Rotates the 3D object around its Y axis in local space.
       *
       * @param {number} angle - The angle in radians.
       * @return {Object3D} A reference to this instance.
       */
      rotateY(angle) {
        return this.rotateOnAxis(_yAxis, angle);
      }
      /**
       * Rotates the 3D object around its Z axis in local space.
       *
       * @param {number} angle - The angle in radians.
       * @return {Object3D} A reference to this instance.
       */
      rotateZ(angle) {
        return this.rotateOnAxis(_zAxis, angle);
      }
      /**
       * Translate the 3D object by a distance along the given axis in local space.
       *
       * @param {Vector3} axis - The (normalized) axis vector.
       * @param {number} distance - The distance in world units.
       * @return {Object3D} A reference to this instance.
       */
      translateOnAxis(axis, distance) {
        _v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add(_v1$4.multiplyScalar(distance));
        return this;
      }
      /**
       * Translate the 3D object by a distance along its X-axis in local space.
       *
       * @param {number} distance - The distance in world units.
       * @return {Object3D} A reference to this instance.
       */
      translateX(distance) {
        return this.translateOnAxis(_xAxis, distance);
      }
      /**
       * Translate the 3D object by a distance along its Y-axis in local space.
       *
       * @param {number} distance - The distance in world units.
       * @return {Object3D} A reference to this instance.
       */
      translateY(distance) {
        return this.translateOnAxis(_yAxis, distance);
      }
      /**
       * Translate the 3D object by a distance along its Z-axis in local space.
       *
       * @param {number} distance - The distance in world units.
       * @return {Object3D} A reference to this instance.
       */
      translateZ(distance) {
        return this.translateOnAxis(_zAxis, distance);
      }
      /**
       * Converts the given vector from this 3D object's local space to world space.
       *
       * @param {Vector3} vector - The vector to convert.
       * @return {Vector3} The converted vector.
       */
      localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
      }
      /**
       * Converts the given vector from this 3D object's word space to local space.
       *
       * @param {Vector3} vector - The vector to convert.
       * @return {Vector3} The converted vector.
       */
      worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
      }
      /**
       * Rotates the object to face a point in world space.
       *
       * This method does not support objects having non-uniformly-scaled parent(s).
       *
       * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
       * @param {number} [y] - The y coordinate in world space.
       * @param {number} [z] - The z coordinate in world space.
       */
      lookAt(x, y, z) {
        if (x.isVector3) {
          _target.copy(x);
        } else {
          _target.set(x, y, z);
        }
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        _position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) {
          _m1$1.lookAt(_position$3, _target, this.up);
        } else {
          _m1$1.lookAt(_target, _position$3, this.up);
        }
        this.quaternion.setFromRotationMatrix(_m1$1);
        if (parent) {
          _m1$1.extractRotation(parent.matrixWorld);
          _q1.setFromRotationMatrix(_m1$1);
          this.quaternion.premultiply(_q1.invert());
        }
      }
      /**
       * Adds the given 3D object as a child to this 3D object. An arbitrary number of
       * objects may be added. Any current parent on an object passed in here will be
       * removed, since an object can have at most one parent.
       *
       * @fires Object3D#added
       * @fires Object3D#childadded
       * @param {Object3D} object - The 3D object to add.
       * @return {Object3D} A reference to this instance.
       */
      add(object) {
        if (arguments.length > 1) {
          for (let i = 0; i < arguments.length; i++) {
            this.add(arguments[i]);
          }
          return this;
        }
        if (object === this) {
          console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
          return this;
        }
        if (object && object.isObject3D) {
          object.removeFromParent();
          object.parent = this;
          this.children.push(object);
          object.dispatchEvent(_addedEvent);
          _childaddedEvent.child = object;
          this.dispatchEvent(_childaddedEvent);
          _childaddedEvent.child = null;
        } else {
          console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        }
        return this;
      }
      /**
       * Removes the given 3D object as child from this 3D object.
       * An arbitrary number of objects may be removed.
       *
       * @fires Object3D#removed
       * @fires Object3D#childremoved
       * @param {Object3D} object - The 3D object to remove.
       * @return {Object3D} A reference to this instance.
       */
      remove(object) {
        if (arguments.length > 1) {
          for (let i = 0; i < arguments.length; i++) {
            this.remove(arguments[i]);
          }
          return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
          object.parent = null;
          this.children.splice(index, 1);
          object.dispatchEvent(_removedEvent);
          _childremovedEvent.child = object;
          this.dispatchEvent(_childremovedEvent);
          _childremovedEvent.child = null;
        }
        return this;
      }
      /**
       * Removes this 3D object from its current parent.
       *
       * @fires Object3D#removed
       * @fires Object3D#childremoved
       * @return {Object3D} A reference to this instance.
       */
      removeFromParent() {
        const parent = this.parent;
        if (parent !== null) {
          parent.remove(this);
        }
        return this;
      }
      /**
       * Removes all child objects.
       *
       * @fires Object3D#removed
       * @fires Object3D#childremoved
       * @return {Object3D} A reference to this instance.
       */
      clear() {
        return this.remove(...this.children);
      }
      /**
       * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
       * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
       *
       * @fires Object3D#added
       * @fires Object3D#childadded
       * @param {Object3D} object - The 3D object to attach.
       * @return {Object3D} A reference to this instance.
       */
      attach(object) {
        this.updateWorldMatrix(true, false);
        _m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
          object.parent.updateWorldMatrix(true, false);
          _m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4(_m1$1);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent(_addedEvent);
        _childaddedEvent.child = object;
        this.dispatchEvent(_childaddedEvent);
        _childaddedEvent.child = null;
        return this;
      }
      /**
       * Searches through the 3D object and its children, starting with the 3D object
       * itself, and returns the first with a matching ID.
       *
       * @param {number} id - The id.
       * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
       */
      getObjectById(id) {
        return this.getObjectByProperty("id", id);
      }
      /**
       * Searches through the 3D object and its children, starting with the 3D object
       * itself, and returns the first with a matching name.
       *
       * @param {string} name - The name.
       * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
       */
      getObjectByName(name) {
        return this.getObjectByProperty("name", name);
      }
      /**
       * Searches through the 3D object and its children, starting with the 3D object
       * itself, and returns the first with a matching property value.
       *
       * @param {string} name - The name of the property.
       * @param {any} value - The value.
       * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
       */
      getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for (let i = 0, l = this.children.length; i < l; i++) {
          const child = this.children[i];
          const object = child.getObjectByProperty(name, value);
          if (object !== void 0) {
            return object;
          }
        }
        return void 0;
      }
      /**
       * Searches through the 3D object and its children, starting with the 3D object
       * itself, and returns all 3D objects with a matching property value.
       *
       * @param {string} name - The name of the property.
       * @param {any} value - The value.
       * @param {Array<Object3D>} result - The method stores the result in this array.
       * @return {Array<Object3D>} The found 3D objects.
       */
      getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for (let i = 0, l = children.length; i < l; i++) {
          children[i].getObjectsByProperty(name, value, result);
        }
        return result;
      }
      /**
       * Returns a vector representing the position of the 3D object in world space.
       *
       * @param {Vector3} target - The target vector the result is stored to.
       * @return {Vector3} The 3D object's position in world space.
       */
      getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
      }
      /**
       * Returns a Quaternion representing the position of the 3D object in world space.
       *
       * @param {Quaternion} target - The target Quaternion the result is stored to.
       * @return {Quaternion} The 3D object's rotation in world space.
       */
      getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose(_position$3, target, _scale$2);
        return target;
      }
      /**
       * Returns a vector representing the scale of the 3D object in world space.
       *
       * @param {Vector3} target - The target vector the result is stored to.
       * @return {Vector3} The 3D object's scale in world space.
       */
      getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose(_position$3, _quaternion$2, target);
        return target;
      }
      /**
       * Returns a vector representing the ("look") direction of the 3D object in world space.
       *
       * @param {Vector3} target - The target vector the result is stored to.
       * @return {Vector3} The 3D object's direction in world space.
       */
      getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
      }
      /**
       * Abstract method to get intersections between a casted ray and this
       * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
       * implement this method in order to use raycasting.
       *
       * @abstract
       * @param {Raycaster} raycaster - The raycaster.
       * @param {Array<Object>} intersects - An array holding the result of the method.
       */
      raycast() {
      }
      /**
       * Executes the callback on this 3D object and all descendants.
       *
       * Note: Modifying the scene graph inside the callback is discouraged.
       *
       * @param {Function} callback - A callback function that allows to process the current 3D object.
       */
      traverse(callback) {
        callback(this);
        const children = this.children;
        for (let i = 0, l = children.length; i < l; i++) {
          children[i].traverse(callback);
        }
      }
      /**
       * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
       * Descendants of invisible 3D objects are not traversed.
       *
       * Note: Modifying the scene graph inside the callback is discouraged.
       *
       * @param {Function} callback - A callback function that allows to process the current 3D object.
       */
      traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for (let i = 0, l = children.length; i < l; i++) {
          children[i].traverseVisible(callback);
        }
      }
      /**
       * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
       *
       * Note: Modifying the scene graph inside the callback is discouraged.
       *
       * @param {Function} callback - A callback function that allows to process the current 3D object.
       */
      traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
          callback(parent);
          parent.traverseAncestors(callback);
        }
      }
      /**
       * Updates the transformation matrix in local space by computing it from the current
       * position, rotation and scale values.
       */
      updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
      }
      /**
       * Updates the transformation matrix in world space of this 3D objects and its descendants.
       *
       * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
       * local space. The computation of the local and world matrix can be controlled with the
       * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
       * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
       *
       * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
       * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
       */
      updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
          if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) {
              this.matrixWorld.copy(this.matrix);
            } else {
              this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
          }
          this.matrixWorldNeedsUpdate = false;
          force = true;
        }
        const children = this.children;
        for (let i = 0, l = children.length; i < l; i++) {
          const child = children[i];
          child.updateMatrixWorld(force);
        }
      }
      /**
       * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
       * update of ancestor and descendant nodes.
       *
       * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
       * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
       */
      updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) {
          parent.updateWorldMatrix(true, false);
        }
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
          if (this.parent === null) {
            this.matrixWorld.copy(this.matrix);
          } else {
            this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
          }
        }
        if (updateChildren === true) {
          const children = this.children;
          for (let i = 0, l = children.length; i < l; i++) {
            const child = children[i];
            child.updateWorldMatrix(false, true);
          }
        }
      }
      /**
       * Serializes the 3D object into JSON.
       *
       * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
       * @return {Object} A JSON object representing the serialized 3D object.
       * @see {@link ObjectLoader#parse}
       */
      toJSON(meta) {
        const isRootObject = meta === void 0 || typeof meta === "string";
        const output = {};
        if (isRootObject) {
          meta = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {}
          };
          output.metadata = {
            version: 4.7,
            type: "Object",
            generator: "Object3D.toJSON"
          };
        }
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        if (this.isInstancedMesh) {
          object.type = "InstancedMesh";
          object.count = this.count;
          object.instanceMatrix = this.instanceMatrix.toJSON();
          if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
          object.type = "BatchedMesh";
          object.perObjectFrustumCulled = this.perObjectFrustumCulled;
          object.sortObjects = this.sortObjects;
          object.drawRanges = this._drawRanges;
          object.reservedRanges = this._reservedRanges;
          object.geometryInfo = this._geometryInfo.map((info) => ({
            ...info,
            boundingBox: info.boundingBox ? info.boundingBox.toJSON() : void 0,
            boundingSphere: info.boundingSphere ? info.boundingSphere.toJSON() : void 0
          }));
          object.instanceInfo = this._instanceInfo.map((info) => ({ ...info }));
          object.availableInstanceIds = this._availableInstanceIds.slice();
          object.availableGeometryIds = this._availableGeometryIds.slice();
          object.nextIndexStart = this._nextIndexStart;
          object.nextVertexStart = this._nextVertexStart;
          object.geometryCount = this._geometryCount;
          object.maxInstanceCount = this._maxInstanceCount;
          object.maxVertexCount = this._maxVertexCount;
          object.maxIndexCount = this._maxIndexCount;
          object.geometryInitialized = this._geometryInitialized;
          object.matricesTexture = this._matricesTexture.toJSON(meta);
          object.indirectTexture = this._indirectTexture.toJSON(meta);
          if (this._colorsTexture !== null) {
            object.colorsTexture = this._colorsTexture.toJSON(meta);
          }
          if (this.boundingSphere !== null) {
            object.boundingSphere = this.boundingSphere.toJSON();
          }
          if (this.boundingBox !== null) {
            object.boundingBox = this.boundingBox.toJSON();
          }
        }
        function serialize(library, element) {
          if (library[element.uuid] === void 0) {
            library[element.uuid] = element.toJSON(meta);
          }
          return element.uuid;
        }
        if (this.isScene) {
          if (this.background) {
            if (this.background.isColor) {
              object.background = this.background.toJSON();
            } else if (this.background.isTexture) {
              object.background = this.background.toJSON(meta).uuid;
            }
          }
          if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) {
            object.environment = this.environment.toJSON(meta).uuid;
          }
        } else if (this.isMesh || this.isLine || this.isPoints) {
          object.geometry = serialize(meta.geometries, this.geometry);
          const parameters = this.geometry.parameters;
          if (parameters !== void 0 && parameters.shapes !== void 0) {
            const shapes = parameters.shapes;
            if (Array.isArray(shapes)) {
              for (let i = 0, l = shapes.length; i < l; i++) {
                const shape = shapes[i];
                serialize(meta.shapes, shape);
              }
            } else {
              serialize(meta.shapes, shapes);
            }
          }
        }
        if (this.isSkinnedMesh) {
          object.bindMode = this.bindMode;
          object.bindMatrix = this.bindMatrix.toArray();
          if (this.skeleton !== void 0) {
            serialize(meta.skeletons, this.skeleton);
            object.skeleton = this.skeleton.uuid;
          }
        }
        if (this.material !== void 0) {
          if (Array.isArray(this.material)) {
            const uuids = [];
            for (let i = 0, l = this.material.length; i < l; i++) {
              uuids.push(serialize(meta.materials, this.material[i]));
            }
            object.material = uuids;
          } else {
            object.material = serialize(meta.materials, this.material);
          }
        }
        if (this.children.length > 0) {
          object.children = [];
          for (let i = 0; i < this.children.length; i++) {
            object.children.push(this.children[i].toJSON(meta).object);
          }
        }
        if (this.animations.length > 0) {
          object.animations = [];
          for (let i = 0; i < this.animations.length; i++) {
            const animation = this.animations[i];
            object.animations.push(serialize(meta.animations, animation));
          }
        }
        if (isRootObject) {
          const geometries = extractFromCache(meta.geometries);
          const materials = extractFromCache(meta.materials);
          const textures = extractFromCache(meta.textures);
          const images = extractFromCache(meta.images);
          const shapes = extractFromCache(meta.shapes);
          const skeletons = extractFromCache(meta.skeletons);
          const animations = extractFromCache(meta.animations);
          const nodes = extractFromCache(meta.nodes);
          if (geometries.length > 0) output.geometries = geometries;
          if (materials.length > 0) output.materials = materials;
          if (textures.length > 0) output.textures = textures;
          if (images.length > 0) output.images = images;
          if (shapes.length > 0) output.shapes = shapes;
          if (skeletons.length > 0) output.skeletons = skeletons;
          if (animations.length > 0) output.animations = animations;
          if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        function extractFromCache(cache) {
          const values = [];
          for (const key in cache) {
            const data = cache[key];
            delete data.metadata;
            values.push(data);
          }
          return values;
        }
      }
      /**
       * Returns a new 3D object with copied values from this instance.
       *
       * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
       * @return {Object3D} A clone of this instance.
       */
      clone(recursive) {
        return new this.constructor().copy(this, recursive);
      }
      /**
       * Copies the values of the given 3D object to this instance.
       *
       * @param {Object3D} source - The 3D object to copy.
       * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
       * @return {Object3D} A reference to this instance.
       */
      copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) {
          for (let i = 0; i < source.children.length; i++) {
            const child = source.children[i];
            this.add(child.clone());
          }
        }
        return this;
      }
    };
    Object3D.DEFAULT_UP = /* @__PURE__ */ new Vector3(0, 1, 0);
    Object3D.DEFAULT_MATRIX_AUTO_UPDATE = true;
    Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
    _v0$1 = /* @__PURE__ */ new Vector3();
    _v1$3 = /* @__PURE__ */ new Vector3();
    _v2$2 = /* @__PURE__ */ new Vector3();
    _v3$2 = /* @__PURE__ */ new Vector3();
    _vab = /* @__PURE__ */ new Vector3();
    _vac = /* @__PURE__ */ new Vector3();
    _vbc = /* @__PURE__ */ new Vector3();
    _vap = /* @__PURE__ */ new Vector3();
    _vbp = /* @__PURE__ */ new Vector3();
    _vcp = /* @__PURE__ */ new Vector3();
    _v40 = /* @__PURE__ */ new Vector4();
    _v41 = /* @__PURE__ */ new Vector4();
    _v42 = /* @__PURE__ */ new Vector4();
    Triangle = class _Triangle {
      /**
       * Constructs a new triangle.
       *
       * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
       * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
       * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
       */
      constructor(a = new Vector3(), b = new Vector3(), c = new Vector3()) {
        this.a = a;
        this.b = b;
        this.c = c;
      }
      /**
       * Computes the normal vector of a triangle.
       *
       * @param {Vector3} a - The first corner of the triangle.
       * @param {Vector3} b - The second corner of the triangle.
       * @param {Vector3} c - The third corner of the triangle.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The triangle's normal.
       */
      static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        _v0$1.subVectors(a, b);
        target.cross(_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) {
          return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        }
        return target.set(0, 0, 0);
      }
      /**
       * Computes a barycentric coordinates from the given vector.
       * Returns `null` if the triangle is degenerate.
       *
       * @param {Vector3} point - A point in 3D space.
       * @param {Vector3} a - The first corner of the triangle.
       * @param {Vector3} b - The second corner of the triangle.
       * @param {Vector3} c - The third corner of the triangle.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {?Vector3} The barycentric coordinates for the given point
       */
      static getBarycoord(point, a, b, c, target) {
        _v0$1.subVectors(c, a);
        _v1$3.subVectors(b, a);
        _v2$2.subVectors(point, a);
        const dot00 = _v0$1.dot(_v0$1);
        const dot01 = _v0$1.dot(_v1$3);
        const dot02 = _v0$1.dot(_v2$2);
        const dot11 = _v1$3.dot(_v1$3);
        const dot12 = _v1$3.dot(_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        if (denom === 0) {
          target.set(0, 0, 0);
          return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        return target.set(1 - u - v, v, u);
      }
      /**
       * Returns `true` if the given point, when projected onto the plane of the
       * triangle, lies within the triangle.
       *
       * @param {Vector3} point - The point in 3D space to test.
       * @param {Vector3} a - The first corner of the triangle.
       * @param {Vector3} b - The second corner of the triangle.
       * @param {Vector3} c - The third corner of the triangle.
       * @return {boolean} Whether the given point, when projected onto the plane of the
       * triangle, lies within the triangle or not.
       */
      static containsPoint(point, a, b, c) {
        if (this.getBarycoord(point, a, b, c, _v3$2) === null) {
          return false;
        }
        return _v3$2.x >= 0 && _v3$2.y >= 0 && _v3$2.x + _v3$2.y <= 1;
      }
      /**
       * Computes the value barycentrically interpolated for the given point on the
       * triangle. Returns `null` if the triangle is degenerate.
       *
       * @param {Vector3} point - Position of interpolated point.
       * @param {Vector3} p1 - The first corner of the triangle.
       * @param {Vector3} p2 - The second corner of the triangle.
       * @param {Vector3} p3 - The third corner of the triangle.
       * @param {Vector3} v1 - Value to interpolate of first vertex.
       * @param {Vector3} v2 - Value to interpolate of second vertex.
       * @param {Vector3} v3 - Value to interpolate of third vertex.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {?Vector3} The interpolated value.
       */
      static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, _v3$2) === null) {
          target.x = 0;
          target.y = 0;
          if ("z" in target) target.z = 0;
          if ("w" in target) target.w = 0;
          return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, _v3$2.x);
        target.addScaledVector(v2, _v3$2.y);
        target.addScaledVector(v3, _v3$2.z);
        return target;
      }
      /**
       * Computes the value barycentrically interpolated for the given attribute and indices.
       *
       * @param {BufferAttribute} attr - The attribute to interpolate.
       * @param {number} i1 - Index of first vertex.
       * @param {number} i2 - Index of second vertex.
       * @param {number} i3 - Index of third vertex.
       * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The interpolated attribute value.
       */
      static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        _v40.setScalar(0);
        _v41.setScalar(0);
        _v42.setScalar(0);
        _v40.fromBufferAttribute(attr, i1);
        _v41.fromBufferAttribute(attr, i2);
        _v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector(_v40, barycoord.x);
        target.addScaledVector(_v41, barycoord.y);
        target.addScaledVector(_v42, barycoord.z);
        return target;
      }
      /**
       * Returns `true` if the triangle is oriented towards the given direction.
       *
       * @param {Vector3} a - The first corner of the triangle.
       * @param {Vector3} b - The second corner of the triangle.
       * @param {Vector3} c - The third corner of the triangle.
       * @param {Vector3} direction - The (normalized) direction vector.
       * @return {boolean} Whether the triangle is oriented towards the given direction or not.
       */
      static isFrontFacing(a, b, c, direction) {
        _v0$1.subVectors(c, b);
        _v1$3.subVectors(a, b);
        return _v0$1.cross(_v1$3).dot(direction) < 0 ? true : false;
      }
      /**
       * Sets the triangle's vertices by copying the given values.
       *
       * @param {Vector3} a - The first corner of the triangle.
       * @param {Vector3} b - The second corner of the triangle.
       * @param {Vector3} c - The third corner of the triangle.
       * @return {Triangle} A reference to this triangle.
       */
      set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
      }
      /**
       * Sets the triangle's vertices by copying the given array values.
       *
       * @param {Array<Vector3>} points - An array with 3D points.
       * @param {number} i0 - The array index representing the first corner of the triangle.
       * @param {number} i1 - The array index representing the second corner of the triangle.
       * @param {number} i2 - The array index representing the third corner of the triangle.
       * @return {Triangle} A reference to this triangle.
       */
      setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
      }
      /**
       * Sets the triangle's vertices by copying the given attribute values.
       *
       * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
       * @param {number} i0 - The attribute index representing the first corner of the triangle.
       * @param {number} i1 - The attribute index representing the second corner of the triangle.
       * @param {number} i2 - The attribute index representing the third corner of the triangle.
       * @return {Triangle} A reference to this triangle.
       */
      setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
      }
      /**
       * Returns a new triangle with copied values from this instance.
       *
       * @return {Triangle} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
      /**
       * Copies the values of the given triangle to this instance.
       *
       * @param {Triangle} triangle - The triangle to copy.
       * @return {Triangle} A reference to this triangle.
       */
      copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
      }
      /**
       * Computes the area of the triangle.
       *
       * @return {number} The triangle's area.
       */
      getArea() {
        _v0$1.subVectors(this.c, this.b);
        _v1$3.subVectors(this.a, this.b);
        return _v0$1.cross(_v1$3).length() * 0.5;
      }
      /**
       * Computes the midpoint of the triangle.
       *
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The triangle's midpoint.
       */
      getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
      }
      /**
       * Computes the normal of the triangle.
       *
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The triangle's normal.
       */
      getNormal(target) {
        return _Triangle.getNormal(this.a, this.b, this.c, target);
      }
      /**
       * Computes a plane the triangle lies within.
       *
       * @param {Plane} target - The target vector that is used to store the method's result.
       * @return {Plane} The plane the triangle lies within.
       */
      getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
      }
      /**
       * Computes a barycentric coordinates from the given vector.
       * Returns `null` if the triangle is degenerate.
       *
       * @param {Vector3} point - A point in 3D space.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {?Vector3} The barycentric coordinates for the given point
       */
      getBarycoord(point, target) {
        return _Triangle.getBarycoord(point, this.a, this.b, this.c, target);
      }
      /**
       * Computes the value barycentrically interpolated for the given point on the
       * triangle. Returns `null` if the triangle is degenerate.
       *
       * @param {Vector3} point - Position of interpolated point.
       * @param {Vector3} v1 - Value to interpolate of first vertex.
       * @param {Vector3} v2 - Value to interpolate of second vertex.
       * @param {Vector3} v3 - Value to interpolate of third vertex.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {?Vector3} The interpolated value.
       */
      getInterpolation(point, v1, v2, v3, target) {
        return _Triangle.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
      }
      /**
       * Returns `true` if the given point, when projected onto the plane of the
       * triangle, lies within the triangle.
       *
       * @param {Vector3} point - The point in 3D space to test.
       * @return {boolean} Whether the given point, when projected onto the plane of the
       * triangle, lies within the triangle or not.
       */
      containsPoint(point) {
        return _Triangle.containsPoint(point, this.a, this.b, this.c);
      }
      /**
       * Returns `true` if the triangle is oriented towards the given direction.
       *
       * @param {Vector3} direction - The (normalized) direction vector.
       * @return {boolean} Whether the triangle is oriented towards the given direction or not.
       */
      isFrontFacing(direction) {
        return _Triangle.isFrontFacing(this.a, this.b, this.c, direction);
      }
      /**
       * Returns `true` if this triangle intersects with the given box.
       *
       * @param {Box3} box - The box to intersect.
       * @return {boolean} Whether this triangle intersects with the given box or not.
       */
      intersectsBox(box) {
        return box.intersectsTriangle(this);
      }
      /**
       * Returns the closest point on the triangle to the given point.
       *
       * @param {Vector3} p - The point to compute the closest point for.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The closest point on the triangle.
       */
      closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        _vab.subVectors(b, a);
        _vac.subVectors(c, a);
        _vap.subVectors(p, a);
        const d1 = _vab.dot(_vap);
        const d2 = _vac.dot(_vap);
        if (d1 <= 0 && d2 <= 0) {
          return target.copy(a);
        }
        _vbp.subVectors(p, b);
        const d3 = _vab.dot(_vbp);
        const d4 = _vac.dot(_vbp);
        if (d3 >= 0 && d4 <= d3) {
          return target.copy(b);
        }
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
          v = d1 / (d1 - d3);
          return target.copy(a).addScaledVector(_vab, v);
        }
        _vcp.subVectors(p, c);
        const d5 = _vab.dot(_vcp);
        const d6 = _vac.dot(_vcp);
        if (d6 >= 0 && d5 <= d6) {
          return target.copy(c);
        }
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
          w = d2 / (d2 - d6);
          return target.copy(a).addScaledVector(_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
          _vbc.subVectors(c, b);
          w = (d4 - d3) / (d4 - d3 + (d5 - d6));
          return target.copy(b).addScaledVector(_vbc, w);
        }
        const denom = 1 / (va + vb + vc);
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector(_vab, v).addScaledVector(_vac, w);
      }
      /**
       * Returns `true` if this triangle is equal with the given one.
       *
       * @param {Triangle} triangle - The triangle to test for equality.
       * @return {boolean} Whether this triangle is equal with the given one.
       */
      equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
      }
    };
    _colorKeywords = {
      "aliceblue": 15792383,
      "antiquewhite": 16444375,
      "aqua": 65535,
      "aquamarine": 8388564,
      "azure": 15794175,
      "beige": 16119260,
      "bisque": 16770244,
      "black": 0,
      "blanchedalmond": 16772045,
      "blue": 255,
      "blueviolet": 9055202,
      "brown": 10824234,
      "burlywood": 14596231,
      "cadetblue": 6266528,
      "chartreuse": 8388352,
      "chocolate": 13789470,
      "coral": 16744272,
      "cornflowerblue": 6591981,
      "cornsilk": 16775388,
      "crimson": 14423100,
      "cyan": 65535,
      "darkblue": 139,
      "darkcyan": 35723,
      "darkgoldenrod": 12092939,
      "darkgray": 11119017,
      "darkgreen": 25600,
      "darkgrey": 11119017,
      "darkkhaki": 12433259,
      "darkmagenta": 9109643,
      "darkolivegreen": 5597999,
      "darkorange": 16747520,
      "darkorchid": 10040012,
      "darkred": 9109504,
      "darksalmon": 15308410,
      "darkseagreen": 9419919,
      "darkslateblue": 4734347,
      "darkslategray": 3100495,
      "darkslategrey": 3100495,
      "darkturquoise": 52945,
      "darkviolet": 9699539,
      "deeppink": 16716947,
      "deepskyblue": 49151,
      "dimgray": 6908265,
      "dimgrey": 6908265,
      "dodgerblue": 2003199,
      "firebrick": 11674146,
      "floralwhite": 16775920,
      "forestgreen": 2263842,
      "fuchsia": 16711935,
      "gainsboro": 14474460,
      "ghostwhite": 16316671,
      "gold": 16766720,
      "goldenrod": 14329120,
      "gray": 8421504,
      "green": 32768,
      "greenyellow": 11403055,
      "grey": 8421504,
      "honeydew": 15794160,
      "hotpink": 16738740,
      "indianred": 13458524,
      "indigo": 4915330,
      "ivory": 16777200,
      "khaki": 15787660,
      "lavender": 15132410,
      "lavenderblush": 16773365,
      "lawngreen": 8190976,
      "lemonchiffon": 16775885,
      "lightblue": 11393254,
      "lightcoral": 15761536,
      "lightcyan": 14745599,
      "lightgoldenrodyellow": 16448210,
      "lightgray": 13882323,
      "lightgreen": 9498256,
      "lightgrey": 13882323,
      "lightpink": 16758465,
      "lightsalmon": 16752762,
      "lightseagreen": 2142890,
      "lightskyblue": 8900346,
      "lightslategray": 7833753,
      "lightslategrey": 7833753,
      "lightsteelblue": 11584734,
      "lightyellow": 16777184,
      "lime": 65280,
      "limegreen": 3329330,
      "linen": 16445670,
      "magenta": 16711935,
      "maroon": 8388608,
      "mediumaquamarine": 6737322,
      "mediumblue": 205,
      "mediumorchid": 12211667,
      "mediumpurple": 9662683,
      "mediumseagreen": 3978097,
      "mediumslateblue": 8087790,
      "mediumspringgreen": 64154,
      "mediumturquoise": 4772300,
      "mediumvioletred": 13047173,
      "midnightblue": 1644912,
      "mintcream": 16121850,
      "mistyrose": 16770273,
      "moccasin": 16770229,
      "navajowhite": 16768685,
      "navy": 128,
      "oldlace": 16643558,
      "olive": 8421376,
      "olivedrab": 7048739,
      "orange": 16753920,
      "orangered": 16729344,
      "orchid": 14315734,
      "palegoldenrod": 15657130,
      "palegreen": 10025880,
      "paleturquoise": 11529966,
      "palevioletred": 14381203,
      "papayawhip": 16773077,
      "peachpuff": 16767673,
      "peru": 13468991,
      "pink": 16761035,
      "plum": 14524637,
      "powderblue": 11591910,
      "purple": 8388736,
      "rebeccapurple": 6697881,
      "red": 16711680,
      "rosybrown": 12357519,
      "royalblue": 4286945,
      "saddlebrown": 9127187,
      "salmon": 16416882,
      "sandybrown": 16032864,
      "seagreen": 3050327,
      "seashell": 16774638,
      "sienna": 10506797,
      "silver": 12632256,
      "skyblue": 8900331,
      "slateblue": 6970061,
      "slategray": 7372944,
      "slategrey": 7372944,
      "snow": 16775930,
      "springgreen": 65407,
      "steelblue": 4620980,
      "tan": 13808780,
      "teal": 32896,
      "thistle": 14204888,
      "tomato": 16737095,
      "turquoise": 4251856,
      "violet": 15631086,
      "wheat": 16113331,
      "white": 16777215,
      "whitesmoke": 16119285,
      "yellow": 16776960,
      "yellowgreen": 10145074
    };
    _hslA = { h: 0, s: 0, l: 0 };
    _hslB = { h: 0, s: 0, l: 0 };
    Color = class {
      /**
       * Constructs a new color.
       *
       * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
       * and that method is used throughout the rest of the documentation.
       *
       * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
       * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
       * @param {number} [g] - The green component.
       * @param {number} [b] - The blue component.
       */
      constructor(r, g, b) {
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
      }
      /**
       * Sets the colors's components from the given values.
       *
       * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
       * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
       * @param {number} [g] - The green component.
       * @param {number} [b] - The blue component.
       * @return {Color} A reference to this color.
       */
      set(r, g, b) {
        if (g === void 0 && b === void 0) {
          const value = r;
          if (value && value.isColor) {
            this.copy(value);
          } else if (typeof value === "number") {
            this.setHex(value);
          } else if (typeof value === "string") {
            this.setStyle(value);
          }
        } else {
          this.setRGB(r, g, b);
        }
        return this;
      }
      /**
       * Sets the colors's components to the given scalar value.
       *
       * @param {number} scalar - The scalar value.
       * @return {Color} A reference to this color.
       */
      setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
      }
      /**
       * Sets this color from a hexadecimal value.
       *
       * @param {number} hex - The hexadecimal value.
       * @param {string} [colorSpace=SRGBColorSpace] - The color space.
       * @return {Color} A reference to this color.
       */
      setHex(hex, colorSpace = SRGBColorSpace) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        ColorManagement.colorSpaceToWorking(this, colorSpace);
        return this;
      }
      /**
       * Sets this color from RGB values.
       *
       * @param {number} r - Red channel value between `0.0` and `1.0`.
       * @param {number} g - Green channel value between `0.0` and `1.0`.
       * @param {number} b - Blue channel value between `0.0` and `1.0`.
       * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
       * @return {Color} A reference to this color.
       */
      setRGB(r, g, b, colorSpace = ColorManagement.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        ColorManagement.colorSpaceToWorking(this, colorSpace);
        return this;
      }
      /**
       * Sets this color from RGB values.
       *
       * @param {number} h - Hue value between `0.0` and `1.0`.
       * @param {number} s - Saturation value between `0.0` and `1.0`.
       * @param {number} l - Lightness value between `0.0` and `1.0`.
       * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
       * @return {Color} A reference to this color.
       */
      setHSL(h, s, l, colorSpace = ColorManagement.workingColorSpace) {
        h = euclideanModulo(h, 1);
        s = clamp(s, 0, 1);
        l = clamp(l, 0, 1);
        if (s === 0) {
          this.r = this.g = this.b = l;
        } else {
          const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
          const q = 2 * l - p;
          this.r = hue2rgb(q, p, h + 1 / 3);
          this.g = hue2rgb(q, p, h);
          this.b = hue2rgb(q, p, h - 1 / 3);
        }
        ColorManagement.colorSpaceToWorking(this, colorSpace);
        return this;
      }
      /**
       * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
       * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
       * any [X11 color name]{@link https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart} -
       * all 140 color names are supported).
       *
       * @param {string} style - Color as a CSS-style string.
       * @param {string} [colorSpace=SRGBColorSpace] - The color space.
       * @return {Color} A reference to this color.
       */
      setStyle(style, colorSpace = SRGBColorSpace) {
        function handleAlpha(string) {
          if (string === void 0) return;
          if (parseFloat(string) < 1) {
            console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
          }
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
          let color;
          const name = m[1];
          const components = m[2];
          switch (name) {
            case "rgb":
            case "rgba":
              if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                handleAlpha(color[4]);
                return this.setRGB(
                  Math.min(255, parseInt(color[1], 10)) / 255,
                  Math.min(255, parseInt(color[2], 10)) / 255,
                  Math.min(255, parseInt(color[3], 10)) / 255,
                  colorSpace
                );
              }
              if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                handleAlpha(color[4]);
                return this.setRGB(
                  Math.min(100, parseInt(color[1], 10)) / 100,
                  Math.min(100, parseInt(color[2], 10)) / 100,
                  Math.min(100, parseInt(color[3], 10)) / 100,
                  colorSpace
                );
              }
              break;
            case "hsl":
            case "hsla":
              if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                handleAlpha(color[4]);
                return this.setHSL(
                  parseFloat(color[1]) / 360,
                  parseFloat(color[2]) / 100,
                  parseFloat(color[3]) / 100,
                  colorSpace
                );
              }
              break;
            default:
              console.warn("THREE.Color: Unknown color model " + style);
          }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
          const hex = m[1];
          const size = hex.length;
          if (size === 3) {
            return this.setRGB(
              parseInt(hex.charAt(0), 16) / 15,
              parseInt(hex.charAt(1), 16) / 15,
              parseInt(hex.charAt(2), 16) / 15,
              colorSpace
            );
          } else if (size === 6) {
            return this.setHex(parseInt(hex, 16), colorSpace);
          } else {
            console.warn("THREE.Color: Invalid hex color " + style);
          }
        } else if (style && style.length > 0) {
          return this.setColorName(style, colorSpace);
        }
        return this;
      }
      /**
       * Sets this color from a color name. Faster than {@link Color#setStyle} if
       * you don't need the other CSS-style formats.
       *
       * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
       * ```js
       * Color.NAMES.aliceblue // returns 0xF0F8FF
       * ```
       *
       * @param {string} style - The color name.
       * @param {string} [colorSpace=SRGBColorSpace] - The color space.
       * @return {Color} A reference to this color.
       */
      setColorName(style, colorSpace = SRGBColorSpace) {
        const hex = _colorKeywords[style.toLowerCase()];
        if (hex !== void 0) {
          this.setHex(hex, colorSpace);
        } else {
          console.warn("THREE.Color: Unknown color " + style);
        }
        return this;
      }
      /**
       * Returns a new color with copied values from this instance.
       *
       * @return {Color} A clone of this instance.
       */
      clone() {
        return new this.constructor(this.r, this.g, this.b);
      }
      /**
       * Copies the values of the given color to this instance.
       *
       * @param {Color} color - The color to copy.
       * @return {Color} A reference to this color.
       */
      copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
      }
      /**
       * Copies the given color into this color, and then converts this color from
       * `SRGBColorSpace` to `LinearSRGBColorSpace`.
       *
       * @param {Color} color - The color to copy/convert.
       * @return {Color} A reference to this color.
       */
      copySRGBToLinear(color) {
        this.r = SRGBToLinear(color.r);
        this.g = SRGBToLinear(color.g);
        this.b = SRGBToLinear(color.b);
        return this;
      }
      /**
       * Copies the given color into this color, and then converts this color from
       * `LinearSRGBColorSpace` to `SRGBColorSpace`.
       *
       * @param {Color} color - The color to copy/convert.
       * @return {Color} A reference to this color.
       */
      copyLinearToSRGB(color) {
        this.r = LinearToSRGB(color.r);
        this.g = LinearToSRGB(color.g);
        this.b = LinearToSRGB(color.b);
        return this;
      }
      /**
       * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
       *
       * @return {Color} A reference to this color.
       */
      convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
      }
      /**
       * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
       *
       * @return {Color} A reference to this color.
       */
      convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
      }
      /**
       * Returns the hexadecimal value of this color.
       *
       * @param {string} [colorSpace=SRGBColorSpace] - The color space.
       * @return {number} The hexadecimal value.
       */
      getHex(colorSpace = SRGBColorSpace) {
        ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
        return Math.round(clamp(_color.r * 255, 0, 255)) * 65536 + Math.round(clamp(_color.g * 255, 0, 255)) * 256 + Math.round(clamp(_color.b * 255, 0, 255));
      }
      /**
       * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
       *
       * @param {string} [colorSpace=SRGBColorSpace] - The color space.
       * @return {string} The hexadecimal value as a string.
       */
      getHexString(colorSpace = SRGBColorSpace) {
        return ("000000" + this.getHex(colorSpace).toString(16)).slice(-6);
      }
      /**
       * Converts the colors RGB values into the HSL format and stores them into the
       * given target object.
       *
       * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
       * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
       * @return {{h:number,s:number,l:number}} The HSL representation of this color.
       */
      getHSL(target, colorSpace = ColorManagement.workingColorSpace) {
        ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
        const r = _color.r, g = _color.g, b = _color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2;
        if (min === max) {
          hue = 0;
          saturation = 0;
        } else {
          const delta = max - min;
          saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
          switch (max) {
            case r:
              hue = (g - b) / delta + (g < b ? 6 : 0);
              break;
            case g:
              hue = (b - r) / delta + 2;
              break;
            case b:
              hue = (r - g) / delta + 4;
              break;
          }
          hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
      }
      /**
       * Returns the RGB values of this color and stores them into the given target object.
       *
       * @param {Color} target - The target color that is used to store the method's result.
       * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
       * @return {Color} The RGB representation of this color.
       */
      getRGB(target, colorSpace = ColorManagement.workingColorSpace) {
        ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
        target.r = _color.r;
        target.g = _color.g;
        target.b = _color.b;
        return target;
      }
      /**
       * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
       *
       * @param {string} [colorSpace=SRGBColorSpace] - The color space.
       * @return {string} The CSS representation of this color.
       */
      getStyle(colorSpace = SRGBColorSpace) {
        ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
        const r = _color.r, g = _color.g, b = _color.b;
        if (colorSpace !== SRGBColorSpace) {
          return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        }
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
      }
      /**
       * Adds the given HSL values to this color's values.
       * Internally, this converts the color's RGB values to HSL, adds HSL
       * and then converts the color back to RGB.
       *
       * @param {number} h - Hue value between `0.0` and `1.0`.
       * @param {number} s - Saturation value between `0.0` and `1.0`.
       * @param {number} l - Lightness value between `0.0` and `1.0`.
       * @return {Color} A reference to this color.
       */
      offsetHSL(h, s, l) {
        this.getHSL(_hslA);
        return this.setHSL(_hslA.h + h, _hslA.s + s, _hslA.l + l);
      }
      /**
       * Adds the RGB values of the given color to the RGB values of this color.
       *
       * @param {Color} color - The color to add.
       * @return {Color} A reference to this color.
       */
      add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
      }
      /**
       * Adds the RGB values of the given colors and stores the result in this instance.
       *
       * @param {Color} color1 - The first color.
       * @param {Color} color2 - The second color.
       * @return {Color} A reference to this color.
       */
      addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
      }
      /**
       * Adds the given scalar value to the RGB values of this color.
       *
       * @param {number} s - The scalar to add.
       * @return {Color} A reference to this color.
       */
      addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
      }
      /**
       * Subtracts the RGB values of the given color from the RGB values of this color.
       *
       * @param {Color} color - The color to subtract.
       * @return {Color} A reference to this color.
       */
      sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
      }
      /**
       * Multiplies the RGB values of the given color with the RGB values of this color.
       *
       * @param {Color} color - The color to multiply.
       * @return {Color} A reference to this color.
       */
      multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
      }
      /**
       * Multiplies the given scalar value with the RGB values of this color.
       *
       * @param {number} s - The scalar to multiply.
       * @return {Color} A reference to this color.
       */
      multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
      }
      /**
       * Linearly interpolates this color's RGB values toward the RGB values of the
       * given color. The alpha argument can be thought of as the ratio between
       * the two colors, where `0.0` is this color and `1.0` is the first argument.
       *
       * @param {Color} color - The color to converge on.
       * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
       * @return {Color} A reference to this color.
       */
      lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
      }
      /**
       * Linearly interpolates between the given colors and stores the result in this instance.
       * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
       * is the first and `1.0` is the second color.
       *
       * @param {Color} color1 - The first color.
       * @param {Color} color2 - The second color.
       * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
       * @return {Color} A reference to this color.
       */
      lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
      }
      /**
       * Linearly interpolates this color's HSL values toward the HSL values of the
       * given color. It differs from {@link Color#lerp} by not interpolating straight
       * from one color to the other, but instead going through all the hues in between
       * those two colors. The alpha argument can be thought of as the ratio between
       * the two colors, where 0.0 is this color and 1.0 is the first argument.
       *
       * @param {Color} color - The color to converge on.
       * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
       * @return {Color} A reference to this color.
       */
      lerpHSL(color, alpha) {
        this.getHSL(_hslA);
        color.getHSL(_hslB);
        const h = lerp(_hslA.h, _hslB.h, alpha);
        const s = lerp(_hslA.s, _hslB.s, alpha);
        const l = lerp(_hslA.l, _hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
      }
      /**
       * Sets the color's RGB components from the given 3D vector.
       *
       * @param {Vector3} v - The vector to set.
       * @return {Color} A reference to this color.
       */
      setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
      }
      /**
       * Transforms this color with the given 3x3 matrix.
       *
       * @param {Matrix3} m - The matrix.
       * @return {Color} A reference to this color.
       */
      applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
      }
      /**
       * Returns `true` if this color is equal with the given one.
       *
       * @param {Color} c - The color to test for equality.
       * @return {boolean} Whether this bounding color is equal with the given one.
       */
      equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
      }
      /**
       * Sets this color's RGB components from the given array.
       *
       * @param {Array<number>} array - An array holding the RGB values.
       * @param {number} [offset=0] - The offset into the array.
       * @return {Color} A reference to this color.
       */
      fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
      }
      /**
       * Writes the RGB components of this color to the given array. If no array is provided,
       * the method returns a new instance.
       *
       * @param {Array<number>} [array=[]] - The target array holding the color components.
       * @param {number} [offset=0] - Index of the first element in the array.
       * @return {Array<number>} The color components.
       */
      toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
      }
      /**
       * Sets the components of this color from the given buffer attribute.
       *
       * @param {BufferAttribute} attribute - The buffer attribute holding color data.
       * @param {number} index - The index into the attribute.
       * @return {Color} A reference to this color.
       */
      fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
      }
      /**
       * This methods defines the serialization result of this class. Returns the color
       * as a hexadecimal value.
       *
       * @return {number} The hexadecimal value.
       */
      toJSON() {
        return this.getHex();
      }
      *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
      }
    };
    _color = /* @__PURE__ */ new Color();
    Color.NAMES = _colorKeywords;
    _materialId = 0;
    Material = class extends EventDispatcher {
      /**
       * Constructs a new material.
       */
      constructor() {
        super();
        this.isMaterial = true;
        Object.defineProperty(this, "id", { value: _materialId++ });
        this.uuid = generateUUID();
        this.name = "";
        this.type = "Material";
        this.blending = NormalBlending;
        this.side = FrontSide;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = SrcAlphaFactor;
        this.blendDst = OneMinusSrcAlphaFactor;
        this.blendEquation = AddEquation;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.blendColor = new Color(0, 0, 0);
        this.blendAlpha = 0;
        this.depthFunc = LessEqualDepth;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 255;
        this.stencilFunc = AlwaysStencilFunc;
        this.stencilRef = 0;
        this.stencilFuncMask = 255;
        this.stencilFail = KeepStencilOp;
        this.stencilZFail = KeepStencilOp;
        this.stencilZPass = KeepStencilOp;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null;
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.allowOverride = true;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
      }
      /**
       * Sets the alpha value to be used when running an alpha test. The material
       * will not be rendered if the opacity is lower than this value.
       *
       * @type {number}
       * @readonly
       * @default 0
       */
      get alphaTest() {
        return this._alphaTest;
      }
      set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) {
          this.version++;
        }
        this._alphaTest = value;
      }
      /**
       * An optional callback that is executed immediately before the material is used to render a 3D object.
       *
       * This method can only be used when rendering with {@link WebGLRenderer}.
       *
       * @param {WebGLRenderer} renderer - The renderer.
       * @param {Scene} scene - The scene.
       * @param {Camera} camera - The camera that is used to render the scene.
       * @param {BufferGeometry} geometry - The 3D object's geometry.
       * @param {Object3D} object - The 3D object.
       * @param {Object} group - The geometry group data.
       */
      onBeforeRender() {
      }
      /**
       * An optional callback that is executed immediately before the shader
       * program is compiled. This function is called with the shader source code
       * as a parameter. Useful for the modification of built-in materials.
       *
       * This method can only be used when rendering with {@link WebGLRenderer}. The
       * recommended approach when customizing materials is to use `WebGPURenderer` with the new
       * Node Material system and [TSL]{@link https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language}.
       *
       * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
       * @param {WebGLRenderer} renderer - A reference to the renderer.
       */
      onBeforeCompile() {
      }
      /**
       * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
       * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
       * shader or recompile the shader for this material as needed.
       *
       * This method can only be used when rendering with {@link WebGLRenderer}.
       *
       * @return {string} The custom program cache key.
       */
      customProgramCacheKey() {
        return this.onBeforeCompile.toString();
      }
      /**
       * This method can be used to set default values from parameter objects.
       * It is a generic implementation so it can be used with different types
       * of materials.
       *
       * @param {Object} [values] - The material values to set.
       */
      setValues(values) {
        if (values === void 0) return;
        for (const key in values) {
          const newValue = values[key];
          if (newValue === void 0) {
            console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
            continue;
          }
          const currentValue = this[key];
          if (currentValue === void 0) {
            console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
            continue;
          }
          if (currentValue && currentValue.isColor) {
            currentValue.set(newValue);
          } else if (currentValue && currentValue.isVector3 && (newValue && newValue.isVector3)) {
            currentValue.copy(newValue);
          } else {
            this[key] = newValue;
          }
        }
      }
      /**
       * Serializes the material into JSON.
       *
       * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
       * @return {Object} A JSON object representing the serialized material.
       * @see {@link ObjectLoader#parse}
       */
      toJSON(meta) {
        const isRootObject = meta === void 0 || typeof meta === "string";
        if (isRootObject) {
          meta = {
            textures: {},
            images: {}
          };
        }
        const data = {
          metadata: {
            version: 4.7,
            type: "Material",
            generator: "Material.toJSON"
          }
        };
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== void 0) data.roughness = this.roughness;
        if (this.metalness !== void 0) data.metalness = this.metalness;
        if (this.sheen !== void 0) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== void 0) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== void 0) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== void 0) data.shininess = this.shininess;
        if (this.clearcoat !== void 0) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== void 0) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) {
          data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        }
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) {
          data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        }
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
          data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
          data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.sheenColorMap && this.sheenColorMap.isTexture) {
          data.sheenColorMap = this.sheenColorMap.toJSON(meta).uuid;
        }
        if (this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture) {
          data.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(meta).uuid;
        }
        if (this.dispersion !== void 0) data.dispersion = this.dispersion;
        if (this.iridescence !== void 0) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== void 0) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== void 0) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) {
          data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        }
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) {
          data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        }
        if (this.anisotropy !== void 0) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== void 0) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) {
          data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        }
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
          data.lightMap = this.lightMap.toJSON(meta).uuid;
          data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
          data.aoMap = this.aoMap.toJSON(meta).uuid;
          data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
          data.bumpMap = this.bumpMap.toJSON(meta).uuid;
          data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
          data.normalMap = this.normalMap.toJSON(meta).uuid;
          data.normalMapType = this.normalMapType;
          data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
          data.displacementMap = this.displacementMap.toJSON(meta).uuid;
          data.displacementScale = this.displacementScale;
          data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
          data.envMap = this.envMap.toJSON(meta).uuid;
          if (this.combine !== void 0) data.combine = this.combine;
        }
        if (this.envMapRotation !== void 0) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== void 0) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== void 0) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== void 0) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) {
          data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        }
        if (this.transmission !== void 0) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== void 0) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== void 0 && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== void 0) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== void 0) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== void 0) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== NormalBlending) data.blending = this.blending;
        if (this.side !== FrontSide) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== SrcAlphaFactor) data.blendSrc = this.blendSrc;
        if (this.blendDst !== OneMinusSrcAlphaFactor) data.blendDst = this.blendDst;
        if (this.blendEquation !== AddEquation) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== LessEqualDepth) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 255) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== AlwaysStencilFunc) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 255) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== KeepStencilOp) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== KeepStencilOp) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== KeepStencilOp) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        if (this.rotation !== void 0 && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== void 0 && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== void 0) data.dashSize = this.dashSize;
        if (this.gapSize !== void 0) data.gapSize = this.gapSize;
        if (this.scale !== void 0) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        function extractFromCache(cache) {
          const values = [];
          for (const key in cache) {
            const data2 = cache[key];
            delete data2.metadata;
            values.push(data2);
          }
          return values;
        }
        if (isRootObject) {
          const textures = extractFromCache(meta.textures);
          const images = extractFromCache(meta.images);
          if (textures.length > 0) data.textures = textures;
          if (images.length > 0) data.images = images;
        }
        return data;
      }
      /**
       * Returns a new material with copied values from this instance.
       *
       * @return {Material} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
      /**
       * Copies the values of the given material to this instance.
       *
       * @param {Material} source - The material to copy.
       * @return {Material} A reference to this instance.
       */
      copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
          const n = srcPlanes.length;
          dstPlanes = new Array(n);
          for (let i = 0; i !== n; ++i) {
            dstPlanes[i] = srcPlanes[i].clone();
          }
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
      }
      /**
       * Frees the GPU-related resources allocated by this instance. Call this
       * method whenever this instance is no longer used in your app.
       *
       * @fires Material#dispose
       */
      dispose() {
        this.dispatchEvent({ type: "dispose" });
      }
      /**
       * Setting this property to `true` indicates the engine the material
       * needs to be recompiled.
       *
       * @type {boolean}
       * @default false
       * @param {boolean} value
       */
      set needsUpdate(value) {
        if (value === true) this.version++;
      }
    };
    MeshBasicMaterial = class extends Material {
      /**
       * Constructs a new mesh basic material.
       *
       * @param {Object} [parameters] - An object with one or more properties
       * defining the material's appearance. Any property of the material
       * (including any property from inherited materials) can be passed
       * in here. Color values can be passed any type of value accepted
       * by {@link Color#set}.
       */
      constructor(parameters) {
        super();
        this.isMeshBasicMaterial = true;
        this.type = "MeshBasicMaterial";
        this.color = new Color(16777215);
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1;
        this.aoMap = null;
        this.aoMapIntensity = 1;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new Euler();
        this.combine = MultiplyOperation;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
      }
      copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
      }
    };
    _vector$9 = /* @__PURE__ */ new Vector3();
    _vector2$1 = /* @__PURE__ */ new Vector2();
    _id$2 = 0;
    BufferAttribute = class {
      /**
       * Constructs a new buffer attribute.
       *
       * @param {TypedArray} array - The array holding the attribute data.
       * @param {number} itemSize - The item size.
       * @param {boolean} [normalized=false] - Whether the data are normalized or not.
       */
      constructor(array, itemSize, normalized = false) {
        if (Array.isArray(array)) {
          throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        }
        this.isBufferAttribute = true;
        Object.defineProperty(this, "id", { value: _id$2++ });
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== void 0 ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = StaticDrawUsage;
        this.updateRanges = [];
        this.gpuType = FloatType;
        this.version = 0;
      }
      /**
       * A callback function that is executed after the renderer has transferred the attribute
       * array data to the GPU.
       */
      onUploadCallback() {
      }
      /**
       * Flag to indicate that this attribute has changed and should be re-sent to
       * the GPU. Set this to `true` when you modify the value of the array.
       *
       * @type {number}
       * @default false
       * @param {boolean} value
       */
      set needsUpdate(value) {
        if (value === true) this.version++;
      }
      /**
       * Sets the usage of this buffer attribute.
       *
       * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
       * @return {BufferAttribute} A reference to this buffer attribute.
       */
      setUsage(value) {
        this.usage = value;
        return this;
      }
      /**
       * Adds a range of data in the data array to be updated on the GPU.
       *
       * @param {number} start - Position at which to start update.
       * @param {number} count - The number of components to update.
       */
      addUpdateRange(start, count) {
        this.updateRanges.push({ start, count });
      }
      /**
       * Clears the update ranges.
       */
      clearUpdateRanges() {
        this.updateRanges.length = 0;
      }
      /**
       * Copies the values of the given buffer attribute to this instance.
       *
       * @param {BufferAttribute} source - The buffer attribute to copy.
       * @return {BufferAttribute} A reference to this instance.
       */
      copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
      }
      /**
       * Copies a vector from the given buffer attribute to this one. The start
       * and destination position in the attribute buffers are represented by the
       * given indices.
       *
       * @param {number} index1 - The destination index into this buffer attribute.
       * @param {BufferAttribute} attribute - The buffer attribute to copy from.
       * @param {number} index2 - The source index into the given buffer attribute.
       * @return {BufferAttribute} A reference to this instance.
       */
      copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for (let i = 0, l = this.itemSize; i < l; i++) {
          this.array[index1 + i] = attribute.array[index2 + i];
        }
        return this;
      }
      /**
       * Copies the given array data into this buffer attribute.
       *
       * @param {(TypedArray|Array)} array - The array to copy.
       * @return {BufferAttribute} A reference to this instance.
       */
      copyArray(array) {
        this.array.set(array);
        return this;
      }
      /**
       * Applies the given 3x3 matrix to the given attribute. Works with
       * item size `2` and `3`.
       *
       * @param {Matrix3} m - The matrix to apply.
       * @return {BufferAttribute} A reference to this instance.
       */
      applyMatrix3(m) {
        if (this.itemSize === 2) {
          for (let i = 0, l = this.count; i < l; i++) {
            _vector2$1.fromBufferAttribute(this, i);
            _vector2$1.applyMatrix3(m);
            this.setXY(i, _vector2$1.x, _vector2$1.y);
          }
        } else if (this.itemSize === 3) {
          for (let i = 0, l = this.count; i < l; i++) {
            _vector$9.fromBufferAttribute(this, i);
            _vector$9.applyMatrix3(m);
            this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
          }
        }
        return this;
      }
      /**
       * Applies the given 4x4 matrix to the given attribute. Only works with
       * item size `3`.
       *
       * @param {Matrix4} m - The matrix to apply.
       * @return {BufferAttribute} A reference to this instance.
       */
      applyMatrix4(m) {
        for (let i = 0, l = this.count; i < l; i++) {
          _vector$9.fromBufferAttribute(this, i);
          _vector$9.applyMatrix4(m);
          this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
        }
        return this;
      }
      /**
       * Applies the given 3x3 normal matrix to the given attribute. Only works with
       * item size `3`.
       *
       * @param {Matrix3} m - The normal matrix to apply.
       * @return {BufferAttribute} A reference to this instance.
       */
      applyNormalMatrix(m) {
        for (let i = 0, l = this.count; i < l; i++) {
          _vector$9.fromBufferAttribute(this, i);
          _vector$9.applyNormalMatrix(m);
          this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
        }
        return this;
      }
      /**
       * Applies the given 4x4 matrix to the given attribute. Only works with
       * item size `3` and with direction vectors.
       *
       * @param {Matrix4} m - The matrix to apply.
       * @return {BufferAttribute} A reference to this instance.
       */
      transformDirection(m) {
        for (let i = 0, l = this.count; i < l; i++) {
          _vector$9.fromBufferAttribute(this, i);
          _vector$9.transformDirection(m);
          this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
        }
        return this;
      }
      /**
       * Sets the given array data in the buffer attribute.
       *
       * @param {(TypedArray|Array)} value - The array data to set.
       * @param {number} [offset=0] - The offset in this buffer attribute's array.
       * @return {BufferAttribute} A reference to this instance.
       */
      set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
      }
      /**
       * Returns the given component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} component - The component index.
       * @return {number} The returned value.
       */
      getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = denormalize(value, this.array);
        return value;
      }
      /**
       * Sets the given value to the given component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} component - The component index.
       * @param {number} value - The value to set.
       * @return {BufferAttribute} A reference to this instance.
       */
      setComponent(index, component, value) {
        if (this.normalized) value = normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
      }
      /**
       * Returns the x component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @return {number} The x component.
       */
      getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = denormalize(x, this.array);
        return x;
      }
      /**
       * Sets the x component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} x - The value to set.
       * @return {BufferAttribute} A reference to this instance.
       */
      setX(index, x) {
        if (this.normalized) x = normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
      }
      /**
       * Returns the y component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @return {number} The y component.
       */
      getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = denormalize(y, this.array);
        return y;
      }
      /**
       * Sets the y component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} y - The value to set.
       * @return {BufferAttribute} A reference to this instance.
       */
      setY(index, y) {
        if (this.normalized) y = normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
      }
      /**
       * Returns the z component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @return {number} The z component.
       */
      getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = denormalize(z, this.array);
        return z;
      }
      /**
       * Sets the z component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} z - The value to set.
       * @return {BufferAttribute} A reference to this instance.
       */
      setZ(index, z) {
        if (this.normalized) z = normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
      }
      /**
       * Returns the w component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @return {number} The w component.
       */
      getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = denormalize(w, this.array);
        return w;
      }
      /**
       * Sets the w component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} w - The value to set.
       * @return {BufferAttribute} A reference to this instance.
       */
      setW(index, w) {
        if (this.normalized) w = normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
      }
      /**
       * Sets the x and y component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} x - The value for the x component to set.
       * @param {number} y - The value for the y component to set.
       * @return {BufferAttribute} A reference to this instance.
       */
      setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
          x = normalize(x, this.array);
          y = normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
      }
      /**
       * Sets the x, y and z component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} x - The value for the x component to set.
       * @param {number} y - The value for the y component to set.
       * @param {number} z - The value for the z component to set.
       * @return {BufferAttribute} A reference to this instance.
       */
      setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
          x = normalize(x, this.array);
          y = normalize(y, this.array);
          z = normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
      }
      /**
       * Sets the x, y, z and w component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} x - The value for the x component to set.
       * @param {number} y - The value for the y component to set.
       * @param {number} z - The value for the z component to set.
       * @param {number} w - The value for the w component to set.
       * @return {BufferAttribute} A reference to this instance.
       */
      setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
          x = normalize(x, this.array);
          y = normalize(y, this.array);
          z = normalize(z, this.array);
          w = normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
      }
      /**
       * Sets the given callback function that is executed after the Renderer has transferred
       * the attribute array data to the GPU. Can be used to perform clean-up operations after
       * the upload when attribute data are not needed anymore on the CPU side.
       *
       * @param {Function} callback - The `onUpload()` callback.
       * @return {BufferAttribute} A reference to this instance.
       */
      onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
      }
      /**
       * Returns a new buffer attribute with copied values from this instance.
       *
       * @return {BufferAttribute} A clone of this instance.
       */
      clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
      }
      /**
       * Serializes the buffer attribute into JSON.
       *
       * @return {Object} A JSON object representing the serialized buffer attribute.
       */
      toJSON() {
        const data = {
          itemSize: this.itemSize,
          type: this.array.constructor.name,
          array: Array.from(this.array),
          normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== StaticDrawUsage) data.usage = this.usage;
        return data;
      }
    };
    Uint16BufferAttribute = class extends BufferAttribute {
      /**
       * Constructs a new buffer attribute.
       *
       * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
       * @param {number} itemSize - The item size.
       * @param {boolean} [normalized=false] - Whether the data are normalized or not.
       */
      constructor(array, itemSize, normalized) {
        super(new Uint16Array(array), itemSize, normalized);
      }
    };
    Uint32BufferAttribute = class extends BufferAttribute {
      /**
       * Constructs a new buffer attribute.
       *
       * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
       * @param {number} itemSize - The item size.
       * @param {boolean} [normalized=false] - Whether the data are normalized or not.
       */
      constructor(array, itemSize, normalized) {
        super(new Uint32Array(array), itemSize, normalized);
      }
    };
    Float32BufferAttribute = class extends BufferAttribute {
      /**
       * Constructs a new buffer attribute.
       *
       * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
       * @param {number} itemSize - The item size.
       * @param {boolean} [normalized=false] - Whether the data are normalized or not.
       */
      constructor(array, itemSize, normalized) {
        super(new Float32Array(array), itemSize, normalized);
      }
    };
    _id$1 = 0;
    _m1 = /* @__PURE__ */ new Matrix4();
    _obj = /* @__PURE__ */ new Object3D();
    _offset = /* @__PURE__ */ new Vector3();
    _box$2 = /* @__PURE__ */ new Box3();
    _boxMorphTargets = /* @__PURE__ */ new Box3();
    _vector$8 = /* @__PURE__ */ new Vector3();
    BufferGeometry = class _BufferGeometry extends EventDispatcher {
      /**
       * Constructs a new geometry.
       */
      constructor() {
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, "id", { value: _id$1++ });
        this.uuid = generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.indirect = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = { start: 0, count: Infinity };
        this.userData = {};
      }
      /**
       * Returns the index of this geometry.
       *
       * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
       */
      getIndex() {
        return this.index;
      }
      /**
       * Sets the given index to this geometry.
       *
       * @param {Array<number>|BufferAttribute} index - The index to set.
       * @return {BufferGeometry} A reference to this instance.
       */
      setIndex(index) {
        if (Array.isArray(index)) {
          this.index = new (arrayNeedsUint32(index) ? Uint32BufferAttribute : Uint16BufferAttribute)(index, 1);
        } else {
          this.index = index;
        }
        return this;
      }
      /**
       * Sets the given indirect attribute to this geometry.
       *
       * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
       * @return {BufferGeometry} A reference to this instance.
       */
      setIndirect(indirect) {
        this.indirect = indirect;
        return this;
      }
      /**
       * Returns the indirect attribute of this geometry.
       *
       * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
       */
      getIndirect() {
        return this.indirect;
      }
      /**
       * Returns the buffer attribute for the given name.
       *
       * @param {string} name - The attribute name.
       * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
       * Returns `undefined` if not attribute has been found.
       */
      getAttribute(name) {
        return this.attributes[name];
      }
      /**
       * Sets the given attribute for the given name.
       *
       * @param {string} name - The attribute name.
       * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
       * @return {BufferGeometry} A reference to this instance.
       */
      setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
      }
      /**
       * Deletes the attribute for the given name.
       *
       * @param {string} name - The attribute name to delete.
       * @return {BufferGeometry} A reference to this instance.
       */
      deleteAttribute(name) {
        delete this.attributes[name];
        return this;
      }
      /**
       * Returns `true` if this geometry has an attribute for the given name.
       *
       * @param {string} name - The attribute name.
       * @return {boolean} Whether this geometry has an attribute for the given name or not.
       */
      hasAttribute(name) {
        return this.attributes[name] !== void 0;
      }
      /**
       * Adds a group to this geometry.
       *
       * @param {number} start - The first element in this draw call. That is the first
       * vertex for non-indexed geometry, otherwise the first triangle index.
       * @param {number} count - Specifies how many vertices (or indices) are part of this group.
       * @param {number} [materialIndex=0] - The material array index to use.
       */
      addGroup(start, count, materialIndex = 0) {
        this.groups.push({
          start,
          count,
          materialIndex
        });
      }
      /**
       * Clears all groups.
       */
      clearGroups() {
        this.groups = [];
      }
      /**
       * Sets the draw range for this geometry.
       *
       * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
       * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
       * For indexed BufferGeometry, `count` is the number of indices to render.
       */
      setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
      }
      /**
       * Applies the given 4x4 transformation matrix to the geometry.
       *
       * @param {Matrix4} matrix - The matrix to apply.
       * @return {BufferGeometry} A reference to this instance.
       */
      applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== void 0) {
          position.applyMatrix4(matrix);
          position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== void 0) {
          const normalMatrix = new Matrix3().getNormalMatrix(matrix);
          normal.applyNormalMatrix(normalMatrix);
          normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== void 0) {
          tangent.transformDirection(matrix);
          tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) {
          this.computeBoundingBox();
        }
        if (this.boundingSphere !== null) {
          this.computeBoundingSphere();
        }
        return this;
      }
      /**
       * Applies the rotation represented by the Quaternion to the geometry.
       *
       * @param {Quaternion} q - The Quaternion to apply.
       * @return {BufferGeometry} A reference to this instance.
       */
      applyQuaternion(q) {
        _m1.makeRotationFromQuaternion(q);
        this.applyMatrix4(_m1);
        return this;
      }
      /**
       * Rotates the geometry about the X axis. This is typically done as a one time
       * operation, and not during a loop. Use {@link Object3D#rotation} for typical
       * real-time mesh rotation.
       *
       * @param {number} angle - The angle in radians.
       * @return {BufferGeometry} A reference to this instance.
       */
      rotateX(angle) {
        _m1.makeRotationX(angle);
        this.applyMatrix4(_m1);
        return this;
      }
      /**
       * Rotates the geometry about the Y axis. This is typically done as a one time
       * operation, and not during a loop. Use {@link Object3D#rotation} for typical
       * real-time mesh rotation.
       *
       * @param {number} angle - The angle in radians.
       * @return {BufferGeometry} A reference to this instance.
       */
      rotateY(angle) {
        _m1.makeRotationY(angle);
        this.applyMatrix4(_m1);
        return this;
      }
      /**
       * Rotates the geometry about the Z axis. This is typically done as a one time
       * operation, and not during a loop. Use {@link Object3D#rotation} for typical
       * real-time mesh rotation.
       *
       * @param {number} angle - The angle in radians.
       * @return {BufferGeometry} A reference to this instance.
       */
      rotateZ(angle) {
        _m1.makeRotationZ(angle);
        this.applyMatrix4(_m1);
        return this;
      }
      /**
       * Translates the geometry. This is typically done as a one time
       * operation, and not during a loop. Use {@link Object3D#position} for typical
       * real-time mesh rotation.
       *
       * @param {number} x - The x offset.
       * @param {number} y - The y offset.
       * @param {number} z - The z offset.
       * @return {BufferGeometry} A reference to this instance.
       */
      translate(x, y, z) {
        _m1.makeTranslation(x, y, z);
        this.applyMatrix4(_m1);
        return this;
      }
      /**
       * Scales the geometry. This is typically done as a one time
       * operation, and not during a loop. Use {@link Object3D#scale} for typical
       * real-time mesh rotation.
       *
       * @param {number} x - The x scale.
       * @param {number} y - The y scale.
       * @param {number} z - The z scale.
       * @return {BufferGeometry} A reference to this instance.
       */
      scale(x, y, z) {
        _m1.makeScale(x, y, z);
        this.applyMatrix4(_m1);
        return this;
      }
      /**
       * Rotates the geometry to face a point in 3D space. This is typically done as a one time
       * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
       * real-time mesh rotation.
       *
       * @param {Vector3} vector - The target point.
       * @return {BufferGeometry} A reference to this instance.
       */
      lookAt(vector) {
        _obj.lookAt(vector);
        _obj.updateMatrix();
        this.applyMatrix4(_obj.matrix);
        return this;
      }
      /**
       * Center the geometry based on its bounding box.
       *
       * @return {BufferGeometry} A reference to this instance.
       */
      center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter(_offset).negate();
        this.translate(_offset.x, _offset.y, _offset.z);
        return this;
      }
      /**
       * Defines a geometry by creating a `position` attribute based on the given array of points. The array
       * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
       * set to `0`.
       *
       * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
       * data from the array. The length of the array must match the vertex count.
       *
       * @param {Array<Vector2>|Array<Vector3>} points - The points.
       * @return {BufferGeometry} A reference to this instance.
       */
      setFromPoints(points) {
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute === void 0) {
          const position = [];
          for (let i = 0, l = points.length; i < l; i++) {
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
          }
          this.setAttribute("position", new Float32BufferAttribute(position, 3));
        } else {
          const l = Math.min(points.length, positionAttribute.count);
          for (let i = 0; i < l; i++) {
            const point = points[i];
            positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
          }
          if (points.length > positionAttribute.count) {
            console.warn("THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.");
          }
          positionAttribute.needsUpdate = true;
        }
        return this;
      }
      /**
       * Computes the bounding box of the geometry, and updates the `boundingBox` member.
       * The bounding box is not computed by the engine; it must be computed by your app.
       * You may need to recompute the bounding box if the geometry vertices are modified.
       */
      computeBoundingBox() {
        if (this.boundingBox === null) {
          this.boundingBox = new Box3();
        }
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
          console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this);
          this.boundingBox.set(
            new Vector3(-Infinity, -Infinity, -Infinity),
            new Vector3(Infinity, Infinity, Infinity)
          );
          return;
        }
        if (position !== void 0) {
          this.boundingBox.setFromBufferAttribute(position);
          if (morphAttributesPosition) {
            for (let i = 0, il = morphAttributesPosition.length; i < il; i++) {
              const morphAttribute = morphAttributesPosition[i];
              _box$2.setFromBufferAttribute(morphAttribute);
              if (this.morphTargetsRelative) {
                _vector$8.addVectors(this.boundingBox.min, _box$2.min);
                this.boundingBox.expandByPoint(_vector$8);
                _vector$8.addVectors(this.boundingBox.max, _box$2.max);
                this.boundingBox.expandByPoint(_vector$8);
              } else {
                this.boundingBox.expandByPoint(_box$2.min);
                this.boundingBox.expandByPoint(_box$2.max);
              }
            }
          }
        } else {
          this.boundingBox.makeEmpty();
        }
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {
          console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
        }
      }
      /**
       * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
       * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
       * You may need to recompute the bounding sphere if the geometry vertices are modified.
       */
      computeBoundingSphere() {
        if (this.boundingSphere === null) {
          this.boundingSphere = new Sphere();
        }
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
          console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this);
          this.boundingSphere.set(new Vector3(), Infinity);
          return;
        }
        if (position) {
          const center = this.boundingSphere.center;
          _box$2.setFromBufferAttribute(position);
          if (morphAttributesPosition) {
            for (let i = 0, il = morphAttributesPosition.length; i < il; i++) {
              const morphAttribute = morphAttributesPosition[i];
              _boxMorphTargets.setFromBufferAttribute(morphAttribute);
              if (this.morphTargetsRelative) {
                _vector$8.addVectors(_box$2.min, _boxMorphTargets.min);
                _box$2.expandByPoint(_vector$8);
                _vector$8.addVectors(_box$2.max, _boxMorphTargets.max);
                _box$2.expandByPoint(_vector$8);
              } else {
                _box$2.expandByPoint(_boxMorphTargets.min);
                _box$2.expandByPoint(_boxMorphTargets.max);
              }
            }
          }
          _box$2.getCenter(center);
          let maxRadiusSq = 0;
          for (let i = 0, il = position.count; i < il; i++) {
            _vector$8.fromBufferAttribute(position, i);
            maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
          }
          if (morphAttributesPosition) {
            for (let i = 0, il = morphAttributesPosition.length; i < il; i++) {
              const morphAttribute = morphAttributesPosition[i];
              const morphTargetsRelative = this.morphTargetsRelative;
              for (let j = 0, jl = morphAttribute.count; j < jl; j++) {
                _vector$8.fromBufferAttribute(morphAttribute, j);
                if (morphTargetsRelative) {
                  _offset.fromBufferAttribute(position, j);
                  _vector$8.add(_offset);
                }
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
              }
            }
          }
          this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
          if (isNaN(this.boundingSphere.radius)) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
          }
        }
      }
      /**
       * Calculates and adds a tangent attribute to this geometry.
       *
       * The computation is only supported for indexed geometries and if position, normal, and uv attributes
       * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
       * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
       */
      computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        if (index === null || attributes.position === void 0 || attributes.normal === void 0 || attributes.uv === void 0) {
          console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
          return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute("tangent") === false) {
          this.setAttribute("tangent", new BufferAttribute(new Float32Array(4 * positionAttribute.count), 4));
        }
        const tangentAttribute = this.getAttribute("tangent");
        const tan1 = [], tan2 = [];
        for (let i = 0; i < positionAttribute.count; i++) {
          tan1[i] = new Vector3();
          tan2[i] = new Vector3();
        }
        const vA = new Vector3(), vB = new Vector3(), vC = new Vector3(), uvA = new Vector2(), uvB = new Vector2(), uvC = new Vector2(), sdir = new Vector3(), tdir = new Vector3();
        function handleTriangle(a, b, c) {
          vA.fromBufferAttribute(positionAttribute, a);
          vB.fromBufferAttribute(positionAttribute, b);
          vC.fromBufferAttribute(positionAttribute, c);
          uvA.fromBufferAttribute(uvAttribute, a);
          uvB.fromBufferAttribute(uvAttribute, b);
          uvC.fromBufferAttribute(uvAttribute, c);
          vB.sub(vA);
          vC.sub(vA);
          uvB.sub(uvA);
          uvC.sub(uvA);
          const r = 1 / (uvB.x * uvC.y - uvC.x * uvB.y);
          if (!isFinite(r)) return;
          sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
          tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
          tan1[a].add(sdir);
          tan1[b].add(sdir);
          tan1[c].add(sdir);
          tan2[a].add(tdir);
          tan2[b].add(tdir);
          tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) {
          groups = [{
            start: 0,
            count: index.count
          }];
        }
        for (let i = 0, il = groups.length; i < il; ++i) {
          const group = groups[i];
          const start = group.start;
          const count = group.count;
          for (let j = start, jl = start + count; j < jl; j += 3) {
            handleTriangle(
              index.getX(j + 0),
              index.getX(j + 1),
              index.getX(j + 2)
            );
          }
        }
        const tmp2 = new Vector3(), tmp22 = new Vector3();
        const n = new Vector3(), n2 = new Vector3();
        function handleVertex(v) {
          n.fromBufferAttribute(normalAttribute, v);
          n2.copy(n);
          const t = tan1[v];
          tmp2.copy(t);
          tmp2.sub(n.multiplyScalar(n.dot(t))).normalize();
          tmp22.crossVectors(n2, t);
          const test = tmp22.dot(tan2[v]);
          const w = test < 0 ? -1 : 1;
          tangentAttribute.setXYZW(v, tmp2.x, tmp2.y, tmp2.z, w);
        }
        for (let i = 0, il = groups.length; i < il; ++i) {
          const group = groups[i];
          const start = group.start;
          const count = group.count;
          for (let j = start, jl = start + count; j < jl; j += 3) {
            handleVertex(index.getX(j + 0));
            handleVertex(index.getX(j + 1));
            handleVertex(index.getX(j + 2));
          }
        }
      }
      /**
       * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
       * each vertex normal to be the average of the face normals of the faces that share that vertex.
       * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
       * to be the same as the face normal.
       */
      computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== void 0) {
          let normalAttribute = this.getAttribute("normal");
          if (normalAttribute === void 0) {
            normalAttribute = new BufferAttribute(new Float32Array(positionAttribute.count * 3), 3);
            this.setAttribute("normal", normalAttribute);
          } else {
            for (let i = 0, il = normalAttribute.count; i < il; i++) {
              normalAttribute.setXYZ(i, 0, 0, 0);
            }
          }
          const pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
          const nA = new Vector3(), nB = new Vector3(), nC = new Vector3();
          const cb = new Vector3(), ab = new Vector3();
          if (index) {
            for (let i = 0, il = index.count; i < il; i += 3) {
              const vA = index.getX(i + 0);
              const vB = index.getX(i + 1);
              const vC = index.getX(i + 2);
              pA.fromBufferAttribute(positionAttribute, vA);
              pB.fromBufferAttribute(positionAttribute, vB);
              pC.fromBufferAttribute(positionAttribute, vC);
              cb.subVectors(pC, pB);
              ab.subVectors(pA, pB);
              cb.cross(ab);
              nA.fromBufferAttribute(normalAttribute, vA);
              nB.fromBufferAttribute(normalAttribute, vB);
              nC.fromBufferAttribute(normalAttribute, vC);
              nA.add(cb);
              nB.add(cb);
              nC.add(cb);
              normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
              normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
              normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
          } else {
            for (let i = 0, il = positionAttribute.count; i < il; i += 3) {
              pA.fromBufferAttribute(positionAttribute, i + 0);
              pB.fromBufferAttribute(positionAttribute, i + 1);
              pC.fromBufferAttribute(positionAttribute, i + 2);
              cb.subVectors(pC, pB);
              ab.subVectors(pA, pB);
              cb.cross(ab);
              normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
              normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
              normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
          }
          this.normalizeNormals();
          normalAttribute.needsUpdate = true;
        }
      }
      /**
       * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
       * correct lighting on the geometry surfaces.
       */
      normalizeNormals() {
        const normals = this.attributes.normal;
        for (let i = 0, il = normals.count; i < il; i++) {
          _vector$8.fromBufferAttribute(normals, i);
          _vector$8.normalize();
          normals.setXYZ(i, _vector$8.x, _vector$8.y, _vector$8.z);
        }
      }
      /**
       * Return a new non-index version of this indexed geometry. If the geometry
       * is already non-indexed, the method is a NOOP.
       *
       * @return {BufferGeometry} The non-indexed version of this indexed geometry.
       */
      toNonIndexed() {
        function convertBufferAttribute(attribute, indices2) {
          const array = attribute.array;
          const itemSize = attribute.itemSize;
          const normalized = attribute.normalized;
          const array2 = new array.constructor(indices2.length * itemSize);
          let index = 0, index2 = 0;
          for (let i = 0, l = indices2.length; i < l; i++) {
            if (attribute.isInterleavedBufferAttribute) {
              index = indices2[i] * attribute.data.stride + attribute.offset;
            } else {
              index = indices2[i] * itemSize;
            }
            for (let j = 0; j < itemSize; j++) {
              array2[index2++] = array[index++];
            }
          }
          return new BufferAttribute(array2, itemSize, normalized);
        }
        if (this.index === null) {
          console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
          return this;
        }
        const geometry2 = new _BufferGeometry();
        const indices = this.index.array;
        const attributes = this.attributes;
        for (const name in attributes) {
          const attribute = attributes[name];
          const newAttribute = convertBufferAttribute(attribute, indices);
          geometry2.setAttribute(name, newAttribute);
        }
        const morphAttributes = this.morphAttributes;
        for (const name in morphAttributes) {
          const morphArray = [];
          const morphAttribute = morphAttributes[name];
          for (let i = 0, il = morphAttribute.length; i < il; i++) {
            const attribute = morphAttribute[i];
            const newAttribute = convertBufferAttribute(attribute, indices);
            morphArray.push(newAttribute);
          }
          geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        const groups = this.groups;
        for (let i = 0, l = groups.length; i < l; i++) {
          const group = groups[i];
          geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
      }
      /**
       * Serializes the geometry into JSON.
       *
       * @return {Object} A JSON object representing the serialized geometry.
       */
      toJSON() {
        const data = {
          metadata: {
            version: 4.7,
            type: "BufferGeometry",
            generator: "BufferGeometry.toJSON"
          }
        };
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== void 0) {
          const parameters = this.parameters;
          for (const key in parameters) {
            if (parameters[key] !== void 0) data[key] = parameters[key];
          }
          return data;
        }
        data.data = { attributes: {} };
        const index = this.index;
        if (index !== null) {
          data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
          };
        }
        const attributes = this.attributes;
        for (const key in attributes) {
          const attribute = attributes[key];
          data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for (const key in this.morphAttributes) {
          const attributeArray = this.morphAttributes[key];
          const array = [];
          for (let i = 0, il = attributeArray.length; i < il; i++) {
            const attribute = attributeArray[i];
            array.push(attribute.toJSON(data.data));
          }
          if (array.length > 0) {
            morphAttributes[key] = array;
            hasMorphAttributes = true;
          }
        }
        if (hasMorphAttributes) {
          data.data.morphAttributes = morphAttributes;
          data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) {
          data.data.groups = JSON.parse(JSON.stringify(groups));
        }
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) {
          data.data.boundingSphere = boundingSphere.toJSON();
        }
        return data;
      }
      /**
       * Returns a new geometry with copied values from this instance.
       *
       * @return {BufferGeometry} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
      /**
       * Copies the values of the given geometry to this instance.
       *
       * @param {BufferGeometry} source - The geometry to copy.
       * @return {BufferGeometry} A reference to this instance.
       */
      copy(source) {
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        const data = {};
        this.name = source.name;
        const index = source.index;
        if (index !== null) {
          this.setIndex(index.clone());
        }
        const attributes = source.attributes;
        for (const name in attributes) {
          const attribute = attributes[name];
          this.setAttribute(name, attribute.clone(data));
        }
        const morphAttributes = source.morphAttributes;
        for (const name in morphAttributes) {
          const array = [];
          const morphAttribute = morphAttributes[name];
          for (let i = 0, l = morphAttribute.length; i < l; i++) {
            array.push(morphAttribute[i].clone(data));
          }
          this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        const groups = source.groups;
        for (let i = 0, l = groups.length; i < l; i++) {
          const group = groups[i];
          this.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) {
          this.boundingBox = boundingBox.clone();
        }
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) {
          this.boundingSphere = boundingSphere.clone();
        }
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        this.userData = source.userData;
        return this;
      }
      /**
       * Frees the GPU-related resources allocated by this instance. Call this
       * method whenever this instance is no longer used in your app.
       *
       * @fires BufferGeometry#dispose
       */
      dispose() {
        this.dispatchEvent({ type: "dispose" });
      }
    };
    _inverseMatrix$3 = /* @__PURE__ */ new Matrix4();
    _ray$3 = /* @__PURE__ */ new Ray();
    _sphere$6 = /* @__PURE__ */ new Sphere();
    _sphereHitAt = /* @__PURE__ */ new Vector3();
    _vA$1 = /* @__PURE__ */ new Vector3();
    _vB$1 = /* @__PURE__ */ new Vector3();
    _vC$1 = /* @__PURE__ */ new Vector3();
    _tempA = /* @__PURE__ */ new Vector3();
    _morphA = /* @__PURE__ */ new Vector3();
    _intersectionPoint = /* @__PURE__ */ new Vector3();
    _intersectionPointWorld = /* @__PURE__ */ new Vector3();
    Mesh = class extends Object3D {
      /**
       * Constructs a new mesh.
       *
       * @param {BufferGeometry} [geometry] - The mesh geometry.
       * @param {Material|Array<Material>} [material] - The mesh material.
       */
      constructor(geometry = new BufferGeometry(), material = new MeshBasicMaterial()) {
        super();
        this.isMesh = true;
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.morphTargetDictionary = void 0;
        this.morphTargetInfluences = void 0;
        this.count = 1;
        this.updateMorphTargets();
      }
      copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== void 0) {
          this.morphTargetInfluences = source.morphTargetInfluences.slice();
        }
        if (source.morphTargetDictionary !== void 0) {
          this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        }
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
      }
      /**
       * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
       * to make sure existing morph targets can influence this 3D object.
       */
      updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
          const morphAttribute = morphAttributes[keys[0]];
          if (morphAttribute !== void 0) {
            this.morphTargetInfluences = [];
            this.morphTargetDictionary = {};
            for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
              const name = morphAttribute[m].name || String(m);
              this.morphTargetInfluences.push(0);
              this.morphTargetDictionary[name] = m;
            }
          }
        }
      }
      /**
       * Returns the local-space position of the vertex at the given index, taking into
       * account the current animation state of both morph targets and skinning.
       *
       * @param {number} index - The vertex index.
       * @param {Vector3} target - The target object that is used to store the method's result.
       * @return {Vector3} The vertex position in local space.
       */
      getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
          _morphA.set(0, 0, 0);
          for (let i = 0, il = morphPosition.length; i < il; i++) {
            const influence = morphInfluences[i];
            const morphAttribute = morphPosition[i];
            if (influence === 0) continue;
            _tempA.fromBufferAttribute(morphAttribute, index);
            if (morphTargetsRelative) {
              _morphA.addScaledVector(_tempA, influence);
            } else {
              _morphA.addScaledVector(_tempA.sub(target), influence);
            }
          }
          target.add(_morphA);
        }
        return target;
      }
      /**
       * Computes intersection points between a casted ray and this line.
       *
       * @param {Raycaster} raycaster - The raycaster.
       * @param {Array<Object>} intersects - The target array that holds the intersection points.
       */
      raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === void 0) return;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere$6.copy(geometry.boundingSphere);
        _sphere$6.applyMatrix4(matrixWorld);
        _ray$3.copy(raycaster.ray).recast(raycaster.near);
        if (_sphere$6.containsPoint(_ray$3.origin) === false) {
          if (_ray$3.intersectSphere(_sphere$6, _sphereHitAt) === null) return;
          if (_ray$3.origin.distanceToSquared(_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        _inverseMatrix$3.copy(matrixWorld).invert();
        _ray$3.copy(raycaster.ray).applyMatrix4(_inverseMatrix$3);
        if (geometry.boundingBox !== null) {
          if (_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        this._computeIntersections(raycaster, intersects, _ray$3);
      }
      _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
          if (Array.isArray(material)) {
            for (let i = 0, il = groups.length; i < il; i++) {
              const group = groups[i];
              const groupMaterial = material[group.materialIndex];
              const start = Math.max(group.start, drawRange.start);
              const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
              for (let j = start, jl = end; j < jl; j += 3) {
                const a = index.getX(j);
                const b = index.getX(j + 1);
                const c = index.getX(j + 2);
                intersection = checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                if (intersection) {
                  intersection.faceIndex = Math.floor(j / 3);
                  intersection.face.materialIndex = group.materialIndex;
                  intersects.push(intersection);
                }
              }
            }
          } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for (let i = start, il = end; i < il; i += 3) {
              const a = index.getX(i);
              const b = index.getX(i + 1);
              const c = index.getX(i + 2);
              intersection = checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
              if (intersection) {
                intersection.faceIndex = Math.floor(i / 3);
                intersects.push(intersection);
              }
            }
          }
        } else if (position !== void 0) {
          if (Array.isArray(material)) {
            for (let i = 0, il = groups.length; i < il; i++) {
              const group = groups[i];
              const groupMaterial = material[group.materialIndex];
              const start = Math.max(group.start, drawRange.start);
              const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
              for (let j = start, jl = end; j < jl; j += 3) {
                const a = j;
                const b = j + 1;
                const c = j + 2;
                intersection = checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                if (intersection) {
                  intersection.faceIndex = Math.floor(j / 3);
                  intersection.face.materialIndex = group.materialIndex;
                  intersects.push(intersection);
                }
              }
            }
          } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(position.count, drawRange.start + drawRange.count);
            for (let i = start, il = end; i < il; i += 3) {
              const a = i;
              const b = i + 1;
              const c = i + 2;
              intersection = checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
              if (intersection) {
                intersection.faceIndex = Math.floor(i / 3);
                intersects.push(intersection);
              }
            }
          }
        }
      }
    };
    BoxGeometry = class _BoxGeometry extends BufferGeometry {
      /**
       * Constructs a new box geometry.
       *
       * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
       * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
       * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
       * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
       * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
       * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
       */
      constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1) {
        super();
        this.type = "BoxGeometry";
        this.parameters = {
          width,
          height,
          depth,
          widthSegments,
          heightSegments,
          depthSegments
        };
        const scope = this;
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        let numberOfVertices = 0;
        let groupStart = 0;
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0);
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1);
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2);
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3);
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4);
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5);
        this.setIndex(indices);
        this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
        this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
        this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width2, height2, depth2, gridX, gridY, materialIndex) {
          const segmentWidth = width2 / gridX;
          const segmentHeight = height2 / gridY;
          const widthHalf = width2 / 2;
          const heightHalf = height2 / 2;
          const depthHalf = depth2 / 2;
          const gridX1 = gridX + 1;
          const gridY1 = gridY + 1;
          let vertexCounter = 0;
          let groupCount = 0;
          const vector = new Vector3();
          for (let iy = 0; iy < gridY1; iy++) {
            const y = iy * segmentHeight - heightHalf;
            for (let ix = 0; ix < gridX1; ix++) {
              const x = ix * segmentWidth - widthHalf;
              vector[u] = x * udir;
              vector[v] = y * vdir;
              vector[w] = depthHalf;
              vertices.push(vector.x, vector.y, vector.z);
              vector[u] = 0;
              vector[v] = 0;
              vector[w] = depth2 > 0 ? 1 : -1;
              normals.push(vector.x, vector.y, vector.z);
              uvs.push(ix / gridX);
              uvs.push(1 - iy / gridY);
              vertexCounter += 1;
            }
          }
          for (let iy = 0; iy < gridY; iy++) {
            for (let ix = 0; ix < gridX; ix++) {
              const a = numberOfVertices + ix + gridX1 * iy;
              const b = numberOfVertices + ix + gridX1 * (iy + 1);
              const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
              const d = numberOfVertices + (ix + 1) + gridX1 * iy;
              indices.push(a, b, d);
              indices.push(b, c, d);
              groupCount += 6;
            }
          }
          scope.addGroup(groupStart, groupCount, materialIndex);
          groupStart += groupCount;
          numberOfVertices += vertexCounter;
        }
      }
      copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
      }
      /**
       * Factory method for creating an instance of this class from the given
       * JSON object.
       *
       * @param {Object} data - A JSON object representing the serialized geometry.
       * @return {BoxGeometry} A new instance.
       */
      static fromJSON(data) {
        return new _BoxGeometry(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
      }
    };
    UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };
    default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
    default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
    ShaderMaterial = class extends Material {
      /**
       * Constructs a new shader material.
       *
       * @param {Object} [parameters] - An object with one or more properties
       * defining the material's appearance. Any property of the material
       * (including any property from inherited materials) can be passed
       * in here. Color values can be passed any type of value accepted
       * by {@link Color#set}.
       */
      constructor(parameters) {
        super();
        this.isShaderMaterial = true;
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = default_vertex;
        this.fragmentShader = default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false;
        this.lights = false;
        this.clipping = false;
        this.forceSinglePass = true;
        this.extensions = {
          clipCullDistance: false,
          // set to use vertex shader clipping
          multiDraw: false
          // set to use vertex shader multi_draw / enable gl_DrawID
        };
        this.defaultAttributeValues = {
          "color": [1, 1, 1],
          "uv": [0, 0],
          "uv1": [0, 0]
        };
        this.index0AttributeName = void 0;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== void 0) {
          this.setValues(parameters);
        }
      }
      copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = cloneUniforms(source.uniforms);
        this.uniformsGroups = cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
      }
      toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for (const name in this.uniforms) {
          const uniform = this.uniforms[name];
          const value = uniform.value;
          if (value && value.isTexture) {
            data.uniforms[name] = {
              type: "t",
              value: value.toJSON(meta).uuid
            };
          } else if (value && value.isColor) {
            data.uniforms[name] = {
              type: "c",
              value: value.getHex()
            };
          } else if (value && value.isVector2) {
            data.uniforms[name] = {
              type: "v2",
              value: value.toArray()
            };
          } else if (value && value.isVector3) {
            data.uniforms[name] = {
              type: "v3",
              value: value.toArray()
            };
          } else if (value && value.isVector4) {
            data.uniforms[name] = {
              type: "v4",
              value: value.toArray()
            };
          } else if (value && value.isMatrix3) {
            data.uniforms[name] = {
              type: "m3",
              value: value.toArray()
            };
          } else if (value && value.isMatrix4) {
            data.uniforms[name] = {
              type: "m4",
              value: value.toArray()
            };
          } else {
            data.uniforms[name] = {
              value
            };
          }
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for (const key in this.extensions) {
          if (this.extensions[key] === true) extensions[key] = true;
        }
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
      }
    };
    Camera = class extends Object3D {
      /**
       * Constructs a new camera.
       */
      constructor() {
        super();
        this.isCamera = true;
        this.type = "Camera";
        this.matrixWorldInverse = new Matrix4();
        this.projectionMatrix = new Matrix4();
        this.projectionMatrixInverse = new Matrix4();
        this.coordinateSystem = WebGLCoordinateSystem;
        this._reversedDepth = false;
      }
      /**
       * The flag that indicates whether the camera uses a reversed depth buffer.
       *
       * @type {boolean}
       * @default false
       */
      get reversedDepth() {
        return this._reversedDepth;
      }
      copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
      }
      /**
       * Returns a vector representing the ("look") direction of the 3D object in world space.
       *
       * This method is overwritten since cameras have a different forward vector compared to other
       * 3D objects. A camera looks down its local, negative z-axis by default.
       *
       * @param {Vector3} target - The target vector the result is stored to.
       * @return {Vector3} The 3D object's direction in world space.
       */
      getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
      }
      updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
      }
      updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
      }
      clone() {
        return new this.constructor().copy(this);
      }
    };
    _v3$1 = /* @__PURE__ */ new Vector3();
    _minTarget = /* @__PURE__ */ new Vector2();
    _maxTarget = /* @__PURE__ */ new Vector2();
    PerspectiveCamera = class extends Camera {
      /**
       * Constructs a new perspective camera.
       *
       * @param {number} [fov=50] - The vertical field of view.
       * @param {number} [aspect=1] - The aspect ratio.
       * @param {number} [near=0.1] - The camera's near plane.
       * @param {number} [far=2000] - The camera's far plane.
       */
      constructor(fov2 = 50, aspect2 = 1, near = 0.1, far = 2e3) {
        super();
        this.isPerspectiveCamera = true;
        this.type = "PerspectiveCamera";
        this.fov = fov2;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect2;
        this.view = null;
        this.filmGauge = 35;
        this.filmOffset = 0;
        this.updateProjectionMatrix();
      }
      copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
      }
      /**
       * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
       *
       * The default film gauge is 35, so that the focal length can be specified for
       * a 35mm (full frame) camera.
       *
       * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
       */
      setFocalLength(focalLength) {
        const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
      }
      /**
       * Returns the focal length from the current {@link PerspectiveCamera#fov} and
       * {@link PerspectiveCamera#filmGauge}.
       *
       * @return {number} The computed focal length.
       */
      getFocalLength() {
        const vExtentSlope = Math.tan(DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
      }
      /**
       * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
       *
       * @return {number} The effective FOV.
       */
      getEffectiveFOV() {
        return RAD2DEG * 2 * Math.atan(
          Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom
        );
      }
      /**
       * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
       * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
       *
       * @return {number} The film width.
       */
      getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
      }
      /**
       * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
       * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
       *
       * @return {number} The film width.
       */
      getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
      }
      /**
       * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
       * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
       *
       * @param {number} distance - The viewing distance.
       * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
       * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
       */
      getViewBounds(distance, minTarget, maxTarget) {
        _v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set(_v3$1.x, _v3$1.y).multiplyScalar(-distance / _v3$1.z);
        _v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set(_v3$1.x, _v3$1.y).multiplyScalar(-distance / _v3$1.z);
      }
      /**
       * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
       *
       * @param {number} distance - The viewing distance.
       * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
       * @returns {Vector2} The view size.
       */
      getViewSize(distance, target) {
        this.getViewBounds(distance, _minTarget, _maxTarget);
        return target.subVectors(_maxTarget, _minTarget);
      }
      /**
       * Sets an offset in a larger frustum. This is useful for multi-window or
       * multi-monitor/multi-machine setups.
       *
       * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
       * the monitors are in grid like this
       *```
       *   +---+---+---+
       *   | A | B | C |
       *   +---+---+---+
       *   | D | E | F |
       *   +---+---+---+
       *```
       * then for each monitor you would call it like this:
       *```js
       * const w = 1920;
       * const h = 1080;
       * const fullWidth = w * 3;
       * const fullHeight = h * 2;
       *
       * // --A--
       * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
       * // --B--
       * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
       * // --C--
       * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
       * // --D--
       * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
       * // --E--
       * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
       * // --F--
       * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
       * ```
       *
       * Note there is no reason monitors have to be the same size or in a grid.
       *
       * @param {number} fullWidth - The full width of multiview setup.
       * @param {number} fullHeight - The full height of multiview setup.
       * @param {number} x - The horizontal offset of the subcamera.
       * @param {number} y - The vertical offset of the subcamera.
       * @param {number} width - The width of subcamera.
       * @param {number} height - The height of subcamera.
       */
      setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) {
          this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
          };
        }
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
      }
      /**
       * Removes the view offset from the projection matrix.
       */
      clearViewOffset() {
        if (this.view !== null) {
          this.view.enabled = false;
        }
        this.updateProjectionMatrix();
      }
      /**
       * Updates the camera's projection matrix. Must be called after any change of
       * camera properties.
       */
      updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
          const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
          left += view.offsetX * width / fullWidth;
          top -= view.offsetY * height / fullHeight;
          width *= view.width / fullWidth;
          height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
      }
      toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
      }
    };
    fov = -90;
    aspect = 1;
    CubeCamera = class extends Object3D {
      /**
       * Constructs a new cube camera.
       *
       * @param {number} near - The camera's near plane.
       * @param {number} far - The camera's far plane.
       * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
       */
      constructor(near, far, renderTarget) {
        super();
        this.type = "CubeCamera";
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        this.activeMipmapLevel = 0;
        const cameraPX = new PerspectiveCamera(fov, aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new PerspectiveCamera(fov, aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new PerspectiveCamera(fov, aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new PerspectiveCamera(fov, aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new PerspectiveCamera(fov, aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new PerspectiveCamera(fov, aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
      }
      /**
       * Must be called when the coordinate system of the cube camera is changed.
       */
      updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras) this.remove(camera);
        if (coordinateSystem === WebGLCoordinateSystem) {
          cameraPX.up.set(0, 1, 0);
          cameraPX.lookAt(1, 0, 0);
          cameraNX.up.set(0, 1, 0);
          cameraNX.lookAt(-1, 0, 0);
          cameraPY.up.set(0, 0, -1);
          cameraPY.lookAt(0, 1, 0);
          cameraNY.up.set(0, 0, 1);
          cameraNY.lookAt(0, -1, 0);
          cameraPZ.up.set(0, 1, 0);
          cameraPZ.lookAt(0, 0, 1);
          cameraNZ.up.set(0, 1, 0);
          cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === WebGPUCoordinateSystem) {
          cameraPX.up.set(0, -1, 0);
          cameraPX.lookAt(-1, 0, 0);
          cameraNX.up.set(0, -1, 0);
          cameraNX.lookAt(1, 0, 0);
          cameraPY.up.set(0, 0, 1);
          cameraPY.lookAt(0, 1, 0);
          cameraNY.up.set(0, 0, -1);
          cameraNY.lookAt(0, -1, 0);
          cameraPZ.up.set(0, -1, 0);
          cameraPZ.lookAt(0, 0, 1);
          cameraNZ.up.set(0, -1, 0);
          cameraNZ.lookAt(0, 0, -1);
        } else {
          throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + coordinateSystem);
        }
        for (const camera of cameras) {
          this.add(camera);
          camera.updateMatrixWorld();
        }
      }
      /**
       * Calling this method will render the given scene with the given renderer
       * into the cube render target of the camera.
       *
       * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
       * @param {Scene} scene - The scene to render.
       */
      update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget, activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
          this.coordinateSystem = renderer.coordinateSystem;
          this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
      }
    };
    CubeTexture = class extends Texture {
      /**
       * Constructs a new cube texture.
       *
       * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
       * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
       * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
       * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
       * @param {number} [magFilter=LinearFilter] - The mag filter value.
       * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
       * @param {number} [format=RGBAFormat] - The texture format.
       * @param {number} [type=UnsignedByteType] - The texture type.
       * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
       * @param {string} [colorSpace=NoColorSpace] - The color space value.
       */
      constructor(images = [], mapping = CubeReflectionMapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace) {
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isCubeTexture = true;
        this.flipY = false;
      }
      /**
       * Alias for {@link CubeTexture#image}.
       *
       * @type {Array<Image>}
       */
      get images() {
        return this.image;
      }
      set images(value) {
        this.image = value;
      }
    };
    WebGLCubeRenderTarget = class extends WebGLRenderTarget {
      /**
       * Constructs a new cube render target.
       *
       * @param {number} [size=1] - The size of the render target.
       * @param {RenderTarget~Options} [options] - The configuration object.
       */
      constructor(size = 1, options = {}) {
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = { width: size, height: size, depth: 1 };
        const images = [image, image, image, image, image, image];
        this.texture = new CubeTexture(images);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
      }
      /**
       * Converts the given equirectangular texture to a cube map.
       *
       * @param {WebGLRenderer} renderer - The renderer.
       * @param {Texture} texture - The equirectangular texture.
       * @return {WebGLCubeRenderTarget} A reference to this cube render target.
       */
      fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
          uniforms: {
            tEquirect: { value: null }
          },
          vertexShader: (
            /* glsl */
            `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
          ),
          fragmentShader: (
            /* glsl */
            `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
          )
        };
        const geometry = new BoxGeometry(5, 5, 5);
        const material = new ShaderMaterial({
          name: "CubemapFromEquirect",
          uniforms: cloneUniforms(shader.uniforms),
          vertexShader: shader.vertexShader,
          fragmentShader: shader.fragmentShader,
          side: BackSide,
          blending: NoBlending
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new Mesh(geometry, material);
        const currentMinFilter = texture.minFilter;
        if (texture.minFilter === LinearMipmapLinearFilter) texture.minFilter = LinearFilter;
        const camera = new CubeCamera(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
      }
      /**
       * Clears this cube render target.
       *
       * @param {WebGLRenderer} renderer - The renderer.
       * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
       * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
       * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
       */
      clear(renderer, color = true, depth = true, stencil = true) {
        const currentRenderTarget = renderer.getRenderTarget();
        for (let i = 0; i < 6; i++) {
          renderer.setRenderTarget(this, i);
          renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
      }
    };
    Group = class extends Object3D {
      constructor() {
        super();
        this.isGroup = true;
        this.type = "Group";
      }
    };
    _moveEvent = { type: "move" };
    WebXRController = class {
      /**
       * Constructs a new XR controller.
       */
      constructor() {
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
      }
      /**
       * Returns a group representing the hand space of the XR controller.
       *
       * @return {Group} A group representing the hand space of the XR controller.
       */
      getHandSpace() {
        if (this._hand === null) {
          this._hand = new Group();
          this._hand.matrixAutoUpdate = false;
          this._hand.visible = false;
          this._hand.joints = {};
          this._hand.inputState = { pinching: false };
        }
        return this._hand;
      }
      /**
       * Returns a group representing the target ray space of the XR controller.
       *
       * @return {Group} A group representing the target ray space of the XR controller.
       */
      getTargetRaySpace() {
        if (this._targetRay === null) {
          this._targetRay = new Group();
          this._targetRay.matrixAutoUpdate = false;
          this._targetRay.visible = false;
          this._targetRay.hasLinearVelocity = false;
          this._targetRay.linearVelocity = new Vector3();
          this._targetRay.hasAngularVelocity = false;
          this._targetRay.angularVelocity = new Vector3();
        }
        return this._targetRay;
      }
      /**
       * Returns a group representing the grip space of the XR controller.
       *
       * @return {Group} A group representing the grip space of the XR controller.
       */
      getGripSpace() {
        if (this._grip === null) {
          this._grip = new Group();
          this._grip.matrixAutoUpdate = false;
          this._grip.visible = false;
          this._grip.hasLinearVelocity = false;
          this._grip.linearVelocity = new Vector3();
          this._grip.hasAngularVelocity = false;
          this._grip.angularVelocity = new Vector3();
        }
        return this._grip;
      }
      /**
       * Dispatches the given event to the groups representing
       * the different coordinate spaces of the XR controller.
       *
       * @param {Object} event - The event to dispatch.
       * @return {WebXRController} A reference to this instance.
       */
      dispatchEvent(event) {
        if (this._targetRay !== null) {
          this._targetRay.dispatchEvent(event);
        }
        if (this._grip !== null) {
          this._grip.dispatchEvent(event);
        }
        if (this._hand !== null) {
          this._hand.dispatchEvent(event);
        }
        return this;
      }
      /**
       * Connects the controller with the given XR input source.
       *
       * @param {XRInputSource} inputSource - The input source.
       * @return {WebXRController} A reference to this instance.
       */
      connect(inputSource) {
        if (inputSource && inputSource.hand) {
          const hand = this._hand;
          if (hand) {
            for (const inputjoint of inputSource.hand.values()) {
              this._getHandJoint(hand, inputjoint);
            }
          }
        }
        this.dispatchEvent({ type: "connected", data: inputSource });
        return this;
      }
      /**
       * Disconnects the controller from the given XR input source.
       *
       * @param {XRInputSource} inputSource - The input source.
       * @return {WebXRController} A reference to this instance.
       */
      disconnect(inputSource) {
        this.dispatchEvent({ type: "disconnected", data: inputSource });
        if (this._targetRay !== null) {
          this._targetRay.visible = false;
        }
        if (this._grip !== null) {
          this._grip.visible = false;
        }
        if (this._hand !== null) {
          this._hand.visible = false;
        }
        return this;
      }
      /**
       * Updates the controller with the given input source, XR frame and reference space.
       * This updates the transformations of the groups that represent the different
       * coordinate systems of the controller.
       *
       * @param {XRInputSource} inputSource - The input source.
       * @param {XRFrame} frame - The XR frame.
       * @param {XRReferenceSpace} referenceSpace - The reference space.
       * @return {WebXRController} A reference to this instance.
       */
      update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
          if (hand && inputSource.hand) {
            handPose = true;
            for (const inputjoint of inputSource.hand.values()) {
              const jointPose = frame.getJointPose(inputjoint, referenceSpace);
              const joint = this._getHandJoint(hand, inputjoint);
              if (jointPose !== null) {
                joint.matrix.fromArray(jointPose.transform.matrix);
                joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                joint.matrixWorldNeedsUpdate = true;
                joint.jointRadius = jointPose.radius;
              }
              joint.visible = jointPose !== null;
            }
            const indexTip = hand.joints["index-finger-tip"];
            const thumbTip = hand.joints["thumb-tip"];
            const distance = indexTip.position.distanceTo(thumbTip.position);
            const distanceToPinch = 0.02;
            const threshold = 5e-3;
            if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
              hand.inputState.pinching = false;
              this.dispatchEvent({
                type: "pinchend",
                handedness: inputSource.handedness,
                target: this
              });
            } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
              hand.inputState.pinching = true;
              this.dispatchEvent({
                type: "pinchstart",
                handedness: inputSource.handedness,
                target: this
              });
            }
          } else {
            if (grip !== null && inputSource.gripSpace) {
              gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
              if (gripPose !== null) {
                grip.matrix.fromArray(gripPose.transform.matrix);
                grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                grip.matrixWorldNeedsUpdate = true;
                if (gripPose.linearVelocity) {
                  grip.hasLinearVelocity = true;
                  grip.linearVelocity.copy(gripPose.linearVelocity);
                } else {
                  grip.hasLinearVelocity = false;
                }
                if (gripPose.angularVelocity) {
                  grip.hasAngularVelocity = true;
                  grip.angularVelocity.copy(gripPose.angularVelocity);
                } else {
                  grip.hasAngularVelocity = false;
                }
              }
            }
          }
          if (targetRay !== null) {
            inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
            if (inputPose === null && gripPose !== null) {
              inputPose = gripPose;
            }
            if (inputPose !== null) {
              targetRay.matrix.fromArray(inputPose.transform.matrix);
              targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
              targetRay.matrixWorldNeedsUpdate = true;
              if (inputPose.linearVelocity) {
                targetRay.hasLinearVelocity = true;
                targetRay.linearVelocity.copy(inputPose.linearVelocity);
              } else {
                targetRay.hasLinearVelocity = false;
              }
              if (inputPose.angularVelocity) {
                targetRay.hasAngularVelocity = true;
                targetRay.angularVelocity.copy(inputPose.angularVelocity);
              } else {
                targetRay.hasAngularVelocity = false;
              }
              this.dispatchEvent(_moveEvent);
            }
          }
        }
        if (targetRay !== null) {
          targetRay.visible = inputPose !== null;
        }
        if (grip !== null) {
          grip.visible = gripPose !== null;
        }
        if (hand !== null) {
          hand.visible = handPose !== null;
        }
        return this;
      }
      /**
       * Returns a group representing the hand joint for the given input joint.
       *
       * @private
       * @param {Group} hand - The group representing the hand space.
       * @param {XRJointSpace} inputjoint - The hand joint data.
       * @return {Group} A group representing the hand joint for the given input joint.
       */
      _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === void 0) {
          const joint = new Group();
          joint.matrixAutoUpdate = false;
          joint.visible = false;
          hand.joints[inputjoint.jointName] = joint;
          hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
      }
    };
    Scene = class extends Object3D {
      /**
       * Constructs a new scene.
       */
      constructor() {
        super();
        this.isScene = true;
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.backgroundRotation = new Euler();
        this.environmentIntensity = 1;
        this.environmentRotation = new Euler();
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== "undefined") {
          __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
        }
      }
      copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
      }
      toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
      }
    };
    InterleavedBuffer = class {
      /**
       * Constructs a new interleaved buffer.
       *
       * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
       * @param {number} stride - The number of typed-array elements per vertex.
       */
      constructor(array, stride) {
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== void 0 ? array.length / stride : 0;
        this.usage = StaticDrawUsage;
        this.updateRanges = [];
        this.version = 0;
        this.uuid = generateUUID();
      }
      /**
       * A callback function that is executed after the renderer has transferred the attribute array
       * data to the GPU.
       */
      onUploadCallback() {
      }
      /**
       * Flag to indicate that this attribute has changed and should be re-sent to
       * the GPU. Set this to `true` when you modify the value of the array.
       *
       * @type {number}
       * @default false
       * @param {boolean} value
       */
      set needsUpdate(value) {
        if (value === true) this.version++;
      }
      /**
       * Sets the usage of this interleaved buffer.
       *
       * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
       * @return {InterleavedBuffer} A reference to this interleaved buffer.
       */
      setUsage(value) {
        this.usage = value;
        return this;
      }
      /**
       * Adds a range of data in the data array to be updated on the GPU.
       *
       * @param {number} start - Position at which to start update.
       * @param {number} count - The number of components to update.
       */
      addUpdateRange(start, count) {
        this.updateRanges.push({ start, count });
      }
      /**
       * Clears the update ranges.
       */
      clearUpdateRanges() {
        this.updateRanges.length = 0;
      }
      /**
       * Copies the values of the given interleaved buffer to this instance.
       *
       * @param {InterleavedBuffer} source - The interleaved buffer to copy.
       * @return {InterleavedBuffer} A reference to this instance.
       */
      copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
      }
      /**
       * Copies a vector from the given interleaved buffer to this one. The start
       * and destination position in the attribute buffers are represented by the
       * given indices.
       *
       * @param {number} index1 - The destination index into this interleaved buffer.
       * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
       * @param {number} index2 - The source index into the given interleaved buffer.
       * @return {InterleavedBuffer} A reference to this instance.
       */
      copyAt(index1, interleavedBuffer, index2) {
        index1 *= this.stride;
        index2 *= interleavedBuffer.stride;
        for (let i = 0, l = this.stride; i < l; i++) {
          this.array[index1 + i] = interleavedBuffer.array[index2 + i];
        }
        return this;
      }
      /**
       * Sets the given array data in the interleaved buffer.
       *
       * @param {(TypedArray|Array)} value - The array data to set.
       * @param {number} [offset=0] - The offset in this interleaved buffer's array.
       * @return {InterleavedBuffer} A reference to this instance.
       */
      set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
      }
      /**
       * Returns a new interleaved buffer with copied values from this instance.
       *
       * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
       * @return {InterleavedBuffer} A clone of this instance.
       */
      clone(data) {
        if (data.arrayBuffers === void 0) {
          data.arrayBuffers = {};
        }
        if (this.array.buffer._uuid === void 0) {
          this.array.buffer._uuid = generateUUID();
        }
        if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
          data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        }
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
      }
      /**
       * Sets the given callback function that is executed after the Renderer has transferred
       * the array data to the GPU. Can be used to perform clean-up operations after
       * the upload when data are not needed anymore on the CPU side.
       *
       * @param {Function} callback - The `onUpload()` callback.
       * @return {InterleavedBuffer} A reference to this instance.
       */
      onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
      }
      /**
       * Serializes the interleaved buffer into JSON.
       *
       * @param {Object} [data] - An optional value holding meta information about the serialization.
       * @return {Object} A JSON object representing the serialized interleaved buffer.
       */
      toJSON(data) {
        if (data.arrayBuffers === void 0) {
          data.arrayBuffers = {};
        }
        if (this.array.buffer._uuid === void 0) {
          this.array.buffer._uuid = generateUUID();
        }
        if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
          data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        }
        return {
          uuid: this.uuid,
          buffer: this.array.buffer._uuid,
          type: this.array.constructor.name,
          stride: this.stride
        };
      }
    };
    _vector$7 = /* @__PURE__ */ new Vector3();
    InterleavedBufferAttribute = class _InterleavedBufferAttribute {
      /**
       * Constructs a new interleaved buffer attribute.
       *
       * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
       * @param {number} itemSize - The item size.
       * @param {number} offset - The attribute offset into the buffer.
       * @param {boolean} [normalized=false] - Whether the data are normalized or not.
       */
      constructor(interleavedBuffer, itemSize, offset, normalized = false) {
        this.isInterleavedBufferAttribute = true;
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
      }
      /**
       * The item count of this buffer attribute.
       *
       * @type {number}
       * @readonly
       */
      get count() {
        return this.data.count;
      }
      /**
       * The array holding the interleaved buffer attribute data.
       *
       * @type {TypedArray}
       */
      get array() {
        return this.data.array;
      }
      /**
       * Flag to indicate that this attribute has changed and should be re-sent to
       * the GPU. Set this to `true` when you modify the value of the array.
       *
       * @type {number}
       * @default false
       * @param {boolean} value
       */
      set needsUpdate(value) {
        this.data.needsUpdate = value;
      }
      /**
       * Applies the given 4x4 matrix to the given attribute. Only works with
       * item size `3`.
       *
       * @param {Matrix4} m - The matrix to apply.
       * @return {InterleavedBufferAttribute} A reference to this instance.
       */
      applyMatrix4(m) {
        for (let i = 0, l = this.data.count; i < l; i++) {
          _vector$7.fromBufferAttribute(this, i);
          _vector$7.applyMatrix4(m);
          this.setXYZ(i, _vector$7.x, _vector$7.y, _vector$7.z);
        }
        return this;
      }
      /**
       * Applies the given 3x3 normal matrix to the given attribute. Only works with
       * item size `3`.
       *
       * @param {Matrix3} m - The normal matrix to apply.
       * @return {InterleavedBufferAttribute} A reference to this instance.
       */
      applyNormalMatrix(m) {
        for (let i = 0, l = this.count; i < l; i++) {
          _vector$7.fromBufferAttribute(this, i);
          _vector$7.applyNormalMatrix(m);
          this.setXYZ(i, _vector$7.x, _vector$7.y, _vector$7.z);
        }
        return this;
      }
      /**
       * Applies the given 4x4 matrix to the given attribute. Only works with
       * item size `3` and with direction vectors.
       *
       * @param {Matrix4} m - The matrix to apply.
       * @return {InterleavedBufferAttribute} A reference to this instance.
       */
      transformDirection(m) {
        for (let i = 0, l = this.count; i < l; i++) {
          _vector$7.fromBufferAttribute(this, i);
          _vector$7.transformDirection(m);
          this.setXYZ(i, _vector$7.x, _vector$7.y, _vector$7.z);
        }
        return this;
      }
      /**
       * Returns the given component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} component - The component index.
       * @return {number} The returned value.
       */
      getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = denormalize(value, this.array);
        return value;
      }
      /**
       * Sets the given value to the given component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} component - The component index.
       * @param {number} value - The value to set.
       * @return {InterleavedBufferAttribute} A reference to this instance.
       */
      setComponent(index, component, value) {
        if (this.normalized) value = normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
      }
      /**
       * Sets the x component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} x - The value to set.
       * @return {InterleavedBufferAttribute} A reference to this instance.
       */
      setX(index, x) {
        if (this.normalized) x = normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
      }
      /**
       * Sets the y component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} y - The value to set.
       * @return {InterleavedBufferAttribute} A reference to this instance.
       */
      setY(index, y) {
        if (this.normalized) y = normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
      }
      /**
       * Sets the z component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} z - The value to set.
       * @return {InterleavedBufferAttribute} A reference to this instance.
       */
      setZ(index, z) {
        if (this.normalized) z = normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
      }
      /**
       * Sets the w component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} w - The value to set.
       * @return {InterleavedBufferAttribute} A reference to this instance.
       */
      setW(index, w) {
        if (this.normalized) w = normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
      }
      /**
       * Returns the x component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @return {number} The x component.
       */
      getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = denormalize(x, this.array);
        return x;
      }
      /**
       * Returns the y component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @return {number} The y component.
       */
      getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = denormalize(y, this.array);
        return y;
      }
      /**
       * Returns the z component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @return {number} The z component.
       */
      getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = denormalize(z, this.array);
        return z;
      }
      /**
       * Returns the w component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @return {number} The w component.
       */
      getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = denormalize(w, this.array);
        return w;
      }
      /**
       * Sets the x and y component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} x - The value for the x component to set.
       * @param {number} y - The value for the y component to set.
       * @return {InterleavedBufferAttribute} A reference to this instance.
       */
      setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
          x = normalize(x, this.array);
          y = normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
      }
      /**
       * Sets the x, y and z component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} x - The value for the x component to set.
       * @param {number} y - The value for the y component to set.
       * @param {number} z - The value for the z component to set.
       * @return {InterleavedBufferAttribute} A reference to this instance.
       */
      setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
          x = normalize(x, this.array);
          y = normalize(y, this.array);
          z = normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
      }
      /**
       * Sets the x, y, z and w component of the vector at the given index.
       *
       * @param {number} index - The index into the buffer attribute.
       * @param {number} x - The value for the x component to set.
       * @param {number} y - The value for the y component to set.
       * @param {number} z - The value for the z component to set.
       * @param {number} w - The value for the w component to set.
       * @return {InterleavedBufferAttribute} A reference to this instance.
       */
      setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
          x = normalize(x, this.array);
          y = normalize(y, this.array);
          z = normalize(z, this.array);
          w = normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
      }
      /**
       * Returns a new buffer attribute with copied values from this instance.
       *
       * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
       *
       * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
       * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
       */
      clone(data) {
        if (data === void 0) {
          console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
          const array = [];
          for (let i = 0; i < this.count; i++) {
            const index = i * this.data.stride + this.offset;
            for (let j = 0; j < this.itemSize; j++) {
              array.push(this.data.array[index + j]);
            }
          }
          return new BufferAttribute(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
          if (data.interleavedBuffers === void 0) {
            data.interleavedBuffers = {};
          }
          if (data.interleavedBuffers[this.data.uuid] === void 0) {
            data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
          }
          return new _InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
      }
      /**
       * Serializes the buffer attribute into JSON.
       *
       * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
       *
       * @param {Object} [data] - An optional value holding meta information about the serialization.
       * @return {Object} A JSON object representing the serialized buffer attribute.
       */
      toJSON(data) {
        if (data === void 0) {
          console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
          const array = [];
          for (let i = 0; i < this.count; i++) {
            const index = i * this.data.stride + this.offset;
            for (let j = 0; j < this.itemSize; j++) {
              array.push(this.data.array[index + j]);
            }
          }
          return {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array,
            normalized: this.normalized
          };
        } else {
          if (data.interleavedBuffers === void 0) {
            data.interleavedBuffers = {};
          }
          if (data.interleavedBuffers[this.data.uuid] === void 0) {
            data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
          }
          return {
            isInterleavedBufferAttribute: true,
            itemSize: this.itemSize,
            data: this.data.uuid,
            offset: this.offset,
            normalized: this.normalized
          };
        }
      }
    };
    SpriteMaterial = class extends Material {
      /**
       * Constructs a new sprite material.
       *
       * @param {Object} [parameters] - An object with one or more properties
       * defining the material's appearance. Any property of the material
       * (including any property from inherited materials) can be passed
       * in here. Color values can be passed any type of value accepted
       * by {@link Color#set}.
       */
      constructor(parameters) {
        super();
        this.isSpriteMaterial = true;
        this.type = "SpriteMaterial";
        this.color = new Color(16777215);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
      }
      copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
      }
    };
    _intersectPoint = /* @__PURE__ */ new Vector3();
    _worldScale = /* @__PURE__ */ new Vector3();
    _mvPosition = /* @__PURE__ */ new Vector3();
    _alignedPosition = /* @__PURE__ */ new Vector2();
    _rotatedPosition = /* @__PURE__ */ new Vector2();
    _viewWorldMatrix = /* @__PURE__ */ new Matrix4();
    _vA = /* @__PURE__ */ new Vector3();
    _vB = /* @__PURE__ */ new Vector3();
    _vC = /* @__PURE__ */ new Vector3();
    _uvA = /* @__PURE__ */ new Vector2();
    _uvB = /* @__PURE__ */ new Vector2();
    _uvC = /* @__PURE__ */ new Vector2();
    Sprite = class extends Object3D {
      /**
       * Constructs a new sprite.
       *
       * @param {(SpriteMaterial|SpriteNodeMaterial)} [material] - The sprite material.
       */
      constructor(material = new SpriteMaterial()) {
        super();
        this.isSprite = true;
        this.type = "Sprite";
        if (_geometry === void 0) {
          _geometry = new BufferGeometry();
          const float32Array = new Float32Array([
            -0.5,
            -0.5,
            0,
            0,
            0,
            0.5,
            -0.5,
            0,
            1,
            0,
            0.5,
            0.5,
            0,
            1,
            1,
            -0.5,
            0.5,
            0,
            0,
            1
          ]);
          const interleavedBuffer = new InterleavedBuffer(float32Array, 5);
          _geometry.setIndex([0, 1, 2, 0, 2, 3]);
          _geometry.setAttribute("position", new InterleavedBufferAttribute(interleavedBuffer, 3, 0, false));
          _geometry.setAttribute("uv", new InterleavedBufferAttribute(interleavedBuffer, 2, 3, false));
        }
        this.geometry = _geometry;
        this.material = material;
        this.center = new Vector2(0.5, 0.5);
        this.count = 1;
      }
      /**
       * Computes intersection points between a casted ray and this sprite.
       *
       * @param {Raycaster} raycaster - The raycaster.
       * @param {Array<Object>} intersects - The target array that holds the intersection points.
       */
      raycast(raycaster, intersects) {
        if (raycaster.camera === null) {
          console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        }
        _worldScale.setFromMatrixScale(this.matrixWorld);
        _viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        _mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) {
          _worldScale.multiplyScalar(-_mvPosition.z);
        }
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
          cos = Math.cos(rotation);
          sin = Math.sin(rotation);
        }
        const center = this.center;
        transformVertex(_vA.set(-0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        transformVertex(_vB.set(0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        transformVertex(_vC.set(0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        _uvA.set(0, 0);
        _uvB.set(1, 0);
        _uvC.set(1, 1);
        let intersect2 = raycaster.ray.intersectTriangle(_vA, _vB, _vC, false, _intersectPoint);
        if (intersect2 === null) {
          transformVertex(_vB.set(-0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
          _uvB.set(0, 1);
          intersect2 = raycaster.ray.intersectTriangle(_vA, _vC, _vB, false, _intersectPoint);
          if (intersect2 === null) {
            return;
          }
        }
        const distance = raycaster.ray.origin.distanceTo(_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
          distance,
          point: _intersectPoint.clone(),
          uv: Triangle.getInterpolation(_intersectPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2()),
          face: null,
          object: this
        });
      }
      copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== void 0) this.center.copy(source.center);
        this.material = source.material;
        return this;
      }
    };
    DataTexture = class extends Texture {
      /**
       * Constructs a new data texture.
       *
       * @param {?TypedArray} [data=null] - The buffer data.
       * @param {number} [width=1] - The width of the texture.
       * @param {number} [height=1] - The height of the texture.
       * @param {number} [format=RGBAFormat] - The texture format.
       * @param {number} [type=UnsignedByteType] - The texture type.
       * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
       * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
       * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
       * @param {number} [magFilter=NearestFilter] - The mag filter value.
       * @param {number} [minFilter=NearestFilter] - The min filter value.
       * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
       * @param {string} [colorSpace=NoColorSpace] - The color space.
       */
      constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, colorSpace) {
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isDataTexture = true;
        this.image = { data, width, height };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
      }
    };
    InstancedBufferAttribute = class extends BufferAttribute {
      /**
       * Constructs a new instanced buffer attribute.
       *
       * @param {TypedArray} array - The array holding the attribute data.
       * @param {number} itemSize - The item size.
       * @param {boolean} [normalized=false] - Whether the data are normalized or not.
       * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
       */
      constructor(array, itemSize, normalized, meshPerAttribute = 1) {
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
      }
      copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
      }
      toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
      }
    };
    _instanceLocalMatrix = /* @__PURE__ */ new Matrix4();
    _instanceWorldMatrix = /* @__PURE__ */ new Matrix4();
    _instanceIntersects = [];
    _box3 = /* @__PURE__ */ new Box3();
    _identity = /* @__PURE__ */ new Matrix4();
    _mesh$1 = /* @__PURE__ */ new Mesh();
    _sphere$4 = /* @__PURE__ */ new Sphere();
    InstancedMesh = class extends Mesh {
      /**
       * Constructs a new instanced mesh.
       *
       * @param {BufferGeometry} [geometry] - The mesh geometry.
       * @param {Material|Array<Material>} [material] - The mesh material.
       * @param {number} count - The number of instances.
       */
      constructor(geometry, material, count) {
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new InstancedBufferAttribute(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.morphTexture = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for (let i = 0; i < count; i++) {
          this.setMatrixAt(i, _identity);
        }
      }
      /**
       * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
       * The bounding box is not automatically computed by the engine; this method must be called by your app.
       * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
       */
      computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) {
          this.boundingBox = new Box3();
        }
        if (geometry.boundingBox === null) {
          geometry.computeBoundingBox();
        }
        this.boundingBox.makeEmpty();
        for (let i = 0; i < count; i++) {
          this.getMatrixAt(i, _instanceLocalMatrix);
          _box3.copy(geometry.boundingBox).applyMatrix4(_instanceLocalMatrix);
          this.boundingBox.union(_box3);
        }
      }
      /**
       * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
       * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
       * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
       */
      computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) {
          this.boundingSphere = new Sphere();
        }
        if (geometry.boundingSphere === null) {
          geometry.computeBoundingSphere();
        }
        this.boundingSphere.makeEmpty();
        for (let i = 0; i < count; i++) {
          this.getMatrixAt(i, _instanceLocalMatrix);
          _sphere$4.copy(geometry.boundingSphere).applyMatrix4(_instanceLocalMatrix);
          this.boundingSphere.union(_sphere$4);
        }
      }
      copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
      }
      /**
       * Gets the color of the defined instance.
       *
       * @param {number} index - The instance index.
       * @param {Color} color - The target object that is used to store the method's result.
       */
      getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
      }
      /**
       * Gets the local transformation matrix of the defined instance.
       *
       * @param {number} index - The instance index.
       * @param {Matrix4} matrix - The target object that is used to store the method's result.
       */
      getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
      }
      /**
       * Gets the morph target weights of the defined instance.
       *
       * @param {number} index - The instance index.
       * @param {Mesh} object - The target object that is used to store the method's result.
       */
      getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1;
        const dataIndex = index * len + 1;
        for (let i = 0; i < objectInfluences.length; i++) {
          objectInfluences[i] = array[dataIndex + i];
        }
      }
      raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        _mesh$1.geometry = this.geometry;
        _mesh$1.material = this.material;
        if (_mesh$1.material === void 0) return;
        if (this.boundingSphere === null) this.computeBoundingSphere();
        _sphere$4.copy(this.boundingSphere);
        _sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere(_sphere$4) === false) return;
        for (let instanceId = 0; instanceId < raycastTimes; instanceId++) {
          this.getMatrixAt(instanceId, _instanceLocalMatrix);
          _instanceWorldMatrix.multiplyMatrices(matrixWorld, _instanceLocalMatrix);
          _mesh$1.matrixWorld = _instanceWorldMatrix;
          _mesh$1.raycast(raycaster, _instanceIntersects);
          for (let i = 0, l = _instanceIntersects.length; i < l; i++) {
            const intersect2 = _instanceIntersects[i];
            intersect2.instanceId = instanceId;
            intersect2.object = this;
            intersects.push(intersect2);
          }
          _instanceIntersects.length = 0;
        }
      }
      /**
       * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
       * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
       *
       * @param {number} index - The instance index.
       * @param {Color} color - The instance color.
       */
      setColorAt(index, color) {
        if (this.instanceColor === null) {
          this.instanceColor = new InstancedBufferAttribute(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        }
        color.toArray(this.instanceColor.array, index * 3);
      }
      /**
       * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
       * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
       *
       * @param {number} index - The instance index.
       * @param {Matrix4} matrix - The local transformation.
       */
      setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
      }
      /**
       * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
       * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
       *
       * @param {number} index - The instance index.
       * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
       * of a single instance.
       */
      setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1;
        if (this.morphTexture === null) {
          this.morphTexture = new DataTexture(new Float32Array(len * this.count), len, this.count, RedFormat, FloatType);
        }
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for (let i = 0; i < objectInfluences.length; i++) {
          morphInfluencesSum += objectInfluences[i];
        }
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
      }
      updateMorphTargets() {
      }
      /**
       * Frees the GPU-related resources allocated by this instance. Call this
       * method whenever this instance is no longer used in your app.
       */
      dispose() {
        this.dispatchEvent({ type: "dispose" });
        if (this.morphTexture !== null) {
          this.morphTexture.dispose();
          this.morphTexture = null;
        }
      }
    };
    _vector1 = /* @__PURE__ */ new Vector3();
    _vector2 = /* @__PURE__ */ new Vector3();
    _normalMatrix = /* @__PURE__ */ new Matrix3();
    Plane = class {
      /**
       * Constructs a new plane.
       *
       * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
       * @param {number} [constant=0] - The signed distance from the origin to the plane.
       */
      constructor(normal = new Vector3(1, 0, 0), constant = 0) {
        this.isPlane = true;
        this.normal = normal;
        this.constant = constant;
      }
      /**
       * Sets the plane components by copying the given values.
       *
       * @param {Vector3} normal - The normal.
       * @param {number} constant - The constant.
       * @return {Plane} A reference to this plane.
       */
      set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
      }
      /**
       * Sets the plane components by defining `x`, `y`, `z` as the
       * plane normal and `w` as the constant.
       *
       * @param {number} x - The value for the normal's x component.
       * @param {number} y - The value for the normal's y component.
       * @param {number} z - The value for the normal's z component.
       * @param {number} w - The constant value.
       * @return {Plane} A reference to this plane.
       */
      setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
      }
      /**
       * Sets the plane from the given normal and coplanar point (that is a point
       * that lies onto the plane).
       *
       * @param {Vector3} normal - The normal.
       * @param {Vector3} point - A coplanar point.
       * @return {Plane} A reference to this plane.
       */
      setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
      }
      /**
       * Sets the plane from three coplanar points. The winding order is
       * assumed to be counter-clockwise, and determines the direction of
       * the plane normal.
       *
       * @param {Vector3} a - The first coplanar point.
       * @param {Vector3} b - The second coplanar point.
       * @param {Vector3} c - The third coplanar point.
       * @return {Plane} A reference to this plane.
       */
      setFromCoplanarPoints(a, b, c) {
        const normal = _vector1.subVectors(c, b).cross(_vector2.subVectors(a, b)).normalize();
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
      }
      /**
       * Copies the values of the given plane to this instance.
       *
       * @param {Plane} plane - The plane to copy.
       * @return {Plane} A reference to this plane.
       */
      copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
      }
      /**
       * Normalizes the plane normal and adjusts the constant accordingly.
       *
       * @return {Plane} A reference to this plane.
       */
      normalize() {
        const inverseNormalLength = 1 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
      }
      /**
       * Negates both the plane normal and the constant.
       *
       * @return {Plane} A reference to this plane.
       */
      negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
      }
      /**
       * Returns the signed distance from the given point to this plane.
       *
       * @param {Vector3} point - The point to compute the distance for.
       * @return {number} The signed distance.
       */
      distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
      }
      /**
       * Returns the signed distance from the given sphere to this plane.
       *
       * @param {Sphere} sphere - The sphere to compute the distance for.
       * @return {number} The signed distance.
       */
      distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
      }
      /**
       * Projects a the given point onto the plane.
       *
       * @param {Vector3} point - The point to project.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The projected point on the plane.
       */
      projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
      }
      /**
       * Returns the intersection point of the passed line and the plane. Returns
       * `null` if the line does not intersect. Returns the line's starting point if
       * the line is coplanar with the plane.
       *
       * @param {Line3} line - The line to compute the intersection for.
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {?Vector3} The intersection point.
       */
      intersectLine(line, target) {
        const direction = line.delta(_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
          if (this.distanceToPoint(line.start) === 0) {
            return target.copy(line.start);
          }
          return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) {
          return null;
        }
        return target.copy(line.start).addScaledVector(direction, t);
      }
      /**
       * Returns `true` if the given line segment intersects with (passes through) the plane.
       *
       * @param {Line3} line - The line to test.
       * @return {boolean} Whether the given line segment intersects with the plane or not.
       */
      intersectsLine(line) {
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
      }
      /**
       * Returns `true` if the given bounding box intersects with the plane.
       *
       * @param {Box3} box - The bounding box to test.
       * @return {boolean} Whether the given bounding box intersects with the plane or not.
       */
      intersectsBox(box) {
        return box.intersectsPlane(this);
      }
      /**
       * Returns `true` if the given bounding sphere intersects with the plane.
       *
       * @param {Sphere} sphere - The bounding sphere to test.
       * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
       */
      intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
      }
      /**
       * Returns a coplanar vector to the plane, by calculating the
       * projection of the normal at the origin onto the plane.
       *
       * @param {Vector3} target - The target vector that is used to store the method's result.
       * @return {Vector3} The coplanar point.
       */
      coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
      }
      /**
       * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
       *
       * The optional normal matrix can be pre-computed like so:
       * ```js
       * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
       * ```
       *
       * @param {Matrix4} matrix - The transformation matrix.
       * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
       * @return {Plane} A reference to this plane.
       */
      applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
      }
      /**
       * Translates the plane by the distance defined by the given offset vector.
       * Note that this only affects the plane constant and will not affect the normal vector.
       *
       * @param {Vector3} offset - The offset vector.
       * @return {Plane} A reference to this plane.
       */
      translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
      }
      /**
       * Returns `true` if this plane is equal with the given one.
       *
       * @param {Plane} plane - The plane to test for equality.
       * @return {boolean} Whether this plane is equal with the given one.
       */
      equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
      }
      /**
       * Returns a new plane with copied values from this instance.
       *
       * @return {Plane} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
    };
    _sphere$3 = /* @__PURE__ */ new Sphere();
    _defaultSpriteCenter = /* @__PURE__ */ new Vector2(0.5, 0.5);
    _vector$6 = /* @__PURE__ */ new Vector3();
    Frustum = class {
      /**
       * Constructs a new frustum.
       *
       * @param {Plane} [p0] - The first plane that encloses the frustum.
       * @param {Plane} [p1] - The second plane that encloses the frustum.
       * @param {Plane} [p2] - The third plane that encloses the frustum.
       * @param {Plane} [p3] - The fourth plane that encloses the frustum.
       * @param {Plane} [p4] - The fifth plane that encloses the frustum.
       * @param {Plane} [p5] - The sixth plane that encloses the frustum.
       */
      constructor(p0 = new Plane(), p1 = new Plane(), p2 = new Plane(), p3 = new Plane(), p4 = new Plane(), p5 = new Plane()) {
        this.planes = [p0, p1, p2, p3, p4, p5];
      }
      /**
       * Sets the frustum planes by copying the given planes.
       *
       * @param {Plane} [p0] - The first plane that encloses the frustum.
       * @param {Plane} [p1] - The second plane that encloses the frustum.
       * @param {Plane} [p2] - The third plane that encloses the frustum.
       * @param {Plane} [p3] - The fourth plane that encloses the frustum.
       * @param {Plane} [p4] - The fifth plane that encloses the frustum.
       * @param {Plane} [p5] - The sixth plane that encloses the frustum.
       * @return {Frustum} A reference to this frustum.
       */
      set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
      }
      /**
       * Copies the values of the given frustum to this instance.
       *
       * @param {Frustum} frustum - The frustum to copy.
       * @return {Frustum} A reference to this frustum.
       */
      copy(frustum) {
        const planes = this.planes;
        for (let i = 0; i < 6; i++) {
          planes[i].copy(frustum.planes[i]);
        }
        return this;
      }
      /**
       * Sets the frustum planes from the given projection matrix.
       *
       * @param {Matrix4} m - The projection matrix.
       * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
       * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
       * @return {Frustum} A reference to this frustum.
       */
      setFromProjectionMatrix(m, coordinateSystem = WebGLCoordinateSystem, reversedDepth = false) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        if (reversedDepth) {
          planes[4].setComponents(me2, me6, me10, me14).normalize();
          planes[5].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        } else {
          planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
          if (coordinateSystem === WebGLCoordinateSystem) {
            planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
          } else if (coordinateSystem === WebGPUCoordinateSystem) {
            planes[5].setComponents(me2, me6, me10, me14).normalize();
          } else {
            throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + coordinateSystem);
          }
        }
        return this;
      }
      /**
       * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
       *
       * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
       *
       * @param {Object3D} object - The 3D object to test.
       * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
       */
      intersectsObject(object) {
        if (object.boundingSphere !== void 0) {
          if (object.boundingSphere === null) object.computeBoundingSphere();
          _sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
          const geometry = object.geometry;
          if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
          _sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere(_sphere$3);
      }
      /**
       * Returns `true` if the given sprite is intersecting this frustum.
       *
       * @param {Sprite} sprite - The sprite to test.
       * @return {boolean} Whether the sprite is intersecting this frustum or not.
       */
      intersectsSprite(sprite) {
        _sphere$3.center.set(0, 0, 0);
        const offset = _defaultSpriteCenter.distanceTo(sprite.center);
        _sphere$3.radius = 0.7071067811865476 + offset;
        _sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere(_sphere$3);
      }
      /**
       * Returns `true` if the given bounding sphere is intersecting this frustum.
       *
       * @param {Sphere} sphere - The bounding sphere to test.
       * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
       */
      intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for (let i = 0; i < 6; i++) {
          const distance = planes[i].distanceToPoint(center);
          if (distance < negRadius) {
            return false;
          }
        }
        return true;
      }
      /**
       * Returns `true` if the given bounding box is intersecting this frustum.
       *
       * @param {Box3} box - The bounding box to test.
       * @return {boolean} Whether the bounding box is intersecting this frustum or not.
       */
      intersectsBox(box) {
        const planes = this.planes;
        for (let i = 0; i < 6; i++) {
          const plane = planes[i];
          _vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
          _vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
          _vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
          if (plane.distanceToPoint(_vector$6) < 0) {
            return false;
          }
        }
        return true;
      }
      /**
       * Returns `true` if the given point lies within the frustum.
       *
       * @param {Vector3} point - The point to test.
       * @return {boolean} Whether the point lies within this frustum or not.
       */
      containsPoint(point) {
        const planes = this.planes;
        for (let i = 0; i < 6; i++) {
          if (planes[i].distanceToPoint(point) < 0) {
            return false;
          }
        }
        return true;
      }
      /**
       * Returns a new frustum with copied values from this instance.
       *
       * @return {Frustum} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
    };
    LineBasicMaterial = class extends Material {
      /**
       * Constructs a new line basic material.
       *
       * @param {Object} [parameters] - An object with one or more properties
       * defining the material's appearance. Any property of the material
       * (including any property from inherited materials) can be passed
       * in here. Color values can be passed any type of value accepted
       * by {@link Color#set}.
       */
      constructor(parameters) {
        super();
        this.isLineBasicMaterial = true;
        this.type = "LineBasicMaterial";
        this.color = new Color(16777215);
        this.map = null;
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.fog = true;
        this.setValues(parameters);
      }
      copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
      }
    };
    _vStart = /* @__PURE__ */ new Vector3();
    _vEnd = /* @__PURE__ */ new Vector3();
    _inverseMatrix$1 = /* @__PURE__ */ new Matrix4();
    _ray$1 = /* @__PURE__ */ new Ray();
    _sphere$1 = /* @__PURE__ */ new Sphere();
    _intersectPointOnRay = /* @__PURE__ */ new Vector3();
    _intersectPointOnSegment = /* @__PURE__ */ new Vector3();
    Line = class extends Object3D {
      /**
       * Constructs a new line.
       *
       * @param {BufferGeometry} [geometry] - The line geometry.
       * @param {Material|Array<Material>} [material] - The line material.
       */
      constructor(geometry = new BufferGeometry(), material = new LineBasicMaterial()) {
        super();
        this.isLine = true;
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.morphTargetDictionary = void 0;
        this.morphTargetInfluences = void 0;
        this.updateMorphTargets();
      }
      copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
      }
      /**
       * Computes an array of distance values which are necessary for rendering dashed lines.
       * For each vertex in the geometry, the method calculates the cumulative length from the
       * current point to the very beginning of the line.
       *
       * @return {Line} A reference to this line.
       */
      computeLineDistances() {
        const geometry = this.geometry;
        if (geometry.index === null) {
          const positionAttribute = geometry.attributes.position;
          const lineDistances = [0];
          for (let i = 1, l = positionAttribute.count; i < l; i++) {
            _vStart.fromBufferAttribute(positionAttribute, i - 1);
            _vEnd.fromBufferAttribute(positionAttribute, i);
            lineDistances[i] = lineDistances[i - 1];
            lineDistances[i] += _vStart.distanceTo(_vEnd);
          }
          geometry.setAttribute("lineDistance", new Float32BufferAttribute(lineDistances, 1));
        } else {
          console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        }
        return this;
      }
      /**
       * Computes intersection points between a casted ray and this line.
       *
       * @param {Raycaster} raycaster - The raycaster.
       * @param {Array<Object>} intersects - The target array that holds the intersection points.
       */
      raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere$1.copy(geometry.boundingSphere);
        _sphere$1.applyMatrix4(matrixWorld);
        _sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere(_sphere$1) === false) return;
        _inverseMatrix$1.copy(matrixWorld).invert();
        _ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
          const start = Math.max(0, drawRange.start);
          const end = Math.min(index.count, drawRange.start + drawRange.count);
          for (let i = start, l = end - 1; i < l; i += step) {
            const a = index.getX(i);
            const b = index.getX(i + 1);
            const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, a, b, i);
            if (intersect2) {
              intersects.push(intersect2);
            }
          }
          if (this.isLineLoop) {
            const a = index.getX(end - 1);
            const b = index.getX(start);
            const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, a, b, end - 1);
            if (intersect2) {
              intersects.push(intersect2);
            }
          }
        } else {
          const start = Math.max(0, drawRange.start);
          const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
          for (let i = start, l = end - 1; i < l; i += step) {
            const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, i, i + 1, i);
            if (intersect2) {
              intersects.push(intersect2);
            }
          }
          if (this.isLineLoop) {
            const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, end - 1, start, end - 1);
            if (intersect2) {
              intersects.push(intersect2);
            }
          }
        }
      }
      /**
       * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
       * to make sure existing morph targets can influence this 3D object.
       */
      updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
          const morphAttribute = morphAttributes[keys[0]];
          if (morphAttribute !== void 0) {
            this.morphTargetInfluences = [];
            this.morphTargetDictionary = {};
            for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
              const name = morphAttribute[m].name || String(m);
              this.morphTargetInfluences.push(0);
              this.morphTargetDictionary[name] = m;
            }
          }
        }
      }
    };
    _start = /* @__PURE__ */ new Vector3();
    _end = /* @__PURE__ */ new Vector3();
    LineSegments = class extends Line {
      /**
       * Constructs a new line segments.
       *
       * @param {BufferGeometry} [geometry] - The line geometry.
       * @param {Material|Array<Material>} [material] - The line material.
       */
      constructor(geometry, material) {
        super(geometry, material);
        this.isLineSegments = true;
        this.type = "LineSegments";
      }
      computeLineDistances() {
        const geometry = this.geometry;
        if (geometry.index === null) {
          const positionAttribute = geometry.attributes.position;
          const lineDistances = [];
          for (let i = 0, l = positionAttribute.count; i < l; i += 2) {
            _start.fromBufferAttribute(positionAttribute, i);
            _end.fromBufferAttribute(positionAttribute, i + 1);
            lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
            lineDistances[i + 1] = lineDistances[i] + _start.distanceTo(_end);
          }
          geometry.setAttribute("lineDistance", new Float32BufferAttribute(lineDistances, 1));
        } else {
          console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        }
        return this;
      }
    };
    CanvasTexture = class extends Texture {
      /**
       * Constructs a new texture.
       *
       * @param {HTMLCanvasElement} [canvas] - The HTML canvas element.
       * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
       * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
       * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
       * @param {number} [magFilter=LinearFilter] - The mag filter value.
       * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
       * @param {number} [format=RGBAFormat] - The texture format.
       * @param {number} [type=UnsignedByteType] - The texture type.
       * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
       */
      constructor(canvas2, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
        super(canvas2, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
      }
    };
    DepthTexture = class extends Texture {
      /**
       * Constructs a new depth texture.
       *
       * @param {number} width - The width of the texture.
       * @param {number} height - The height of the texture.
       * @param {number} [type=UnsignedIntType] - The texture type.
       * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
       * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
       * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
       * @param {number} [magFilter=LinearFilter] - The mag filter value.
       * @param {number} [minFilter=LinearFilter] - The min filter value.
       * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
       * @param {number} [format=DepthFormat] - The texture format.
       * @param {number} [depth=1] - The depth of the texture.
       */
      constructor(width, height, type = UnsignedIntType, mapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, format = DepthFormat, depth = 1) {
        if (format !== DepthFormat && format !== DepthStencilFormat) {
          throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        }
        const image = { width, height, depth };
        super(image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
      }
      copy(source) {
        super.copy(source);
        this.source = new Source(Object.assign({}, source.image));
        this.compareFunction = source.compareFunction;
        return this;
      }
      toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
      }
    };
    ExternalTexture = class extends Texture {
      /**
       * Creates a new raw texture.
       *
       * @param {?(WebGLTexture|GPUTexture)} [sourceTexture=null] - The external texture.
       */
      constructor(sourceTexture = null) {
        super();
        this.sourceTexture = sourceTexture;
        this.isExternalTexture = true;
      }
      copy(source) {
        super.copy(source);
        this.sourceTexture = source.sourceTexture;
        return this;
      }
    };
    CylinderGeometry = class _CylinderGeometry extends BufferGeometry {
      /**
       * Constructs a new cylinder geometry.
       *
       * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
       * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
       * @param {number} [height=1] - Height of the cylinder.
       * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
       * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
       * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
       * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
       * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
       * The default value results in a complete cylinder.
       */
      constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2) {
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
          radiusTop,
          radiusBottom,
          height,
          radialSegments,
          heightSegments,
          openEnded,
          thetaStart,
          thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        generateTorso();
        if (openEnded === false) {
          if (radiusTop > 0) generateCap(true);
          if (radiusBottom > 0) generateCap(false);
        }
        this.setIndex(indices);
        this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
        this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
        this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
        function generateTorso() {
          const normal = new Vector3();
          const vertex2 = new Vector3();
          let groupCount = 0;
          const slope = (radiusBottom - radiusTop) / height;
          for (let y = 0; y <= heightSegments; y++) {
            const indexRow = [];
            const v = y / heightSegments;
            const radius = v * (radiusBottom - radiusTop) + radiusTop;
            for (let x = 0; x <= radialSegments; x++) {
              const u = x / radialSegments;
              const theta = u * thetaLength + thetaStart;
              const sinTheta = Math.sin(theta);
              const cosTheta = Math.cos(theta);
              vertex2.x = radius * sinTheta;
              vertex2.y = -v * height + halfHeight;
              vertex2.z = radius * cosTheta;
              vertices.push(vertex2.x, vertex2.y, vertex2.z);
              normal.set(sinTheta, slope, cosTheta).normalize();
              normals.push(normal.x, normal.y, normal.z);
              uvs.push(u, 1 - v);
              indexRow.push(index++);
            }
            indexArray.push(indexRow);
          }
          for (let x = 0; x < radialSegments; x++) {
            for (let y = 0; y < heightSegments; y++) {
              const a = indexArray[y][x];
              const b = indexArray[y + 1][x];
              const c = indexArray[y + 1][x + 1];
              const d = indexArray[y][x + 1];
              if (radiusTop > 0 || y !== 0) {
                indices.push(a, b, d);
                groupCount += 3;
              }
              if (radiusBottom > 0 || y !== heightSegments - 1) {
                indices.push(b, c, d);
                groupCount += 3;
              }
            }
          }
          scope.addGroup(groupStart, groupCount, 0);
          groupStart += groupCount;
        }
        function generateCap(top) {
          const centerIndexStart = index;
          const uv = new Vector2();
          const vertex2 = new Vector3();
          let groupCount = 0;
          const radius = top === true ? radiusTop : radiusBottom;
          const sign = top === true ? 1 : -1;
          for (let x = 1; x <= radialSegments; x++) {
            vertices.push(0, halfHeight * sign, 0);
            normals.push(0, sign, 0);
            uvs.push(0.5, 0.5);
            index++;
          }
          const centerIndexEnd = index;
          for (let x = 0; x <= radialSegments; x++) {
            const u = x / radialSegments;
            const theta = u * thetaLength + thetaStart;
            const cosTheta = Math.cos(theta);
            const sinTheta = Math.sin(theta);
            vertex2.x = radius * sinTheta;
            vertex2.y = halfHeight * sign;
            vertex2.z = radius * cosTheta;
            vertices.push(vertex2.x, vertex2.y, vertex2.z);
            normals.push(0, sign, 0);
            uv.x = cosTheta * 0.5 + 0.5;
            uv.y = sinTheta * 0.5 * sign + 0.5;
            uvs.push(uv.x, uv.y);
            index++;
          }
          for (let x = 0; x < radialSegments; x++) {
            const c = centerIndexStart + x;
            const i = centerIndexEnd + x;
            if (top === true) {
              indices.push(i, i + 1, c);
            } else {
              indices.push(i + 1, i, c);
            }
            groupCount += 3;
          }
          scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
          groupStart += groupCount;
        }
      }
      copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
      }
      /**
       * Factory method for creating an instance of this class from the given
       * JSON object.
       *
       * @param {Object} data - A JSON object representing the serialized geometry.
       * @return {CylinderGeometry} A new instance.
       */
      static fromJSON(data) {
        return new _CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
      }
    };
    Curve = class {
      /**
       * Constructs a new curve.
       */
      constructor() {
        this.type = "Curve";
        this.arcLengthDivisions = 200;
        this.needsUpdate = false;
        this.cacheArcLengths = null;
      }
      /**
       * This method returns a vector in 2D or 3D space (depending on the curve definition)
       * for the given interpolation factor.
       *
       * @abstract
       * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
       * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
       * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
       */
      getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
      }
      /**
       * This method returns a vector in 2D or 3D space (depending on the curve definition)
       * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
       * of the curve which equidistant samples.
       *
       * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
       * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
       * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
       */
      getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
      }
      /**
       * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
       * the curve shape.
       *
       * @param {number} [divisions=5] - The number of divisions.
       * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
       */
      getPoints(divisions = 5) {
        const points = [];
        for (let d = 0; d <= divisions; d++) {
          points.push(this.getPoint(d / divisions));
        }
        return points;
      }
      // Get sequence of points using getPointAt( u )
      /**
       * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
       * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
       * curve.
       *
       * @param {number} [divisions=5] - The number of divisions.
       * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
       */
      getSpacedPoints(divisions = 5) {
        const points = [];
        for (let d = 0; d <= divisions; d++) {
          points.push(this.getPointAt(d / divisions));
        }
        return points;
      }
      /**
       * Returns the total arc length of the curve.
       *
       * @return {number} The length of the curve.
       */
      getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
      }
      /**
       * Returns an array of cumulative segment lengths of the curve.
       *
       * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
       * @return {Array<number>} An array holding the cumulative segment lengths.
       */
      getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) {
          return this.cacheArcLengths;
        }
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for (let p = 1; p <= divisions; p++) {
          current = this.getPoint(p / divisions);
          sum += current.distanceTo(last);
          cache.push(sum);
          last = current;
        }
        this.cacheArcLengths = cache;
        return cache;
      }
      /**
       * Update the cumulative segment distance cache. The method must be called
       * every time curve parameters are changed. If an updated curve is part of a
       * composed curve like {@link CurvePath}, this method must be called on the
       * composed curve, too.
       */
      updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
      }
      /**
       * Given an interpolation factor in the range `[0,1]`, this method returns an updated
       * interpolation factor in the same range that can be ued to sample equidistant points
       * from a curve.
       *
       * @param {number} u - The interpolation factor.
       * @param {?number} distance - An optional distance on the curve.
       * @return {number} The updated interpolation factor.
       */
      getUtoTmapping(u, distance = null) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength;
        if (distance) {
          targetArcLength = distance;
        } else {
          targetArcLength = u * arcLengths[il - 1];
        }
        let low = 0, high = il - 1, comparison;
        while (low <= high) {
          i = Math.floor(low + (high - low) / 2);
          comparison = arcLengths[i] - targetArcLength;
          if (comparison < 0) {
            low = i + 1;
          } else if (comparison > 0) {
            high = i - 1;
          } else {
            high = i;
            break;
          }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) {
          return i / (il - 1);
        }
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        const t = (i + segmentFraction) / (il - 1);
        return t;
      }
      /**
       * Returns a unit vector tangent for the given interpolation factor.
       * If the derived curve does not implement its tangent derivation,
       * two points a small delta apart will be used to find its gradient
       * which seems to give a reasonable approximation.
       *
       * @param {number} t - The interpolation factor.
       * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
       * @return {(Vector2|Vector3)} The tangent vector.
       */
      getTangent(t, optionalTarget) {
        const delta = 1e-4;
        let t1 = t - delta;
        let t2 = t + delta;
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new Vector2() : new Vector3());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
      }
      /**
       * Same as {@link Curve#getTangent} but with equidistant samples.
       *
       * @param {number} u - The interpolation factor.
       * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
       * @return {(Vector2|Vector3)} The tangent vector.
       * @see {@link Curve#getPointAt}
       */
      getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
      }
      /**
       * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
       * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
       *
       * @param {number} segments - The number of segments.
       * @param {boolean} [closed=false] - Whether the curve is closed or not.
       * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
       */
      computeFrenetFrames(segments, closed = false) {
        const normal = new Vector3();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new Vector3();
        const mat = new Matrix4();
        for (let i = 0; i <= segments; i++) {
          const u = i / segments;
          tangents[i] = this.getTangentAt(u, new Vector3());
        }
        normals[0] = new Vector3();
        binormals[0] = new Vector3();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
          min = tx;
          normal.set(1, 0, 0);
        }
        if (ty <= min) {
          min = ty;
          normal.set(0, 1, 0);
        }
        if (tz <= min) {
          normal.set(0, 0, 1);
        }
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        for (let i = 1; i <= segments; i++) {
          normals[i] = normals[i - 1].clone();
          binormals[i] = binormals[i - 1].clone();
          vec.crossVectors(tangents[i - 1], tangents[i]);
          if (vec.length() > Number.EPSILON) {
            vec.normalize();
            const theta = Math.acos(clamp(tangents[i - 1].dot(tangents[i]), -1, 1));
            normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
          }
          binormals[i].crossVectors(tangents[i], normals[i]);
        }
        if (closed === true) {
          let theta = Math.acos(clamp(normals[0].dot(normals[segments]), -1, 1));
          theta /= segments;
          if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) {
            theta = -theta;
          }
          for (let i = 1; i <= segments; i++) {
            normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
            binormals[i].crossVectors(tangents[i], normals[i]);
          }
        }
        return {
          tangents,
          normals,
          binormals
        };
      }
      /**
       * Returns a new curve with copied values from this instance.
       *
       * @return {Curve} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
      /**
       * Copies the values of the given curve to this instance.
       *
       * @param {Curve} source - The curve to copy.
       * @return {Curve} A reference to this curve.
       */
      copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
      }
      /**
       * Serializes the curve into JSON.
       *
       * @return {Object} A JSON object representing the serialized curve.
       * @see {@link ObjectLoader#parse}
       */
      toJSON() {
        const data = {
          metadata: {
            version: 4.7,
            type: "Curve",
            generator: "Curve.toJSON"
          }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
      }
      /**
       * Deserializes the curve from the given JSON.
       *
       * @param {Object} json - The JSON holding the serialized curve.
       * @return {Curve} A reference to this curve.
       */
      fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
      }
    };
    tmp = /* @__PURE__ */ new Vector3();
    px = /* @__PURE__ */ new CubicPoly();
    py = /* @__PURE__ */ new CubicPoly();
    pz = /* @__PURE__ */ new CubicPoly();
    CatmullRomCurve3 = class extends Curve {
      /**
       * Constructs a new Catmull-Rom curve.
       *
       * @param {Array<Vector3>} [points] - An array of 3D points defining the curve.
       * @param {boolean} [closed=false] - Whether the curve is closed or not.
       * @param {('centripetal'|'chordal'|'catmullrom')} [curveType='centripetal'] - The curve type.
       * @param {number} [tension=0.5] - Tension of the curve.
       */
      constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5) {
        super();
        this.isCatmullRomCurve3 = true;
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
      }
      /**
       * Returns a point on the curve.
       *
       * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
       * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
       * @return {Vector3} The position on the curve.
       */
      getPoint(t, optionalTarget = new Vector3()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) {
          intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        } else if (weight === 0 && intPoint === l - 1) {
          intPoint = l - 2;
          weight = 1;
        }
        let p0, p3;
        if (this.closed || intPoint > 0) {
          p0 = points[(intPoint - 1) % l];
        } else {
          tmp.subVectors(points[0], points[1]).add(points[0]);
          p0 = tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) {
          p3 = points[(intPoint + 2) % l];
        } else {
          tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
          p3 = tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
          const pow = this.curveType === "chordal" ? 0.5 : 0.25;
          let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
          let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
          let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
          if (dt1 < 1e-4) dt1 = 1;
          if (dt0 < 1e-4) dt0 = dt1;
          if (dt2 < 1e-4) dt2 = dt1;
          px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
          py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
          pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
          px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
          py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
          pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set(
          px.calc(weight),
          py.calc(weight),
          pz.calc(weight)
        );
        return point;
      }
      copy(source) {
        super.copy(source);
        this.points = [];
        for (let i = 0, l = source.points.length; i < l; i++) {
          const point = source.points[i];
          this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
      }
      toJSON() {
        const data = super.toJSON();
        data.points = [];
        for (let i = 0, l = this.points.length; i < l; i++) {
          const point = this.points[i];
          data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
      }
      fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for (let i = 0, l = json.points.length; i < l; i++) {
          const point = json.points[i];
          this.points.push(new Vector3().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
      }
    };
    PlaneGeometry = class _PlaneGeometry extends BufferGeometry {
      /**
       * Constructs a new plane geometry.
       *
       * @param {number} [width=1] - The width along the X axis.
       * @param {number} [height=1] - The height along the Y axis
       * @param {number} [widthSegments=1] - The number of segments along the X axis.
       * @param {number} [heightSegments=1] - The number of segments along the Y axis.
       */
      constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1) {
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
          width,
          height,
          widthSegments,
          heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for (let iy = 0; iy < gridY1; iy++) {
          const y = iy * segment_height - height_half;
          for (let ix = 0; ix < gridX1; ix++) {
            const x = ix * segment_width - width_half;
            vertices.push(x, -y, 0);
            normals.push(0, 0, 1);
            uvs.push(ix / gridX);
            uvs.push(1 - iy / gridY);
          }
        }
        for (let iy = 0; iy < gridY; iy++) {
          for (let ix = 0; ix < gridX; ix++) {
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
          }
        }
        this.setIndex(indices);
        this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
        this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
        this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
      }
      copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
      }
      /**
       * Factory method for creating an instance of this class from the given
       * JSON object.
       *
       * @param {Object} data - A JSON object representing the serialized geometry.
       * @return {PlaneGeometry} A new instance.
       */
      static fromJSON(data) {
        return new _PlaneGeometry(data.width, data.height, data.widthSegments, data.heightSegments);
      }
    };
    MeshStandardMaterial = class extends Material {
      /**
       * Constructs a new mesh standard material.
       *
       * @param {Object} [parameters] - An object with one or more properties
       * defining the material's appearance. Any property of the material
       * (including any property from inherited materials) can be passed
       * in here. Color values can be passed any type of value accepted
       * by {@link Color#set}.
       */
      constructor(parameters) {
        super();
        this.isMeshStandardMaterial = true;
        this.type = "MeshStandardMaterial";
        this.defines = { "STANDARD": "" };
        this.color = new Color(16777215);
        this.roughness = 1;
        this.metalness = 0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1;
        this.aoMap = null;
        this.aoMapIntensity = 1;
        this.emissive = new Color(0);
        this.emissiveIntensity = 1;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = TangentSpaceNormalMap;
        this.normalScale = new Vector2(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new Euler();
        this.envMapIntensity = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
      }
      copy(source) {
        super.copy(source);
        this.defines = { "STANDARD": "" };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
      }
    };
    MeshPhysicalMaterial = class extends MeshStandardMaterial {
      /**
       * Constructs a new mesh physical material.
       *
       * @param {Object} [parameters] - An object with one or more properties
       * defining the material's appearance. Any property of the material
       * (including any property from inherited materials) can be passed
       * in here. Color values can be passed any type of value accepted
       * by {@link Color#set}.
       */
      constructor(parameters) {
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
          "STANDARD": "",
          "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new Vector2(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
          get: function() {
            return clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
          },
          set: function(reflectivity) {
            this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
          }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [100, 400];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new Color(0);
        this.sheenColorMap = null;
        this.sheenRoughness = 1;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new Color(1, 1, 1);
        this.specularIntensity = 1;
        this.specularIntensityMap = null;
        this.specularColor = new Color(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0;
        this._transmission = 0;
        this.setValues(parameters);
      }
      /**
       * The anisotropy strength.
       *
       * @type {number}
       * @default 0
       */
      get anisotropy() {
        return this._anisotropy;
      }
      set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) {
          this.version++;
        }
        this._anisotropy = value;
      }
      /**
       * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
       * clear coat related properties to enable multilayer materials that have a
       * thin translucent layer over the base layer.
       *
       * @type {number}
       * @default 0
       */
      get clearcoat() {
        return this._clearcoat;
      }
      set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) {
          this.version++;
        }
        this._clearcoat = value;
      }
      /**
       * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
       * the surface and the viewer, from `0.0` to `1.0`.
       *
       * @type {number}
       * @default 0
       */
      get iridescence() {
        return this._iridescence;
      }
      set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) {
          this.version++;
        }
        this._iridescence = value;
      }
      /**
       * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
       * through a relatively clear volume. Any value zero or larger is valid, the typical range of
       * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
       *
       * @type {number}
       * @default 0
       */
      get dispersion() {
        return this._dispersion;
      }
      set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) {
          this.version++;
        }
        this._dispersion = value;
      }
      /**
       * The intensity of the sheen layer, from `0.0` to `1.0`.
       *
       * @type {number}
       * @default 0
       */
      get sheen() {
        return this._sheen;
      }
      set sheen(value) {
        if (this._sheen > 0 !== value > 0) {
          this.version++;
        }
        this._sheen = value;
      }
      /**
       * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
       *
       * Thin, transparent or semitransparent, plastic or glass materials remain
       * largely reflective even if they are fully transmissive. The transmission
       * property can be used to model these materials.
       *
       * When transmission is non-zero, `opacity` should be  set to `1`.
       *
       * @type {number}
       * @default 0
       */
      get transmission() {
        return this._transmission;
      }
      set transmission(value) {
        if (this._transmission > 0 !== value > 0) {
          this.version++;
        }
        this._transmission = value;
      }
      copy(source) {
        super.copy(source);
        this.defines = {
          "STANDARD": "",
          "PHYSICAL": ""
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [...source.iridescenceThicknessRange];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
      }
    };
    MeshLambertMaterial = class extends Material {
      /**
       * Constructs a new mesh lambert material.
       *
       * @param {Object} [parameters] - An object with one or more properties
       * defining the material's appearance. Any property of the material
       * (including any property from inherited materials) can be passed
       * in here. Color values can be passed any type of value accepted
       * by {@link Color#set}.
       */
      constructor(parameters) {
        super();
        this.isMeshLambertMaterial = true;
        this.type = "MeshLambertMaterial";
        this.color = new Color(16777215);
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1;
        this.aoMap = null;
        this.aoMapIntensity = 1;
        this.emissive = new Color(0);
        this.emissiveIntensity = 1;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = TangentSpaceNormalMap;
        this.normalScale = new Vector2(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new Euler();
        this.combine = MultiplyOperation;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
      }
      copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
      }
    };
    MeshDepthMaterial = class extends Material {
      /**
       * Constructs a new mesh depth material.
       *
       * @param {Object} [parameters] - An object with one or more properties
       * defining the material's appearance. Any property of the material
       * (including any property from inherited materials) can be passed
       * in here. Color values can be passed any type of value accepted
       * by {@link Color#set}.
       */
      constructor(parameters) {
        super();
        this.isMeshDepthMaterial = true;
        this.type = "MeshDepthMaterial";
        this.depthPacking = BasicDepthPacking;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
      }
      copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
      }
    };
    MeshDistanceMaterial = class extends Material {
      /**
       * Constructs a new mesh distance material.
       *
       * @param {Object} [parameters] - An object with one or more properties
       * defining the material's appearance. Any property of the material
       * (including any property from inherited materials) can be passed
       * in here. Color values can be passed any type of value accepted
       * by {@link Color#set}.
       */
      constructor(parameters) {
        super();
        this.isMeshDistanceMaterial = true;
        this.type = "MeshDistanceMaterial";
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
      }
      copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
      }
    };
    Interpolant = class {
      /**
       * Constructs a new interpolant.
       *
       * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
       * @param {TypedArray} sampleValues - The sample values.
       * @param {number} sampleSize - The sample size
       * @param {TypedArray} [resultBuffer] - The result buffer.
       */
      constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== void 0 ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
      }
      /**
       * Evaluate the interpolant at position `t`.
       *
       * @param {number} t - The interpolation factor.
       * @return {TypedArray} The result buffer.
       */
      evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
          seek: {
            let right;
            linear_scan: {
              forward_scan: if (!(t < t1)) {
                for (let giveUpAt = i1 + 2; ; ) {
                  if (t1 === void 0) {
                    if (t < t0) break forward_scan;
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                  }
                  if (i1 === giveUpAt) break;
                  t0 = t1;
                  t1 = pp[++i1];
                  if (t < t1) {
                    break seek;
                  }
                }
                right = pp.length;
                break linear_scan;
              }
              if (!(t >= t0)) {
                const t1global = pp[1];
                if (t < t1global) {
                  i1 = 2;
                  t0 = t1global;
                }
                for (let giveUpAt = i1 - 2; ; ) {
                  if (t0 === void 0) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                  }
                  if (i1 === giveUpAt) break;
                  t1 = t0;
                  t0 = pp[--i1 - 1];
                  if (t >= t0) {
                    break seek;
                  }
                }
                right = i1;
                i1 = 0;
                break linear_scan;
              }
              break validate_interval;
            }
            while (i1 < right) {
              const mid = i1 + right >>> 1;
              if (t < pp[mid]) {
                right = mid;
              } else {
                i1 = mid + 1;
              }
            }
            t1 = pp[i1];
            t0 = pp[i1 - 1];
            if (t0 === void 0) {
              this._cachedIndex = 0;
              return this.copySampleValue_(0);
            }
            if (t1 === void 0) {
              i1 = pp.length;
              this._cachedIndex = i1;
              return this.copySampleValue_(i1 - 1);
            }
          }
          this._cachedIndex = i1;
          this.intervalChanged_(i1, t0, t1);
        }
        return this.interpolate_(i1, t0, t, t1);
      }
      /**
       * Returns the interpolation settings.
       *
       * @return {Object} The interpolation settings.
       */
      getSettings_() {
        return this.settings || this.DefaultSettings_;
      }
      /**
       * Copies a sample value to the result buffer.
       *
       * @param {number} index - An index into the sample value buffer.
       * @return {TypedArray} The result buffer.
       */
      copySampleValue_(index) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for (let i = 0; i !== stride; ++i) {
          result[i] = values[offset + i];
        }
        return result;
      }
      /**
       * Copies a sample value to the result buffer.
       *
       * @abstract
       * @param {number} i1 - An index into the sample value buffer.
       * @param {number} t0 - The previous interpolation factor.
       * @param {number} t - The current interpolation factor.
       * @param {number} t1 - The next interpolation factor.
       * @return {TypedArray} The result buffer.
       */
      interpolate_() {
        throw new Error("call to abstract method");
      }
      /**
       * Optional method that is executed when the interval has changed.
       *
       * @param {number} i1 - An index into the sample value buffer.
       * @param {number} t0 - The previous interpolation factor.
       * @param {number} t - The current interpolation factor.
       */
      intervalChanged_() {
      }
    };
    CubicInterpolant = class extends Interpolant {
      /**
       * Constructs a new cubic interpolant.
       *
       * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
       * @param {TypedArray} sampleValues - The sample values.
       * @param {number} sampleSize - The sample size
       * @param {TypedArray} [resultBuffer] - The result buffer.
       */
      constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
          endingStart: ZeroCurvatureEnding,
          endingEnd: ZeroCurvatureEnding
        };
      }
      intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === void 0) {
          switch (this.getSettings_().endingStart) {
            case ZeroSlopeEnding:
              iPrev = i1;
              tPrev = 2 * t0 - t1;
              break;
            case WrapAroundEnding:
              iPrev = pp.length - 2;
              tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
              break;
            default:
              iPrev = i1;
              tPrev = t1;
          }
        }
        if (tNext === void 0) {
          switch (this.getSettings_().endingEnd) {
            case ZeroSlopeEnding:
              iNext = i1;
              tNext = 2 * t1 - t0;
              break;
            case WrapAroundEnding:
              iNext = 1;
              tNext = t1 + pp[1] - pp[0];
              break;
            default:
              iNext = i1 - 1;
              tNext = t0;
          }
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
      }
      interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        for (let i = 0; i !== stride; ++i) {
          result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        }
        return result;
      }
    };
    LinearInterpolant = class extends Interpolant {
      /**
       * Constructs a new linear interpolant.
       *
       * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
       * @param {TypedArray} sampleValues - The sample values.
       * @param {number} sampleSize - The sample size
       * @param {TypedArray} [resultBuffer] - The result buffer.
       */
      constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
      }
      interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for (let i = 0; i !== stride; ++i) {
          result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        }
        return result;
      }
    };
    DiscreteInterpolant = class extends Interpolant {
      /**
       * Constructs a new discrete interpolant.
       *
       * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
       * @param {TypedArray} sampleValues - The sample values.
       * @param {number} sampleSize - The sample size
       * @param {TypedArray} [resultBuffer] - The result buffer.
       */
      constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
      }
      interpolate_(i1) {
        return this.copySampleValue_(i1 - 1);
      }
    };
    KeyframeTrack = class {
      /**
       * Constructs a new keyframe track.
       *
       * @param {string} name - The keyframe track's name.
       * @param {Array<number>} times - A list of keyframe times.
       * @param {Array<number|string|boolean>} values - A list of keyframe values.
       * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
       */
      constructor(name, times, values, interpolation) {
        if (name === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === void 0 || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = convertArray(times, this.TimeBufferType);
        this.values = convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
      }
      /**
       * Converts the keyframe track to JSON.
       *
       * @static
       * @param {KeyframeTrack} track - The keyframe track to serialize.
       * @return {Object} The serialized keyframe track as JSON.
       */
      static toJSON(track) {
        const trackType = track.constructor;
        let json;
        if (trackType.toJSON !== this.toJSON) {
          json = trackType.toJSON(track);
        } else {
          json = {
            "name": track.name,
            "times": convertArray(track.times, Array),
            "values": convertArray(track.values, Array)
          };
          const interpolation = track.getInterpolation();
          if (interpolation !== track.DefaultInterpolation) {
            json.interpolation = interpolation;
          }
        }
        json.type = track.ValueTypeName;
        return json;
      }
      /**
       * Factory method for creating a new discrete interpolant.
       *
       * @static
       * @param {TypedArray} [result] - The result buffer.
       * @return {DiscreteInterpolant} The new interpolant.
       */
      InterpolantFactoryMethodDiscrete(result) {
        return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), result);
      }
      /**
       * Factory method for creating a new linear interpolant.
       *
       * @static
       * @param {TypedArray} [result] - The result buffer.
       * @return {LinearInterpolant} The new interpolant.
       */
      InterpolantFactoryMethodLinear(result) {
        return new LinearInterpolant(this.times, this.values, this.getValueSize(), result);
      }
      /**
       * Factory method for creating a new smooth interpolant.
       *
       * @static
       * @param {TypedArray} [result] - The result buffer.
       * @return {CubicInterpolant} The new interpolant.
       */
      InterpolantFactoryMethodSmooth(result) {
        return new CubicInterpolant(this.times, this.values, this.getValueSize(), result);
      }
      /**
       * Defines the interpolation factor method for this keyframe track.
       *
       * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} interpolation - The interpolation type.
       * @return {KeyframeTrack} A reference to this keyframe track.
       */
      setInterpolation(interpolation) {
        let factoryMethod;
        switch (interpolation) {
          case InterpolateDiscrete:
            factoryMethod = this.InterpolantFactoryMethodDiscrete;
            break;
          case InterpolateLinear:
            factoryMethod = this.InterpolantFactoryMethodLinear;
            break;
          case InterpolateSmooth:
            factoryMethod = this.InterpolantFactoryMethodSmooth;
            break;
        }
        if (factoryMethod === void 0) {
          const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
          if (this.createInterpolant === void 0) {
            if (interpolation !== this.DefaultInterpolation) {
              this.setInterpolation(this.DefaultInterpolation);
            } else {
              throw new Error(message);
            }
          }
          console.warn("THREE.KeyframeTrack:", message);
          return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
      }
      /**
       * Returns the current interpolation type.
       *
       * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} The interpolation type.
       */
      getInterpolation() {
        switch (this.createInterpolant) {
          case this.InterpolantFactoryMethodDiscrete:
            return InterpolateDiscrete;
          case this.InterpolantFactoryMethodLinear:
            return InterpolateLinear;
          case this.InterpolantFactoryMethodSmooth:
            return InterpolateSmooth;
        }
      }
      /**
       * Returns the value size.
       *
       * @return {number} The value size.
       */
      getValueSize() {
        return this.values.length / this.times.length;
      }
      /**
       * Moves all keyframes either forward or backward in time.
       *
       * @param {number} timeOffset - The offset to move the time values.
       * @return {KeyframeTrack} A reference to this keyframe track.
       */
      shift(timeOffset) {
        if (timeOffset !== 0) {
          const times = this.times;
          for (let i = 0, n = times.length; i !== n; ++i) {
            times[i] += timeOffset;
          }
        }
        return this;
      }
      /**
       * Scale all keyframe times by a factor (useful for frame - seconds conversions).
       *
       * @param {number} timeScale - The time scale.
       * @return {KeyframeTrack} A reference to this keyframe track.
       */
      scale(timeScale) {
        if (timeScale !== 1) {
          const times = this.times;
          for (let i = 0, n = times.length; i !== n; ++i) {
            times[i] *= timeScale;
          }
        }
        return this;
      }
      /**
       * Removes keyframes before and after animation without changing any values within the defined time range.
       *
       * Note: The method does not shift around keys to the start of the track time, because for interpolated
       * keys this will change their values
       *
       * @param {number} startTime - The start time.
       * @param {number} endTime - The end time.
       * @return {KeyframeTrack} A reference to this keyframe track.
       */
      trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while (from !== nKeys && times[from] < startTime) {
          ++from;
        }
        while (to !== -1 && times[to] > endTime) {
          --to;
        }
        ++to;
        if (from !== 0 || to !== nKeys) {
          if (from >= to) {
            to = Math.max(to, 1);
            from = to - 1;
          }
          const stride = this.getValueSize();
          this.times = times.slice(from, to);
          this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
      }
      /**
       * Performs minimal validation on the keyframe track. Returns `true` if the values
       * are valid.
       *
       * @return {boolean} Whether the keyframes are valid or not.
       */
      validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
          console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
          valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
          console.error("THREE.KeyframeTrack: Track is empty.", this);
          valid = false;
        }
        let prevTime = null;
        for (let i = 0; i !== nKeys; i++) {
          const currTime = times[i];
          if (typeof currTime === "number" && isNaN(currTime)) {
            console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
            valid = false;
            break;
          }
          if (prevTime !== null && prevTime > currTime) {
            console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
            valid = false;
            break;
          }
          prevTime = currTime;
        }
        if (values !== void 0) {
          if (isTypedArray(values)) {
            for (let i = 0, n = values.length; i !== n; ++i) {
              const value = values[i];
              if (isNaN(value)) {
                console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                valid = false;
                break;
              }
            }
          }
        }
        return valid;
      }
      /**
       * Optimizes this keyframe track by removing equivalent sequential keys (which are
       * common in morph target sequences).
       *
       * @return {AnimationClip} A reference to this animation clip.
       */
      optimize() {
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === InterpolateSmooth, lastIndex = times.length - 1;
        let writeIndex = 1;
        for (let i = 1; i < lastIndex; ++i) {
          let keep = false;
          const time = times[i];
          const timeNext = times[i + 1];
          if (time !== timeNext && (i !== 1 || time !== times[0])) {
            if (!smoothInterpolation) {
              const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
              for (let j = 0; j !== stride; ++j) {
                const value = values[offset + j];
                if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                  keep = true;
                  break;
                }
              }
            } else {
              keep = true;
            }
          }
          if (keep) {
            if (i !== writeIndex) {
              times[writeIndex] = times[i];
              const readOffset = i * stride, writeOffset = writeIndex * stride;
              for (let j = 0; j !== stride; ++j) {
                values[writeOffset + j] = values[readOffset + j];
              }
            }
            ++writeIndex;
          }
        }
        if (lastIndex > 0) {
          times[writeIndex] = times[lastIndex];
          for (let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j) {
            values[writeOffset + j] = values[readOffset + j];
          }
          ++writeIndex;
        }
        if (writeIndex !== times.length) {
          this.times = times.slice(0, writeIndex);
          this.values = values.slice(0, writeIndex * stride);
        } else {
          this.times = times;
          this.values = values;
        }
        return this;
      }
      /**
       * Returns a new keyframe track with copied values from this instance.
       *
       * @return {KeyframeTrack} A clone of this instance.
       */
      clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        track.createInterpolant = this.createInterpolant;
        return track;
      }
    };
    KeyframeTrack.prototype.ValueTypeName = "";
    KeyframeTrack.prototype.TimeBufferType = Float32Array;
    KeyframeTrack.prototype.ValueBufferType = Float32Array;
    KeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
    BooleanKeyframeTrack = class extends KeyframeTrack {
      /**
       * Constructs a new boolean keyframe track.
       *
       * This keyframe track type has no `interpolation` parameter because the
       * interpolation is always discrete.
       *
       * @param {string} name - The keyframe track's name.
       * @param {Array<number>} times - A list of keyframe times.
       * @param {Array<boolean>} values - A list of keyframe values.
       */
      constructor(name, times, values) {
        super(name, times, values);
      }
    };
    BooleanKeyframeTrack.prototype.ValueTypeName = "bool";
    BooleanKeyframeTrack.prototype.ValueBufferType = Array;
    BooleanKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
    BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
    BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
    ColorKeyframeTrack = class extends KeyframeTrack {
      /**
       * Constructs a new color keyframe track.
       *
       * @param {string} name - The keyframe track's name.
       * @param {Array<number>} times - A list of keyframe times.
       * @param {Array<number>} values - A list of keyframe values.
       * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
       */
      constructor(name, times, values, interpolation) {
        super(name, times, values, interpolation);
      }
    };
    ColorKeyframeTrack.prototype.ValueTypeName = "color";
    NumberKeyframeTrack = class extends KeyframeTrack {
      /**
       * Constructs a new number keyframe track.
       *
       * @param {string} name - The keyframe track's name.
       * @param {Array<number>} times - A list of keyframe times.
       * @param {Array<number>} values - A list of keyframe values.
       * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
       */
      constructor(name, times, values, interpolation) {
        super(name, times, values, interpolation);
      }
    };
    NumberKeyframeTrack.prototype.ValueTypeName = "number";
    QuaternionLinearInterpolant = class extends Interpolant {
      /**
       * Constructs a new SLERP interpolant.
       *
       * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
       * @param {TypedArray} sampleValues - The sample values.
       * @param {number} sampleSize - The sample size
       * @param {TypedArray} [resultBuffer] - The result buffer.
       */
      constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
      }
      interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for (let end = offset + stride; offset !== end; offset += 4) {
          Quaternion.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        }
        return result;
      }
    };
    QuaternionKeyframeTrack = class extends KeyframeTrack {
      /**
       * Constructs a new Quaternion keyframe track.
       *
       * @param {string} name - The keyframe track's name.
       * @param {Array<number>} times - A list of keyframe times.
       * @param {Array<number>} values - A list of keyframe values.
       * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
       */
      constructor(name, times, values, interpolation) {
        super(name, times, values, interpolation);
      }
      /**
       * Overwritten so the method returns Quaternion based interpolant.
       *
       * @static
       * @param {TypedArray} [result] - The result buffer.
       * @return {QuaternionLinearInterpolant} The new interpolant.
       */
      InterpolantFactoryMethodLinear(result) {
        return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), result);
      }
    };
    QuaternionKeyframeTrack.prototype.ValueTypeName = "quaternion";
    QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
    StringKeyframeTrack = class extends KeyframeTrack {
      /**
       * Constructs a new string keyframe track.
       *
       * This keyframe track type has no `interpolation` parameter because the
       * interpolation is always discrete.
       *
       * @param {string} name - The keyframe track's name.
       * @param {Array<number>} times - A list of keyframe times.
       * @param {Array<string>} values - A list of keyframe values.
       */
      constructor(name, times, values) {
        super(name, times, values);
      }
    };
    StringKeyframeTrack.prototype.ValueTypeName = "string";
    StringKeyframeTrack.prototype.ValueBufferType = Array;
    StringKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
    StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
    StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
    VectorKeyframeTrack = class extends KeyframeTrack {
      /**
       * Constructs a new vector keyframe track.
       *
       * @param {string} name - The keyframe track's name.
       * @param {Array<number>} times - A list of keyframe times.
       * @param {Array<number>} values - A list of keyframe values.
       * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
       */
      constructor(name, times, values, interpolation) {
        super(name, times, values, interpolation);
      }
    };
    VectorKeyframeTrack.prototype.ValueTypeName = "vector";
    LoadingManager = class {
      /**
       * Constructs a new loading manager.
       *
       * @param {Function} [onLoad] - Executes when all items have been loaded.
       * @param {Function} [onProgress] - Executes when single items have been loaded.
       * @param {Function} [onError] - Executes when an error occurs.
       */
      constructor(onLoad, onProgress, onError) {
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = void 0;
        const handlers = [];
        this.onStart = void 0;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.abortController = new AbortController();
        this.itemStart = function(url) {
          itemsTotal++;
          if (isLoading === false) {
            if (scope.onStart !== void 0) {
              scope.onStart(url, itemsLoaded, itemsTotal);
            }
          }
          isLoading = true;
        };
        this.itemEnd = function(url) {
          itemsLoaded++;
          if (scope.onProgress !== void 0) {
            scope.onProgress(url, itemsLoaded, itemsTotal);
          }
          if (itemsLoaded === itemsTotal) {
            isLoading = false;
            if (scope.onLoad !== void 0) {
              scope.onLoad();
            }
          }
        };
        this.itemError = function(url) {
          if (scope.onError !== void 0) {
            scope.onError(url);
          }
        };
        this.resolveURL = function(url) {
          if (urlModifier) {
            return urlModifier(url);
          }
          return url;
        };
        this.setURLModifier = function(transform) {
          urlModifier = transform;
          return this;
        };
        this.addHandler = function(regex, loader) {
          handlers.push(regex, loader);
          return this;
        };
        this.removeHandler = function(regex) {
          const index = handlers.indexOf(regex);
          if (index !== -1) {
            handlers.splice(index, 2);
          }
          return this;
        };
        this.getHandler = function(file) {
          for (let i = 0, l = handlers.length; i < l; i += 2) {
            const regex = handlers[i];
            const loader = handlers[i + 1];
            if (regex.global) regex.lastIndex = 0;
            if (regex.test(file)) {
              return loader;
            }
          }
          return null;
        };
        this.abort = function() {
          this.abortController.abort();
          this.abortController = new AbortController();
          return this;
        };
      }
    };
    DefaultLoadingManager = /* @__PURE__ */ new LoadingManager();
    Loader = class {
      /**
       * Constructs a new loader.
       *
       * @param {LoadingManager} [manager] - The loading manager.
       */
      constructor(manager) {
        this.manager = manager !== void 0 ? manager : DefaultLoadingManager;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
      }
      /**
       * This method needs to be implemented by all concrete loaders. It holds the
       * logic for loading assets from the backend.
       *
       * @abstract
       * @param {string} url - The path/URL of the file to be loaded.
       * @param {Function} onLoad - Executed when the loading process has been finished.
       * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
       * @param {onErrorCallback} [onError] - Executed when errors occur.
       */
      load() {
      }
      /**
       * A async version of {@link Loader#load}.
       *
       * @param {string} url - The path/URL of the file to be loaded.
       * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
       * @return {Promise} A Promise that resolves when the asset has been loaded.
       */
      loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
          scope.load(url, resolve, onProgress, reject);
        });
      }
      /**
       * This method needs to be implemented by all concrete loaders. It holds the
       * logic for parsing the asset into three.js entities.
       *
       * @abstract
       * @param {any} data - The data to parse.
       */
      parse() {
      }
      /**
       * Sets the `crossOrigin` String to implement CORS for loading the URL
       * from a different domain that allows CORS.
       *
       * @param {string} crossOrigin - The `crossOrigin` value.
       * @return {Loader} A reference to this instance.
       */
      setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
      }
      /**
       * Whether the XMLHttpRequest uses credentials such as cookies, authorization
       * headers or TLS client certificates, see [XMLHttpRequest.withCredentials]{@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials}.
       *
       * Note: This setting has no effect if you are loading files locally or from the same domain.
       *
       * @param {boolean} value - The `withCredentials` value.
       * @return {Loader} A reference to this instance.
       */
      setWithCredentials(value) {
        this.withCredentials = value;
        return this;
      }
      /**
       * Sets the base path for the asset.
       *
       * @param {string} path - The base path.
       * @return {Loader} A reference to this instance.
       */
      setPath(path) {
        this.path = path;
        return this;
      }
      /**
       * Sets the base path for dependent resources like textures.
       *
       * @param {string} resourcePath - The resource path.
       * @return {Loader} A reference to this instance.
       */
      setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
      }
      /**
       * Sets the given request header.
       *
       * @param {Object} requestHeader - A [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
       * for configuring the HTTP request.
       * @return {Loader} A reference to this instance.
       */
      setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
      }
      /**
       * This method can be implemented in loaders for aborting ongoing requests.
       *
       * @abstract
       * @return {Loader} A reference to this instance.
       */
      abort() {
        return this;
      }
    };
    Loader.DEFAULT_MATERIAL_NAME = "__DEFAULT";
    Light = class extends Object3D {
      /**
       * Constructs a new light.
       *
       * @param {(number|Color|string)} [color=0xffffff] - The light's color.
       * @param {number} [intensity=1] - The light's strength/intensity.
       */
      constructor(color, intensity = 1) {
        super();
        this.isLight = true;
        this.type = "Light";
        this.color = new Color(color);
        this.intensity = intensity;
      }
      /**
       * Frees the GPU-related resources allocated by this instance. Call this
       * method whenever this instance is no longer used in your app.
       */
      dispose() {
      }
      copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
      }
      toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== void 0) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== void 0) data.object.distance = this.distance;
        if (this.angle !== void 0) data.object.angle = this.angle;
        if (this.decay !== void 0) data.object.decay = this.decay;
        if (this.penumbra !== void 0) data.object.penumbra = this.penumbra;
        if (this.shadow !== void 0) data.object.shadow = this.shadow.toJSON();
        if (this.target !== void 0) data.object.target = this.target.uuid;
        return data;
      }
    };
    HemisphereLight = class extends Light {
      /**
       * Constructs a new hemisphere light.
       *
       * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
       * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
       * @param {number} [intensity=1] - The light's strength/intensity.
       */
      constructor(skyColor, groundColor, intensity) {
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = "HemisphereLight";
        this.position.copy(Object3D.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new Color(groundColor);
      }
      copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
      }
    };
    _projScreenMatrix$1 = /* @__PURE__ */ new Matrix4();
    _lightPositionWorld$1 = /* @__PURE__ */ new Vector3();
    _lookTarget$1 = /* @__PURE__ */ new Vector3();
    LightShadow = class {
      /**
       * Constructs a new light shadow.
       *
       * @param {Camera} camera - The light's view of the world.
       */
      constructor(camera) {
        this.camera = camera;
        this.intensity = 1;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new Vector2(512, 512);
        this.mapType = UnsignedByteType;
        this.map = null;
        this.mapPass = null;
        this.matrix = new Matrix4();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new Frustum();
        this._frameExtents = new Vector2(1, 1);
        this._viewportCount = 1;
        this._viewports = [
          new Vector4(0, 0, 1, 1)
        ];
      }
      /**
       * Used internally by the renderer to get the number of viewports that need
       * to be rendered for this shadow.
       *
       * @return {number} The viewport count.
       */
      getViewportCount() {
        return this._viewportCount;
      }
      /**
       * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
       *
       * @return {Frustum} The shadow camera frustum.
       */
      getFrustum() {
        return this._frustum;
      }
      /**
       * Update the matrices for the camera and shadow, used internally by the renderer.
       *
       * @param {Light} light - The light for which the shadow is being rendered.
       */
      updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        _lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy(_lightPositionWorld$1);
        _lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt(_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        _projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix(_projScreenMatrix$1, shadowCamera.coordinateSystem, shadowCamera.reversedDepth);
        if (shadowCamera.reversedDepth) {
          shadowMatrix.set(
            0.5,
            0,
            0,
            0.5,
            0,
            0.5,
            0,
            0.5,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
          );
        } else {
          shadowMatrix.set(
            0.5,
            0,
            0,
            0.5,
            0,
            0.5,
            0,
            0.5,
            0,
            0,
            0.5,
            0.5,
            0,
            0,
            0,
            1
          );
        }
        shadowMatrix.multiply(_projScreenMatrix$1);
      }
      /**
       * Returns a viewport definition for the given viewport index.
       *
       * @param {number} viewportIndex - The viewport index.
       * @return {Vector4} The viewport.
       */
      getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
      }
      /**
       * Returns the frame extends.
       *
       * @return {Vector2} The frame extends.
       */
      getFrameExtents() {
        return this._frameExtents;
      }
      /**
       * Frees the GPU-related resources allocated by this instance. Call this
       * method whenever this instance is no longer used in your app.
       */
      dispose() {
        if (this.map) {
          this.map.dispose();
        }
        if (this.mapPass) {
          this.mapPass.dispose();
        }
      }
      /**
       * Copies the values of the given light shadow instance to this instance.
       *
       * @param {LightShadow} source - The light shadow to copy.
       * @return {LightShadow} A reference to this light shadow instance.
       */
      copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.autoUpdate = source.autoUpdate;
        this.needsUpdate = source.needsUpdate;
        this.normalBias = source.normalBias;
        this.blurSamples = source.blurSamples;
        this.mapSize.copy(source.mapSize);
        return this;
      }
      /**
       * Returns a new light shadow instance with copied values from this instance.
       *
       * @return {LightShadow} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
      /**
       * Serializes the light shadow into JSON.
       *
       * @return {Object} A JSON object representing the serialized light shadow.
       * @see {@link ObjectLoader#parse}
       */
      toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
      }
    };
    _projScreenMatrix = /* @__PURE__ */ new Matrix4();
    _lightPositionWorld = /* @__PURE__ */ new Vector3();
    _lookTarget = /* @__PURE__ */ new Vector3();
    PointLightShadow = class extends LightShadow {
      /**
       * Constructs a new point light shadow.
       */
      constructor() {
        super(new PerspectiveCamera(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new Vector2(4, 2);
        this._viewportCount = 6;
        this._viewports = [
          // These viewports map a cube-map onto a 2D texture with the
          // following orientation:
          //
          //  xzXZ
          //   y Y
          //
          // X - Positive x direction
          // x - Negative x direction
          // Y - Positive y direction
          // y - Negative y direction
          // Z - Positive z direction
          // z - Negative z direction
          // positive X
          new Vector4(2, 1, 1, 1),
          // negative X
          new Vector4(0, 1, 1, 1),
          // positive Z
          new Vector4(3, 1, 1, 1),
          // negative Z
          new Vector4(1, 1, 1, 1),
          // positive Y
          new Vector4(3, 0, 1, 1),
          // negative Y
          new Vector4(1, 0, 1, 1)
        ];
        this._cubeDirections = [
          new Vector3(1, 0, 0),
          new Vector3(-1, 0, 0),
          new Vector3(0, 0, 1),
          new Vector3(0, 0, -1),
          new Vector3(0, 1, 0),
          new Vector3(0, -1, 0)
        ];
        this._cubeUps = [
          new Vector3(0, 1, 0),
          new Vector3(0, 1, 0),
          new Vector3(0, 1, 0),
          new Vector3(0, 1, 0),
          new Vector3(0, 0, 1),
          new Vector3(0, 0, -1)
        ];
      }
      /**
       * Update the matrices for the camera and shadow, used internally by the renderer.
       *
       * @param {Light} light - The light for which the shadow is being rendered.
       * @param {number} [viewportIndex=0] - The viewport index.
       */
      updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
          camera.far = far;
          camera.updateProjectionMatrix();
        }
        _lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy(_lightPositionWorld);
        _lookTarget.copy(camera.position);
        _lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt(_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-_lightPositionWorld.x, -_lightPositionWorld.y, -_lightPositionWorld.z);
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix(_projScreenMatrix, camera.coordinateSystem, camera.reversedDepth);
      }
    };
    PointLight = class extends Light {
      /**
       * Constructs a new point light.
       *
       * @param {(number|Color|string)} [color=0xffffff] - The light's color.
       * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
       * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
       * @param {number} [decay=2] - The amount the light dims along the distance of the light.
       */
      constructor(color, intensity, distance = 0, decay = 2) {
        super(color, intensity);
        this.isPointLight = true;
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay;
        this.shadow = new PointLightShadow();
      }
      /**
       * The light's power. Power is the luminous power of the light measured in lumens (lm).
       * Changing the power will also change the light's intensity.
       *
       * @type {number}
       */
      get power() {
        return this.intensity * 4 * Math.PI;
      }
      set power(power) {
        this.intensity = power / (4 * Math.PI);
      }
      dispose() {
        this.shadow.dispose();
      }
      copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
      }
    };
    OrthographicCamera = class extends Camera {
      /**
       * Constructs a new orthographic camera.
       *
       * @param {number} [left=-1] - The left plane of the camera's frustum.
       * @param {number} [right=1] - The right plane of the camera's frustum.
       * @param {number} [top=1] - The top plane of the camera's frustum.
       * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
       * @param {number} [near=0.1] - The camera's near plane.
       * @param {number} [far=2000] - The camera's far plane.
       */
      constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2e3) {
        super();
        this.isOrthographicCamera = true;
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
      }
      copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
      }
      /**
       * Sets an offset in a larger frustum. This is useful for multi-window or
       * multi-monitor/multi-machine setups.
       *
       * @param {number} fullWidth - The full width of multiview setup.
       * @param {number} fullHeight - The full height of multiview setup.
       * @param {number} x - The horizontal offset of the subcamera.
       * @param {number} y - The vertical offset of the subcamera.
       * @param {number} width - The width of subcamera.
       * @param {number} height - The height of subcamera.
       * @see {@link PerspectiveCamera#setViewOffset}
       */
      setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) {
          this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
          };
        }
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
      }
      /**
       * Removes the view offset from the projection matrix.
       */
      clearViewOffset() {
        if (this.view !== null) {
          this.view.enabled = false;
        }
        this.updateProjectionMatrix();
      }
      /**
       * Updates the camera's projection matrix. Must be called after any change of
       * camera properties.
       */
      updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
          const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
          const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
          left += scaleW * this.view.offsetX;
          right = left + scaleW * this.view.width;
          top -= scaleH * this.view.offsetY;
          bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
      }
      toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
      }
    };
    DirectionalLightShadow = class extends LightShadow {
      /**
       * Constructs a new directional light shadow.
       */
      constructor() {
        super(new OrthographicCamera(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
      }
    };
    DirectionalLight = class extends Light {
      /**
       * Constructs a new directional light.
       *
       * @param {(number|Color|string)} [color=0xffffff] - The light's color.
       * @param {number} [intensity=1] - The light's strength/intensity.
       */
      constructor(color, intensity) {
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = "DirectionalLight";
        this.position.copy(Object3D.DEFAULT_UP);
        this.updateMatrix();
        this.target = new Object3D();
        this.shadow = new DirectionalLightShadow();
      }
      dispose() {
        this.shadow.dispose();
      }
      copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
      }
    };
    ArrayCamera = class extends PerspectiveCamera {
      /**
       * Constructs a new array camera.
       *
       * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
       */
      constructor(array = []) {
        super();
        this.isArrayCamera = true;
        this.isMultiViewCamera = false;
        this.cameras = array;
      }
    };
    Clock = class {
      /**
       * Constructs a new clock.
       *
       * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
       * `getDelta()` is called for the first time.
       */
      constructor(autoStart = true) {
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
      }
      /**
       * Starts the clock. When `autoStart` is set to `true`, the method is automatically
       * called by the class.
       */
      start() {
        this.startTime = performance.now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
      }
      /**
       * Stops the clock.
       */
      stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
      }
      /**
       * Returns the elapsed time in seconds.
       *
       * @return {number} The elapsed time.
       */
      getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
      }
      /**
       * Returns the delta time in seconds.
       *
       * @return {number} The delta time.
       */
      getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
          this.start();
          return 0;
        }
        if (this.running) {
          const newTime = performance.now();
          diff = (newTime - this.oldTime) / 1e3;
          this.oldTime = newTime;
          this.elapsedTime += diff;
        }
        return diff;
      }
    };
    _RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
    _reservedRe = new RegExp("[" + _RESERVED_CHARS_RE + "]", "g");
    _wordChar = "[^" + _RESERVED_CHARS_RE + "]";
    _wordCharOrDot = "[^" + _RESERVED_CHARS_RE.replace("\\.", "") + "]";
    _directoryRe = /* @__PURE__ */ /((?:WC+[\/:])*)/.source.replace("WC", _wordChar);
    _nodeRe = /* @__PURE__ */ /(WCOD+)?/.source.replace("WCOD", _wordCharOrDot);
    _objectRe = /* @__PURE__ */ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", _wordChar);
    _propertyRe = /* @__PURE__ */ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", _wordChar);
    _trackRe = new RegExp(
      "^" + _directoryRe + _nodeRe + _objectRe + _propertyRe + "$"
    );
    _supportedObjectNames = ["material", "materials", "bones", "map"];
    Composite = class {
      constructor(targetGroup, path, optionalParsedPath) {
        const parsedPath = optionalParsedPath || PropertyBinding.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
      }
      getValue(array, offset) {
        this.bind();
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        if (binding !== void 0) binding.getValue(array, offset);
      }
      setValue(array, offset) {
        const bindings = this._bindings;
        for (let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i) {
          bindings[i].setValue(array, offset);
        }
      }
      bind() {
        const bindings = this._bindings;
        for (let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i) {
          bindings[i].bind();
        }
      }
      unbind() {
        const bindings = this._bindings;
        for (let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i) {
          bindings[i].unbind();
        }
      }
    };
    PropertyBinding = class _PropertyBinding {
      /**
       * Constructs a new property binding.
       *
       * @param {Object} rootNode - The root node.
       * @param {string} path - The path.
       * @param {?Object} [parsedPath] - The parsed path.
       */
      constructor(rootNode, path, parsedPath) {
        this.path = path;
        this.parsedPath = parsedPath || _PropertyBinding.parseTrackName(path);
        this.node = _PropertyBinding.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
      }
      /**
       * Factory method for creating a property binding from the given parameters.
       *
       * @static
       * @param {Object} root - The root node.
       * @param {string} path - The path.
       * @param {?Object} [parsedPath] - The parsed path.
       * @return {PropertyBinding|Composite} The created property binding or composite.
       */
      static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) {
          return new _PropertyBinding(root, path, parsedPath);
        } else {
          return new _PropertyBinding.Composite(root, path, parsedPath);
        }
      }
      /**
       * Replaces spaces with underscores and removes unsupported characters from
       * node names, to ensure compatibility with parseTrackName().
       *
       * @param {string} name - Node name to be sanitized.
       * @return {string} The sanitized node name.
       */
      static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace(_reservedRe, "");
      }
      /**
       * Parses the given track name (an object path to an animated property) and
       * returns an object with information about the path. Matches strings in the following forms:
       *
       * - nodeName.property
       * - nodeName.property[accessor]
       * - nodeName.material.property[accessor]
       * - uuid.property[accessor]
       * - uuid.objectName[objectIndex].propertyName[propertyIndex]
       * - parentName/nodeName.property
       * - parentName/parentName/nodeName.property[index]
       * - .bone[Armature.DEF_cog].position
       * - scene:helium_balloon_model:helium_balloon_model.position
       *
       * @static
       * @param {string} trackName - The track name to parse.
       * @return {Object} The parsed track name as an object.
       */
      static parseTrackName(trackName) {
        const matches = _trackRe.exec(trackName);
        if (matches === null) {
          throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        }
        const results = {
          // directoryName: matches[ 1 ], // (tschw) currently unused
          nodeName: matches[2],
          objectName: matches[3],
          objectIndex: matches[4],
          propertyName: matches[5],
          // required
          propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== void 0 && lastDot !== -1) {
          const objectName = results.nodeName.substring(lastDot + 1);
          if (_supportedObjectNames.indexOf(objectName) !== -1) {
            results.nodeName = results.nodeName.substring(0, lastDot);
            results.objectName = objectName;
          }
        }
        if (results.propertyName === null || results.propertyName.length === 0) {
          throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        }
        return results;
      }
      /**
       * Searches for a node in the hierarchy of the given root object by the given
       * node name.
       *
       * @static
       * @param {Object} root - The root object.
       * @param {string|number} nodeName - The name of the node.
       * @return {?Object} The found node. Returns `null` if no object was found.
       */
      static findNode(root, nodeName) {
        if (nodeName === void 0 || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) {
          return root;
        }
        if (root.skeleton) {
          const bone = root.skeleton.getBoneByName(nodeName);
          if (bone !== void 0) {
            return bone;
          }
        }
        if (root.children) {
          const searchNodeSubtree = function(children) {
            for (let i = 0; i < children.length; i++) {
              const childNode = children[i];
              if (childNode.name === nodeName || childNode.uuid === nodeName) {
                return childNode;
              }
              const result = searchNodeSubtree(childNode.children);
              if (result) return result;
            }
            return null;
          };
          const subTreeNode = searchNodeSubtree(root.children);
          if (subTreeNode) {
            return subTreeNode;
          }
        }
        return null;
      }
      // these are used to "bind" a nonexistent property
      _getValue_unavailable() {
      }
      _setValue_unavailable() {
      }
      // Getters
      _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
      }
      _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for (let i = 0, n = source.length; i !== n; ++i) {
          buffer[offset++] = source[i];
        }
      }
      _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
      }
      _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
      }
      // Direct
      _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
      }
      _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
      }
      _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
      }
      // EntireArray
      _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for (let i = 0, n = dest.length; i !== n; ++i) {
          dest[i] = buffer[offset++];
        }
      }
      _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for (let i = 0, n = dest.length; i !== n; ++i) {
          dest[i] = buffer[offset++];
        }
        this.targetObject.needsUpdate = true;
      }
      _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for (let i = 0, n = dest.length; i !== n; ++i) {
          dest[i] = buffer[offset++];
        }
        this.targetObject.matrixWorldNeedsUpdate = true;
      }
      // ArrayElement
      _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
      }
      _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
      }
      _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
      }
      // HasToFromArray
      _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
      }
      _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
      }
      _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
      }
      _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
      }
      _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
      }
      /**
       * Creates a getter / setter pair for the property tracked by this binding.
       */
      bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
          targetObject = _PropertyBinding.findNode(this.rootNode, parsedPath.nodeName);
          this.node = targetObject;
        }
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        if (!targetObject) {
          console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
          return;
        }
        if (objectName) {
          let objectIndex = parsedPath.objectIndex;
          switch (objectName) {
            case "materials":
              if (!targetObject.material) {
                console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                return;
              }
              if (!targetObject.material.materials) {
                console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                return;
              }
              targetObject = targetObject.material.materials;
              break;
            case "bones":
              if (!targetObject.skeleton) {
                console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                return;
              }
              targetObject = targetObject.skeleton.bones;
              for (let i = 0; i < targetObject.length; i++) {
                if (targetObject[i].name === objectIndex) {
                  objectIndex = i;
                  break;
                }
              }
              break;
            case "map":
              if ("map" in targetObject) {
                targetObject = targetObject.map;
                break;
              }
              if (!targetObject.material) {
                console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                return;
              }
              if (!targetObject.material.map) {
                console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                return;
              }
              targetObject = targetObject.material.map;
              break;
            default:
              if (targetObject[objectName] === void 0) {
                console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                return;
              }
              targetObject = targetObject[objectName];
          }
          if (objectIndex !== void 0) {
            if (targetObject[objectIndex] === void 0) {
              console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
              return;
            }
            targetObject = targetObject[objectIndex];
          }
        }
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === void 0) {
          const nodeName = parsedPath.nodeName;
          console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
          return;
        }
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.isMaterial === true) {
          versioning = this.Versioning.NeedsUpdate;
        } else if (targetObject.isObject3D === true) {
          versioning = this.Versioning.MatrixWorldNeedsUpdate;
        }
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== void 0) {
          if (propertyName === "morphTargetInfluences") {
            if (!targetObject.geometry) {
              console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
              return;
            }
            if (!targetObject.geometry.morphAttributes) {
              console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
              return;
            }
            if (targetObject.morphTargetDictionary[propertyIndex] !== void 0) {
              propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
          }
          bindingType = this.BindingType.ArrayElement;
          this.resolvedProperty = nodeProperty;
          this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== void 0 && nodeProperty.toArray !== void 0) {
          bindingType = this.BindingType.HasFromToArray;
          this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
          bindingType = this.BindingType.EntireArray;
          this.resolvedProperty = nodeProperty;
        } else {
          this.propertyName = propertyName;
        }
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
      }
      /**
       * Unbinds the property.
       */
      unbind() {
        this.node = null;
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
      }
    };
    PropertyBinding.Composite = Composite;
    PropertyBinding.prototype.BindingType = {
      Direct: 0,
      EntireArray: 1,
      ArrayElement: 2,
      HasFromToArray: 3
    };
    PropertyBinding.prototype.Versioning = {
      None: 0,
      NeedsUpdate: 1,
      MatrixWorldNeedsUpdate: 2
    };
    PropertyBinding.prototype.GetterByBindingType = [
      PropertyBinding.prototype._getValue_direct,
      PropertyBinding.prototype._getValue_array,
      PropertyBinding.prototype._getValue_arrayElement,
      PropertyBinding.prototype._getValue_toArray
    ];
    PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [
      [
        // Direct
        PropertyBinding.prototype._setValue_direct,
        PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
        PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate
      ],
      [
        // EntireArray
        PropertyBinding.prototype._setValue_array,
        PropertyBinding.prototype._setValue_array_setNeedsUpdate,
        PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate
      ],
      [
        // ArrayElement
        PropertyBinding.prototype._setValue_arrayElement,
        PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
        PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
      ],
      [
        // HasToFromArray
        PropertyBinding.prototype._setValue_fromArray,
        PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
        PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
      ]
    ];
    _controlInterpolantsResultBuffer = new Float32Array(1);
    _matrix = /* @__PURE__ */ new Matrix4();
    Raycaster = class {
      /**
       * Constructs a new raycaster.
       *
       * @param {Vector3} origin - The origin vector where the ray casts from.
       * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
       * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
       * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
       */
      constructor(origin, direction, near = 0, far = Infinity) {
        this.ray = new Ray(origin, direction);
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new Layers();
        this.params = {
          Mesh: {},
          Line: { threshold: 1 },
          LOD: {},
          Points: { threshold: 1 },
          Sprite: {}
        };
      }
      /**
       * Updates the ray with a new origin and direction by copying the values from the arguments.
       *
       * @param {Vector3} origin - The origin vector where the ray casts from.
       * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
       */
      set(origin, direction) {
        this.ray.set(origin, direction);
      }
      /**
       * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
       *
       * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
       * X and Y components should be between `-1` and `1`.
       * @param {Camera} camera - The camera from which the ray should originate.
       */
      setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
          this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
          this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
          this.camera = camera;
        } else if (camera.isOrthographicCamera) {
          this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera);
          this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
          this.camera = camera;
        } else {
          console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
        }
      }
      /**
       * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
       *
       * @param {WebXRController} controller - The controller to copy the position and direction from.
       * @return {Raycaster} A reference to this raycaster.
       */
      setFromXRController(controller) {
        _matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4(_matrix);
        return this;
      }
      /**
       * The intersection point of a raycaster intersection test.
       * @typedef {Object} Raycaster~Intersection
       * @property {number} distance - The distance from the ray's origin to the intersection point.
       * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
       * intersection to the nearest point on the ray. For other objects it will be `undefined`.
       * @property {Vector3} point - The intersection point, in world coordinates.
       * @property {Object} face - The face that has been intersected.
       * @property {number} faceIndex - The face index.
       * @property {Object3D} object - The 3D object that has been intersected.
       * @property {Vector2} uv - U,V coordinates at point of intersection.
       * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
       * @property {Vector3} uv1 - Interpolated normal vector at point of intersection.
       * @property {number} instanceId - The index number of the instance where the ray
       * intersects the {@link InstancedMesh}.
       */
      /**
       * Checks all intersection between the ray and the object with or without the
       * descendants. Intersections are returned sorted by distance, closest first.
       *
       * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
       * evaluating whether the ray intersects the object or not. This allows meshes to respond
       * differently to ray casting than lines or points.
       *
       * Note that for meshes, faces must be pointed towards the origin of the ray in order
       * to be detected; intersections of the ray passing through the back of a face will not
       * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
       * to `THREE.DoubleSide`.
       *
       * @param {Object3D} object - The 3D object to check for intersection with the ray.
       * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
       * Otherwise it only checks intersection with the object.
       * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
       * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
       */
      intersectObject(object, recursive = true, intersects = []) {
        intersect(object, this, intersects, recursive);
        intersects.sort(ascSort);
        return intersects;
      }
      /**
       * Checks all intersection between the ray and the objects with or without
       * the descendants. Intersections are returned sorted by distance, closest first.
       *
       * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
       * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
       * Otherwise it only checks intersection with the object.
       * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
       * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
       */
      intersectObjects(objects, recursive = true, intersects = []) {
        for (let i = 0, l = objects.length; i < l; i++) {
          intersect(objects[i], this, intersects, recursive);
        }
        intersects.sort(ascSort);
        return intersects;
      }
    };
    Spherical = class {
      /**
       * Constructs a new spherical.
       *
       * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
       * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
       * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
       */
      constructor(radius = 1, phi = 0, theta = 0) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
      }
      /**
       * Sets the spherical components by copying the given values.
       *
       * @param {number} radius - The radius.
       * @param {number} phi - The polar angle.
       * @param {number} theta - The azimuthal angle.
       * @return {Spherical} A reference to this spherical.
       */
      set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
      }
      /**
       * Copies the values of the given spherical to this instance.
       *
       * @param {Spherical} other - The spherical to copy.
       * @return {Spherical} A reference to this spherical.
       */
      copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
      }
      /**
       * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
       * `0.000001`.
       *
       * @return {Spherical} A reference to this spherical.
       */
      makeSafe() {
        const EPS = 1e-6;
        this.phi = clamp(this.phi, EPS, Math.PI - EPS);
        return this;
      }
      /**
       * Sets the spherical components from the given vector which is assumed to hold
       * Cartesian coordinates.
       *
       * @param {Vector3} v - The vector to set.
       * @return {Spherical} A reference to this spherical.
       */
      setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
      }
      /**
       * Sets the spherical components from the given Cartesian coordinates.
       *
       * @param {number} x - The x value.
       * @param {number} y - The y value.
       * @param {number} z - The z value.
       * @return {Spherical} A reference to this spherical.
       */
      setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
          this.theta = 0;
          this.phi = 0;
        } else {
          this.theta = Math.atan2(x, z);
          this.phi = Math.acos(clamp(y / this.radius, -1, 1));
        }
        return this;
      }
      /**
       * Returns a new spherical with copied values from this instance.
       *
       * @return {Spherical} A clone of this instance.
       */
      clone() {
        return new this.constructor().copy(this);
      }
    };
    Controls = class extends EventDispatcher {
      /**
       * Constructs a new controls instance.
       *
       * @param {Object3D} object - The object that is managed by the controls.
       * @param {?HTMLDOMElement} domElement - The HTML element used for event listeners.
       */
      constructor(object, domElement = null) {
        super();
        this.object = object;
        this.domElement = domElement;
        this.enabled = true;
        this.state = -1;
        this.keys = {};
        this.mouseButtons = { LEFT: null, MIDDLE: null, RIGHT: null };
        this.touches = { ONE: null, TWO: null };
      }
      /**
       * Connects the controls to the DOM. This method has so called "side effects" since
       * it adds the module's event listeners to the DOM.
       *
       * @param {HTMLDOMElement} element - The DOM element to connect to.
       */
      connect(element) {
        if (element === void 0) {
          console.warn("THREE.Controls: connect() now requires an element.");
          return;
        }
        if (this.domElement !== null) this.disconnect();
        this.domElement = element;
      }
      /**
       * Disconnects the controls from the DOM.
       */
      disconnect() {
      }
      /**
       * Call this method if you no longer want use to the controls. It frees all internal
       * resources and removes all event listeners.
       */
      dispose() {
      }
      /**
       * Controls should implement this method if they have to update their internal state
       * per simulation step.
       *
       * @param {number} [delta] - The time delta in seconds.
       */
      update() {
      }
    };
    if (typeof __THREE_DEVTOOLS__ !== "undefined") {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
        revision: REVISION
      } }));
    }
    if (typeof window !== "undefined") {
      if (window.__THREE__) {
        console.warn("WARNING: Multiple instances of Three.js being imported.");
      } else {
        window.__THREE__ = REVISION;
      }
    }
  }
});

// site/vendor/three.module.js
function WebGLAnimation() {
  let context = null;
  let isAnimating = false;
  let animationLoop = null;
  let requestId = null;
  function onAnimationFrame(time, frame) {
    animationLoop(time, frame);
    requestId = context.requestAnimationFrame(onAnimationFrame);
  }
  return {
    start: function() {
      if (isAnimating === true) return;
      if (animationLoop === null) return;
      requestId = context.requestAnimationFrame(onAnimationFrame);
      isAnimating = true;
    },
    stop: function() {
      context.cancelAnimationFrame(requestId);
      isAnimating = false;
    },
    setAnimationLoop: function(callback) {
      animationLoop = callback;
    },
    setContext: function(value) {
      context = value;
    }
  };
}
function WebGLAttributes(gl) {
  const buffers = /* @__PURE__ */ new WeakMap();
  function createBuffer(attribute, bufferType) {
    const array = attribute.array;
    const usage = attribute.usage;
    const size = array.byteLength;
    const buffer = gl.createBuffer();
    gl.bindBuffer(bufferType, buffer);
    gl.bufferData(bufferType, array, usage);
    attribute.onUploadCallback();
    let type;
    if (array instanceof Float32Array) {
      type = gl.FLOAT;
    } else if (typeof Float16Array !== "undefined" && array instanceof Float16Array) {
      type = gl.HALF_FLOAT;
    } else if (array instanceof Uint16Array) {
      if (attribute.isFloat16BufferAttribute) {
        type = gl.HALF_FLOAT;
      } else {
        type = gl.UNSIGNED_SHORT;
      }
    } else if (array instanceof Int16Array) {
      type = gl.SHORT;
    } else if (array instanceof Uint32Array) {
      type = gl.UNSIGNED_INT;
    } else if (array instanceof Int32Array) {
      type = gl.INT;
    } else if (array instanceof Int8Array) {
      type = gl.BYTE;
    } else if (array instanceof Uint8Array) {
      type = gl.UNSIGNED_BYTE;
    } else if (array instanceof Uint8ClampedArray) {
      type = gl.UNSIGNED_BYTE;
    } else {
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
    }
    return {
      buffer,
      type,
      bytesPerElement: array.BYTES_PER_ELEMENT,
      version: attribute.version,
      size
    };
  }
  function updateBuffer(buffer, attribute, bufferType) {
    const array = attribute.array;
    const updateRanges = attribute.updateRanges;
    gl.bindBuffer(bufferType, buffer);
    if (updateRanges.length === 0) {
      gl.bufferSubData(bufferType, 0, array);
    } else {
      updateRanges.sort((a, b) => a.start - b.start);
      let mergeIndex = 0;
      for (let i = 1; i < updateRanges.length; i++) {
        const previousRange = updateRanges[mergeIndex];
        const range = updateRanges[i];
        if (range.start <= previousRange.start + previousRange.count + 1) {
          previousRange.count = Math.max(
            previousRange.count,
            range.start + range.count - previousRange.start
          );
        } else {
          ++mergeIndex;
          updateRanges[mergeIndex] = range;
        }
      }
      updateRanges.length = mergeIndex + 1;
      for (let i = 0, l = updateRanges.length; i < l; i++) {
        const range = updateRanges[i];
        gl.bufferSubData(
          bufferType,
          range.start * array.BYTES_PER_ELEMENT,
          array,
          range.start,
          range.count
        );
      }
      attribute.clearUpdateRanges();
    }
    attribute.onUploadCallback();
  }
  function get(attribute) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    return buffers.get(attribute);
  }
  function remove(attribute) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    const data = buffers.get(attribute);
    if (data) {
      gl.deleteBuffer(data.buffer);
      buffers.delete(attribute);
    }
  }
  function update(attribute, bufferType) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    if (attribute.isGLBufferAttribute) {
      const cached = buffers.get(attribute);
      if (!cached || cached.version < attribute.version) {
        buffers.set(attribute, {
          buffer: attribute.buffer,
          type: attribute.type,
          bytesPerElement: attribute.elementSize,
          version: attribute.version
        });
      }
      return;
    }
    const data = buffers.get(attribute);
    if (data === void 0) {
      buffers.set(attribute, createBuffer(attribute, bufferType));
    } else if (data.version < attribute.version) {
      if (data.size !== attribute.array.byteLength) {
        throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
      }
      updateBuffer(data.buffer, attribute, bufferType);
      data.version = attribute.version;
    }
  }
  return {
    get,
    remove,
    update
  };
}
function WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
  const clearColor = new Color(0);
  let clearAlpha = alpha === true ? 0 : 1;
  let planeMesh;
  let boxMesh;
  let currentBackground = null;
  let currentBackgroundVersion = 0;
  let currentTonemapping = null;
  function getBackground(scene) {
    let background = scene.isScene === true ? scene.background : null;
    if (background && background.isTexture) {
      const usePMREM = scene.backgroundBlurriness > 0;
      background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
    }
    return background;
  }
  function render(scene) {
    let forceClear = false;
    const background = getBackground(scene);
    if (background === null) {
      setClear(clearColor, clearAlpha);
    } else if (background && background.isColor) {
      setClear(background, 1);
      forceClear = true;
    }
    const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
    if (environmentBlendMode === "additive") {
      state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
    } else if (environmentBlendMode === "alpha-blend") {
      state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
    }
    if (renderer.autoClear || forceClear) {
      state.buffers.depth.setTest(true);
      state.buffers.depth.setMask(true);
      state.buffers.color.setMask(true);
      renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
    }
  }
  function addToRenderList(renderList, scene) {
    const background = getBackground(scene);
    if (background && (background.isCubeTexture || background.mapping === CubeUVReflectionMapping)) {
      if (boxMesh === void 0) {
        boxMesh = new Mesh(
          new BoxGeometry(1, 1, 1),
          new ShaderMaterial({
            name: "BackgroundCubeMaterial",
            uniforms: cloneUniforms(ShaderLib.backgroundCube.uniforms),
            vertexShader: ShaderLib.backgroundCube.vertexShader,
            fragmentShader: ShaderLib.backgroundCube.fragmentShader,
            side: BackSide,
            depthTest: false,
            depthWrite: false,
            fog: false,
            allowOverride: false
          })
        );
        boxMesh.geometry.deleteAttribute("normal");
        boxMesh.geometry.deleteAttribute("uv");
        boxMesh.onBeforeRender = function(renderer2, scene2, camera) {
          this.matrixWorld.copyPosition(camera.matrixWorld);
        };
        Object.defineProperty(boxMesh.material, "envMap", {
          get: function() {
            return this.uniforms.envMap.value;
          }
        });
        objects.update(boxMesh);
      }
      _e1$1.copy(scene.backgroundRotation);
      _e1$1.x *= -1;
      _e1$1.y *= -1;
      _e1$1.z *= -1;
      if (background.isCubeTexture && background.isRenderTargetTexture === false) {
        _e1$1.y *= -1;
        _e1$1.z *= -1;
      }
      boxMesh.material.uniforms.envMap.value = background;
      boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
      boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
      boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
      boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4(_m1$12.makeRotationFromEuler(_e1$1));
      boxMesh.material.toneMapped = ColorManagement.getTransfer(background.colorSpace) !== SRGBTransfer;
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        boxMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      boxMesh.layers.enableAll();
      renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
    } else if (background && background.isTexture) {
      if (planeMesh === void 0) {
        planeMesh = new Mesh(
          new PlaneGeometry(2, 2),
          new ShaderMaterial({
            name: "BackgroundMaterial",
            uniforms: cloneUniforms(ShaderLib.background.uniforms),
            vertexShader: ShaderLib.background.vertexShader,
            fragmentShader: ShaderLib.background.fragmentShader,
            side: FrontSide,
            depthTest: false,
            depthWrite: false,
            fog: false,
            allowOverride: false
          })
        );
        planeMesh.geometry.deleteAttribute("normal");
        Object.defineProperty(planeMesh.material, "map", {
          get: function() {
            return this.uniforms.t2D.value;
          }
        });
        objects.update(planeMesh);
      }
      planeMesh.material.uniforms.t2D.value = background;
      planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
      planeMesh.material.toneMapped = ColorManagement.getTransfer(background.colorSpace) !== SRGBTransfer;
      if (background.matrixAutoUpdate === true) {
        background.updateMatrix();
      }
      planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        planeMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      planeMesh.layers.enableAll();
      renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
    }
  }
  function setClear(color, alpha2) {
    color.getRGB(_rgb, getUnlitUniformColorSpace(renderer));
    state.buffers.color.setClear(_rgb.r, _rgb.g, _rgb.b, alpha2, premultipliedAlpha);
  }
  function dispose() {
    if (boxMesh !== void 0) {
      boxMesh.geometry.dispose();
      boxMesh.material.dispose();
      boxMesh = void 0;
    }
    if (planeMesh !== void 0) {
      planeMesh.geometry.dispose();
      planeMesh.material.dispose();
      planeMesh = void 0;
    }
  }
  return {
    getClearColor: function() {
      return clearColor;
    },
    setClearColor: function(color, alpha2 = 1) {
      clearColor.set(color);
      clearAlpha = alpha2;
      setClear(clearColor, clearAlpha);
    },
    getClearAlpha: function() {
      return clearAlpha;
    },
    setClearAlpha: function(alpha2) {
      clearAlpha = alpha2;
      setClear(clearColor, clearAlpha);
    },
    render,
    addToRenderList,
    dispose
  };
}
function WebGLBindingStates(gl, attributes) {
  const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
  const bindingStates = {};
  const defaultState = createBindingState(null);
  let currentState = defaultState;
  let forceUpdate = false;
  function setup(object, material, program, geometry, index) {
    let updateBuffers = false;
    const state = getBindingState(geometry, program, material);
    if (currentState !== state) {
      currentState = state;
      bindVertexArrayObject(currentState.object);
    }
    updateBuffers = needsUpdate(object, geometry, program, index);
    if (updateBuffers) saveCache(object, geometry, program, index);
    if (index !== null) {
      attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
    }
    if (updateBuffers || forceUpdate) {
      forceUpdate = false;
      setupVertexAttributes(object, material, program, geometry);
      if (index !== null) {
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
      }
    }
  }
  function createVertexArrayObject() {
    return gl.createVertexArray();
  }
  function bindVertexArrayObject(vao) {
    return gl.bindVertexArray(vao);
  }
  function deleteVertexArrayObject(vao) {
    return gl.deleteVertexArray(vao);
  }
  function getBindingState(geometry, program, material) {
    const wireframe = material.wireframe === true;
    let programMap = bindingStates[geometry.id];
    if (programMap === void 0) {
      programMap = {};
      bindingStates[geometry.id] = programMap;
    }
    let stateMap = programMap[program.id];
    if (stateMap === void 0) {
      stateMap = {};
      programMap[program.id] = stateMap;
    }
    let state = stateMap[wireframe];
    if (state === void 0) {
      state = createBindingState(createVertexArrayObject());
      stateMap[wireframe] = state;
    }
    return state;
  }
  function createBindingState(vao) {
    const newAttributes = [];
    const enabledAttributes = [];
    const attributeDivisors = [];
    for (let i = 0; i < maxVertexAttributes; i++) {
      newAttributes[i] = 0;
      enabledAttributes[i] = 0;
      attributeDivisors[i] = 0;
    }
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: false,
      newAttributes,
      enabledAttributes,
      attributeDivisors,
      object: vao,
      attributes: {},
      index: null
    };
  }
  function needsUpdate(object, geometry, program, index) {
    const cachedAttributes = currentState.attributes;
    const geometryAttributes = geometry.attributes;
    let attributesNum = 0;
    const programAttributes = program.getAttributes();
    for (const name in programAttributes) {
      const programAttribute = programAttributes[name];
      if (programAttribute.location >= 0) {
        const cachedAttribute = cachedAttributes[name];
        let geometryAttribute = geometryAttributes[name];
        if (geometryAttribute === void 0) {
          if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
          if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
        }
        if (cachedAttribute === void 0) return true;
        if (cachedAttribute.attribute !== geometryAttribute) return true;
        if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
        attributesNum++;
      }
    }
    if (currentState.attributesNum !== attributesNum) return true;
    if (currentState.index !== index) return true;
    return false;
  }
  function saveCache(object, geometry, program, index) {
    const cache = {};
    const attributes2 = geometry.attributes;
    let attributesNum = 0;
    const programAttributes = program.getAttributes();
    for (const name in programAttributes) {
      const programAttribute = programAttributes[name];
      if (programAttribute.location >= 0) {
        let attribute = attributes2[name];
        if (attribute === void 0) {
          if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
          if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
        }
        const data = {};
        data.attribute = attribute;
        if (attribute && attribute.data) {
          data.data = attribute.data;
        }
        cache[name] = data;
        attributesNum++;
      }
    }
    currentState.attributes = cache;
    currentState.attributesNum = attributesNum;
    currentState.index = index;
  }
  function initAttributes() {
    const newAttributes = currentState.newAttributes;
    for (let i = 0, il = newAttributes.length; i < il; i++) {
      newAttributes[i] = 0;
    }
  }
  function enableAttribute(attribute) {
    enableAttributeAndDivisor(attribute, 0);
  }
  function enableAttributeAndDivisor(attribute, meshPerAttribute) {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    const attributeDivisors = currentState.attributeDivisors;
    newAttributes[attribute] = 1;
    if (enabledAttributes[attribute] === 0) {
      gl.enableVertexAttribArray(attribute);
      enabledAttributes[attribute] = 1;
    }
    if (attributeDivisors[attribute] !== meshPerAttribute) {
      gl.vertexAttribDivisor(attribute, meshPerAttribute);
      attributeDivisors[attribute] = meshPerAttribute;
    }
  }
  function disableUnusedAttributes() {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    for (let i = 0, il = enabledAttributes.length; i < il; i++) {
      if (enabledAttributes[i] !== newAttributes[i]) {
        gl.disableVertexAttribArray(i);
        enabledAttributes[i] = 0;
      }
    }
  }
  function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
    if (integer === true) {
      gl.vertexAttribIPointer(index, size, type, stride, offset);
    } else {
      gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
  }
  function setupVertexAttributes(object, material, program, geometry) {
    initAttributes();
    const geometryAttributes = geometry.attributes;
    const programAttributes = program.getAttributes();
    const materialDefaultAttributeValues = material.defaultAttributeValues;
    for (const name in programAttributes) {
      const programAttribute = programAttributes[name];
      if (programAttribute.location >= 0) {
        let geometryAttribute = geometryAttributes[name];
        if (geometryAttribute === void 0) {
          if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
          if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
        }
        if (geometryAttribute !== void 0) {
          const normalized = geometryAttribute.normalized;
          const size = geometryAttribute.itemSize;
          const attribute = attributes.get(geometryAttribute);
          if (attribute === void 0) continue;
          const buffer = attribute.buffer;
          const type = attribute.type;
          const bytesPerElement = attribute.bytesPerElement;
          const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === IntType;
          if (geometryAttribute.isInterleavedBufferAttribute) {
            const data = geometryAttribute.data;
            const stride = data.stride;
            const offset = geometryAttribute.offset;
            if (data.isInstancedInterleavedBuffer) {
              for (let i = 0; i < programAttribute.locationSize; i++) {
                enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
              }
              if (object.isInstancedMesh !== true && geometry._maxInstanceCount === void 0) {
                geometry._maxInstanceCount = data.meshPerAttribute * data.count;
              }
            } else {
              for (let i = 0; i < programAttribute.locationSize; i++) {
                enableAttribute(programAttribute.location + i);
              }
            }
            gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
            for (let i = 0; i < programAttribute.locationSize; i++) {
              vertexAttribPointer(
                programAttribute.location + i,
                size / programAttribute.locationSize,
                type,
                normalized,
                stride * bytesPerElement,
                (offset + size / programAttribute.locationSize * i) * bytesPerElement,
                integer
              );
            }
          } else {
            if (geometryAttribute.isInstancedBufferAttribute) {
              for (let i = 0; i < programAttribute.locationSize; i++) {
                enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
              }
              if (object.isInstancedMesh !== true && geometry._maxInstanceCount === void 0) {
                geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
              }
            } else {
              for (let i = 0; i < programAttribute.locationSize; i++) {
                enableAttribute(programAttribute.location + i);
              }
            }
            gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
            for (let i = 0; i < programAttribute.locationSize; i++) {
              vertexAttribPointer(
                programAttribute.location + i,
                size / programAttribute.locationSize,
                type,
                normalized,
                size * bytesPerElement,
                size / programAttribute.locationSize * i * bytesPerElement,
                integer
              );
            }
          }
        } else if (materialDefaultAttributeValues !== void 0) {
          const value = materialDefaultAttributeValues[name];
          if (value !== void 0) {
            switch (value.length) {
              case 2:
                gl.vertexAttrib2fv(programAttribute.location, value);
                break;
              case 3:
                gl.vertexAttrib3fv(programAttribute.location, value);
                break;
              case 4:
                gl.vertexAttrib4fv(programAttribute.location, value);
                break;
              default:
                gl.vertexAttrib1fv(programAttribute.location, value);
            }
          }
        }
      }
    }
    disableUnusedAttributes();
  }
  function dispose() {
    reset();
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      for (const programId in programMap) {
        const stateMap = programMap[programId];
        for (const wireframe in stateMap) {
          deleteVertexArrayObject(stateMap[wireframe].object);
          delete stateMap[wireframe];
        }
        delete programMap[programId];
      }
      delete bindingStates[geometryId];
    }
  }
  function releaseStatesOfGeometry(geometry) {
    if (bindingStates[geometry.id] === void 0) return;
    const programMap = bindingStates[geometry.id];
    for (const programId in programMap) {
      const stateMap = programMap[programId];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[programId];
    }
    delete bindingStates[geometry.id];
  }
  function releaseStatesOfProgram(program) {
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      if (programMap[program.id] === void 0) continue;
      const stateMap = programMap[program.id];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[program.id];
    }
  }
  function reset() {
    resetDefaultState();
    forceUpdate = true;
    if (currentState === defaultState) return;
    currentState = defaultState;
    bindVertexArrayObject(currentState.object);
  }
  function resetDefaultState() {
    defaultState.geometry = null;
    defaultState.program = null;
    defaultState.wireframe = false;
  }
  return {
    setup,
    reset,
    resetDefaultState,
    dispose,
    releaseStatesOfGeometry,
    releaseStatesOfProgram,
    initAttributes,
    enableAttribute,
    disableUnusedAttributes
  };
}
function WebGLBufferRenderer(gl, extensions, info) {
  let mode;
  function setMode(value) {
    mode = value;
  }
  function render(start, count) {
    gl.drawArrays(mode, start, count);
    info.update(count, mode, 1);
  }
  function renderInstances(start, count, primcount) {
    if (primcount === 0) return;
    gl.drawArraysInstanced(mode, start, count, primcount);
    info.update(count, mode, primcount);
  }
  function renderMultiDraw(starts, counts, drawCount) {
    if (drawCount === 0) return;
    const extension = extensions.get("WEBGL_multi_draw");
    extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
    let elementCount = 0;
    for (let i = 0; i < drawCount; i++) {
      elementCount += counts[i];
    }
    info.update(elementCount, mode, 1);
  }
  function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
    if (drawCount === 0) return;
    const extension = extensions.get("WEBGL_multi_draw");
    if (extension === null) {
      for (let i = 0; i < starts.length; i++) {
        renderInstances(starts[i], counts[i], primcount[i]);
      }
    } else {
      extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
      let elementCount = 0;
      for (let i = 0; i < drawCount; i++) {
        elementCount += counts[i] * primcount[i];
      }
      info.update(elementCount, mode, 1);
    }
  }
  this.setMode = setMode;
  this.render = render;
  this.renderInstances = renderInstances;
  this.renderMultiDraw = renderMultiDraw;
  this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function WebGLCapabilities(gl, extensions, parameters, utils) {
  let maxAnisotropy;
  function getMaxAnisotropy() {
    if (maxAnisotropy !== void 0) return maxAnisotropy;
    if (extensions.has("EXT_texture_filter_anisotropic") === true) {
      const extension = extensions.get("EXT_texture_filter_anisotropic");
      maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else {
      maxAnisotropy = 0;
    }
    return maxAnisotropy;
  }
  function textureFormatReadable(textureFormat) {
    if (textureFormat !== RGBAFormat && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
      return false;
    }
    return true;
  }
  function textureTypeReadable(textureType) {
    const halfFloatSupportedByExt = textureType === HalfFloatType && (extensions.has("EXT_color_buffer_half_float") || extensions.has("EXT_color_buffer_float"));
    if (textureType !== UnsignedByteType && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
    textureType !== FloatType && !halfFloatSupportedByExt) {
      return false;
    }
    return true;
  }
  function getMaxPrecision(precision2) {
    if (precision2 === "highp") {
      if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) {
        return "highp";
      }
      precision2 = "mediump";
    }
    if (precision2 === "mediump") {
      if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) {
        return "mediump";
      }
    }
    return "lowp";
  }
  let precision = parameters.precision !== void 0 ? parameters.precision : "highp";
  const maxPrecision = getMaxPrecision(precision);
  if (maxPrecision !== precision) {
    console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
    precision = maxPrecision;
  }
  const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
  const reversedDepthBuffer = parameters.reversedDepthBuffer === true && extensions.has("EXT_clip_control");
  const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
  const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
  const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
  const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
  const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
  const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
  const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
  const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
  const vertexTextures = maxVertexTextures > 0;
  const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
  return {
    isWebGL2: true,
    // keeping this for backwards compatibility
    getMaxAnisotropy,
    getMaxPrecision,
    textureFormatReadable,
    textureTypeReadable,
    precision,
    logarithmicDepthBuffer,
    reversedDepthBuffer,
    maxTextures,
    maxVertexTextures,
    maxTextureSize,
    maxCubemapSize,
    maxAttributes,
    maxVertexUniforms,
    maxVaryings,
    maxFragmentUniforms,
    vertexTextures,
    maxSamples
  };
}
function WebGLClipping(properties) {
  const scope = this;
  let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
  const plane = new Plane(), viewNormalMatrix = new Matrix3(), uniform = { value: null, needsUpdate: false };
  this.uniform = uniform;
  this.numPlanes = 0;
  this.numIntersection = 0;
  this.init = function(planes, enableLocalClipping) {
    const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    numGlobalPlanes !== 0 || localClippingEnabled;
    localClippingEnabled = enableLocalClipping;
    numGlobalPlanes = planes.length;
    return enabled;
  };
  this.beginShadows = function() {
    renderingShadows = true;
    projectPlanes(null);
  };
  this.endShadows = function() {
    renderingShadows = false;
  };
  this.setGlobalState = function(planes, camera) {
    globalState = projectPlanes(planes, camera, 0);
  };
  this.setState = function(material, camera, useCache) {
    const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
    const materialProperties = properties.get(material);
    if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
      if (renderingShadows) {
        projectPlanes(null);
      } else {
        resetGlobalState();
      }
    } else {
      const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
      let dstArray = materialProperties.clippingState || null;
      uniform.value = dstArray;
      dstArray = projectPlanes(planes, camera, lGlobal, useCache);
      for (let i = 0; i !== lGlobal; ++i) {
        dstArray[i] = globalState[i];
      }
      materialProperties.clippingState = dstArray;
      this.numIntersection = clipIntersection ? this.numPlanes : 0;
      this.numPlanes += nGlobal;
    }
  };
  function resetGlobalState() {
    if (uniform.value !== globalState) {
      uniform.value = globalState;
      uniform.needsUpdate = numGlobalPlanes > 0;
    }
    scope.numPlanes = numGlobalPlanes;
    scope.numIntersection = 0;
  }
  function projectPlanes(planes, camera, dstOffset, skipTransform) {
    const nPlanes = planes !== null ? planes.length : 0;
    let dstArray = null;
    if (nPlanes !== 0) {
      dstArray = uniform.value;
      if (skipTransform !== true || dstArray === null) {
        const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
        viewNormalMatrix.getNormalMatrix(viewMatrix);
        if (dstArray === null || dstArray.length < flatSize) {
          dstArray = new Float32Array(flatSize);
        }
        for (let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4) {
          plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
          plane.normal.toArray(dstArray, i4);
          dstArray[i4 + 3] = plane.constant;
        }
      }
      uniform.value = dstArray;
      uniform.needsUpdate = true;
    }
    scope.numPlanes = nPlanes;
    scope.numIntersection = 0;
    return dstArray;
  }
}
function WebGLCubeMaps(renderer) {
  let cubemaps = /* @__PURE__ */ new WeakMap();
  function mapTextureMapping(texture, mapping) {
    if (mapping === EquirectangularReflectionMapping) {
      texture.mapping = CubeReflectionMapping;
    } else if (mapping === EquirectangularRefractionMapping) {
      texture.mapping = CubeRefractionMapping;
    }
    return texture;
  }
  function get(texture) {
    if (texture && texture.isTexture) {
      const mapping = texture.mapping;
      if (mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping) {
        if (cubemaps.has(texture)) {
          const cubemap = cubemaps.get(texture).texture;
          return mapTextureMapping(cubemap, texture.mapping);
        } else {
          const image = texture.image;
          if (image && image.height > 0) {
            const renderTarget = new WebGLCubeRenderTarget(image.height);
            renderTarget.fromEquirectangularTexture(renderer, texture);
            cubemaps.set(texture, renderTarget);
            texture.addEventListener("dispose", onTextureDispose);
            return mapTextureMapping(renderTarget.texture, texture.mapping);
          } else {
            return null;
          }
        }
      }
    }
    return texture;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    const cubemap = cubemaps.get(texture);
    if (cubemap !== void 0) {
      cubemaps.delete(texture);
      cubemap.dispose();
    }
  }
  function dispose() {
    cubemaps = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose
  };
}
function _createPlanes(lodMax) {
  const lodPlanes = [];
  const sizeLods = [];
  const sigmas = [];
  let lod = lodMax;
  const totalLods = lodMax - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;
  for (let i = 0; i < totalLods; i++) {
    const sizeLod = Math.pow(2, lod);
    sizeLods.push(sizeLod);
    let sigma = 1 / sizeLod;
    if (i > lodMax - LOD_MIN) {
      sigma = EXTRA_LOD_SIGMA[i - lodMax + LOD_MIN - 1];
    } else if (i === 0) {
      sigma = 0;
    }
    sigmas.push(sigma);
    const texelSize = 1 / (sizeLod - 2);
    const min = -texelSize;
    const max = 1 + texelSize;
    const uv1 = [min, min, max, min, max, max, min, min, max, max, min, max];
    const cubeFaces = 6;
    const vertices = 6;
    const positionSize = 3;
    const uvSize = 2;
    const faceIndexSize = 1;
    const position = new Float32Array(positionSize * vertices * cubeFaces);
    const uv = new Float32Array(uvSize * vertices * cubeFaces);
    const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
    for (let face = 0; face < cubeFaces; face++) {
      const x = face % 3 * 2 / 3 - 1;
      const y = face > 2 ? 0 : -1;
      const coordinates = [
        x,
        y,
        0,
        x + 2 / 3,
        y,
        0,
        x + 2 / 3,
        y + 1,
        0,
        x,
        y,
        0,
        x + 2 / 3,
        y + 1,
        0,
        x,
        y + 1,
        0
      ];
      position.set(coordinates, positionSize * vertices * face);
      uv.set(uv1, uvSize * vertices * face);
      const fill = [face, face, face, face, face, face];
      faceIndex.set(fill, faceIndexSize * vertices * face);
    }
    const planes = new BufferGeometry();
    planes.setAttribute("position", new BufferAttribute(position, positionSize));
    planes.setAttribute("uv", new BufferAttribute(uv, uvSize));
    planes.setAttribute("faceIndex", new BufferAttribute(faceIndex, faceIndexSize));
    lodPlanes.push(planes);
    if (lod > LOD_MIN) {
      lod--;
    }
  }
  return { lodPlanes, sizeLods, sigmas };
}
function _createRenderTarget(width, height, params) {
  const cubeUVRenderTarget = new WebGLRenderTarget(width, height, params);
  cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
  cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
  cubeUVRenderTarget.scissorTest = true;
  return cubeUVRenderTarget;
}
function _setViewport(target, x, y, width, height) {
  target.viewport.set(x, y, width, height);
  target.scissor.set(x, y, width, height);
}
function _getBlurShader(lodMax, width, height) {
  const weights = new Float32Array(MAX_SAMPLES);
  const poleAxis = new Vector3(0, 1, 0);
  const shaderMaterial = new ShaderMaterial({
    name: "SphericalGaussianBlur",
    defines: {
      "n": MAX_SAMPLES,
      "CUBEUV_TEXEL_WIDTH": 1 / width,
      "CUBEUV_TEXEL_HEIGHT": 1 / height,
      "CUBEUV_MAX_MIP": `${lodMax}.0`
    },
    uniforms: {
      "envMap": { value: null },
      "samples": { value: 1 },
      "weights": { value: weights },
      "latitudinal": { value: false },
      "dTheta": { value: 0 },
      "mipInt": { value: 0 },
      "poleAxis": { value: poleAxis }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
  return shaderMaterial;
}
function _getEquirectMaterial() {
  return new ShaderMaterial({
    name: "EquirectangularToCubeUV",
    uniforms: {
      "envMap": { value: null }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
}
function _getCubemapMaterial() {
  return new ShaderMaterial({
    name: "CubemapToCubeUV",
    uniforms: {
      "envMap": { value: null },
      "flipEnvMap": { value: -1 }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
}
function _getCommonVertexShader() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function WebGLCubeUVMaps(renderer) {
  let cubeUVmaps = /* @__PURE__ */ new WeakMap();
  let pmremGenerator = null;
  function get(texture) {
    if (texture && texture.isTexture) {
      const mapping = texture.mapping;
      const isEquirectMap = mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping;
      const isCubeMap = mapping === CubeReflectionMapping || mapping === CubeRefractionMapping;
      if (isEquirectMap || isCubeMap) {
        let renderTarget = cubeUVmaps.get(texture);
        const currentPMREMVersion = renderTarget !== void 0 ? renderTarget.texture.pmremVersion : 0;
        if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
          if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);
          renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
          renderTarget.texture.pmremVersion = texture.pmremVersion;
          cubeUVmaps.set(texture, renderTarget);
          return renderTarget.texture;
        } else {
          if (renderTarget !== void 0) {
            return renderTarget.texture;
          } else {
            const image = texture.image;
            if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
              if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);
              renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
              renderTarget.texture.pmremVersion = texture.pmremVersion;
              cubeUVmaps.set(texture, renderTarget);
              texture.addEventListener("dispose", onTextureDispose);
              return renderTarget.texture;
            } else {
              return null;
            }
          }
        }
      }
    }
    return texture;
  }
  function isCubeTextureComplete(image) {
    let count = 0;
    const length = 6;
    for (let i = 0; i < length; i++) {
      if (image[i] !== void 0) count++;
    }
    return count === length;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    const cubemapUV = cubeUVmaps.get(texture);
    if (cubemapUV !== void 0) {
      cubeUVmaps.delete(texture);
      cubemapUV.dispose();
    }
  }
  function dispose() {
    cubeUVmaps = /* @__PURE__ */ new WeakMap();
    if (pmremGenerator !== null) {
      pmremGenerator.dispose();
      pmremGenerator = null;
    }
  }
  return {
    get,
    dispose
  };
}
function WebGLExtensions(gl) {
  const extensions = {};
  function getExtension(name) {
    if (extensions[name] !== void 0) {
      return extensions[name];
    }
    let extension;
    switch (name) {
      case "WEBGL_depth_texture":
        extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        extension = gl.getExtension(name);
    }
    extensions[name] = extension;
    return extension;
  }
  return {
    has: function(name) {
      return getExtension(name) !== null;
    },
    init: function() {
      getExtension("EXT_color_buffer_float");
      getExtension("WEBGL_clip_cull_distance");
      getExtension("OES_texture_float_linear");
      getExtension("EXT_color_buffer_half_float");
      getExtension("WEBGL_multisampled_render_to_texture");
      getExtension("WEBGL_render_shared_exponent");
    },
    get: function(name) {
      const extension = getExtension(name);
      if (extension === null) {
        warnOnce("THREE.WebGLRenderer: " + name + " extension not supported.");
      }
      return extension;
    }
  };
}
function WebGLGeometries(gl, attributes, info, bindingStates) {
  const geometries = {};
  const wireframeAttributes = /* @__PURE__ */ new WeakMap();
  function onGeometryDispose(event) {
    const geometry = event.target;
    if (geometry.index !== null) {
      attributes.remove(geometry.index);
    }
    for (const name in geometry.attributes) {
      attributes.remove(geometry.attributes[name]);
    }
    geometry.removeEventListener("dispose", onGeometryDispose);
    delete geometries[geometry.id];
    const attribute = wireframeAttributes.get(geometry);
    if (attribute) {
      attributes.remove(attribute);
      wireframeAttributes.delete(geometry);
    }
    bindingStates.releaseStatesOfGeometry(geometry);
    if (geometry.isInstancedBufferGeometry === true) {
      delete geometry._maxInstanceCount;
    }
    info.memory.geometries--;
  }
  function get(object, geometry) {
    if (geometries[geometry.id] === true) return geometry;
    geometry.addEventListener("dispose", onGeometryDispose);
    geometries[geometry.id] = true;
    info.memory.geometries++;
    return geometry;
  }
  function update(geometry) {
    const geometryAttributes = geometry.attributes;
    for (const name in geometryAttributes) {
      attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
  }
  function updateWireframeAttribute(geometry) {
    const indices = [];
    const geometryIndex = geometry.index;
    const geometryPosition = geometry.attributes.position;
    let version = 0;
    if (geometryIndex !== null) {
      const array = geometryIndex.array;
      version = geometryIndex.version;
      for (let i = 0, l = array.length; i < l; i += 3) {
        const a = array[i + 0];
        const b = array[i + 1];
        const c = array[i + 2];
        indices.push(a, b, b, c, c, a);
      }
    } else if (geometryPosition !== void 0) {
      const array = geometryPosition.array;
      version = geometryPosition.version;
      for (let i = 0, l = array.length / 3 - 1; i < l; i += 3) {
        const a = i + 0;
        const b = i + 1;
        const c = i + 2;
        indices.push(a, b, b, c, c, a);
      }
    } else {
      return;
    }
    const attribute = new (arrayNeedsUint32(indices) ? Uint32BufferAttribute : Uint16BufferAttribute)(indices, 1);
    attribute.version = version;
    const previousAttribute = wireframeAttributes.get(geometry);
    if (previousAttribute) attributes.remove(previousAttribute);
    wireframeAttributes.set(geometry, attribute);
  }
  function getWireframeAttribute(geometry) {
    const currentAttribute = wireframeAttributes.get(geometry);
    if (currentAttribute) {
      const geometryIndex = geometry.index;
      if (geometryIndex !== null) {
        if (currentAttribute.version < geometryIndex.version) {
          updateWireframeAttribute(geometry);
        }
      }
    } else {
      updateWireframeAttribute(geometry);
    }
    return wireframeAttributes.get(geometry);
  }
  return {
    get,
    update,
    getWireframeAttribute
  };
}
function WebGLIndexedBufferRenderer(gl, extensions, info) {
  let mode;
  function setMode(value) {
    mode = value;
  }
  let type, bytesPerElement;
  function setIndex(value) {
    type = value.type;
    bytesPerElement = value.bytesPerElement;
  }
  function render(start, count) {
    gl.drawElements(mode, count, type, start * bytesPerElement);
    info.update(count, mode, 1);
  }
  function renderInstances(start, count, primcount) {
    if (primcount === 0) return;
    gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
    info.update(count, mode, primcount);
  }
  function renderMultiDraw(starts, counts, drawCount) {
    if (drawCount === 0) return;
    const extension = extensions.get("WEBGL_multi_draw");
    extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
    let elementCount = 0;
    for (let i = 0; i < drawCount; i++) {
      elementCount += counts[i];
    }
    info.update(elementCount, mode, 1);
  }
  function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
    if (drawCount === 0) return;
    const extension = extensions.get("WEBGL_multi_draw");
    if (extension === null) {
      for (let i = 0; i < starts.length; i++) {
        renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
      }
    } else {
      extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
      let elementCount = 0;
      for (let i = 0; i < drawCount; i++) {
        elementCount += counts[i] * primcount[i];
      }
      info.update(elementCount, mode, 1);
    }
  }
  this.setMode = setMode;
  this.setIndex = setIndex;
  this.render = render;
  this.renderInstances = renderInstances;
  this.renderMultiDraw = renderMultiDraw;
  this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function WebGLInfo(gl) {
  const memory = {
    geometries: 0,
    textures: 0
  };
  const render = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function update(count, mode, instanceCount) {
    render.calls++;
    switch (mode) {
      case gl.TRIANGLES:
        render.triangles += instanceCount * (count / 3);
        break;
      case gl.LINES:
        render.lines += instanceCount * (count / 2);
        break;
      case gl.LINE_STRIP:
        render.lines += instanceCount * (count - 1);
        break;
      case gl.LINE_LOOP:
        render.lines += instanceCount * count;
        break;
      case gl.POINTS:
        render.points += instanceCount * count;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
        break;
    }
  }
  function reset() {
    render.calls = 0;
    render.triangles = 0;
    render.points = 0;
    render.lines = 0;
  }
  return {
    memory,
    render,
    programs: null,
    autoReset: true,
    reset,
    update
  };
}
function WebGLMorphtargets(gl, capabilities, textures) {
  const morphTextures = /* @__PURE__ */ new WeakMap();
  const morph = new Vector4();
  function update(object, geometry, program) {
    const objectInfluences = object.morphTargetInfluences;
    const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
    const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
    let entry = morphTextures.get(geometry);
    if (entry === void 0 || entry.count !== morphTargetsCount) {
      let disposeTexture = function() {
        texture.dispose();
        morphTextures.delete(geometry);
        geometry.removeEventListener("dispose", disposeTexture);
      };
      if (entry !== void 0) entry.texture.dispose();
      const hasMorphPosition = geometry.morphAttributes.position !== void 0;
      const hasMorphNormals = geometry.morphAttributes.normal !== void 0;
      const hasMorphColors = geometry.morphAttributes.color !== void 0;
      const morphTargets = geometry.morphAttributes.position || [];
      const morphNormals = geometry.morphAttributes.normal || [];
      const morphColors = geometry.morphAttributes.color || [];
      let vertexDataCount = 0;
      if (hasMorphPosition === true) vertexDataCount = 1;
      if (hasMorphNormals === true) vertexDataCount = 2;
      if (hasMorphColors === true) vertexDataCount = 3;
      let width = geometry.attributes.position.count * vertexDataCount;
      let height = 1;
      if (width > capabilities.maxTextureSize) {
        height = Math.ceil(width / capabilities.maxTextureSize);
        width = capabilities.maxTextureSize;
      }
      const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
      const texture = new DataArrayTexture(buffer, width, height, morphTargetsCount);
      texture.type = FloatType;
      texture.needsUpdate = true;
      const vertexDataStride = vertexDataCount * 4;
      for (let i = 0; i < morphTargetsCount; i++) {
        const morphTarget = morphTargets[i];
        const morphNormal = morphNormals[i];
        const morphColor = morphColors[i];
        const offset = width * height * 4 * i;
        for (let j = 0; j < morphTarget.count; j++) {
          const stride = j * vertexDataStride;
          if (hasMorphPosition === true) {
            morph.fromBufferAttribute(morphTarget, j);
            buffer[offset + stride + 0] = morph.x;
            buffer[offset + stride + 1] = morph.y;
            buffer[offset + stride + 2] = morph.z;
            buffer[offset + stride + 3] = 0;
          }
          if (hasMorphNormals === true) {
            morph.fromBufferAttribute(morphNormal, j);
            buffer[offset + stride + 4] = morph.x;
            buffer[offset + stride + 5] = morph.y;
            buffer[offset + stride + 6] = morph.z;
            buffer[offset + stride + 7] = 0;
          }
          if (hasMorphColors === true) {
            morph.fromBufferAttribute(morphColor, j);
            buffer[offset + stride + 8] = morph.x;
            buffer[offset + stride + 9] = morph.y;
            buffer[offset + stride + 10] = morph.z;
            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
          }
        }
      }
      entry = {
        count: morphTargetsCount,
        texture,
        size: new Vector2(width, height)
      };
      morphTextures.set(geometry, entry);
      geometry.addEventListener("dispose", disposeTexture);
    }
    if (object.isInstancedMesh === true && object.morphTexture !== null) {
      program.getUniforms().setValue(gl, "morphTexture", object.morphTexture, textures);
    } else {
      let morphInfluencesSum = 0;
      for (let i = 0; i < objectInfluences.length; i++) {
        morphInfluencesSum += objectInfluences[i];
      }
      const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
      program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
      program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
    }
    program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
    program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
  }
  return {
    update
  };
}
function WebGLObjects(gl, geometries, attributes, info) {
  let updateMap = /* @__PURE__ */ new WeakMap();
  function update(object) {
    const frame = info.render.frame;
    const geometry = object.geometry;
    const buffergeometry = geometries.get(object, geometry);
    if (updateMap.get(buffergeometry) !== frame) {
      geometries.update(buffergeometry);
      updateMap.set(buffergeometry, frame);
    }
    if (object.isInstancedMesh) {
      if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) {
        object.addEventListener("dispose", onInstancedMeshDispose);
      }
      if (updateMap.get(object) !== frame) {
        attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
        if (object.instanceColor !== null) {
          attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
        }
        updateMap.set(object, frame);
      }
    }
    if (object.isSkinnedMesh) {
      const skeleton = object.skeleton;
      if (updateMap.get(skeleton) !== frame) {
        skeleton.update();
        updateMap.set(skeleton, frame);
      }
    }
    return buffergeometry;
  }
  function dispose() {
    updateMap = /* @__PURE__ */ new WeakMap();
  }
  function onInstancedMeshDispose(event) {
    const instancedMesh = event.target;
    instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
    attributes.remove(instancedMesh.instanceMatrix);
    if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
  }
  return {
    update,
    dispose
  };
}
function flatten(array, nBlocks, blockSize) {
  const firstElem = array[0];
  if (firstElem <= 0 || firstElem > 0) return array;
  const n = nBlocks * blockSize;
  let r = arrayCacheF32[n];
  if (r === void 0) {
    r = new Float32Array(n);
    arrayCacheF32[n] = r;
  }
  if (nBlocks !== 0) {
    firstElem.toArray(r, 0);
    for (let i = 1, offset = 0; i !== nBlocks; ++i) {
      offset += blockSize;
      array[i].toArray(r, offset);
    }
  }
  return r;
}
function arraysEqual(a, b) {
  if (a.length !== b.length) return false;
  for (let i = 0, l = a.length; i < l; i++) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}
function copyArray(a, b) {
  for (let i = 0, l = b.length; i < l; i++) {
    a[i] = b[i];
  }
}
function allocTexUnits(textures, n) {
  let r = arrayCacheI32[n];
  if (r === void 0) {
    r = new Int32Array(n);
    arrayCacheI32[n] = r;
  }
  for (let i = 0; i !== n; ++i) {
    r[i] = textures.allocateTextureUnit();
  }
  return r;
}
function setValueV1f(gl, v) {
  const cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1f(this.addr, v);
  cache[0] = v;
}
function setValueV2f(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y) {
      gl.uniform2f(this.addr, v.x, v.y);
      cache[0] = v.x;
      cache[1] = v.y;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform2fv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueV3f(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
      gl.uniform3f(this.addr, v.x, v.y, v.z);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
    }
  } else if (v.r !== void 0) {
    if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
      gl.uniform3f(this.addr, v.r, v.g, v.b);
      cache[0] = v.r;
      cache[1] = v.g;
      cache[2] = v.b;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform3fv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueV4f(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
      gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
      cache[3] = v.w;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform4fv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueM2(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v)) return;
    gl.uniformMatrix2fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat2array.set(elements);
    gl.uniformMatrix2fv(this.addr, false, mat2array);
    copyArray(cache, elements);
  }
}
function setValueM3(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v)) return;
    gl.uniformMatrix3fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat3array.set(elements);
    gl.uniformMatrix3fv(this.addr, false, mat3array);
    copyArray(cache, elements);
  }
}
function setValueM4(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v)) return;
    gl.uniformMatrix4fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat4array.set(elements);
    gl.uniformMatrix4fv(this.addr, false, mat4array);
    copyArray(cache, elements);
  }
}
function setValueV1i(gl, v) {
  const cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1i(this.addr, v);
  cache[0] = v;
}
function setValueV2i(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y) {
      gl.uniform2i(this.addr, v.x, v.y);
      cache[0] = v.x;
      cache[1] = v.y;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueV3i(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
      gl.uniform3i(this.addr, v.x, v.y, v.z);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueV4i(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
      gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
      cache[3] = v.w;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueV1ui(gl, v) {
  const cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1ui(this.addr, v);
  cache[0] = v;
}
function setValueV2ui(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y) {
      gl.uniform2ui(this.addr, v.x, v.y);
      cache[0] = v.x;
      cache[1] = v.y;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform2uiv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueV3ui(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
      gl.uniform3ui(this.addr, v.x, v.y, v.z);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform3uiv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueV4ui(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
      gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
      cache[3] = v.w;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform4uiv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueT1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  let emptyTexture2D;
  if (this.type === gl.SAMPLER_2D_SHADOW) {
    emptyShadowTexture.compareFunction = LessEqualCompare;
    emptyTexture2D = emptyShadowTexture;
  } else {
    emptyTexture2D = emptyTexture;
  }
  textures.setTexture2D(v || emptyTexture2D, unit);
}
function setValueT3D1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTexture3D(v || empty3dTexture, unit);
}
function setValueT6(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTextureCube(v || emptyCubeTexture, unit);
}
function setValueT2DArray1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTexture2DArray(v || emptyArrayTexture, unit);
}
function getSingularSetter(type) {
  switch (type) {
    case 5126:
      return setValueV1f;
    // FLOAT
    case 35664:
      return setValueV2f;
    // _VEC2
    case 35665:
      return setValueV3f;
    // _VEC3
    case 35666:
      return setValueV4f;
    // _VEC4
    case 35674:
      return setValueM2;
    // _MAT2
    case 35675:
      return setValueM3;
    // _MAT3
    case 35676:
      return setValueM4;
    // _MAT4
    case 5124:
    case 35670:
      return setValueV1i;
    // INT, BOOL
    case 35667:
    case 35671:
      return setValueV2i;
    // _VEC2
    case 35668:
    case 35672:
      return setValueV3i;
    // _VEC3
    case 35669:
    case 35673:
      return setValueV4i;
    // _VEC4
    case 5125:
      return setValueV1ui;
    // UINT
    case 36294:
      return setValueV2ui;
    // _VEC2
    case 36295:
      return setValueV3ui;
    // _VEC3
    case 36296:
      return setValueV4ui;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return setValueT1;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return setValueT3D1;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return setValueT6;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return setValueT2DArray1;
  }
}
function setValueV1fArray(gl, v) {
  gl.uniform1fv(this.addr, v);
}
function setValueV2fArray(gl, v) {
  const data = flatten(v, this.size, 2);
  gl.uniform2fv(this.addr, data);
}
function setValueV3fArray(gl, v) {
  const data = flatten(v, this.size, 3);
  gl.uniform3fv(this.addr, data);
}
function setValueV4fArray(gl, v) {
  const data = flatten(v, this.size, 4);
  gl.uniform4fv(this.addr, data);
}
function setValueM2Array(gl, v) {
  const data = flatten(v, this.size, 4);
  gl.uniformMatrix2fv(this.addr, false, data);
}
function setValueM3Array(gl, v) {
  const data = flatten(v, this.size, 9);
  gl.uniformMatrix3fv(this.addr, false, data);
}
function setValueM4Array(gl, v) {
  const data = flatten(v, this.size, 16);
  gl.uniformMatrix4fv(this.addr, false, data);
}
function setValueV1iArray(gl, v) {
  gl.uniform1iv(this.addr, v);
}
function setValueV2iArray(gl, v) {
  gl.uniform2iv(this.addr, v);
}
function setValueV3iArray(gl, v) {
  gl.uniform3iv(this.addr, v);
}
function setValueV4iArray(gl, v) {
  gl.uniform4iv(this.addr, v);
}
function setValueV1uiArray(gl, v) {
  gl.uniform1uiv(this.addr, v);
}
function setValueV2uiArray(gl, v) {
  gl.uniform2uiv(this.addr, v);
}
function setValueV3uiArray(gl, v) {
  gl.uniform3uiv(this.addr, v);
}
function setValueV4uiArray(gl, v) {
  gl.uniform4uiv(this.addr, v);
}
function setValueT1Array(gl, v, textures) {
  const cache = this.cache;
  const n = v.length;
  const units = allocTexUnits(textures, n);
  if (!arraysEqual(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray(cache, units);
  }
  for (let i = 0; i !== n; ++i) {
    textures.setTexture2D(v[i] || emptyTexture, units[i]);
  }
}
function setValueT3DArray(gl, v, textures) {
  const cache = this.cache;
  const n = v.length;
  const units = allocTexUnits(textures, n);
  if (!arraysEqual(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray(cache, units);
  }
  for (let i = 0; i !== n; ++i) {
    textures.setTexture3D(v[i] || empty3dTexture, units[i]);
  }
}
function setValueT6Array(gl, v, textures) {
  const cache = this.cache;
  const n = v.length;
  const units = allocTexUnits(textures, n);
  if (!arraysEqual(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray(cache, units);
  }
  for (let i = 0; i !== n; ++i) {
    textures.setTextureCube(v[i] || emptyCubeTexture, units[i]);
  }
}
function setValueT2DArrayArray(gl, v, textures) {
  const cache = this.cache;
  const n = v.length;
  const units = allocTexUnits(textures, n);
  if (!arraysEqual(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray(cache, units);
  }
  for (let i = 0; i !== n; ++i) {
    textures.setTexture2DArray(v[i] || emptyArrayTexture, units[i]);
  }
}
function getPureArraySetter(type) {
  switch (type) {
    case 5126:
      return setValueV1fArray;
    // FLOAT
    case 35664:
      return setValueV2fArray;
    // _VEC2
    case 35665:
      return setValueV3fArray;
    // _VEC3
    case 35666:
      return setValueV4fArray;
    // _VEC4
    case 35674:
      return setValueM2Array;
    // _MAT2
    case 35675:
      return setValueM3Array;
    // _MAT3
    case 35676:
      return setValueM4Array;
    // _MAT4
    case 5124:
    case 35670:
      return setValueV1iArray;
    // INT, BOOL
    case 35667:
    case 35671:
      return setValueV2iArray;
    // _VEC2
    case 35668:
    case 35672:
      return setValueV3iArray;
    // _VEC3
    case 35669:
    case 35673:
      return setValueV4iArray;
    // _VEC4
    case 5125:
      return setValueV1uiArray;
    // UINT
    case 36294:
      return setValueV2uiArray;
    // _VEC2
    case 36295:
      return setValueV3uiArray;
    // _VEC3
    case 36296:
      return setValueV4uiArray;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return setValueT1Array;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return setValueT3DArray;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return setValueT6Array;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return setValueT2DArrayArray;
  }
}
function addUniform(container, uniformObject) {
  container.seq.push(uniformObject);
  container.map[uniformObject.id] = uniformObject;
}
function parseUniform(activeInfo, addr, container) {
  const path = activeInfo.name, pathLength = path.length;
  RePathPart.lastIndex = 0;
  while (true) {
    const match = RePathPart.exec(path), matchEnd = RePathPart.lastIndex;
    let id = match[1];
    const idIsIndex = match[2] === "]", subscript = match[3];
    if (idIsIndex) id = id | 0;
    if (subscript === void 0 || subscript === "[" && matchEnd + 2 === pathLength) {
      addUniform(container, subscript === void 0 ? new SingleUniform(id, activeInfo, addr) : new PureArrayUniform(id, activeInfo, addr));
      break;
    } else {
      const map = container.map;
      let next = map[id];
      if (next === void 0) {
        next = new StructuredUniform(id);
        addUniform(container, next);
      }
      container = next;
    }
  }
}
function WebGLShader(gl, type, string) {
  const shader = gl.createShader(type);
  gl.shaderSource(shader, string);
  gl.compileShader(shader);
  return shader;
}
function handleSource(string, errorLine) {
  const lines = string.split("\n");
  const lines2 = [];
  const from = Math.max(errorLine - 6, 0);
  const to = Math.min(errorLine + 6, lines.length);
  for (let i = from; i < to; i++) {
    const line = i + 1;
    lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i]}`);
  }
  return lines2.join("\n");
}
function getEncodingComponents(colorSpace) {
  ColorManagement._getMatrix(_m0, ColorManagement.workingColorSpace, colorSpace);
  const encodingMatrix = `mat3( ${_m0.elements.map((v) => v.toFixed(4))} )`;
  switch (ColorManagement.getTransfer(colorSpace)) {
    case LinearTransfer:
      return [encodingMatrix, "LinearTransferOETF"];
    case SRGBTransfer:
      return [encodingMatrix, "sRGBTransferOETF"];
    default:
      console.warn("THREE.WebGLProgram: Unsupported color space: ", colorSpace);
      return [encodingMatrix, "LinearTransferOETF"];
  }
}
function getShaderErrors(gl, shader, type) {
  const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
  const shaderInfoLog = gl.getShaderInfoLog(shader) || "";
  const errors = shaderInfoLog.trim();
  if (status && errors === "") return "";
  const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
  if (errorMatches) {
    const errorLine = parseInt(errorMatches[1]);
    return type.toUpperCase() + "\n\n" + errors + "\n\n" + handleSource(gl.getShaderSource(shader), errorLine);
  } else {
    return errors;
  }
}
function getTexelEncodingFunction(functionName, colorSpace) {
  const components = getEncodingComponents(colorSpace);
  return [
    `vec4 ${functionName}( vec4 value ) {`,
    `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
    "}"
  ].join("\n");
}
function getToneMappingFunction(functionName, toneMapping) {
  let toneMappingName;
  switch (toneMapping) {
    case LinearToneMapping:
      toneMappingName = "Linear";
      break;
    case ReinhardToneMapping:
      toneMappingName = "Reinhard";
      break;
    case CineonToneMapping:
      toneMappingName = "Cineon";
      break;
    case ACESFilmicToneMapping:
      toneMappingName = "ACESFilmic";
      break;
    case AgXToneMapping:
      toneMappingName = "AgX";
      break;
    case NeutralToneMapping:
      toneMappingName = "Neutral";
      break;
    case CustomToneMapping:
      toneMappingName = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
      toneMappingName = "Linear";
  }
  return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function getLuminanceFunction() {
  ColorManagement.getLuminanceCoefficients(_v0);
  const r = _v0.x.toFixed(4);
  const g = _v0.y.toFixed(4);
  const b = _v0.z.toFixed(4);
  return [
    "float luminance( const in vec3 rgb ) {",
    `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
    "	return dot( weights, rgb );",
    "}"
  ].join("\n");
}
function generateVertexExtensions(parameters) {
  const chunks = [
    parameters.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
    parameters.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
  ];
  return chunks.filter(filterEmptyLine).join("\n");
}
function generateDefines(defines) {
  const chunks = [];
  for (const name in defines) {
    const value = defines[name];
    if (value === false) continue;
    chunks.push("#define " + name + " " + value);
  }
  return chunks.join("\n");
}
function fetchAttributeLocations(gl, program) {
  const attributes = {};
  const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
  for (let i = 0; i < n; i++) {
    const info = gl.getActiveAttrib(program, i);
    const name = info.name;
    let locationSize = 1;
    if (info.type === gl.FLOAT_MAT2) locationSize = 2;
    if (info.type === gl.FLOAT_MAT3) locationSize = 3;
    if (info.type === gl.FLOAT_MAT4) locationSize = 4;
    attributes[name] = {
      type: info.type,
      location: gl.getAttribLocation(program, name),
      locationSize
    };
  }
  return attributes;
}
function filterEmptyLine(string) {
  return string !== "";
}
function replaceLightNums(string, parameters) {
  const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
  return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function replaceClippingPlaneNums(string, parameters) {
  return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
function resolveIncludes(string) {
  return string.replace(includePattern, includeReplacer);
}
function includeReplacer(match, include) {
  let string = ShaderChunk[include];
  if (string === void 0) {
    const newInclude = shaderChunkMap.get(include);
    if (newInclude !== void 0) {
      string = ShaderChunk[newInclude];
      console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
    } else {
      throw new Error("Can not resolve #include <" + include + ">");
    }
  }
  return resolveIncludes(string);
}
function unrollLoops(string) {
  return string.replace(unrollLoopPattern, loopReplacer);
}
function loopReplacer(match, start, end, snippet) {
  let string = "";
  for (let i = parseInt(start); i < parseInt(end); i++) {
    string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
  }
  return string;
}
function generatePrecision(parameters) {
  let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
  if (parameters.precision === "highp") {
    precisionstring += "\n#define HIGH_PRECISION";
  } else if (parameters.precision === "mediump") {
    precisionstring += "\n#define MEDIUM_PRECISION";
  } else if (parameters.precision === "lowp") {
    precisionstring += "\n#define LOW_PRECISION";
  }
  return precisionstring;
}
function generateShadowMapTypeDefine(parameters) {
  let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
  if (parameters.shadowMapType === PCFShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
  } else if (parameters.shadowMapType === PCFSoftShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
  } else if (parameters.shadowMapType === VSMShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
  }
  return shadowMapTypeDefine;
}
function generateEnvMapTypeDefine(parameters) {
  let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeReflectionMapping:
      case CubeRefractionMapping:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE";
        break;
      case CubeUVReflectionMapping:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  }
  return envMapTypeDefine;
}
function generateEnvMapModeDefine(parameters) {
  let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeRefractionMapping:
        envMapModeDefine = "ENVMAP_MODE_REFRACTION";
        break;
    }
  }
  return envMapModeDefine;
}
function generateEnvMapBlendingDefine(parameters) {
  let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
  if (parameters.envMap) {
    switch (parameters.combine) {
      case MultiplyOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case MixOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
        break;
      case AddOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
        break;
    }
  }
  return envMapBlendingDefine;
}
function generateCubeUVSize(parameters) {
  const imageHeight = parameters.envMapCubeUVHeight;
  if (imageHeight === null) return null;
  const maxMip = Math.log2(imageHeight) - 2;
  const texelHeight = 1 / imageHeight;
  const texelWidth = 1 / (3 * Math.max(Math.pow(2, maxMip), 7 * 16));
  return { texelWidth, texelHeight, maxMip };
}
function WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
  const gl = renderer.getContext();
  const defines = parameters.defines;
  let vertexShader = parameters.vertexShader;
  let fragmentShader = parameters.fragmentShader;
  const shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
  const envMapTypeDefine = generateEnvMapTypeDefine(parameters);
  const envMapModeDefine = generateEnvMapModeDefine(parameters);
  const envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
  const envMapCubeUVSize = generateCubeUVSize(parameters);
  const customVertexExtensions = generateVertexExtensions(parameters);
  const customDefines = generateDefines(defines);
  const program = gl.createProgram();
  let prefixVertex, prefixFragment;
  let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
  if (parameters.isRawShaderMaterial) {
    prefixVertex = [
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines
    ].filter(filterEmptyLine).join("\n");
    if (prefixVertex.length > 0) {
      prefixVertex += "\n";
    }
    prefixFragment = [
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines
    ].filter(filterEmptyLine).join("\n");
    if (prefixFragment.length > 0) {
      prefixFragment += "\n";
    }
  } else {
    prefixVertex = [
      generatePrecision(parameters),
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      parameters.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
      parameters.batching ? "#define USE_BATCHING" : "",
      parameters.batchingColor ? "#define USE_BATCHING_COLOR" : "",
      parameters.instancing ? "#define USE_INSTANCING" : "",
      parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
      parameters.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
      parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
      parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
      parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
      parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
      parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
      parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
      //
      parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
      parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
      parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
      parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
      parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
      parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
      parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
      parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
      parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
      parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
      parameters.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + parameters.anisotropyMapUv : "",
      parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
      parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
      parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
      parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
      parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
      parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
      parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
      parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
      parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
      parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
      parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
      parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
      //
      parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
      parameters.vertexColors ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUv1s ? "#define USE_UV1" : "",
      parameters.vertexUv2s ? "#define USE_UV2" : "",
      parameters.vertexUv3s ? "#define USE_UV3" : "",
      parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.skinning ? "#define USE_SKINNING" : "",
      parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
      parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
      parameters.morphColors ? "#define USE_MORPHCOLORS" : "",
      parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
      parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
      parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
      parameters.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
      "uniform mat4 modelMatrix;",
      "uniform mat4 modelViewMatrix;",
      "uniform mat4 projectionMatrix;",
      "uniform mat4 viewMatrix;",
      "uniform mat3 normalMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      "#ifdef USE_INSTANCING",
      "	attribute mat4 instanceMatrix;",
      "#endif",
      "#ifdef USE_INSTANCING_COLOR",
      "	attribute vec3 instanceColor;",
      "#endif",
      "#ifdef USE_INSTANCING_MORPH",
      "	uniform sampler2D morphTexture;",
      "#endif",
      "attribute vec3 position;",
      "attribute vec3 normal;",
      "attribute vec2 uv;",
      "#ifdef USE_UV1",
      "	attribute vec2 uv1;",
      "#endif",
      "#ifdef USE_UV2",
      "	attribute vec2 uv2;",
      "#endif",
      "#ifdef USE_UV3",
      "	attribute vec2 uv3;",
      "#endif",
      "#ifdef USE_TANGENT",
      "	attribute vec4 tangent;",
      "#endif",
      "#if defined( USE_COLOR_ALPHA )",
      "	attribute vec4 color;",
      "#elif defined( USE_COLOR )",
      "	attribute vec3 color;",
      "#endif",
      "#ifdef USE_SKINNING",
      "	attribute vec4 skinIndex;",
      "	attribute vec4 skinWeight;",
      "#endif",
      "\n"
    ].filter(filterEmptyLine).join("\n");
    prefixFragment = [
      generatePrecision(parameters),
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.matcap ? "#define USE_MATCAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapTypeDefine : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.envMap ? "#define " + envMapBlendingDefine : "",
      envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
      envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
      envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
      parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
      parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
      parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.dispersion ? "#define USE_DISPERSION" : "",
      parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
      parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
      parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
      parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.alphaTest ? "#define USE_ALPHATEST" : "",
      parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
      parameters.sheen ? "#define USE_SHEEN" : "",
      parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
      parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
      parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUv1s ? "#define USE_UV1" : "",
      parameters.vertexUv2s ? "#define USE_UV2" : "",
      parameters.vertexUv3s ? "#define USE_UV3" : "",
      parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
      parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
      parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
      parameters.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
      parameters.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
      parameters.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
      "uniform mat4 viewMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      parameters.toneMapping !== NoToneMapping ? "#define TONE_MAPPING" : "",
      parameters.toneMapping !== NoToneMapping ? ShaderChunk["tonemapping_pars_fragment"] : "",
      // this code is required here because it is used by the toneMapping() function defined below
      parameters.toneMapping !== NoToneMapping ? getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
      parameters.dithering ? "#define DITHERING" : "",
      parameters.opaque ? "#define OPAQUE" : "",
      ShaderChunk["colorspace_pars_fragment"],
      // this code is required here because it is used by the various encoding/decoding function defined below
      getTexelEncodingFunction("linearToOutputTexel", parameters.outputColorSpace),
      getLuminanceFunction(),
      parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
      "\n"
    ].filter(filterEmptyLine).join("\n");
  }
  vertexShader = resolveIncludes(vertexShader);
  vertexShader = replaceLightNums(vertexShader, parameters);
  vertexShader = replaceClippingPlaneNums(vertexShader, parameters);
  fragmentShader = resolveIncludes(fragmentShader);
  fragmentShader = replaceLightNums(fragmentShader, parameters);
  fragmentShader = replaceClippingPlaneNums(fragmentShader, parameters);
  vertexShader = unrollLoops(vertexShader);
  fragmentShader = unrollLoops(fragmentShader);
  if (parameters.isRawShaderMaterial !== true) {
    versionString = "#version 300 es\n";
    prefixVertex = [
      customVertexExtensions,
      "#define attribute in",
      "#define varying out",
      "#define texture2D texture"
    ].join("\n") + "\n" + prefixVertex;
    prefixFragment = [
      "#define varying in",
      parameters.glslVersion === GLSL3 ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
      parameters.glslVersion === GLSL3 ? "" : "#define gl_FragColor pc_fragColor",
      "#define gl_FragDepthEXT gl_FragDepth",
      "#define texture2D texture",
      "#define textureCube texture",
      "#define texture2DProj textureProj",
      "#define texture2DLodEXT textureLod",
      "#define texture2DProjLodEXT textureProjLod",
      "#define textureCubeLodEXT textureLod",
      "#define texture2DGradEXT textureGrad",
      "#define texture2DProjGradEXT textureProjGrad",
      "#define textureCubeGradEXT textureGrad"
    ].join("\n") + "\n" + prefixFragment;
  }
  const vertexGlsl = versionString + prefixVertex + vertexShader;
  const fragmentGlsl = versionString + prefixFragment + fragmentShader;
  const glVertexShader = WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
  const glFragmentShader = WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
  gl.attachShader(program, glVertexShader);
  gl.attachShader(program, glFragmentShader);
  if (parameters.index0AttributeName !== void 0) {
    gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
  } else if (parameters.morphTargets === true) {
    gl.bindAttribLocation(program, 0, "position");
  }
  gl.linkProgram(program);
  function onFirstUse(self2) {
    if (renderer.debug.checkShaderErrors) {
      const programInfoLog = gl.getProgramInfoLog(program) || "";
      const vertexShaderInfoLog = gl.getShaderInfoLog(glVertexShader) || "";
      const fragmentShaderInfoLog = gl.getShaderInfoLog(glFragmentShader) || "";
      const programLog = programInfoLog.trim();
      const vertexLog = vertexShaderInfoLog.trim();
      const fragmentLog = fragmentShaderInfoLog.trim();
      let runnable = true;
      let haveDiagnostics = true;
      if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
        runnable = false;
        if (typeof renderer.debug.onShaderError === "function") {
          renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
        } else {
          const vertexErrors = getShaderErrors(gl, glVertexShader, "vertex");
          const fragmentErrors = getShaderErrors(gl, glFragmentShader, "fragment");
          console.error(
            "THREE.WebGLProgram: Shader Error " + gl.getError() + " - VALIDATE_STATUS " + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + "\n\nMaterial Name: " + self2.name + "\nMaterial Type: " + self2.type + "\n\nProgram Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors
          );
        }
      } else if (programLog !== "") {
        console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
      } else if (vertexLog === "" || fragmentLog === "") {
        haveDiagnostics = false;
      }
      if (haveDiagnostics) {
        self2.diagnostics = {
          runnable,
          programLog,
          vertexShader: {
            log: vertexLog,
            prefix: prefixVertex
          },
          fragmentShader: {
            log: fragmentLog,
            prefix: prefixFragment
          }
        };
      }
    }
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    cachedUniforms = new WebGLUniforms(gl, program);
    cachedAttributes = fetchAttributeLocations(gl, program);
  }
  let cachedUniforms;
  this.getUniforms = function() {
    if (cachedUniforms === void 0) {
      onFirstUse(this);
    }
    return cachedUniforms;
  };
  let cachedAttributes;
  this.getAttributes = function() {
    if (cachedAttributes === void 0) {
      onFirstUse(this);
    }
    return cachedAttributes;
  };
  let programReady = parameters.rendererExtensionParallelShaderCompile === false;
  this.isReady = function() {
    if (programReady === false) {
      programReady = gl.getProgramParameter(program, COMPLETION_STATUS_KHR);
    }
    return programReady;
  };
  this.destroy = function() {
    bindingStates.releaseStatesOfProgram(this);
    gl.deleteProgram(program);
    this.program = void 0;
  };
  this.type = parameters.shaderType;
  this.name = parameters.shaderName;
  this.id = programIdCount++;
  this.cacheKey = cacheKey;
  this.usedTimes = 1;
  this.program = program;
  this.vertexShader = glVertexShader;
  this.fragmentShader = glFragmentShader;
  return this;
}
function WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
  const _programLayers = new Layers();
  const _customShaders = new WebGLShaderCache();
  const _activeChannels = /* @__PURE__ */ new Set();
  const programs = [];
  const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
  const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
  let precision = capabilities.precision;
  const shaderIDs = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function getChannel(value) {
    _activeChannels.add(value);
    if (value === 0) return "uv";
    return `uv${value}`;
  }
  function getParameters(material, lights, shadows, scene, object) {
    const fog = scene.fog;
    const geometry = object.geometry;
    const environment = material.isMeshStandardMaterial ? scene.environment : null;
    const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
    const envMapCubeUVHeight = !!envMap && envMap.mapping === CubeUVReflectionMapping ? envMap.image.height : null;
    const shaderID = shaderIDs[material.type];
    if (material.precision !== null) {
      precision = capabilities.getMaxPrecision(material.precision);
      if (precision !== material.precision) {
        console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
      }
    }
    const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
    const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
    let morphTextureStride = 0;
    if (geometry.morphAttributes.position !== void 0) morphTextureStride = 1;
    if (geometry.morphAttributes.normal !== void 0) morphTextureStride = 2;
    if (geometry.morphAttributes.color !== void 0) morphTextureStride = 3;
    let vertexShader, fragmentShader;
    let customVertexShaderID, customFragmentShaderID;
    if (shaderID) {
      const shader = ShaderLib[shaderID];
      vertexShader = shader.vertexShader;
      fragmentShader = shader.fragmentShader;
    } else {
      vertexShader = material.vertexShader;
      fragmentShader = material.fragmentShader;
      _customShaders.update(material);
      customVertexShaderID = _customShaders.getVertexShaderID(material);
      customFragmentShaderID = _customShaders.getFragmentShaderID(material);
    }
    const currentRenderTarget = renderer.getRenderTarget();
    const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
    const IS_INSTANCEDMESH = object.isInstancedMesh === true;
    const IS_BATCHEDMESH = object.isBatchedMesh === true;
    const HAS_MAP = !!material.map;
    const HAS_MATCAP = !!material.matcap;
    const HAS_ENVMAP = !!envMap;
    const HAS_AOMAP = !!material.aoMap;
    const HAS_LIGHTMAP = !!material.lightMap;
    const HAS_BUMPMAP = !!material.bumpMap;
    const HAS_NORMALMAP = !!material.normalMap;
    const HAS_DISPLACEMENTMAP = !!material.displacementMap;
    const HAS_EMISSIVEMAP = !!material.emissiveMap;
    const HAS_METALNESSMAP = !!material.metalnessMap;
    const HAS_ROUGHNESSMAP = !!material.roughnessMap;
    const HAS_ANISOTROPY = material.anisotropy > 0;
    const HAS_CLEARCOAT = material.clearcoat > 0;
    const HAS_DISPERSION = material.dispersion > 0;
    const HAS_IRIDESCENCE = material.iridescence > 0;
    const HAS_SHEEN = material.sheen > 0;
    const HAS_TRANSMISSION = material.transmission > 0;
    const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
    const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
    const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
    const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
    const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
    const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
    const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
    const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
    const HAS_SPECULARMAP = !!material.specularMap;
    const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
    const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
    const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
    const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
    const HAS_GRADIENTMAP = !!material.gradientMap;
    const HAS_ALPHAMAP = !!material.alphaMap;
    const HAS_ALPHATEST = material.alphaTest > 0;
    const HAS_ALPHAHASH = !!material.alphaHash;
    const HAS_EXTENSIONS = !!material.extensions;
    let toneMapping = NoToneMapping;
    if (material.toneMapped) {
      if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) {
        toneMapping = renderer.toneMapping;
      }
    }
    const parameters = {
      shaderID,
      shaderType: material.type,
      shaderName: material.name,
      vertexShader,
      fragmentShader,
      defines: material.defines,
      customVertexShaderID,
      customFragmentShaderID,
      isRawShaderMaterial: material.isRawShaderMaterial === true,
      glslVersion: material.glslVersion,
      precision,
      batching: IS_BATCHEDMESH,
      batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
      instancing: IS_INSTANCEDMESH,
      instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
      instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
      supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
      outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace,
      alphaToCoverage: !!material.alphaToCoverage,
      map: HAS_MAP,
      matcap: HAS_MATCAP,
      envMap: HAS_ENVMAP,
      envMapMode: HAS_ENVMAP && envMap.mapping,
      envMapCubeUVHeight,
      aoMap: HAS_AOMAP,
      lightMap: HAS_LIGHTMAP,
      bumpMap: HAS_BUMPMAP,
      normalMap: HAS_NORMALMAP,
      displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
      emissiveMap: HAS_EMISSIVEMAP,
      normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === ObjectSpaceNormalMap,
      normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === TangentSpaceNormalMap,
      metalnessMap: HAS_METALNESSMAP,
      roughnessMap: HAS_ROUGHNESSMAP,
      anisotropy: HAS_ANISOTROPY,
      anisotropyMap: HAS_ANISOTROPYMAP,
      clearcoat: HAS_CLEARCOAT,
      clearcoatMap: HAS_CLEARCOATMAP,
      clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
      clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
      dispersion: HAS_DISPERSION,
      iridescence: HAS_IRIDESCENCE,
      iridescenceMap: HAS_IRIDESCENCEMAP,
      iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
      sheen: HAS_SHEEN,
      sheenColorMap: HAS_SHEEN_COLORMAP,
      sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
      specularMap: HAS_SPECULARMAP,
      specularColorMap: HAS_SPECULAR_COLORMAP,
      specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
      transmission: HAS_TRANSMISSION,
      transmissionMap: HAS_TRANSMISSIONMAP,
      thicknessMap: HAS_THICKNESSMAP,
      gradientMap: HAS_GRADIENTMAP,
      opaque: material.transparent === false && material.blending === NormalBlending && material.alphaToCoverage === false,
      alphaMap: HAS_ALPHAMAP,
      alphaTest: HAS_ALPHATEST,
      alphaHash: HAS_ALPHAHASH,
      combine: material.combine,
      //
      mapUv: HAS_MAP && getChannel(material.map.channel),
      aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
      lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
      bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
      normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
      displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
      emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
      metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
      roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
      anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
      clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
      clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
      iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
      iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
      sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
      sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
      specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
      specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
      specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
      transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
      thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
      alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
      //
      vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
      vertexColors: material.vertexColors,
      vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
      pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
      fog: !!fog,
      useFog: material.fog === true,
      fogExp2: !!fog && fog.isFogExp2,
      flatShading: material.flatShading === true && material.wireframe === false,
      sizeAttenuation: material.sizeAttenuation === true,
      logarithmicDepthBuffer,
      reversedDepthBuffer,
      skinning: object.isSkinnedMesh === true,
      morphTargets: geometry.morphAttributes.position !== void 0,
      morphNormals: geometry.morphAttributes.normal !== void 0,
      morphColors: geometry.morphAttributes.color !== void 0,
      morphTargetsCount,
      morphTextureStride,
      numDirLights: lights.directional.length,
      numPointLights: lights.point.length,
      numSpotLights: lights.spot.length,
      numSpotLightMaps: lights.spotLightMap.length,
      numRectAreaLights: lights.rectArea.length,
      numHemiLights: lights.hemi.length,
      numDirLightShadows: lights.directionalShadowMap.length,
      numPointLightShadows: lights.pointShadowMap.length,
      numSpotLightShadows: lights.spotShadowMap.length,
      numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
      numLightProbes: lights.numLightProbes,
      numClippingPlanes: clipping.numPlanes,
      numClipIntersection: clipping.numIntersection,
      dithering: material.dithering,
      shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
      shadowMapType: renderer.shadowMap.type,
      toneMapping,
      decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && ColorManagement.getTransfer(material.map.colorSpace) === SRGBTransfer,
      decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && ColorManagement.getTransfer(material.emissiveMap.colorSpace) === SRGBTransfer,
      premultipliedAlpha: material.premultipliedAlpha,
      doubleSided: material.side === DoubleSide,
      flipSided: material.side === BackSide,
      useDepthPacking: material.depthPacking >= 0,
      depthPacking: material.depthPacking || 0,
      index0AttributeName: material.index0AttributeName,
      extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has("WEBGL_clip_cull_distance"),
      extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has("WEBGL_multi_draw"),
      rendererExtensionParallelShaderCompile: extensions.has("KHR_parallel_shader_compile"),
      customProgramCacheKey: material.customProgramCacheKey()
    };
    parameters.vertexUv1s = _activeChannels.has(1);
    parameters.vertexUv2s = _activeChannels.has(2);
    parameters.vertexUv3s = _activeChannels.has(3);
    _activeChannels.clear();
    return parameters;
  }
  function getProgramCacheKey(parameters) {
    const array = [];
    if (parameters.shaderID) {
      array.push(parameters.shaderID);
    } else {
      array.push(parameters.customVertexShaderID);
      array.push(parameters.customFragmentShaderID);
    }
    if (parameters.defines !== void 0) {
      for (const name in parameters.defines) {
        array.push(name);
        array.push(parameters.defines[name]);
      }
    }
    if (parameters.isRawShaderMaterial === false) {
      getProgramCacheKeyParameters(array, parameters);
      getProgramCacheKeyBooleans(array, parameters);
      array.push(renderer.outputColorSpace);
    }
    array.push(parameters.customProgramCacheKey);
    return array.join();
  }
  function getProgramCacheKeyParameters(array, parameters) {
    array.push(parameters.precision);
    array.push(parameters.outputColorSpace);
    array.push(parameters.envMapMode);
    array.push(parameters.envMapCubeUVHeight);
    array.push(parameters.mapUv);
    array.push(parameters.alphaMapUv);
    array.push(parameters.lightMapUv);
    array.push(parameters.aoMapUv);
    array.push(parameters.bumpMapUv);
    array.push(parameters.normalMapUv);
    array.push(parameters.displacementMapUv);
    array.push(parameters.emissiveMapUv);
    array.push(parameters.metalnessMapUv);
    array.push(parameters.roughnessMapUv);
    array.push(parameters.anisotropyMapUv);
    array.push(parameters.clearcoatMapUv);
    array.push(parameters.clearcoatNormalMapUv);
    array.push(parameters.clearcoatRoughnessMapUv);
    array.push(parameters.iridescenceMapUv);
    array.push(parameters.iridescenceThicknessMapUv);
    array.push(parameters.sheenColorMapUv);
    array.push(parameters.sheenRoughnessMapUv);
    array.push(parameters.specularMapUv);
    array.push(parameters.specularColorMapUv);
    array.push(parameters.specularIntensityMapUv);
    array.push(parameters.transmissionMapUv);
    array.push(parameters.thicknessMapUv);
    array.push(parameters.combine);
    array.push(parameters.fogExp2);
    array.push(parameters.sizeAttenuation);
    array.push(parameters.morphTargetsCount);
    array.push(parameters.morphAttributeCount);
    array.push(parameters.numDirLights);
    array.push(parameters.numPointLights);
    array.push(parameters.numSpotLights);
    array.push(parameters.numSpotLightMaps);
    array.push(parameters.numHemiLights);
    array.push(parameters.numRectAreaLights);
    array.push(parameters.numDirLightShadows);
    array.push(parameters.numPointLightShadows);
    array.push(parameters.numSpotLightShadows);
    array.push(parameters.numSpotLightShadowsWithMaps);
    array.push(parameters.numLightProbes);
    array.push(parameters.shadowMapType);
    array.push(parameters.toneMapping);
    array.push(parameters.numClippingPlanes);
    array.push(parameters.numClipIntersection);
    array.push(parameters.depthPacking);
  }
  function getProgramCacheKeyBooleans(array, parameters) {
    _programLayers.disableAll();
    if (parameters.supportsVertexTextures)
      _programLayers.enable(0);
    if (parameters.instancing)
      _programLayers.enable(1);
    if (parameters.instancingColor)
      _programLayers.enable(2);
    if (parameters.instancingMorph)
      _programLayers.enable(3);
    if (parameters.matcap)
      _programLayers.enable(4);
    if (parameters.envMap)
      _programLayers.enable(5);
    if (parameters.normalMapObjectSpace)
      _programLayers.enable(6);
    if (parameters.normalMapTangentSpace)
      _programLayers.enable(7);
    if (parameters.clearcoat)
      _programLayers.enable(8);
    if (parameters.iridescence)
      _programLayers.enable(9);
    if (parameters.alphaTest)
      _programLayers.enable(10);
    if (parameters.vertexColors)
      _programLayers.enable(11);
    if (parameters.vertexAlphas)
      _programLayers.enable(12);
    if (parameters.vertexUv1s)
      _programLayers.enable(13);
    if (parameters.vertexUv2s)
      _programLayers.enable(14);
    if (parameters.vertexUv3s)
      _programLayers.enable(15);
    if (parameters.vertexTangents)
      _programLayers.enable(16);
    if (parameters.anisotropy)
      _programLayers.enable(17);
    if (parameters.alphaHash)
      _programLayers.enable(18);
    if (parameters.batching)
      _programLayers.enable(19);
    if (parameters.dispersion)
      _programLayers.enable(20);
    if (parameters.batchingColor)
      _programLayers.enable(21);
    if (parameters.gradientMap)
      _programLayers.enable(22);
    array.push(_programLayers.mask);
    _programLayers.disableAll();
    if (parameters.fog)
      _programLayers.enable(0);
    if (parameters.useFog)
      _programLayers.enable(1);
    if (parameters.flatShading)
      _programLayers.enable(2);
    if (parameters.logarithmicDepthBuffer)
      _programLayers.enable(3);
    if (parameters.reversedDepthBuffer)
      _programLayers.enable(4);
    if (parameters.skinning)
      _programLayers.enable(5);
    if (parameters.morphTargets)
      _programLayers.enable(6);
    if (parameters.morphNormals)
      _programLayers.enable(7);
    if (parameters.morphColors)
      _programLayers.enable(8);
    if (parameters.premultipliedAlpha)
      _programLayers.enable(9);
    if (parameters.shadowMapEnabled)
      _programLayers.enable(10);
    if (parameters.doubleSided)
      _programLayers.enable(11);
    if (parameters.flipSided)
      _programLayers.enable(12);
    if (parameters.useDepthPacking)
      _programLayers.enable(13);
    if (parameters.dithering)
      _programLayers.enable(14);
    if (parameters.transmission)
      _programLayers.enable(15);
    if (parameters.sheen)
      _programLayers.enable(16);
    if (parameters.opaque)
      _programLayers.enable(17);
    if (parameters.pointsUvs)
      _programLayers.enable(18);
    if (parameters.decodeVideoTexture)
      _programLayers.enable(19);
    if (parameters.decodeVideoTextureEmissive)
      _programLayers.enable(20);
    if (parameters.alphaToCoverage)
      _programLayers.enable(21);
    array.push(_programLayers.mask);
  }
  function getUniforms(material) {
    const shaderID = shaderIDs[material.type];
    let uniforms;
    if (shaderID) {
      const shader = ShaderLib[shaderID];
      uniforms = UniformsUtils.clone(shader.uniforms);
    } else {
      uniforms = material.uniforms;
    }
    return uniforms;
  }
  function acquireProgram(parameters, cacheKey) {
    let program;
    for (let p = 0, pl = programs.length; p < pl; p++) {
      const preexistingProgram = programs[p];
      if (preexistingProgram.cacheKey === cacheKey) {
        program = preexistingProgram;
        ++program.usedTimes;
        break;
      }
    }
    if (program === void 0) {
      program = new WebGLProgram(renderer, cacheKey, parameters, bindingStates);
      programs.push(program);
    }
    return program;
  }
  function releaseProgram(program) {
    if (--program.usedTimes === 0) {
      const i = programs.indexOf(program);
      programs[i] = programs[programs.length - 1];
      programs.pop();
      program.destroy();
    }
  }
  function releaseShaderCache(material) {
    _customShaders.remove(material);
  }
  function dispose() {
    _customShaders.dispose();
  }
  return {
    getParameters,
    getProgramCacheKey,
    getUniforms,
    acquireProgram,
    releaseProgram,
    releaseShaderCache,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs,
    dispose
  };
}
function WebGLProperties() {
  let properties = /* @__PURE__ */ new WeakMap();
  function has(object) {
    return properties.has(object);
  }
  function get(object) {
    let map = properties.get(object);
    if (map === void 0) {
      map = {};
      properties.set(object, map);
    }
    return map;
  }
  function remove(object) {
    properties.delete(object);
  }
  function update(object, key, value) {
    properties.get(object)[key] = value;
  }
  function dispose() {
    properties = /* @__PURE__ */ new WeakMap();
  }
  return {
    has,
    get,
    remove,
    update,
    dispose
  };
}
function painterSortStable(a, b) {
  if (a.groupOrder !== b.groupOrder) {
    return a.groupOrder - b.groupOrder;
  } else if (a.renderOrder !== b.renderOrder) {
    return a.renderOrder - b.renderOrder;
  } else if (a.material.id !== b.material.id) {
    return a.material.id - b.material.id;
  } else if (a.z !== b.z) {
    return a.z - b.z;
  } else {
    return a.id - b.id;
  }
}
function reversePainterSortStable(a, b) {
  if (a.groupOrder !== b.groupOrder) {
    return a.groupOrder - b.groupOrder;
  } else if (a.renderOrder !== b.renderOrder) {
    return a.renderOrder - b.renderOrder;
  } else if (a.z !== b.z) {
    return b.z - a.z;
  } else {
    return a.id - b.id;
  }
}
function WebGLRenderList() {
  const renderItems = [];
  let renderItemsIndex = 0;
  const opaque = [];
  const transmissive = [];
  const transparent = [];
  function init() {
    renderItemsIndex = 0;
    opaque.length = 0;
    transmissive.length = 0;
    transparent.length = 0;
  }
  function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
    let renderItem = renderItems[renderItemsIndex];
    if (renderItem === void 0) {
      renderItem = {
        id: object.id,
        object,
        geometry,
        material,
        groupOrder,
        renderOrder: object.renderOrder,
        z,
        group
      };
      renderItems[renderItemsIndex] = renderItem;
    } else {
      renderItem.id = object.id;
      renderItem.object = object;
      renderItem.geometry = geometry;
      renderItem.material = material;
      renderItem.groupOrder = groupOrder;
      renderItem.renderOrder = object.renderOrder;
      renderItem.z = z;
      renderItem.group = group;
    }
    renderItemsIndex++;
    return renderItem;
  }
  function push(object, geometry, material, groupOrder, z, group) {
    const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
    if (material.transmission > 0) {
      transmissive.push(renderItem);
    } else if (material.transparent === true) {
      transparent.push(renderItem);
    } else {
      opaque.push(renderItem);
    }
  }
  function unshift(object, geometry, material, groupOrder, z, group) {
    const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
    if (material.transmission > 0) {
      transmissive.unshift(renderItem);
    } else if (material.transparent === true) {
      transparent.unshift(renderItem);
    } else {
      opaque.unshift(renderItem);
    }
  }
  function sort(customOpaqueSort, customTransparentSort) {
    if (opaque.length > 1) opaque.sort(customOpaqueSort || painterSortStable);
    if (transmissive.length > 1) transmissive.sort(customTransparentSort || reversePainterSortStable);
    if (transparent.length > 1) transparent.sort(customTransparentSort || reversePainterSortStable);
  }
  function finish() {
    for (let i = renderItemsIndex, il = renderItems.length; i < il; i++) {
      const renderItem = renderItems[i];
      if (renderItem.id === null) break;
      renderItem.id = null;
      renderItem.object = null;
      renderItem.geometry = null;
      renderItem.material = null;
      renderItem.group = null;
    }
  }
  return {
    opaque,
    transmissive,
    transparent,
    init,
    push,
    unshift,
    finish,
    sort
  };
}
function WebGLRenderLists() {
  let lists = /* @__PURE__ */ new WeakMap();
  function get(scene, renderCallDepth) {
    const listArray = lists.get(scene);
    let list;
    if (listArray === void 0) {
      list = new WebGLRenderList();
      lists.set(scene, [list]);
    } else {
      if (renderCallDepth >= listArray.length) {
        list = new WebGLRenderList();
        listArray.push(list);
      } else {
        list = listArray[renderCallDepth];
      }
    }
    return list;
  }
  function dispose() {
    lists = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose
  };
}
function UniformsCache() {
  const lights = {};
  return {
    get: function(light) {
      if (lights[light.id] !== void 0) {
        return lights[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            direction: new Vector3(),
            color: new Color()
          };
          break;
        case "SpotLight":
          uniforms = {
            position: new Vector3(),
            direction: new Vector3(),
            color: new Color(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          uniforms = {
            position: new Vector3(),
            color: new Color(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          uniforms = {
            direction: new Vector3(),
            skyColor: new Color(),
            groundColor: new Color()
          };
          break;
        case "RectAreaLight":
          uniforms = {
            color: new Color(),
            position: new Vector3(),
            halfWidth: new Vector3(),
            halfHeight: new Vector3()
          };
          break;
      }
      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}
function ShadowUniformsCache() {
  const lights = {};
  return {
    get: function(light) {
      if (lights[light.id] !== void 0) {
        return lights[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2()
          };
          break;
        case "SpotLight":
          uniforms = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2()
          };
          break;
        case "PointLight":
          uniforms = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}
function shadowCastingAndTexturingLightsFirst(lightA, lightB) {
  return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function WebGLLights(extensions) {
  const cache = new UniformsCache();
  const shadowCache = ShadowUniformsCache();
  const state = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1,
      numLightProbes: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0,
    numLightProbes: 0
  };
  for (let i = 0; i < 9; i++) state.probe.push(new Vector3());
  const vector3 = new Vector3();
  const matrix4 = new Matrix4();
  const matrix42 = new Matrix4();
  function setup(lights) {
    let r = 0, g = 0, b = 0;
    for (let i = 0; i < 9; i++) state.probe[i].set(0, 0, 0);
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    let numDirectionalShadows = 0;
    let numPointShadows = 0;
    let numSpotShadows = 0;
    let numSpotMaps = 0;
    let numSpotShadowsWithMaps = 0;
    let numLightProbes = 0;
    lights.sort(shadowCastingAndTexturingLightsFirst);
    for (let i = 0, l = lights.length; i < l; i++) {
      const light = lights[i];
      const color = light.color;
      const intensity = light.intensity;
      const distance = light.distance;
      const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
      if (light.isAmbientLight) {
        r += color.r * intensity;
        g += color.g * intensity;
        b += color.b * intensity;
      } else if (light.isLightProbe) {
        for (let j = 0; j < 9; j++) {
          state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
        }
        numLightProbes++;
      } else if (light.isDirectionalLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity);
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowIntensity = shadow.intensity;
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          state.directionalShadow[directionalLength] = shadowUniforms;
          state.directionalShadowMap[directionalLength] = shadowMap;
          state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
          numDirectionalShadows++;
        }
        state.directional[directionalLength] = uniforms;
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = cache.get(light);
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.color.copy(color).multiplyScalar(intensity);
        uniforms.distance = distance;
        uniforms.coneCos = Math.cos(light.angle);
        uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
        uniforms.decay = light.decay;
        state.spot[spotLength] = uniforms;
        const shadow = light.shadow;
        if (light.map) {
          state.spotLightMap[numSpotMaps] = light.map;
          numSpotMaps++;
          shadow.updateMatrices(light);
          if (light.castShadow) numSpotShadowsWithMaps++;
        }
        state.spotLightMatrix[spotLength] = shadow.matrix;
        if (light.castShadow) {
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowIntensity = shadow.intensity;
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          state.spotShadow[spotLength] = shadowUniforms;
          state.spotShadowMap[spotLength] = shadowMap;
          numSpotShadows++;
        }
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(color).multiplyScalar(intensity);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        state.rectArea[rectAreaLength] = uniforms;
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity);
        uniforms.distance = light.distance;
        uniforms.decay = light.decay;
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowIntensity = shadow.intensity;
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          shadowUniforms.shadowCameraNear = shadow.camera.near;
          shadowUniforms.shadowCameraFar = shadow.camera.far;
          state.pointShadow[pointLength] = shadowUniforms;
          state.pointShadowMap[pointLength] = shadowMap;
          state.pointShadowMatrix[pointLength] = light.shadow.matrix;
          numPointShadows++;
        }
        state.point[pointLength] = uniforms;
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = cache.get(light);
        uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
        uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
        state.hemi[hemiLength] = uniforms;
        hemiLength++;
      }
    }
    if (rectAreaLength > 0) {
      if (extensions.has("OES_texture_float_linear") === true) {
        state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
        state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
      } else {
        state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
        state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;
      }
    }
    state.ambient[0] = r;
    state.ambient[1] = g;
    state.ambient[2] = b;
    const hash = state.hash;
    if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
      state.directional.length = directionalLength;
      state.spot.length = spotLength;
      state.rectArea.length = rectAreaLength;
      state.point.length = pointLength;
      state.hemi.length = hemiLength;
      state.directionalShadow.length = numDirectionalShadows;
      state.directionalShadowMap.length = numDirectionalShadows;
      state.pointShadow.length = numPointShadows;
      state.pointShadowMap.length = numPointShadows;
      state.spotShadow.length = numSpotShadows;
      state.spotShadowMap.length = numSpotShadows;
      state.directionalShadowMatrix.length = numDirectionalShadows;
      state.pointShadowMatrix.length = numPointShadows;
      state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
      state.spotLightMap.length = numSpotMaps;
      state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
      state.numLightProbes = numLightProbes;
      hash.directionalLength = directionalLength;
      hash.pointLength = pointLength;
      hash.spotLength = spotLength;
      hash.rectAreaLength = rectAreaLength;
      hash.hemiLength = hemiLength;
      hash.numDirectionalShadows = numDirectionalShadows;
      hash.numPointShadows = numPointShadows;
      hash.numSpotShadows = numSpotShadows;
      hash.numSpotMaps = numSpotMaps;
      hash.numLightProbes = numLightProbes;
      state.version = nextVersion++;
    }
  }
  function setupView(lights, camera) {
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    const viewMatrix = camera.matrixWorldInverse;
    for (let i = 0, l = lights.length; i < l; i++) {
      const light = lights[i];
      if (light.isDirectionalLight) {
        const uniforms = state.directional[directionalLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = state.spot[spotLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = state.rectArea[rectAreaLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        matrix42.identity();
        matrix4.copy(light.matrixWorld);
        matrix4.premultiply(viewMatrix);
        matrix42.extractRotation(matrix4);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        uniforms.halfWidth.applyMatrix4(matrix42);
        uniforms.halfHeight.applyMatrix4(matrix42);
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = state.point[pointLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = state.hemi[hemiLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        uniforms.direction.transformDirection(viewMatrix);
        hemiLength++;
      }
    }
  }
  return {
    setup,
    setupView,
    state
  };
}
function WebGLRenderState(extensions) {
  const lights = new WebGLLights(extensions);
  const lightsArray = [];
  const shadowsArray = [];
  function init(camera) {
    state.camera = camera;
    lightsArray.length = 0;
    shadowsArray.length = 0;
  }
  function pushLight(light) {
    lightsArray.push(light);
  }
  function pushShadow(shadowLight) {
    shadowsArray.push(shadowLight);
  }
  function setupLights() {
    lights.setup(lightsArray);
  }
  function setupLightsView(camera) {
    lights.setupView(lightsArray, camera);
  }
  const state = {
    lightsArray,
    shadowsArray,
    camera: null,
    lights,
    transmissionRenderTarget: {}
  };
  return {
    init,
    state,
    setupLights,
    setupLightsView,
    pushLight,
    pushShadow
  };
}
function WebGLRenderStates(extensions) {
  let renderStates = /* @__PURE__ */ new WeakMap();
  function get(scene, renderCallDepth = 0) {
    const renderStateArray = renderStates.get(scene);
    let renderState;
    if (renderStateArray === void 0) {
      renderState = new WebGLRenderState(extensions);
      renderStates.set(scene, [renderState]);
    } else {
      if (renderCallDepth >= renderStateArray.length) {
        renderState = new WebGLRenderState(extensions);
        renderStateArray.push(renderState);
      } else {
        renderState = renderStateArray[renderCallDepth];
      }
    }
    return renderState;
  }
  function dispose() {
    renderStates = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose
  };
}
function WebGLShadowMap(renderer, objects, capabilities) {
  let _frustum = new Frustum();
  const _shadowMapSize = new Vector2(), _viewportSize = new Vector2(), _viewport = new Vector4(), _depthMaterial = new MeshDepthMaterial({ depthPacking: RGBADepthPacking }), _distanceMaterial = new MeshDistanceMaterial(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
  const shadowSide = { [FrontSide]: BackSide, [BackSide]: FrontSide, [DoubleSide]: DoubleSide };
  const shadowMaterialVertical = new ShaderMaterial({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Vector2() },
      radius: { value: 4 }
    },
    vertexShader: vertex,
    fragmentShader: fragment
  });
  const shadowMaterialHorizontal = shadowMaterialVertical.clone();
  shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
  const fullScreenTri = new BufferGeometry();
  fullScreenTri.setAttribute(
    "position",
    new BufferAttribute(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const fullScreenMesh = new Mesh(fullScreenTri, shadowMaterialVertical);
  const scope = this;
  this.enabled = false;
  this.autoUpdate = true;
  this.needsUpdate = false;
  this.type = PCFShadowMap;
  let _previousType = this.type;
  this.render = function(lights, scene, camera) {
    if (scope.enabled === false) return;
    if (scope.autoUpdate === false && scope.needsUpdate === false) return;
    if (lights.length === 0) return;
    const currentRenderTarget = renderer.getRenderTarget();
    const activeCubeFace = renderer.getActiveCubeFace();
    const activeMipmapLevel = renderer.getActiveMipmapLevel();
    const _state = renderer.state;
    _state.setBlending(NoBlending);
    if (_state.buffers.depth.getReversed() === true) {
      _state.buffers.color.setClear(0, 0, 0, 0);
    } else {
      _state.buffers.color.setClear(1, 1, 1, 1);
    }
    _state.buffers.depth.setTest(true);
    _state.setScissorTest(false);
    const toVSM = _previousType !== VSMShadowMap && this.type === VSMShadowMap;
    const fromVSM = _previousType === VSMShadowMap && this.type !== VSMShadowMap;
    for (let i = 0, il = lights.length; i < il; i++) {
      const light = lights[i];
      const shadow = light.shadow;
      if (shadow === void 0) {
        console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
        continue;
      }
      if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
      _shadowMapSize.copy(shadow.mapSize);
      const shadowFrameExtents = shadow.getFrameExtents();
      _shadowMapSize.multiply(shadowFrameExtents);
      _viewportSize.copy(shadow.mapSize);
      if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
        if (_shadowMapSize.x > _maxTextureSize) {
          _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
          _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
          shadow.mapSize.x = _viewportSize.x;
        }
        if (_shadowMapSize.y > _maxTextureSize) {
          _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
          _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
          shadow.mapSize.y = _viewportSize.y;
        }
      }
      if (shadow.map === null || toVSM === true || fromVSM === true) {
        const pars = this.type !== VSMShadowMap ? { minFilter: NearestFilter, magFilter: NearestFilter } : {};
        if (shadow.map !== null) {
          shadow.map.dispose();
        }
        shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
        shadow.map.texture.name = light.name + ".shadowMap";
        shadow.camera.updateProjectionMatrix();
      }
      renderer.setRenderTarget(shadow.map);
      renderer.clear();
      const viewportCount = shadow.getViewportCount();
      for (let vp = 0; vp < viewportCount; vp++) {
        const viewport = shadow.getViewport(vp);
        _viewport.set(
          _viewportSize.x * viewport.x,
          _viewportSize.y * viewport.y,
          _viewportSize.x * viewport.z,
          _viewportSize.y * viewport.w
        );
        _state.viewport(_viewport);
        shadow.updateMatrices(light, vp);
        _frustum = shadow.getFrustum();
        renderObject(scene, camera, shadow.camera, light, this.type);
      }
      if (shadow.isPointLightShadow !== true && this.type === VSMShadowMap) {
        VSMPass(shadow, camera);
      }
      shadow.needsUpdate = false;
    }
    _previousType = this.type;
    scope.needsUpdate = false;
    renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
  };
  function VSMPass(shadow, camera) {
    const geometry = objects.update(fullScreenMesh);
    if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
      shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
      shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
      shadowMaterialVertical.needsUpdate = true;
      shadowMaterialHorizontal.needsUpdate = true;
    }
    if (shadow.mapPass === null) {
      shadow.mapPass = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y);
    }
    shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
    shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialVertical.uniforms.radius.value = shadow.radius;
    renderer.setRenderTarget(shadow.mapPass);
    renderer.clear();
    renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
    shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
    shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
    renderer.setRenderTarget(shadow.map);
    renderer.clear();
    renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
  }
  function getDepthMaterial(object, material, light, type) {
    let result = null;
    const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
    if (customMaterial !== void 0) {
      result = customMaterial;
    } else {
      result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
      if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0 || material.alphaToCoverage === true) {
        const keyA = result.uuid, keyB = material.uuid;
        let materialsForVariant = _materialCache[keyA];
        if (materialsForVariant === void 0) {
          materialsForVariant = {};
          _materialCache[keyA] = materialsForVariant;
        }
        let cachedMaterial = materialsForVariant[keyB];
        if (cachedMaterial === void 0) {
          cachedMaterial = result.clone();
          materialsForVariant[keyB] = cachedMaterial;
          material.addEventListener("dispose", onMaterialDispose);
        }
        result = cachedMaterial;
      }
    }
    result.visible = material.visible;
    result.wireframe = material.wireframe;
    if (type === VSMShadowMap) {
      result.side = material.shadowSide !== null ? material.shadowSide : material.side;
    } else {
      result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
    }
    result.alphaMap = material.alphaMap;
    result.alphaTest = material.alphaToCoverage === true ? 0.5 : material.alphaTest;
    result.map = material.map;
    result.clipShadows = material.clipShadows;
    result.clippingPlanes = material.clippingPlanes;
    result.clipIntersection = material.clipIntersection;
    result.displacementMap = material.displacementMap;
    result.displacementScale = material.displacementScale;
    result.displacementBias = material.displacementBias;
    result.wireframeLinewidth = material.wireframeLinewidth;
    result.linewidth = material.linewidth;
    if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
      const materialProperties = renderer.properties.get(result);
      materialProperties.light = light;
    }
    return result;
  }
  function renderObject(object, camera, shadowCamera, light, type) {
    if (object.visible === false) return;
    const visible = object.layers.test(camera.layers);
    if (visible && (object.isMesh || object.isLine || object.isPoints)) {
      if ((object.castShadow || object.receiveShadow && type === VSMShadowMap) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
        object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
        const geometry = objects.update(object);
        const material = object.material;
        if (Array.isArray(material)) {
          const groups = geometry.groups;
          for (let k = 0, kl = groups.length; k < kl; k++) {
            const group = groups[k];
            const groupMaterial = material[group.materialIndex];
            if (groupMaterial && groupMaterial.visible) {
              const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
              object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
              renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
              object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
            }
          }
        } else if (material.visible) {
          const depthMaterial = getDepthMaterial(object, material, light, type);
          object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
          renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
          object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
        }
      }
    }
    const children = object.children;
    for (let i = 0, l = children.length; i < l; i++) {
      renderObject(children[i], camera, shadowCamera, light, type);
    }
  }
  function onMaterialDispose(event) {
    const material = event.target;
    material.removeEventListener("dispose", onMaterialDispose);
    for (const id in _materialCache) {
      const cache = _materialCache[id];
      const uuid = event.target.uuid;
      if (uuid in cache) {
        const shadowMaterial = cache[uuid];
        shadowMaterial.dispose();
        delete cache[uuid];
      }
    }
  }
}
function WebGLState(gl, extensions) {
  function ColorBuffer() {
    let locked = false;
    const color = new Vector4();
    let currentColorMask = null;
    const currentColorClear = new Vector4(0, 0, 0, 0);
    return {
      setMask: function(colorMask) {
        if (currentColorMask !== colorMask && !locked) {
          gl.colorMask(colorMask, colorMask, colorMask, colorMask);
          currentColorMask = colorMask;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(r, g, b, a, premultipliedAlpha) {
        if (premultipliedAlpha === true) {
          r *= a;
          g *= a;
          b *= a;
        }
        color.set(r, g, b, a);
        if (currentColorClear.equals(color) === false) {
          gl.clearColor(r, g, b, a);
          currentColorClear.copy(color);
        }
      },
      reset: function() {
        locked = false;
        currentColorMask = null;
        currentColorClear.set(-1, 0, 0, 0);
      }
    };
  }
  function DepthBuffer() {
    let locked = false;
    let currentReversed = false;
    let currentDepthMask = null;
    let currentDepthFunc = null;
    let currentDepthClear = null;
    return {
      setReversed: function(reversed) {
        if (currentReversed !== reversed) {
          const ext = extensions.get("EXT_clip_control");
          if (reversed) {
            ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
          } else {
            ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
          }
          currentReversed = reversed;
          const oldDepth = currentDepthClear;
          currentDepthClear = null;
          this.setClear(oldDepth);
        }
      },
      getReversed: function() {
        return currentReversed;
      },
      setTest: function(depthTest) {
        if (depthTest) {
          enable(gl.DEPTH_TEST);
        } else {
          disable(gl.DEPTH_TEST);
        }
      },
      setMask: function(depthMask) {
        if (currentDepthMask !== depthMask && !locked) {
          gl.depthMask(depthMask);
          currentDepthMask = depthMask;
        }
      },
      setFunc: function(depthFunc) {
        if (currentReversed) depthFunc = reversedFuncs[depthFunc];
        if (currentDepthFunc !== depthFunc) {
          switch (depthFunc) {
            case NeverDepth:
              gl.depthFunc(gl.NEVER);
              break;
            case AlwaysDepth:
              gl.depthFunc(gl.ALWAYS);
              break;
            case LessDepth:
              gl.depthFunc(gl.LESS);
              break;
            case LessEqualDepth:
              gl.depthFunc(gl.LEQUAL);
              break;
            case EqualDepth:
              gl.depthFunc(gl.EQUAL);
              break;
            case GreaterEqualDepth:
              gl.depthFunc(gl.GEQUAL);
              break;
            case GreaterDepth:
              gl.depthFunc(gl.GREATER);
              break;
            case NotEqualDepth:
              gl.depthFunc(gl.NOTEQUAL);
              break;
            default:
              gl.depthFunc(gl.LEQUAL);
          }
          currentDepthFunc = depthFunc;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(depth) {
        if (currentDepthClear !== depth) {
          if (currentReversed) {
            depth = 1 - depth;
          }
          gl.clearDepth(depth);
          currentDepthClear = depth;
        }
      },
      reset: function() {
        locked = false;
        currentDepthMask = null;
        currentDepthFunc = null;
        currentDepthClear = null;
        currentReversed = false;
      }
    };
  }
  function StencilBuffer() {
    let locked = false;
    let currentStencilMask = null;
    let currentStencilFunc = null;
    let currentStencilRef = null;
    let currentStencilFuncMask = null;
    let currentStencilFail = null;
    let currentStencilZFail = null;
    let currentStencilZPass = null;
    let currentStencilClear = null;
    return {
      setTest: function(stencilTest) {
        if (!locked) {
          if (stencilTest) {
            enable(gl.STENCIL_TEST);
          } else {
            disable(gl.STENCIL_TEST);
          }
        }
      },
      setMask: function(stencilMask) {
        if (currentStencilMask !== stencilMask && !locked) {
          gl.stencilMask(stencilMask);
          currentStencilMask = stencilMask;
        }
      },
      setFunc: function(stencilFunc, stencilRef, stencilMask) {
        if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
          gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
          currentStencilFunc = stencilFunc;
          currentStencilRef = stencilRef;
          currentStencilFuncMask = stencilMask;
        }
      },
      setOp: function(stencilFail, stencilZFail, stencilZPass) {
        if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
          gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
          currentStencilFail = stencilFail;
          currentStencilZFail = stencilZFail;
          currentStencilZPass = stencilZPass;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(stencil) {
        if (currentStencilClear !== stencil) {
          gl.clearStencil(stencil);
          currentStencilClear = stencil;
        }
      },
      reset: function() {
        locked = false;
        currentStencilMask = null;
        currentStencilFunc = null;
        currentStencilRef = null;
        currentStencilFuncMask = null;
        currentStencilFail = null;
        currentStencilZFail = null;
        currentStencilZPass = null;
        currentStencilClear = null;
      }
    };
  }
  const colorBuffer = new ColorBuffer();
  const depthBuffer = new DepthBuffer();
  const stencilBuffer = new StencilBuffer();
  const uboBindings = /* @__PURE__ */ new WeakMap();
  const uboProgramMap = /* @__PURE__ */ new WeakMap();
  let enabledCapabilities = {};
  let currentBoundFramebuffers = {};
  let currentDrawbuffers = /* @__PURE__ */ new WeakMap();
  let defaultDrawbuffers = [];
  let currentProgram = null;
  let currentBlendingEnabled = false;
  let currentBlending = null;
  let currentBlendEquation = null;
  let currentBlendSrc = null;
  let currentBlendDst = null;
  let currentBlendEquationAlpha = null;
  let currentBlendSrcAlpha = null;
  let currentBlendDstAlpha = null;
  let currentBlendColor = new Color(0, 0, 0);
  let currentBlendAlpha = 0;
  let currentPremultipledAlpha = false;
  let currentFlipSided = null;
  let currentCullFace = null;
  let currentLineWidth = null;
  let currentPolygonOffsetFactor = null;
  let currentPolygonOffsetUnits = null;
  const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  let lineWidthAvailable = false;
  let version = 0;
  const glVersion = gl.getParameter(gl.VERSION);
  if (glVersion.indexOf("WebGL") !== -1) {
    version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version >= 1;
  } else if (glVersion.indexOf("OpenGL ES") !== -1) {
    version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version >= 2;
  }
  let currentTextureSlot = null;
  let currentBoundTextures = {};
  const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
  const viewportParam = gl.getParameter(gl.VIEWPORT);
  const currentScissor = new Vector4().fromArray(scissorParam);
  const currentViewport = new Vector4().fromArray(viewportParam);
  function createTexture(type, target, count, dimensions) {
    const data = new Uint8Array(4);
    const texture = gl.createTexture();
    gl.bindTexture(type, texture);
    gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    for (let i = 0; i < count; i++) {
      if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) {
        gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
      } else {
        gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
      }
    }
    return texture;
  }
  const emptyTextures = {};
  emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
  emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
  emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
  emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
  colorBuffer.setClear(0, 0, 0, 1);
  depthBuffer.setClear(1);
  stencilBuffer.setClear(0);
  enable(gl.DEPTH_TEST);
  depthBuffer.setFunc(LessEqualDepth);
  setFlipSided(false);
  setCullFace(CullFaceBack);
  enable(gl.CULL_FACE);
  setBlending(NoBlending);
  function enable(id) {
    if (enabledCapabilities[id] !== true) {
      gl.enable(id);
      enabledCapabilities[id] = true;
    }
  }
  function disable(id) {
    if (enabledCapabilities[id] !== false) {
      gl.disable(id);
      enabledCapabilities[id] = false;
    }
  }
  function bindFramebuffer(target, framebuffer) {
    if (currentBoundFramebuffers[target] !== framebuffer) {
      gl.bindFramebuffer(target, framebuffer);
      currentBoundFramebuffers[target] = framebuffer;
      if (target === gl.DRAW_FRAMEBUFFER) {
        currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
      }
      if (target === gl.FRAMEBUFFER) {
        currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
      }
      return true;
    }
    return false;
  }
  function drawBuffers(renderTarget, framebuffer) {
    let drawBuffers2 = defaultDrawbuffers;
    let needsUpdate = false;
    if (renderTarget) {
      drawBuffers2 = currentDrawbuffers.get(framebuffer);
      if (drawBuffers2 === void 0) {
        drawBuffers2 = [];
        currentDrawbuffers.set(framebuffer, drawBuffers2);
      }
      const textures = renderTarget.textures;
      if (drawBuffers2.length !== textures.length || drawBuffers2[0] !== gl.COLOR_ATTACHMENT0) {
        for (let i = 0, il = textures.length; i < il; i++) {
          drawBuffers2[i] = gl.COLOR_ATTACHMENT0 + i;
        }
        drawBuffers2.length = textures.length;
        needsUpdate = true;
      }
    } else {
      if (drawBuffers2[0] !== gl.BACK) {
        drawBuffers2[0] = gl.BACK;
        needsUpdate = true;
      }
    }
    if (needsUpdate) {
      gl.drawBuffers(drawBuffers2);
    }
  }
  function useProgram(program) {
    if (currentProgram !== program) {
      gl.useProgram(program);
      currentProgram = program;
      return true;
    }
    return false;
  }
  const equationToGL = {
    [AddEquation]: gl.FUNC_ADD,
    [SubtractEquation]: gl.FUNC_SUBTRACT,
    [ReverseSubtractEquation]: gl.FUNC_REVERSE_SUBTRACT
  };
  equationToGL[MinEquation] = gl.MIN;
  equationToGL[MaxEquation] = gl.MAX;
  const factorToGL = {
    [ZeroFactor]: gl.ZERO,
    [OneFactor]: gl.ONE,
    [SrcColorFactor]: gl.SRC_COLOR,
    [SrcAlphaFactor]: gl.SRC_ALPHA,
    [SrcAlphaSaturateFactor]: gl.SRC_ALPHA_SATURATE,
    [DstColorFactor]: gl.DST_COLOR,
    [DstAlphaFactor]: gl.DST_ALPHA,
    [OneMinusSrcColorFactor]: gl.ONE_MINUS_SRC_COLOR,
    [OneMinusSrcAlphaFactor]: gl.ONE_MINUS_SRC_ALPHA,
    [OneMinusDstColorFactor]: gl.ONE_MINUS_DST_COLOR,
    [OneMinusDstAlphaFactor]: gl.ONE_MINUS_DST_ALPHA,
    [ConstantColorFactor]: gl.CONSTANT_COLOR,
    [OneMinusConstantColorFactor]: gl.ONE_MINUS_CONSTANT_COLOR,
    [ConstantAlphaFactor]: gl.CONSTANT_ALPHA,
    [OneMinusConstantAlphaFactor]: gl.ONE_MINUS_CONSTANT_ALPHA
  };
  function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
    if (blending === NoBlending) {
      if (currentBlendingEnabled === true) {
        disable(gl.BLEND);
        currentBlendingEnabled = false;
      }
      return;
    }
    if (currentBlendingEnabled === false) {
      enable(gl.BLEND);
      currentBlendingEnabled = true;
    }
    if (blending !== CustomBlending) {
      if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
        if (currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation) {
          gl.blendEquation(gl.FUNC_ADD);
          currentBlendEquation = AddEquation;
          currentBlendEquationAlpha = AddEquation;
        }
        if (premultipliedAlpha) {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
              break;
            case AdditiveBlending:
              gl.blendFunc(gl.ONE, gl.ONE);
              break;
            case SubtractiveBlending:
              gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
              break;
            case MultiplyBlending:
              gl.blendFuncSeparate(gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        } else {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
              break;
            case AdditiveBlending:
              gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
              break;
            case SubtractiveBlending:
              console.error("THREE.WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
              break;
            case MultiplyBlending:
              console.error("THREE.WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        }
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor.set(0, 0, 0);
        currentBlendAlpha = 0;
        currentBlending = blending;
        currentPremultipledAlpha = premultipliedAlpha;
      }
      return;
    }
    blendEquationAlpha = blendEquationAlpha || blendEquation;
    blendSrcAlpha = blendSrcAlpha || blendSrc;
    blendDstAlpha = blendDstAlpha || blendDst;
    if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
      gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
      currentBlendEquation = blendEquation;
      currentBlendEquationAlpha = blendEquationAlpha;
    }
    if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
      gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
      currentBlendSrc = blendSrc;
      currentBlendDst = blendDst;
      currentBlendSrcAlpha = blendSrcAlpha;
      currentBlendDstAlpha = blendDstAlpha;
    }
    if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
      gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
      currentBlendColor.copy(blendColor);
      currentBlendAlpha = blendAlpha;
    }
    currentBlending = blending;
    currentPremultipledAlpha = false;
  }
  function setMaterial(material, frontFaceCW) {
    material.side === DoubleSide ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
    let flipSided = material.side === BackSide;
    if (frontFaceCW) flipSided = !flipSided;
    setFlipSided(flipSided);
    material.blending === NormalBlending && material.transparent === false ? setBlending(NoBlending) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
    depthBuffer.setFunc(material.depthFunc);
    depthBuffer.setTest(material.depthTest);
    depthBuffer.setMask(material.depthWrite);
    colorBuffer.setMask(material.colorWrite);
    const stencilWrite = material.stencilWrite;
    stencilBuffer.setTest(stencilWrite);
    if (stencilWrite) {
      stencilBuffer.setMask(material.stencilWriteMask);
      stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
      stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
    }
    setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
    material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
  }
  function setFlipSided(flipSided) {
    if (currentFlipSided !== flipSided) {
      if (flipSided) {
        gl.frontFace(gl.CW);
      } else {
        gl.frontFace(gl.CCW);
      }
      currentFlipSided = flipSided;
    }
  }
  function setCullFace(cullFace) {
    if (cullFace !== CullFaceNone) {
      enable(gl.CULL_FACE);
      if (cullFace !== currentCullFace) {
        if (cullFace === CullFaceBack) {
          gl.cullFace(gl.BACK);
        } else if (cullFace === CullFaceFront) {
          gl.cullFace(gl.FRONT);
        } else {
          gl.cullFace(gl.FRONT_AND_BACK);
        }
      }
    } else {
      disable(gl.CULL_FACE);
    }
    currentCullFace = cullFace;
  }
  function setLineWidth(width) {
    if (width !== currentLineWidth) {
      if (lineWidthAvailable) gl.lineWidth(width);
      currentLineWidth = width;
    }
  }
  function setPolygonOffset(polygonOffset, factor, units) {
    if (polygonOffset) {
      enable(gl.POLYGON_OFFSET_FILL);
      if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
        gl.polygonOffset(factor, units);
        currentPolygonOffsetFactor = factor;
        currentPolygonOffsetUnits = units;
      }
    } else {
      disable(gl.POLYGON_OFFSET_FILL);
    }
  }
  function setScissorTest(scissorTest) {
    if (scissorTest) {
      enable(gl.SCISSOR_TEST);
    } else {
      disable(gl.SCISSOR_TEST);
    }
  }
  function activeTexture(webglSlot) {
    if (webglSlot === void 0) webglSlot = gl.TEXTURE0 + maxTextures - 1;
    if (currentTextureSlot !== webglSlot) {
      gl.activeTexture(webglSlot);
      currentTextureSlot = webglSlot;
    }
  }
  function bindTexture(webglType, webglTexture, webglSlot) {
    if (webglSlot === void 0) {
      if (currentTextureSlot === null) {
        webglSlot = gl.TEXTURE0 + maxTextures - 1;
      } else {
        webglSlot = currentTextureSlot;
      }
    }
    let boundTexture = currentBoundTextures[webglSlot];
    if (boundTexture === void 0) {
      boundTexture = { type: void 0, texture: void 0 };
      currentBoundTextures[webglSlot] = boundTexture;
    }
    if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
      if (currentTextureSlot !== webglSlot) {
        gl.activeTexture(webglSlot);
        currentTextureSlot = webglSlot;
      }
      gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
      boundTexture.type = webglType;
      boundTexture.texture = webglTexture;
    }
  }
  function unbindTexture() {
    const boundTexture = currentBoundTextures[currentTextureSlot];
    if (boundTexture !== void 0 && boundTexture.type !== void 0) {
      gl.bindTexture(boundTexture.type, null);
      boundTexture.type = void 0;
      boundTexture.texture = void 0;
    }
  }
  function compressedTexImage2D() {
    try {
      gl.compressedTexImage2D(...arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function compressedTexImage3D() {
    try {
      gl.compressedTexImage3D(...arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texSubImage2D() {
    try {
      gl.texSubImage2D(...arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texSubImage3D() {
    try {
      gl.texSubImage3D(...arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function compressedTexSubImage2D() {
    try {
      gl.compressedTexSubImage2D(...arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function compressedTexSubImage3D() {
    try {
      gl.compressedTexSubImage3D(...arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texStorage2D() {
    try {
      gl.texStorage2D(...arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texStorage3D() {
    try {
      gl.texStorage3D(...arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texImage2D() {
    try {
      gl.texImage2D(...arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texImage3D() {
    try {
      gl.texImage3D(...arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function scissor(scissor2) {
    if (currentScissor.equals(scissor2) === false) {
      gl.scissor(scissor2.x, scissor2.y, scissor2.z, scissor2.w);
      currentScissor.copy(scissor2);
    }
  }
  function viewport(viewport2) {
    if (currentViewport.equals(viewport2) === false) {
      gl.viewport(viewport2.x, viewport2.y, viewport2.z, viewport2.w);
      currentViewport.copy(viewport2);
    }
  }
  function updateUBOMapping(uniformsGroup, program) {
    let mapping = uboProgramMap.get(program);
    if (mapping === void 0) {
      mapping = /* @__PURE__ */ new WeakMap();
      uboProgramMap.set(program, mapping);
    }
    let blockIndex = mapping.get(uniformsGroup);
    if (blockIndex === void 0) {
      blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
      mapping.set(uniformsGroup, blockIndex);
    }
  }
  function uniformBlockBinding(uniformsGroup, program) {
    const mapping = uboProgramMap.get(program);
    const blockIndex = mapping.get(uniformsGroup);
    if (uboBindings.get(program) !== blockIndex) {
      gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
      uboBindings.set(program, blockIndex);
    }
  }
  function reset() {
    gl.disable(gl.BLEND);
    gl.disable(gl.CULL_FACE);
    gl.disable(gl.DEPTH_TEST);
    gl.disable(gl.POLYGON_OFFSET_FILL);
    gl.disable(gl.SCISSOR_TEST);
    gl.disable(gl.STENCIL_TEST);
    gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    gl.blendEquation(gl.FUNC_ADD);
    gl.blendFunc(gl.ONE, gl.ZERO);
    gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
    gl.blendColor(0, 0, 0, 0);
    gl.colorMask(true, true, true, true);
    gl.clearColor(0, 0, 0, 0);
    gl.depthMask(true);
    gl.depthFunc(gl.LESS);
    depthBuffer.setReversed(false);
    gl.clearDepth(1);
    gl.stencilMask(4294967295);
    gl.stencilFunc(gl.ALWAYS, 0, 4294967295);
    gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    gl.clearStencil(0);
    gl.cullFace(gl.BACK);
    gl.frontFace(gl.CCW);
    gl.polygonOffset(0, 0);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
    gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
    gl.useProgram(null);
    gl.lineWidth(1);
    gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
    gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
    enabledCapabilities = {};
    currentTextureSlot = null;
    currentBoundTextures = {};
    currentBoundFramebuffers = {};
    currentDrawbuffers = /* @__PURE__ */ new WeakMap();
    defaultDrawbuffers = [];
    currentProgram = null;
    currentBlendingEnabled = false;
    currentBlending = null;
    currentBlendEquation = null;
    currentBlendSrc = null;
    currentBlendDst = null;
    currentBlendEquationAlpha = null;
    currentBlendSrcAlpha = null;
    currentBlendDstAlpha = null;
    currentBlendColor = new Color(0, 0, 0);
    currentBlendAlpha = 0;
    currentPremultipledAlpha = false;
    currentFlipSided = null;
    currentCullFace = null;
    currentLineWidth = null;
    currentPolygonOffsetFactor = null;
    currentPolygonOffsetUnits = null;
    currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
    currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
    colorBuffer.reset();
    depthBuffer.reset();
    stencilBuffer.reset();
  }
  return {
    buffers: {
      color: colorBuffer,
      depth: depthBuffer,
      stencil: stencilBuffer
    },
    enable,
    disable,
    bindFramebuffer,
    drawBuffers,
    useProgram,
    setBlending,
    setMaterial,
    setFlipSided,
    setCullFace,
    setLineWidth,
    setPolygonOffset,
    setScissorTest,
    activeTexture,
    bindTexture,
    unbindTexture,
    compressedTexImage2D,
    compressedTexImage3D,
    texImage2D,
    texImage3D,
    updateUBOMapping,
    uniformBlockBinding,
    texStorage2D,
    texStorage3D,
    texSubImage2D,
    texSubImage3D,
    compressedTexSubImage2D,
    compressedTexSubImage3D,
    scissor,
    viewport,
    reset
  };
}
function WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
  const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
  const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
  const _imageDimensions = new Vector2();
  const _videoTextures = /* @__PURE__ */ new WeakMap();
  let _canvas2;
  const _sources = /* @__PURE__ */ new WeakMap();
  let useOffscreenCanvas = false;
  try {
    useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch (err) {
  }
  function createCanvas(width, height) {
    return useOffscreenCanvas ? (
      // eslint-disable-next-line compat/compat
      new OffscreenCanvas(width, height)
    ) : createElementNS("canvas");
  }
  function resizeImage(image, needsNewCanvas, maxSize) {
    let scale = 1;
    const dimensions = getDimensions(image);
    if (dimensions.width > maxSize || dimensions.height > maxSize) {
      scale = maxSize / Math.max(dimensions.width, dimensions.height);
    }
    if (scale < 1) {
      if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap || typeof VideoFrame !== "undefined" && image instanceof VideoFrame) {
        const width = Math.floor(scale * dimensions.width);
        const height = Math.floor(scale * dimensions.height);
        if (_canvas2 === void 0) _canvas2 = createCanvas(width, height);
        const canvas2 = needsNewCanvas ? createCanvas(width, height) : _canvas2;
        canvas2.width = width;
        canvas2.height = height;
        const context = canvas2.getContext("2d");
        context.drawImage(image, 0, 0, width, height);
        console.warn("THREE.WebGLRenderer: Texture has been resized from (" + dimensions.width + "x" + dimensions.height + ") to (" + width + "x" + height + ").");
        return canvas2;
      } else {
        if ("data" in image) {
          console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + dimensions.width + "x" + dimensions.height + ").");
        }
        return image;
      }
    }
    return image;
  }
  function textureNeedsGenerateMipmaps(texture) {
    return texture.generateMipmaps;
  }
  function generateMipmap(target) {
    _gl.generateMipmap(target);
  }
  function getTargetType(texture) {
    if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
    if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
    if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
    return _gl.TEXTURE_2D;
  }
  function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
    if (internalFormatName !== null) {
      if (_gl[internalFormatName] !== void 0) return _gl[internalFormatName];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
    }
    let internalFormat = glFormat;
    if (glFormat === _gl.RED) {
      if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
      if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
    }
    if (glFormat === _gl.RED_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.R8I;
      if (glType === _gl.SHORT) internalFormat = _gl.R16I;
      if (glType === _gl.INT) internalFormat = _gl.R32I;
    }
    if (glFormat === _gl.RG) {
      if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
      if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
    }
    if (glFormat === _gl.RG_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
      if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
      if (glType === _gl.INT) internalFormat = _gl.RG32I;
    }
    if (glFormat === _gl.RGB_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
      if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
      if (glType === _gl.INT) internalFormat = _gl.RGB32I;
    }
    if (glFormat === _gl.RGBA_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
      if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
      if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
    }
    if (glFormat === _gl.RGB) {
      if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
      if (glType === _gl.UNSIGNED_INT_10F_11F_11F_REV) internalFormat = _gl.R11F_G11F_B10F;
    }
    if (glFormat === _gl.RGBA) {
      const transfer = forceLinearTransfer ? LinearTransfer : ColorManagement.getTransfer(colorSpace);
      if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
      if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === SRGBTransfer ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
      if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
      if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
    }
    if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) {
      extensions.get("EXT_color_buffer_float");
    }
    return internalFormat;
  }
  function getInternalDepthFormat(useStencil, depthType) {
    let glInternalFormat;
    if (useStencil) {
      if (depthType === null || depthType === UnsignedIntType || depthType === UnsignedInt248Type) {
        glInternalFormat = _gl.DEPTH24_STENCIL8;
      } else if (depthType === FloatType) {
        glInternalFormat = _gl.DEPTH32F_STENCIL8;
      } else if (depthType === UnsignedShortType) {
        glInternalFormat = _gl.DEPTH24_STENCIL8;
        console.warn("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.");
      }
    } else {
      if (depthType === null || depthType === UnsignedIntType || depthType === UnsignedInt248Type) {
        glInternalFormat = _gl.DEPTH_COMPONENT24;
      } else if (depthType === FloatType) {
        glInternalFormat = _gl.DEPTH_COMPONENT32F;
      } else if (depthType === UnsignedShortType) {
        glInternalFormat = _gl.DEPTH_COMPONENT16;
      }
    }
    return glInternalFormat;
  }
  function getMipLevels(texture, image) {
    if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) {
      return Math.log2(Math.max(image.width, image.height)) + 1;
    } else if (texture.mipmaps !== void 0 && texture.mipmaps.length > 0) {
      return texture.mipmaps.length;
    } else if (texture.isCompressedTexture && Array.isArray(texture.image)) {
      return image.mipmaps.length;
    } else {
      return 1;
    }
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    deallocateTexture(texture);
    if (texture.isVideoTexture) {
      _videoTextures.delete(texture);
    }
  }
  function onRenderTargetDispose(event) {
    const renderTarget = event.target;
    renderTarget.removeEventListener("dispose", onRenderTargetDispose);
    deallocateRenderTarget(renderTarget);
  }
  function deallocateTexture(texture) {
    const textureProperties = properties.get(texture);
    if (textureProperties.__webglInit === void 0) return;
    const source = texture.source;
    const webglTextures = _sources.get(source);
    if (webglTextures) {
      const webglTexture = webglTextures[textureProperties.__cacheKey];
      webglTexture.usedTimes--;
      if (webglTexture.usedTimes === 0) {
        deleteTexture(texture);
      }
      if (Object.keys(webglTextures).length === 0) {
        _sources.delete(source);
      }
    }
    properties.remove(texture);
  }
  function deleteTexture(texture) {
    const textureProperties = properties.get(texture);
    _gl.deleteTexture(textureProperties.__webglTexture);
    const source = texture.source;
    const webglTextures = _sources.get(source);
    delete webglTextures[textureProperties.__cacheKey];
    info.memory.textures--;
  }
  function deallocateRenderTarget(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    if (renderTarget.depthTexture) {
      renderTarget.depthTexture.dispose();
      properties.remove(renderTarget.depthTexture);
    }
    if (renderTarget.isWebGLCubeRenderTarget) {
      for (let i = 0; i < 6; i++) {
        if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) {
          for (let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++) _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
        } else {
          _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
        }
        if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
      }
    } else {
      if (Array.isArray(renderTargetProperties.__webglFramebuffer)) {
        for (let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++) _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
      } else {
        _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
      }
      if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
      if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
      if (renderTargetProperties.__webglColorRenderbuffer) {
        for (let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++) {
          if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
        }
      }
      if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
    }
    const textures = renderTarget.textures;
    for (let i = 0, il = textures.length; i < il; i++) {
      const attachmentProperties = properties.get(textures[i]);
      if (attachmentProperties.__webglTexture) {
        _gl.deleteTexture(attachmentProperties.__webglTexture);
        info.memory.textures--;
      }
      properties.remove(textures[i]);
    }
    properties.remove(renderTarget);
  }
  let textureUnits = 0;
  function resetTextureUnits() {
    textureUnits = 0;
  }
  function allocateTextureUnit() {
    const textureUnit = textureUnits;
    if (textureUnit >= capabilities.maxTextures) {
      console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + capabilities.maxTextures);
    }
    textureUnits += 1;
    return textureUnit;
  }
  function getTextureCacheKey(texture) {
    const array = [];
    array.push(texture.wrapS);
    array.push(texture.wrapT);
    array.push(texture.wrapR || 0);
    array.push(texture.magFilter);
    array.push(texture.minFilter);
    array.push(texture.anisotropy);
    array.push(texture.internalFormat);
    array.push(texture.format);
    array.push(texture.type);
    array.push(texture.generateMipmaps);
    array.push(texture.premultiplyAlpha);
    array.push(texture.flipY);
    array.push(texture.unpackAlignment);
    array.push(texture.colorSpace);
    return array.join();
  }
  function setTexture2D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.isVideoTexture) updateVideoTexture(texture);
    if (texture.isRenderTargetTexture === false && texture.isExternalTexture !== true && texture.version > 0 && textureProperties.__version !== texture.version) {
      const image = texture.image;
      if (image === null) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
      } else if (image.complete === false) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      } else {
        uploadTexture(textureProperties, texture, slot);
        return;
      }
    } else if (texture.isExternalTexture) {
      textureProperties.__webglTexture = texture.sourceTexture ? texture.sourceTexture : null;
    }
    state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  function setTexture2DArray(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  function setTexture3D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  function setTextureCube(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadCubeTexture(textureProperties, texture, slot);
      return;
    }
    state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  const wrappingToGL = {
    [RepeatWrapping]: _gl.REPEAT,
    [ClampToEdgeWrapping]: _gl.CLAMP_TO_EDGE,
    [MirroredRepeatWrapping]: _gl.MIRRORED_REPEAT
  };
  const filterToGL = {
    [NearestFilter]: _gl.NEAREST,
    [NearestMipmapNearestFilter]: _gl.NEAREST_MIPMAP_NEAREST,
    [NearestMipmapLinearFilter]: _gl.NEAREST_MIPMAP_LINEAR,
    [LinearFilter]: _gl.LINEAR,
    [LinearMipmapNearestFilter]: _gl.LINEAR_MIPMAP_NEAREST,
    [LinearMipmapLinearFilter]: _gl.LINEAR_MIPMAP_LINEAR
  };
  const compareToGL = {
    [NeverCompare]: _gl.NEVER,
    [AlwaysCompare]: _gl.ALWAYS,
    [LessCompare]: _gl.LESS,
    [LessEqualCompare]: _gl.LEQUAL,
    [EqualCompare]: _gl.EQUAL,
    [GreaterEqualCompare]: _gl.GEQUAL,
    [GreaterCompare]: _gl.GREATER,
    [NotEqualCompare]: _gl.NOTEQUAL
  };
  function setTextureParameters(textureType, texture) {
    if (texture.type === FloatType && extensions.has("OES_texture_float_linear") === false && (texture.magFilter === LinearFilter || texture.magFilter === LinearMipmapNearestFilter || texture.magFilter === NearestMipmapLinearFilter || texture.magFilter === LinearMipmapLinearFilter || texture.minFilter === LinearFilter || texture.minFilter === LinearMipmapNearestFilter || texture.minFilter === NearestMipmapLinearFilter || texture.minFilter === LinearMipmapLinearFilter)) {
      console.warn("THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.");
    }
    _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
    _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
    if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) {
      _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
    }
    _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
    _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
    if (texture.compareFunction) {
      _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
      _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
    }
    if (extensions.has("EXT_texture_filter_anisotropic") === true) {
      if (texture.magFilter === NearestFilter) return;
      if (texture.minFilter !== NearestMipmapLinearFilter && texture.minFilter !== LinearMipmapLinearFilter) return;
      if (texture.type === FloatType && extensions.has("OES_texture_float_linear") === false) return;
      if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
        const extension = extensions.get("EXT_texture_filter_anisotropic");
        _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
        properties.get(texture).__currentAnisotropy = texture.anisotropy;
      }
    }
  }
  function initTexture(textureProperties, texture) {
    let forceUpload = false;
    if (textureProperties.__webglInit === void 0) {
      textureProperties.__webglInit = true;
      texture.addEventListener("dispose", onTextureDispose);
    }
    const source = texture.source;
    let webglTextures = _sources.get(source);
    if (webglTextures === void 0) {
      webglTextures = {};
      _sources.set(source, webglTextures);
    }
    const textureCacheKey = getTextureCacheKey(texture);
    if (textureCacheKey !== textureProperties.__cacheKey) {
      if (webglTextures[textureCacheKey] === void 0) {
        webglTextures[textureCacheKey] = {
          texture: _gl.createTexture(),
          usedTimes: 0
        };
        info.memory.textures++;
        forceUpload = true;
      }
      webglTextures[textureCacheKey].usedTimes++;
      const webglTexture = webglTextures[textureProperties.__cacheKey];
      if (webglTexture !== void 0) {
        webglTextures[textureProperties.__cacheKey].usedTimes--;
        if (webglTexture.usedTimes === 0) {
          deleteTexture(texture);
        }
      }
      textureProperties.__cacheKey = textureCacheKey;
      textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
    }
    return forceUpload;
  }
  function getRow(index, rowLength, componentStride) {
    return Math.floor(Math.floor(index / componentStride) / rowLength);
  }
  function updateTexture(texture, image, glFormat, glType) {
    const componentStride = 4;
    const updateRanges = texture.updateRanges;
    if (updateRanges.length === 0) {
      state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
    } else {
      updateRanges.sort((a, b) => a.start - b.start);
      let mergeIndex = 0;
      for (let i = 1; i < updateRanges.length; i++) {
        const previousRange = updateRanges[mergeIndex];
        const range = updateRanges[i];
        const previousEnd = previousRange.start + previousRange.count;
        const currentRow = getRow(range.start, image.width, componentStride);
        const previousRow = getRow(previousRange.start, image.width, componentStride);
        if (range.start <= previousEnd + 1 && currentRow === previousRow && getRow(range.start + range.count - 1, image.width, componentStride) === currentRow) {
          previousRange.count = Math.max(
            previousRange.count,
            range.start + range.count - previousRange.start
          );
        } else {
          ++mergeIndex;
          updateRanges[mergeIndex] = range;
        }
      }
      updateRanges.length = mergeIndex + 1;
      const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
      const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
      const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
      _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
      for (let i = 0, l = updateRanges.length; i < l; i++) {
        const range = updateRanges[i];
        const pixelStart = Math.floor(range.start / componentStride);
        const pixelCount = Math.ceil(range.count / componentStride);
        const x = pixelStart % image.width;
        const y = Math.floor(pixelStart / image.width);
        const width = pixelCount;
        const height = 1;
        _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, x);
        _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, y);
        state.texSubImage2D(_gl.TEXTURE_2D, 0, x, y, width, height, glFormat, glType, image.data);
      }
      texture.clearUpdateRanges();
      _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
      _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
      _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
    }
  }
  function uploadTexture(textureProperties, texture, slot) {
    let textureType = _gl.TEXTURE_2D;
    if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
    if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
    const forceUpload = initTexture(textureProperties, texture);
    const source = texture.source;
    state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    const sourceProperties = properties.get(source);
    if (source.version !== sourceProperties.__version || forceUpload === true) {
      state.activeTexture(_gl.TEXTURE0 + slot);
      const workingPrimaries = ColorManagement.getPrimaries(ColorManagement.workingColorSpace);
      const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries(texture.colorSpace);
      const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
      _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
      _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
      _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
      _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
      let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
      image = verifyColorSpace(texture, image);
      const glFormat = utils.convert(texture.format, texture.colorSpace);
      const glType = utils.convert(texture.type);
      let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
      setTextureParameters(textureType, texture);
      let mipmap;
      const mipmaps = texture.mipmaps;
      const useTexStorage = texture.isVideoTexture !== true;
      const allocateMemory = sourceProperties.__version === void 0 || forceUpload === true;
      const dataReady = source.dataReady;
      const levels = getMipLevels(texture, image);
      if (texture.isDepthTexture) {
        glInternalFormat = getInternalDepthFormat(texture.format === DepthStencilFormat, texture.type);
        if (allocateMemory) {
          if (useTexStorage) {
            state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
          } else {
            state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
          }
        }
      } else if (texture.isDataTexture) {
        if (mipmaps.length > 0) {
          if (useTexStorage && allocateMemory) {
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
          }
          for (let i = 0, il = mipmaps.length; i < il; i++) {
            mipmap = mipmaps[i];
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
          }
          texture.generateMipmaps = false;
        } else {
          if (useTexStorage) {
            if (allocateMemory) {
              state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
            }
            if (dataReady) {
              updateTexture(texture, image, glFormat, glType);
            }
          } else {
            state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
          }
        }
      } else if (texture.isCompressedTexture) {
        if (texture.isCompressedArrayTexture) {
          if (useTexStorage && allocateMemory) {
            state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
          }
          for (let i = 0, il = mipmaps.length; i < il; i++) {
            mipmap = mipmaps[i];
            if (texture.format !== RGBAFormat) {
              if (glFormat !== null) {
                if (useTexStorage) {
                  if (dataReady) {
                    if (texture.layerUpdates.size > 0) {
                      const layerByteLength = getByteLength(mipmap.width, mipmap.height, texture.format, texture.type);
                      for (const layerIndex of texture.layerUpdates) {
                        const layerData = mipmap.data.subarray(
                          layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT,
                          (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT
                        );
                        state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                      }
                      texture.clearLayerUpdates();
                    } else {
                      state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                    }
                  }
                } else {
                  state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                }
              } else {
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
              }
            } else {
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                }
              } else {
                state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
              }
            }
          }
        } else {
          if (useTexStorage && allocateMemory) {
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
          }
          for (let i = 0, il = mipmaps.length; i < il; i++) {
            mipmap = mipmaps[i];
            if (texture.format !== RGBAFormat) {
              if (glFormat !== null) {
                if (useTexStorage) {
                  if (dataReady) {
                    state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                  }
                } else {
                  state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                }
              } else {
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
              }
            } else {
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
              }
            }
          }
        }
      } else if (texture.isDataArrayTexture) {
        if (useTexStorage) {
          if (allocateMemory) {
            state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
          }
          if (dataReady) {
            if (texture.layerUpdates.size > 0) {
              const layerByteLength = getByteLength(image.width, image.height, texture.format, texture.type);
              for (const layerIndex of texture.layerUpdates) {
                const layerData = image.data.subarray(
                  layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT,
                  (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT
                );
                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
              }
              texture.clearLayerUpdates();
            } else {
              state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
            }
          }
        } else {
          state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        }
      } else if (texture.isData3DTexture) {
        if (useTexStorage) {
          if (allocateMemory) {
            state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
          }
          if (dataReady) {
            state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
          }
        } else {
          state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        }
      } else if (texture.isFramebufferTexture) {
        if (allocateMemory) {
          if (useTexStorage) {
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
          } else {
            let width = image.width, height = image.height;
            for (let i = 0; i < levels; i++) {
              state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
              width >>= 1;
              height >>= 1;
            }
          }
        }
      } else {
        if (mipmaps.length > 0) {
          if (useTexStorage && allocateMemory) {
            const dimensions = getDimensions(mipmaps[0]);
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
          }
          for (let i = 0, il = mipmaps.length; i < il; i++) {
            mipmap = mipmaps[i];
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
            }
          }
          texture.generateMipmaps = false;
        } else {
          if (useTexStorage) {
            if (allocateMemory) {
              const dimensions = getDimensions(image);
              state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
            }
            if (dataReady) {
              state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
            }
          } else {
            state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
          }
        }
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(textureType);
      }
      sourceProperties.__version = source.version;
      if (texture.onUpdate) texture.onUpdate(texture);
    }
    textureProperties.__version = texture.version;
  }
  function uploadCubeTexture(textureProperties, texture, slot) {
    if (texture.image.length !== 6) return;
    const forceUpload = initTexture(textureProperties, texture);
    const source = texture.source;
    state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    const sourceProperties = properties.get(source);
    if (source.version !== sourceProperties.__version || forceUpload === true) {
      state.activeTexture(_gl.TEXTURE0 + slot);
      const workingPrimaries = ColorManagement.getPrimaries(ColorManagement.workingColorSpace);
      const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries(texture.colorSpace);
      const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
      _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
      _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
      _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
      _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
      const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
      const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
      const cubeImage = [];
      for (let i = 0; i < 6; i++) {
        if (!isCompressed && !isDataTexture) {
          cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
        } else {
          cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
        }
        cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
      }
      const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
      const useTexStorage = texture.isVideoTexture !== true;
      const allocateMemory = sourceProperties.__version === void 0 || forceUpload === true;
      const dataReady = source.dataReady;
      let levels = getMipLevels(texture, image);
      setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
      let mipmaps;
      if (isCompressed) {
        if (useTexStorage && allocateMemory) {
          state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
        }
        for (let i = 0; i < 6; i++) {
          mipmaps = cubeImage[i].mipmaps;
          for (let j = 0; j < mipmaps.length; j++) {
            const mipmap = mipmaps[j];
            if (texture.format !== RGBAFormat) {
              if (glFormat !== null) {
                if (useTexStorage) {
                  if (dataReady) {
                    state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                  }
                } else {
                  state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                }
              } else {
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
              }
            } else {
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
              }
            }
          }
        }
      } else {
        mipmaps = texture.mipmaps;
        if (useTexStorage && allocateMemory) {
          if (mipmaps.length > 0) levels++;
          const dimensions = getDimensions(cubeImage[0]);
          state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
        }
        for (let i = 0; i < 6; i++) {
          if (isDataTexture) {
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
            }
            for (let j = 0; j < mipmaps.length; j++) {
              const mipmap = mipmaps[j];
              const mipmapImage = mipmap.image[i].image;
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
              }
            }
          } else {
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
            }
            for (let j = 0; j < mipmaps.length; j++) {
              const mipmap = mipmaps[j];
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
              }
            }
          }
        }
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(_gl.TEXTURE_CUBE_MAP);
      }
      sourceProperties.__version = source.version;
      if (texture.onUpdate) texture.onUpdate(texture);
    }
    textureProperties.__version = texture.version;
  }
  function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
    const glFormat = utils.convert(texture.format, texture.colorSpace);
    const glType = utils.convert(texture.type);
    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    textureProperties.__renderTarget = renderTarget;
    if (!renderTargetProperties.__hasExternalTextures) {
      const width = Math.max(1, renderTarget.width >> level);
      const height = Math.max(1, renderTarget.height >> level);
      if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) {
        state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
      } else {
        state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
      }
    }
    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
    if (useMultisampledRTT(renderTarget)) {
      multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
    } else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) {
      _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
    }
    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
  }
  function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
    if (renderTarget.depthBuffer) {
      const depthTexture = renderTarget.depthTexture;
      const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
      const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
      const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
      const samples = getRenderTargetSamples(renderTarget);
      const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
      if (isUseMultisampledRTT) {
        multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else if (isMultisample) {
        _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
      }
      _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
    } else {
      const textures = renderTarget.textures;
      for (let i = 0; i < textures.length; i++) {
        const texture = textures[i];
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const samples = getRenderTargetSamples(renderTarget);
        if (isMultisample && useMultisampledRTT(renderTarget) === false) {
          _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        } else if (useMultisampledRTT(renderTarget)) {
          multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        } else {
          _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
        }
      }
    }
    _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
  }
  function setupDepthTexture(framebuffer, renderTarget) {
    const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
    if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
    if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) {
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    }
    const textureProperties = properties.get(renderTarget.depthTexture);
    textureProperties.__renderTarget = renderTarget;
    if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
      renderTarget.depthTexture.image.width = renderTarget.width;
      renderTarget.depthTexture.image.height = renderTarget.height;
      renderTarget.depthTexture.needsUpdate = true;
    }
    setTexture2D(renderTarget.depthTexture, 0);
    const webglDepthTexture = textureProperties.__webglTexture;
    const samples = getRenderTargetSamples(renderTarget);
    if (renderTarget.depthTexture.format === DepthFormat) {
      if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
      } else {
        _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
      }
    } else if (renderTarget.depthTexture.format === DepthStencilFormat) {
      if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
      } else {
        _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
      }
    } else {
      throw new Error("Unknown depthTexture format");
    }
  }
  function setupDepthRenderbuffer(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
      const depthTexture = renderTarget.depthTexture;
      if (renderTargetProperties.__depthDisposeCallback) {
        renderTargetProperties.__depthDisposeCallback();
      }
      if (depthTexture) {
        const disposeEvent = () => {
          delete renderTargetProperties.__boundDepthTexture;
          delete renderTargetProperties.__depthDisposeCallback;
          depthTexture.removeEventListener("dispose", disposeEvent);
        };
        depthTexture.addEventListener("dispose", disposeEvent);
        renderTargetProperties.__depthDisposeCallback = disposeEvent;
      }
      renderTargetProperties.__boundDepthTexture = depthTexture;
    }
    if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
      if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
      const mipmaps = renderTarget.texture.mipmaps;
      if (mipmaps && mipmaps.length > 0) {
        setupDepthTexture(renderTargetProperties.__webglFramebuffer[0], renderTarget);
      } else {
        setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
      }
    } else {
      if (isCube) {
        renderTargetProperties.__webglDepthbuffer = [];
        for (let i = 0; i < 6; i++) {
          state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
          if (renderTargetProperties.__webglDepthbuffer[i] === void 0) {
            renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
          } else {
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
            _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
          }
        }
      } else {
        const mipmaps = renderTarget.texture.mipmaps;
        if (mipmaps && mipmaps.length > 0) {
          state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
        } else {
          state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
        }
        if (renderTargetProperties.__webglDepthbuffer === void 0) {
          renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        } else {
          const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
          const renderbuffer = renderTargetProperties.__webglDepthbuffer;
          _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
          _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        }
      }
    }
    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
  }
  function rebindTextures(renderTarget, colorTexture, depthTexture) {
    const renderTargetProperties = properties.get(renderTarget);
    if (colorTexture !== void 0) {
      setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
    }
    if (depthTexture !== void 0) {
      setupDepthRenderbuffer(renderTarget);
    }
  }
  function setupRenderTarget(renderTarget) {
    const texture = renderTarget.texture;
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    renderTarget.addEventListener("dispose", onRenderTargetDispose);
    const textures = renderTarget.textures;
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    const isMultipleRenderTargets = textures.length > 1;
    if (!isMultipleRenderTargets) {
      if (textureProperties.__webglTexture === void 0) {
        textureProperties.__webglTexture = _gl.createTexture();
      }
      textureProperties.__version = texture.version;
      info.memory.textures++;
    }
    if (isCube) {
      renderTargetProperties.__webglFramebuffer = [];
      for (let i = 0; i < 6; i++) {
        if (texture.mipmaps && texture.mipmaps.length > 0) {
          renderTargetProperties.__webglFramebuffer[i] = [];
          for (let level = 0; level < texture.mipmaps.length; level++) {
            renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
          }
        } else {
          renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        }
      }
    } else {
      if (texture.mipmaps && texture.mipmaps.length > 0) {
        renderTargetProperties.__webglFramebuffer = [];
        for (let level = 0; level < texture.mipmaps.length; level++) {
          renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
        }
      } else {
        renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
      }
      if (isMultipleRenderTargets) {
        for (let i = 0, il = textures.length; i < il; i++) {
          const attachmentProperties = properties.get(textures[i]);
          if (attachmentProperties.__webglTexture === void 0) {
            attachmentProperties.__webglTexture = _gl.createTexture();
            info.memory.textures++;
          }
        }
      }
      if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
        renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
        renderTargetProperties.__webglColorRenderbuffer = [];
        state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        for (let i = 0; i < textures.length; i++) {
          const texture2 = textures[i];
          renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
          _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
          const glFormat = utils.convert(texture2.format, texture2.colorSpace);
          const glType = utils.convert(texture2.type);
          const glInternalFormat = getInternalFormat(texture2.internalFormat, glFormat, glType, texture2.colorSpace, renderTarget.isXRRenderTarget === true);
          const samples = getRenderTargetSamples(renderTarget);
          _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
          _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
        if (renderTarget.depthBuffer) {
          renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
      }
    }
    if (isCube) {
      state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
      setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
      for (let i = 0; i < 6; i++) {
        if (texture.mipmaps && texture.mipmaps.length > 0) {
          for (let level = 0; level < texture.mipmaps.length; level++) {
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
          }
        } else {
          setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
        }
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(_gl.TEXTURE_CUBE_MAP);
      }
      state.unbindTexture();
    } else if (isMultipleRenderTargets) {
      for (let i = 0, il = textures.length; i < il; i++) {
        const attachment = textures[i];
        const attachmentProperties = properties.get(attachment);
        let glTextureType = _gl.TEXTURE_2D;
        if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
          glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
        }
        state.bindTexture(glTextureType, attachmentProperties.__webglTexture);
        setTextureParameters(glTextureType, attachment);
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, glTextureType, 0);
        if (textureNeedsGenerateMipmaps(attachment)) {
          generateMipmap(glTextureType);
        }
      }
      state.unbindTexture();
    } else {
      let glTextureType = _gl.TEXTURE_2D;
      if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
        glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
      }
      state.bindTexture(glTextureType, textureProperties.__webglTexture);
      setTextureParameters(glTextureType, texture);
      if (texture.mipmaps && texture.mipmaps.length > 0) {
        for (let level = 0; level < texture.mipmaps.length; level++) {
          setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
        }
      } else {
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(glTextureType);
      }
      state.unbindTexture();
    }
    if (renderTarget.depthBuffer) {
      setupDepthRenderbuffer(renderTarget);
    }
  }
  function updateRenderTargetMipmap(renderTarget) {
    const textures = renderTarget.textures;
    for (let i = 0, il = textures.length; i < il; i++) {
      const texture = textures[i];
      if (textureNeedsGenerateMipmaps(texture)) {
        const targetType = getTargetType(renderTarget);
        const webglTexture = properties.get(texture).__webglTexture;
        state.bindTexture(targetType, webglTexture);
        generateMipmap(targetType);
        state.unbindTexture();
      }
    }
  }
  const invalidationArrayRead = [];
  const invalidationArrayDraw = [];
  function updateMultisampleRenderTarget(renderTarget) {
    if (renderTarget.samples > 0) {
      if (useMultisampledRTT(renderTarget) === false) {
        const textures = renderTarget.textures;
        const width = renderTarget.width;
        const height = renderTarget.height;
        let mask = _gl.COLOR_BUFFER_BIT;
        const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
        const renderTargetProperties = properties.get(renderTarget);
        const isMultipleRenderTargets = textures.length > 1;
        if (isMultipleRenderTargets) {
          for (let i = 0; i < textures.length; i++) {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
          }
        }
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        const mipmaps = renderTarget.texture.mipmaps;
        if (mipmaps && mipmaps.length > 0) {
          state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
        } else {
          state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
        }
        for (let i = 0; i < textures.length; i++) {
          if (renderTarget.resolveDepthBuffer) {
            if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
            if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
          }
          if (isMultipleRenderTargets) {
            _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
            const webglTexture = properties.get(textures[i]).__webglTexture;
            _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
          }
          _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
          if (supportsInvalidateFramebuffer === true) {
            invalidationArrayRead.length = 0;
            invalidationArrayDraw.length = 0;
            invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
            if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
              invalidationArrayRead.push(depthStyle);
              invalidationArrayDraw.push(depthStyle);
              _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
            }
            _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
          }
        }
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
        if (isMultipleRenderTargets) {
          for (let i = 0; i < textures.length; i++) {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
            const webglTexture = properties.get(textures[i]).__webglTexture;
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
          }
        }
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
      } else {
        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
          const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
          _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [depthStyle]);
        }
      }
    }
  }
  function getRenderTargetSamples(renderTarget) {
    return Math.min(capabilities.maxSamples, renderTarget.samples);
  }
  function useMultisampledRTT(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    return renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
  }
  function updateVideoTexture(texture) {
    const frame = info.render.frame;
    if (_videoTextures.get(texture) !== frame) {
      _videoTextures.set(texture, frame);
      texture.update();
    }
  }
  function verifyColorSpace(texture, image) {
    const colorSpace = texture.colorSpace;
    const format = texture.format;
    const type = texture.type;
    if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
    if (colorSpace !== LinearSRGBColorSpace && colorSpace !== NoColorSpace) {
      if (ColorManagement.getTransfer(colorSpace) === SRGBTransfer) {
        if (format !== RGBAFormat || type !== UnsignedByteType) {
          console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
        }
      } else {
        console.error("THREE.WebGLTextures: Unsupported texture color space:", colorSpace);
      }
    }
    return image;
  }
  function getDimensions(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement) {
      _imageDimensions.width = image.naturalWidth || image.width;
      _imageDimensions.height = image.naturalHeight || image.height;
    } else if (typeof VideoFrame !== "undefined" && image instanceof VideoFrame) {
      _imageDimensions.width = image.displayWidth;
      _imageDimensions.height = image.displayHeight;
    } else {
      _imageDimensions.width = image.width;
      _imageDimensions.height = image.height;
    }
    return _imageDimensions;
  }
  this.allocateTextureUnit = allocateTextureUnit;
  this.resetTextureUnits = resetTextureUnits;
  this.setTexture2D = setTexture2D;
  this.setTexture2DArray = setTexture2DArray;
  this.setTexture3D = setTexture3D;
  this.setTextureCube = setTextureCube;
  this.rebindTextures = rebindTextures;
  this.setupRenderTarget = setupRenderTarget;
  this.updateRenderTargetMipmap = updateRenderTargetMipmap;
  this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
  this.setupDepthRenderbuffer = setupDepthRenderbuffer;
  this.setupFrameBufferTexture = setupFrameBufferTexture;
  this.useMultisampledRTT = useMultisampledRTT;
}
function WebGLUtils(gl, extensions) {
  function convert(p, colorSpace = NoColorSpace) {
    let extension;
    const transfer = ColorManagement.getTransfer(colorSpace);
    if (p === UnsignedByteType) return gl.UNSIGNED_BYTE;
    if (p === UnsignedShort4444Type) return gl.UNSIGNED_SHORT_4_4_4_4;
    if (p === UnsignedShort5551Type) return gl.UNSIGNED_SHORT_5_5_5_1;
    if (p === UnsignedInt5999Type) return gl.UNSIGNED_INT_5_9_9_9_REV;
    if (p === UnsignedInt101111Type) return gl.UNSIGNED_INT_10F_11F_11F_REV;
    if (p === ByteType) return gl.BYTE;
    if (p === ShortType) return gl.SHORT;
    if (p === UnsignedShortType) return gl.UNSIGNED_SHORT;
    if (p === IntType) return gl.INT;
    if (p === UnsignedIntType) return gl.UNSIGNED_INT;
    if (p === FloatType) return gl.FLOAT;
    if (p === HalfFloatType) return gl.HALF_FLOAT;
    if (p === AlphaFormat) return gl.ALPHA;
    if (p === RGBFormat) return gl.RGB;
    if (p === RGBAFormat) return gl.RGBA;
    if (p === DepthFormat) return gl.DEPTH_COMPONENT;
    if (p === DepthStencilFormat) return gl.DEPTH_STENCIL;
    if (p === RedFormat) return gl.RED;
    if (p === RedIntegerFormat) return gl.RED_INTEGER;
    if (p === RGFormat) return gl.RG;
    if (p === RGIntegerFormat) return gl.RG_INTEGER;
    if (p === RGBAIntegerFormat) return gl.RGBA_INTEGER;
    if (p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format || p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format) {
      if (transfer === SRGBTransfer) {
        extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
        if (extension !== null) {
          if (p === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (p === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (p === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (p === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else {
          return null;
        }
      } else {
        extension = extensions.get("WEBGL_compressed_texture_s3tc");
        if (extension !== null) {
          if (p === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
          if (p === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
          if (p === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
          if (p === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
        } else {
          return null;
        }
      }
    }
    if (p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format || p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format) {
      extension = extensions.get("WEBGL_compressed_texture_pvrtc");
      if (extension !== null) {
        if (p === RGB_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (p === RGB_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (p === RGBA_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (p === RGBA_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else {
        return null;
      }
    }
    if (p === RGB_ETC1_Format || p === RGB_ETC2_Format || p === RGBA_ETC2_EAC_Format) {
      extension = extensions.get("WEBGL_compressed_texture_etc");
      if (extension !== null) {
        if (p === RGB_ETC1_Format || p === RGB_ETC2_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
        if (p === RGBA_ETC2_EAC_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
      } else {
        return null;
      }
    }
    if (p === RGBA_ASTC_4x4_Format || p === RGBA_ASTC_5x4_Format || p === RGBA_ASTC_5x5_Format || p === RGBA_ASTC_6x5_Format || p === RGBA_ASTC_6x6_Format || p === RGBA_ASTC_8x5_Format || p === RGBA_ASTC_8x6_Format || p === RGBA_ASTC_8x8_Format || p === RGBA_ASTC_10x5_Format || p === RGBA_ASTC_10x6_Format || p === RGBA_ASTC_10x8_Format || p === RGBA_ASTC_10x10_Format || p === RGBA_ASTC_12x10_Format || p === RGBA_ASTC_12x12_Format) {
      extension = extensions.get("WEBGL_compressed_texture_astc");
      if (extension !== null) {
        if (p === RGBA_ASTC_4x4_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (p === RGBA_ASTC_5x4_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (p === RGBA_ASTC_5x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (p === RGBA_ASTC_6x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (p === RGBA_ASTC_6x6_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (p === RGBA_ASTC_8x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (p === RGBA_ASTC_8x6_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (p === RGBA_ASTC_8x8_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (p === RGBA_ASTC_10x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (p === RGBA_ASTC_10x6_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (p === RGBA_ASTC_10x8_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (p === RGBA_ASTC_10x10_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (p === RGBA_ASTC_12x10_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (p === RGBA_ASTC_12x12_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else {
        return null;
      }
    }
    if (p === RGBA_BPTC_Format || p === RGB_BPTC_SIGNED_Format || p === RGB_BPTC_UNSIGNED_Format) {
      extension = extensions.get("EXT_texture_compression_bptc");
      if (extension !== null) {
        if (p === RGBA_BPTC_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
        if (p === RGB_BPTC_SIGNED_Format) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
        if (p === RGB_BPTC_UNSIGNED_Format) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
      } else {
        return null;
      }
    }
    if (p === RED_RGTC1_Format || p === SIGNED_RED_RGTC1_Format || p === RED_GREEN_RGTC2_Format || p === SIGNED_RED_GREEN_RGTC2_Format) {
      extension = extensions.get("EXT_texture_compression_rgtc");
      if (extension !== null) {
        if (p === RED_RGTC1_Format) return extension.COMPRESSED_RED_RGTC1_EXT;
        if (p === SIGNED_RED_RGTC1_Format) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        if (p === RED_GREEN_RGTC2_Format) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
        if (p === SIGNED_RED_GREEN_RGTC2_Format) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
      } else {
        return null;
      }
    }
    if (p === UnsignedInt248Type) return gl.UNSIGNED_INT_24_8;
    return gl[p] !== void 0 ? gl[p] : null;
  }
  return { convert };
}
function WebGLMaterials(renderer, properties) {
  function refreshTransformUniform(map, uniform) {
    if (map.matrixAutoUpdate === true) {
      map.updateMatrix();
    }
    uniform.value.copy(map.matrix);
  }
  function refreshFogUniforms(uniforms, fog) {
    fog.color.getRGB(uniforms.fogColor.value, getUnlitUniformColorSpace(renderer));
    if (fog.isFog) {
      uniforms.fogNear.value = fog.near;
      uniforms.fogFar.value = fog.far;
    } else if (fog.isFogExp2) {
      uniforms.fogDensity.value = fog.density;
    }
  }
  function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
    if (material.isMeshBasicMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshLambertMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshToonMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsToon(uniforms, material);
    } else if (material.isMeshPhongMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsPhong(uniforms, material);
    } else if (material.isMeshStandardMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsStandard(uniforms, material);
      if (material.isMeshPhysicalMaterial) {
        refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
      }
    } else if (material.isMeshMatcapMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsMatcap(uniforms, material);
    } else if (material.isMeshDepthMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshDistanceMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsDistance(uniforms, material);
    } else if (material.isMeshNormalMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isLineBasicMaterial) {
      refreshUniformsLine(uniforms, material);
      if (material.isLineDashedMaterial) {
        refreshUniformsDash(uniforms, material);
      }
    } else if (material.isPointsMaterial) {
      refreshUniformsPoints(uniforms, material, pixelRatio, height);
    } else if (material.isSpriteMaterial) {
      refreshUniformsSprites(uniforms, material);
    } else if (material.isShadowMaterial) {
      uniforms.color.value.copy(material.color);
      uniforms.opacity.value = material.opacity;
    } else if (material.isShaderMaterial) {
      material.uniformsNeedUpdate = false;
    }
  }
  function refreshUniformsCommon(uniforms, material) {
    uniforms.opacity.value = material.opacity;
    if (material.color) {
      uniforms.diffuse.value.copy(material.color);
    }
    if (material.emissive) {
      uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
    }
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.mapTransform);
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
      refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide) {
        uniforms.bumpScale.value *= -1;
      }
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide) {
        uniforms.normalScale.value.negate();
      }
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
      refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
    }
    if (material.specularMap) {
      uniforms.specularMap.value = material.specularMap;
      refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
    const materialProperties = properties.get(material);
    const envMap = materialProperties.envMap;
    const envMapRotation = materialProperties.envMapRotation;
    if (envMap) {
      uniforms.envMap.value = envMap;
      _e1.copy(envMapRotation);
      _e1.x *= -1;
      _e1.y *= -1;
      _e1.z *= -1;
      if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
        _e1.y *= -1;
        _e1.z *= -1;
      }
      uniforms.envMapRotation.value.setFromMatrix4(_m12.makeRotationFromEuler(_e1));
      uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
      uniforms.reflectivity.value = material.reflectivity;
      uniforms.ior.value = material.ior;
      uniforms.refractionRatio.value = material.refractionRatio;
    }
    if (material.lightMap) {
      uniforms.lightMap.value = material.lightMap;
      uniforms.lightMapIntensity.value = material.lightMapIntensity;
      refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
    }
    if (material.aoMap) {
      uniforms.aoMap.value = material.aoMap;
      uniforms.aoMapIntensity.value = material.aoMapIntensity;
      refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
    }
  }
  function refreshUniformsLine(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.mapTransform);
    }
  }
  function refreshUniformsDash(uniforms, material) {
    uniforms.dashSize.value = material.dashSize;
    uniforms.totalSize.value = material.dashSize + material.gapSize;
    uniforms.scale.value = material.scale;
  }
  function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.size.value = material.size * pixelRatio;
    uniforms.scale.value = height * 0.5;
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.uvTransform);
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
      refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
  }
  function refreshUniformsSprites(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.rotation.value = material.rotation;
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.mapTransform);
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
      refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
  }
  function refreshUniformsPhong(uniforms, material) {
    uniforms.specular.value.copy(material.specular);
    uniforms.shininess.value = Math.max(material.shininess, 1e-4);
  }
  function refreshUniformsToon(uniforms, material) {
    if (material.gradientMap) {
      uniforms.gradientMap.value = material.gradientMap;
    }
  }
  function refreshUniformsStandard(uniforms, material) {
    uniforms.metalness.value = material.metalness;
    if (material.metalnessMap) {
      uniforms.metalnessMap.value = material.metalnessMap;
      refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
    }
    uniforms.roughness.value = material.roughness;
    if (material.roughnessMap) {
      uniforms.roughnessMap.value = material.roughnessMap;
      refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
    }
    if (material.envMap) {
      uniforms.envMapIntensity.value = material.envMapIntensity;
    }
  }
  function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
    uniforms.ior.value = material.ior;
    if (material.sheen > 0) {
      uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
      uniforms.sheenRoughness.value = material.sheenRoughness;
      if (material.sheenColorMap) {
        uniforms.sheenColorMap.value = material.sheenColorMap;
        refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
      }
      if (material.sheenRoughnessMap) {
        uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
        refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
      }
    }
    if (material.clearcoat > 0) {
      uniforms.clearcoat.value = material.clearcoat;
      uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
      if (material.clearcoatMap) {
        uniforms.clearcoatMap.value = material.clearcoatMap;
        refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
      }
      if (material.clearcoatRoughnessMap) {
        uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
        refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
      }
      if (material.clearcoatNormalMap) {
        uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
        refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
        uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
        if (material.side === BackSide) {
          uniforms.clearcoatNormalScale.value.negate();
        }
      }
    }
    if (material.dispersion > 0) {
      uniforms.dispersion.value = material.dispersion;
    }
    if (material.iridescence > 0) {
      uniforms.iridescence.value = material.iridescence;
      uniforms.iridescenceIOR.value = material.iridescenceIOR;
      uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
      uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
      if (material.iridescenceMap) {
        uniforms.iridescenceMap.value = material.iridescenceMap;
        refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
      }
      if (material.iridescenceThicknessMap) {
        uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
        refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
      }
    }
    if (material.transmission > 0) {
      uniforms.transmission.value = material.transmission;
      uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
      uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
      if (material.transmissionMap) {
        uniforms.transmissionMap.value = material.transmissionMap;
        refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
      }
      uniforms.thickness.value = material.thickness;
      if (material.thicknessMap) {
        uniforms.thicknessMap.value = material.thicknessMap;
        refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
      }
      uniforms.attenuationDistance.value = material.attenuationDistance;
      uniforms.attenuationColor.value.copy(material.attenuationColor);
    }
    if (material.anisotropy > 0) {
      uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
      if (material.anisotropyMap) {
        uniforms.anisotropyMap.value = material.anisotropyMap;
        refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
      }
    }
    uniforms.specularIntensity.value = material.specularIntensity;
    uniforms.specularColor.value.copy(material.specularColor);
    if (material.specularColorMap) {
      uniforms.specularColorMap.value = material.specularColorMap;
      refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
    }
    if (material.specularIntensityMap) {
      uniforms.specularIntensityMap.value = material.specularIntensityMap;
      refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
    }
  }
  function refreshUniformsMatcap(uniforms, material) {
    if (material.matcap) {
      uniforms.matcap.value = material.matcap;
    }
  }
  function refreshUniformsDistance(uniforms, material) {
    const light = properties.get(material).light;
    uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
    uniforms.nearDistance.value = light.shadow.camera.near;
    uniforms.farDistance.value = light.shadow.camera.far;
  }
  return {
    refreshFogUniforms,
    refreshMaterialUniforms
  };
}
function WebGLUniformsGroups(gl, info, capabilities, state) {
  let buffers = {};
  let updateList = {};
  let allocatedBindingPoints = [];
  const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS);
  function bind(uniformsGroup, program) {
    const webglProgram = program.program;
    state.uniformBlockBinding(uniformsGroup, webglProgram);
  }
  function update(uniformsGroup, program) {
    let buffer = buffers[uniformsGroup.id];
    if (buffer === void 0) {
      prepareUniformsGroup(uniformsGroup);
      buffer = createBuffer(uniformsGroup);
      buffers[uniformsGroup.id] = buffer;
      uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
    }
    const webglProgram = program.program;
    state.updateUBOMapping(uniformsGroup, webglProgram);
    const frame = info.render.frame;
    if (updateList[uniformsGroup.id] !== frame) {
      updateBufferData(uniformsGroup);
      updateList[uniformsGroup.id] = frame;
    }
  }
  function createBuffer(uniformsGroup) {
    const bindingPointIndex = allocateBindingPointIndex();
    uniformsGroup.__bindingPointIndex = bindingPointIndex;
    const buffer = gl.createBuffer();
    const size = uniformsGroup.__size;
    const usage = uniformsGroup.usage;
    gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
    gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
    gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
    return buffer;
  }
  function allocateBindingPointIndex() {
    for (let i = 0; i < maxBindingPoints; i++) {
      if (allocatedBindingPoints.indexOf(i) === -1) {
        allocatedBindingPoints.push(i);
        return i;
      }
    }
    console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
    return 0;
  }
  function updateBufferData(uniformsGroup) {
    const buffer = buffers[uniformsGroup.id];
    const uniforms = uniformsGroup.uniforms;
    const cache = uniformsGroup.__cache;
    gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
    for (let i = 0, il = uniforms.length; i < il; i++) {
      const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [uniforms[i]];
      for (let j = 0, jl = uniformArray.length; j < jl; j++) {
        const uniform = uniformArray[j];
        if (hasUniformChanged(uniform, i, j, cache) === true) {
          const offset = uniform.__offset;
          const values = Array.isArray(uniform.value) ? uniform.value : [uniform.value];
          let arrayOffset = 0;
          for (let k = 0; k < values.length; k++) {
            const value = values[k];
            const info2 = getUniformSize(value);
            if (typeof value === "number" || typeof value === "boolean") {
              uniform.__data[0] = value;
              gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
            } else if (value.isMatrix3) {
              uniform.__data[0] = value.elements[0];
              uniform.__data[1] = value.elements[1];
              uniform.__data[2] = value.elements[2];
              uniform.__data[3] = 0;
              uniform.__data[4] = value.elements[3];
              uniform.__data[5] = value.elements[4];
              uniform.__data[6] = value.elements[5];
              uniform.__data[7] = 0;
              uniform.__data[8] = value.elements[6];
              uniform.__data[9] = value.elements[7];
              uniform.__data[10] = value.elements[8];
              uniform.__data[11] = 0;
            } else {
              value.toArray(uniform.__data, arrayOffset);
              arrayOffset += info2.storage / Float32Array.BYTES_PER_ELEMENT;
            }
          }
          gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
        }
      }
    }
    gl.bindBuffer(gl.UNIFORM_BUFFER, null);
  }
  function hasUniformChanged(uniform, index, indexArray, cache) {
    const value = uniform.value;
    const indexString = index + "_" + indexArray;
    if (cache[indexString] === void 0) {
      if (typeof value === "number" || typeof value === "boolean") {
        cache[indexString] = value;
      } else {
        cache[indexString] = value.clone();
      }
      return true;
    } else {
      const cachedObject = cache[indexString];
      if (typeof value === "number" || typeof value === "boolean") {
        if (cachedObject !== value) {
          cache[indexString] = value;
          return true;
        }
      } else {
        if (cachedObject.equals(value) === false) {
          cachedObject.copy(value);
          return true;
        }
      }
    }
    return false;
  }
  function prepareUniformsGroup(uniformsGroup) {
    const uniforms = uniformsGroup.uniforms;
    let offset = 0;
    const chunkSize = 16;
    for (let i = 0, l = uniforms.length; i < l; i++) {
      const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [uniforms[i]];
      for (let j = 0, jl = uniformArray.length; j < jl; j++) {
        const uniform = uniformArray[j];
        const values = Array.isArray(uniform.value) ? uniform.value : [uniform.value];
        for (let k = 0, kl = values.length; k < kl; k++) {
          const value = values[k];
          const info2 = getUniformSize(value);
          const chunkOffset2 = offset % chunkSize;
          const chunkPadding = chunkOffset2 % info2.boundary;
          const chunkStart = chunkOffset2 + chunkPadding;
          offset += chunkPadding;
          if (chunkStart !== 0 && chunkSize - chunkStart < info2.storage) {
            offset += chunkSize - chunkStart;
          }
          uniform.__data = new Float32Array(info2.storage / Float32Array.BYTES_PER_ELEMENT);
          uniform.__offset = offset;
          offset += info2.storage;
        }
      }
    }
    const chunkOffset = offset % chunkSize;
    if (chunkOffset > 0) offset += chunkSize - chunkOffset;
    uniformsGroup.__size = offset;
    uniformsGroup.__cache = {};
    return this;
  }
  function getUniformSize(value) {
    const info2 = {
      boundary: 0,
      // bytes
      storage: 0
      // bytes
    };
    if (typeof value === "number" || typeof value === "boolean") {
      info2.boundary = 4;
      info2.storage = 4;
    } else if (value.isVector2) {
      info2.boundary = 8;
      info2.storage = 8;
    } else if (value.isVector3 || value.isColor) {
      info2.boundary = 16;
      info2.storage = 12;
    } else if (value.isVector4) {
      info2.boundary = 16;
      info2.storage = 16;
    } else if (value.isMatrix3) {
      info2.boundary = 48;
      info2.storage = 48;
    } else if (value.isMatrix4) {
      info2.boundary = 64;
      info2.storage = 64;
    } else if (value.isTexture) {
      console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
    } else {
      console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
    }
    return info2;
  }
  function onUniformsGroupsDispose(event) {
    const uniformsGroup = event.target;
    uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
    const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
    allocatedBindingPoints.splice(index, 1);
    gl.deleteBuffer(buffers[uniformsGroup.id]);
    delete buffers[uniformsGroup.id];
    delete updateList[uniformsGroup.id];
  }
  function dispose() {
    for (const id in buffers) {
      gl.deleteBuffer(buffers[id]);
    }
    allocatedBindingPoints = [];
    buffers = {};
    updateList = {};
  }
  return {
    bind,
    update,
    dispose
  };
}
var alphahash_fragment, alphahash_pars_fragment, alphamap_fragment, alphamap_pars_fragment, alphatest_fragment, alphatest_pars_fragment, aomap_fragment, aomap_pars_fragment, batching_pars_vertex, batching_vertex, begin_vertex, beginnormal_vertex, bsdfs, iridescence_fragment, bumpmap_pars_fragment, clipping_planes_fragment, clipping_planes_pars_fragment, clipping_planes_pars_vertex, clipping_planes_vertex, color_fragment, color_pars_fragment, color_pars_vertex, color_vertex, common, cube_uv_reflection_fragment, defaultnormal_vertex, displacementmap_pars_vertex, displacementmap_vertex, emissivemap_fragment, emissivemap_pars_fragment, colorspace_fragment, colorspace_pars_fragment, envmap_fragment, envmap_common_pars_fragment, envmap_pars_fragment, envmap_pars_vertex, envmap_vertex, fog_vertex, fog_pars_vertex, fog_fragment, fog_pars_fragment, gradientmap_pars_fragment, lightmap_pars_fragment, lights_lambert_fragment, lights_lambert_pars_fragment, lights_pars_begin, envmap_physical_pars_fragment, lights_toon_fragment, lights_toon_pars_fragment, lights_phong_fragment, lights_phong_pars_fragment, lights_physical_fragment, lights_physical_pars_fragment, lights_fragment_begin, lights_fragment_maps, lights_fragment_end, logdepthbuf_fragment, logdepthbuf_pars_fragment, logdepthbuf_pars_vertex, logdepthbuf_vertex, map_fragment, map_pars_fragment, map_particle_fragment, map_particle_pars_fragment, metalnessmap_fragment, metalnessmap_pars_fragment, morphinstance_vertex, morphcolor_vertex, morphnormal_vertex, morphtarget_pars_vertex, morphtarget_vertex, normal_fragment_begin, normal_fragment_maps, normal_pars_fragment, normal_pars_vertex, normal_vertex, normalmap_pars_fragment, clearcoat_normal_fragment_begin, clearcoat_normal_fragment_maps, clearcoat_pars_fragment, iridescence_pars_fragment, opaque_fragment, packing, premultiplied_alpha_fragment, project_vertex, dithering_fragment, dithering_pars_fragment, roughnessmap_fragment, roughnessmap_pars_fragment, shadowmap_pars_fragment, shadowmap_pars_vertex, shadowmap_vertex, shadowmask_pars_fragment, skinbase_vertex, skinning_pars_vertex, skinning_vertex, skinnormal_vertex, specularmap_fragment, specularmap_pars_fragment, tonemapping_fragment, tonemapping_pars_fragment, transmission_fragment, transmission_pars_fragment, uv_pars_fragment, uv_pars_vertex, uv_vertex, worldpos_vertex, vertex$h, fragment$h, vertex$g, fragment$g, vertex$f, fragment$f, vertex$e, fragment$e, vertex$d, fragment$d, vertex$c, fragment$c, vertex$b, fragment$b, vertex$a, fragment$a, vertex$9, fragment$9, vertex$8, fragment$8, vertex$7, fragment$7, vertex$6, fragment$6, vertex$5, fragment$5, vertex$4, fragment$4, vertex$3, fragment$3, vertex$2, fragment$2, vertex$1, fragment$1, ShaderChunk, UniformsLib, ShaderLib, _rgb, _e1$1, _m1$12, LOD_MIN, EXTRA_LOD_SIGMA, MAX_SAMPLES, _flatCamera, _clearColor, _oldTarget, _oldActiveCubeFace, _oldActiveMipmapLevel, _oldXrEnabled, PHI, INV_PHI, _axisDirections, _origin, PMREMGenerator, emptyTexture, emptyShadowTexture, emptyArrayTexture, empty3dTexture, emptyCubeTexture, arrayCacheF32, arrayCacheI32, mat4array, mat3array, mat2array, SingleUniform, PureArrayUniform, StructuredUniform, RePathPart, WebGLUniforms, COMPLETION_STATUS_KHR, programIdCount, _m0, _v0, includePattern, shaderChunkMap, unrollLoopPattern, _id, WebGLShaderCache, WebGLShaderStage, nextVersion, vertex, fragment, reversedFuncs, _occlusion_vertex, _occlusion_fragment, WebXRDepthSensing, WebXRManager, _e1, _m12, WebGLRenderer;
var init_three_module = __esm({
  "site/vendor/three.module.js"() {
    init_three_core();
    init_three_core();
    alphahash_fragment = "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
    alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif";
    alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
    alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
    alphatest_fragment = "#ifdef USE_ALPHATEST\n	#ifdef ALPHA_TO_COVERAGE\n	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n	if ( diffuseColor.a == 0.0 ) discard;\n	#else\n	if ( diffuseColor.a < alphaTest ) discard;\n	#endif\n#endif";
    alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
    aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
    aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
    batching_pars_vertex = "#ifdef USE_BATCHING\n	#if ! defined( GL_ANGLE_multi_draw )\n	#define gl_DrawID _gl_DrawID\n	uniform int _gl_DrawID;\n	#endif\n	uniform highp sampler2D batchingTexture;\n	uniform highp usampler2D batchingIdTexture;\n	mat4 getBatchingMatrix( const in float i ) {\n		int size = textureSize( batchingTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n	float getIndirectIndex( const in int i ) {\n		int size = textureSize( batchingIdTexture, 0 ).x;\n		int x = i % size;\n		int y = i / size;\n		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n	}\n#endif\n#ifdef USE_BATCHING_COLOR\n	uniform sampler2D batchingColorTexture;\n	vec3 getBatchingColor( const in float i ) {\n		int size = textureSize( batchingColorTexture, 0 ).x;\n		int j = int( i );\n		int x = j % size;\n		int y = j / size;\n		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n	}\n#endif";
    batching_vertex = "#ifdef USE_BATCHING\n	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
    begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif";
    beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
    bsdfs = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
    iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
    bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
    clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#ifdef ALPHA_TO_COVERAGE\n		float distanceToPlane, distanceGradient;\n		float clipOpacity = 1.0;\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n			distanceGradient = fwidth( distanceToPlane ) / 2.0;\n			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			if ( clipOpacity == 0.0 ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			float unionClipOpacity = 1.0;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n				distanceGradient = fwidth( distanceToPlane ) / 2.0;\n				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			}\n			#pragma unroll_loop_end\n			clipOpacity *= 1.0 - unionClipOpacity;\n		#endif\n		diffuseColor.a *= clipOpacity;\n		if ( diffuseColor.a == 0.0 ) discard;\n	#else\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			bool clipped = true;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n			}\n			#pragma unroll_loop_end\n			if ( clipped ) discard;\n		#endif\n	#endif\n#endif";
    clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
    clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
    clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
    color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
    color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
    color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	varying vec3 vColor;\n#endif";
    color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n	vColor.xyz *= batchingColor.xyz;\n#endif";
    common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
    cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
    defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n	vec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n	mat3 bm = mat3( batchingMatrix );\n	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n	transformedNormal = bm * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = bm * transformedTangent;\n	#endif\n#endif\n#ifdef USE_INSTANCING\n	mat3 im = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n	transformedNormal = im * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = im * transformedTangent;\n	#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
    displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
    displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
    emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n		emissiveColor = sRGBTransferEOTF( emissiveColor );\n	#endif\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
    emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
    colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
    colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
    envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
    envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	uniform mat3 envMapRotation;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
    envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
    envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
    envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
    fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
    fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
    fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
    fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
    gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
    lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
    lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
    lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
    lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n	if ( cutoffDistance > 0.0 ) {\n		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n	}\n	return distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
    envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif";
    lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
    lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
    lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
    lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
    lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n	material.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	if( material.anisotropy == 0.0 ) {\n		anisotropyV = vec2( 1.0, 0.0 );\n	} else {\n		anisotropyV /= material.anisotropy;\n		material.anisotropy = saturate( material.anisotropy );\n	}\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
    lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	float dispersion;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
    lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
    lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometryNormal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
    lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
    logdepthbuf_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
    logdepthbuf_pars_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
    logdepthbuf_pars_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
    logdepthbuf_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n	vFragDepth = 1.0 + gl_Position.w;\n	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
    map_fragment = "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif";
    map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
    map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
    map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
    metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
    metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
    morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n	float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n	}\n#endif";
    morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
    morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
    morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	#ifndef USE_INSTANCING_MORPH\n		uniform float morphTargetBaseInfluence;\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	#endif\n	uniform sampler2DArray morphTargetsTexture;\n	uniform ivec2 morphTargetsTextureSize;\n	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n		int y = texelIndex / morphTargetsTextureSize.x;\n		int x = texelIndex - y * morphTargetsTextureSize.x;\n		ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n		return texelFetch( morphTargetsTexture, morphUV, 0 );\n	}\n#endif";
    morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
    normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
    normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
    normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
    normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
    normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
    normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
    clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
    clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
    clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
    iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
    opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
    packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n	if( v <= 0.0 )\n		return vec4( 0., 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec4( 1., 1., 1., 1. );\n	float vuf;\n	float af = modf( v * PackFactors.a, vuf );\n	float bf = modf( vuf * ShiftRight8, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n	if( v <= 0.0 )\n		return vec3( 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec3( 1., 1., 1. );\n	float vuf;\n	float bf = modf( v * PackFactors.b, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n	if( v <= 0.0 )\n		return vec2( 0., 0. );\n	if( v >= 1.0 )\n		return vec2( 1., 1. );\n	float vuf;\n	float gf = modf( v * 256., vuf );\n	return vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n	return dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
    premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
    project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n	mvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
    dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
    dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
    roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
    roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
    shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		float depth = unpackRGBAToDepth( texture2D( depths, uv ) );\n		#ifdef USE_REVERSED_DEPTH_BUFFER\n			return step( depth, compare );\n		#else\n			return step( compare, depth );\n		#endif\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow( sampler2D shadow, vec2 uv, float compare ) {\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		#ifdef USE_REVERSED_DEPTH_BUFFER\n			float hard_shadow = step( distribution.x, compare );\n		#else\n			float hard_shadow = step( compare, distribution.x );\n		#endif\n		if ( hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		float shadow = 1.0;\n		vec3 lightToPosition = shadowCoord.xyz;\n		\n		float lightToPositionLength = length( lightToPosition );\n		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;\n			vec3 bd3D = normalize( lightToPosition );\n			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n				shadow = (\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n				) * ( 1.0 / 9.0 );\n			#else\n				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n			#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n#endif";
    shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
    shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
    shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
    skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
    skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	mat4 getBoneMatrix( const in float i ) {\n		int size = textureSize( boneTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n#endif";
    skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
    skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
    specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
    specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
    tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
    tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n	vec3( 1.6605, - 0.1246, - 0.0182 ),\n	vec3( - 0.5876, 1.1329, - 0.1006 ),\n	vec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n	vec3( 0.6274, 0.0691, 0.0164 ),\n	vec3( 0.3293, 0.9195, 0.0880 ),\n	vec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n	vec3 x2 = x * x;\n	vec3 x4 = x2 * x2;\n	return + 15.5 * x4 * x2\n		- 40.14 * x4 * x\n		+ 31.96 * x4\n		- 6.868 * x2 * x\n		+ 0.4298 * x2\n		+ 0.1191 * x\n		- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n	const mat3 AgXInsetMatrix = mat3(\n		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n	);\n	const mat3 AgXOutsetMatrix = mat3(\n		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n	);\n	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;\n	color *= toneMappingExposure;\n	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n	color = AgXInsetMatrix * color;\n	color = max( color, 1e-10 );	color = log2( color );\n	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n	color = clamp( color, 0.0, 1.0 );\n	color = agxDefaultContrastApprox( color );\n	color = AgXOutsetMatrix * color;\n	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n	color = clamp( color, 0.0, 1.0 );\n	return color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n	const float StartCompression = 0.8 - 0.04;\n	const float Desaturation = 0.15;\n	color *= toneMappingExposure;\n	float x = min( color.r, min( color.g, color.b ) );\n	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n	color -= offset;\n	float peak = max( color.r, max( color.g, color.b ) );\n	if ( peak < StartCompression ) return color;\n	float d = 1. - StartCompression;\n	float newPeak = 1. - d * d / ( peak + d - StartCompression );\n	color *= newPeak / peak;\n	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n	return mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
    transmission_fragment = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
    transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec4 transmittedLight;\n		vec3 transmittance;\n		#ifdef USE_DISPERSION\n			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n			for ( int i = 0; i < 3; i ++ ) {\n				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n				vec3 refractedRayExit = position + transmissionRay;\n				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n				vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n				refractionCoords += 1.0;\n				refractionCoords /= 2.0;\n				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n				transmittedLight[ i ] = transmissionSample[ i ];\n				transmittedLight.a += transmissionSample.a;\n				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n			}\n			transmittedLight.a /= 3.0;\n		#else\n			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n			vec3 refractedRayExit = position + transmissionRay;\n			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n			vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n			refractionCoords += 1.0;\n			refractionCoords /= 2.0;\n			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		#endif\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif";
    uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
    uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
    uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
    worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_BATCHING\n		worldPosition = batchingMatrix * worldPosition;\n	#endif\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
    vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
    fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
    vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
    fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
    vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
    fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
    vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
    fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	#ifdef USE_REVERSED_DEPTH_BUFFER\n		float fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n	#else\n		float fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n	#endif\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#elif DEPTH_PACKING == 3202\n		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n	#elif DEPTH_PACKING == 3203\n		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n	#endif\n}";
    vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
    fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
    vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
    fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
    vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
    fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
    vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
    fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
    vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
    fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
    vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
    fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
    vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
    fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
    vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
    fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
    vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
    fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n	uniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
    vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
    fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
    vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
    fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
    vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
    fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
    vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix[ 3 ];\n	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
    fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
    ShaderChunk = {
      alphahash_fragment,
      alphahash_pars_fragment,
      alphamap_fragment,
      alphamap_pars_fragment,
      alphatest_fragment,
      alphatest_pars_fragment,
      aomap_fragment,
      aomap_pars_fragment,
      batching_pars_vertex,
      batching_vertex,
      begin_vertex,
      beginnormal_vertex,
      bsdfs,
      iridescence_fragment,
      bumpmap_pars_fragment,
      clipping_planes_fragment,
      clipping_planes_pars_fragment,
      clipping_planes_pars_vertex,
      clipping_planes_vertex,
      color_fragment,
      color_pars_fragment,
      color_pars_vertex,
      color_vertex,
      common,
      cube_uv_reflection_fragment,
      defaultnormal_vertex,
      displacementmap_pars_vertex,
      displacementmap_vertex,
      emissivemap_fragment,
      emissivemap_pars_fragment,
      colorspace_fragment,
      colorspace_pars_fragment,
      envmap_fragment,
      envmap_common_pars_fragment,
      envmap_pars_fragment,
      envmap_pars_vertex,
      envmap_physical_pars_fragment,
      envmap_vertex,
      fog_vertex,
      fog_pars_vertex,
      fog_fragment,
      fog_pars_fragment,
      gradientmap_pars_fragment,
      lightmap_pars_fragment,
      lights_lambert_fragment,
      lights_lambert_pars_fragment,
      lights_pars_begin,
      lights_toon_fragment,
      lights_toon_pars_fragment,
      lights_phong_fragment,
      lights_phong_pars_fragment,
      lights_physical_fragment,
      lights_physical_pars_fragment,
      lights_fragment_begin,
      lights_fragment_maps,
      lights_fragment_end,
      logdepthbuf_fragment,
      logdepthbuf_pars_fragment,
      logdepthbuf_pars_vertex,
      logdepthbuf_vertex,
      map_fragment,
      map_pars_fragment,
      map_particle_fragment,
      map_particle_pars_fragment,
      metalnessmap_fragment,
      metalnessmap_pars_fragment,
      morphinstance_vertex,
      morphcolor_vertex,
      morphnormal_vertex,
      morphtarget_pars_vertex,
      morphtarget_vertex,
      normal_fragment_begin,
      normal_fragment_maps,
      normal_pars_fragment,
      normal_pars_vertex,
      normal_vertex,
      normalmap_pars_fragment,
      clearcoat_normal_fragment_begin,
      clearcoat_normal_fragment_maps,
      clearcoat_pars_fragment,
      iridescence_pars_fragment,
      opaque_fragment,
      packing,
      premultiplied_alpha_fragment,
      project_vertex,
      dithering_fragment,
      dithering_pars_fragment,
      roughnessmap_fragment,
      roughnessmap_pars_fragment,
      shadowmap_pars_fragment,
      shadowmap_pars_vertex,
      shadowmap_vertex,
      shadowmask_pars_fragment,
      skinbase_vertex,
      skinning_pars_vertex,
      skinning_vertex,
      skinnormal_vertex,
      specularmap_fragment,
      specularmap_pars_fragment,
      tonemapping_fragment,
      tonemapping_pars_fragment,
      transmission_fragment,
      transmission_pars_fragment,
      uv_pars_fragment,
      uv_pars_vertex,
      uv_vertex,
      worldpos_vertex,
      background_vert: vertex$h,
      background_frag: fragment$h,
      backgroundCube_vert: vertex$g,
      backgroundCube_frag: fragment$g,
      cube_vert: vertex$f,
      cube_frag: fragment$f,
      depth_vert: vertex$e,
      depth_frag: fragment$e,
      distanceRGBA_vert: vertex$d,
      distanceRGBA_frag: fragment$d,
      equirect_vert: vertex$c,
      equirect_frag: fragment$c,
      linedashed_vert: vertex$b,
      linedashed_frag: fragment$b,
      meshbasic_vert: vertex$a,
      meshbasic_frag: fragment$a,
      meshlambert_vert: vertex$9,
      meshlambert_frag: fragment$9,
      meshmatcap_vert: vertex$8,
      meshmatcap_frag: fragment$8,
      meshnormal_vert: vertex$7,
      meshnormal_frag: fragment$7,
      meshphong_vert: vertex$6,
      meshphong_frag: fragment$6,
      meshphysical_vert: vertex$5,
      meshphysical_frag: fragment$5,
      meshtoon_vert: vertex$4,
      meshtoon_frag: fragment$4,
      points_vert: vertex$3,
      points_frag: fragment$3,
      shadow_vert: vertex$2,
      shadow_frag: fragment$2,
      sprite_vert: vertex$1,
      sprite_frag: fragment$1
    };
    UniformsLib = {
      common: {
        diffuse: { value: /* @__PURE__ */ new Color(16777215) },
        opacity: { value: 1 },
        map: { value: null },
        mapTransform: { value: /* @__PURE__ */ new Matrix3() },
        alphaMap: { value: null },
        alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        alphaTest: { value: 0 }
      },
      specularmap: {
        specularMap: { value: null },
        specularMapTransform: { value: /* @__PURE__ */ new Matrix3() }
      },
      envmap: {
        envMap: { value: null },
        envMapRotation: { value: /* @__PURE__ */ new Matrix3() },
        flipEnvMap: { value: -1 },
        reflectivity: { value: 1 },
        // basic, lambert, phong
        ior: { value: 1.5 },
        // physical
        refractionRatio: { value: 0.98 }
        // basic, lambert, phong
      },
      aomap: {
        aoMap: { value: null },
        aoMapIntensity: { value: 1 },
        aoMapTransform: { value: /* @__PURE__ */ new Matrix3() }
      },
      lightmap: {
        lightMap: { value: null },
        lightMapIntensity: { value: 1 },
        lightMapTransform: { value: /* @__PURE__ */ new Matrix3() }
      },
      bumpmap: {
        bumpMap: { value: null },
        bumpMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        bumpScale: { value: 1 }
      },
      normalmap: {
        normalMap: { value: null },
        normalMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        normalScale: { value: /* @__PURE__ */ new Vector2(1, 1) }
      },
      displacementmap: {
        displacementMap: { value: null },
        displacementMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        displacementScale: { value: 1 },
        displacementBias: { value: 0 }
      },
      emissivemap: {
        emissiveMap: { value: null },
        emissiveMapTransform: { value: /* @__PURE__ */ new Matrix3() }
      },
      metalnessmap: {
        metalnessMap: { value: null },
        metalnessMapTransform: { value: /* @__PURE__ */ new Matrix3() }
      },
      roughnessmap: {
        roughnessMap: { value: null },
        roughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() }
      },
      gradientmap: {
        gradientMap: { value: null }
      },
      fog: {
        fogDensity: { value: 25e-5 },
        fogNear: { value: 1 },
        fogFar: { value: 2e3 },
        fogColor: { value: /* @__PURE__ */ new Color(16777215) }
      },
      lights: {
        ambientLightColor: { value: [] },
        lightProbe: { value: [] },
        directionalLights: { value: [], properties: {
          direction: {},
          color: {}
        } },
        directionalLightShadows: { value: [], properties: {
          shadowIntensity: 1,
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {}
        } },
        directionalShadowMap: { value: [] },
        directionalShadowMatrix: { value: [] },
        spotLights: { value: [], properties: {
          color: {},
          position: {},
          direction: {},
          distance: {},
          coneCos: {},
          penumbraCos: {},
          decay: {}
        } },
        spotLightShadows: { value: [], properties: {
          shadowIntensity: 1,
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {}
        } },
        spotLightMap: { value: [] },
        spotShadowMap: { value: [] },
        spotLightMatrix: { value: [] },
        pointLights: { value: [], properties: {
          color: {},
          position: {},
          decay: {},
          distance: {}
        } },
        pointLightShadows: { value: [], properties: {
          shadowIntensity: 1,
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {},
          shadowCameraNear: {},
          shadowCameraFar: {}
        } },
        pointShadowMap: { value: [] },
        pointShadowMatrix: { value: [] },
        hemisphereLights: { value: [], properties: {
          direction: {},
          skyColor: {},
          groundColor: {}
        } },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: { value: [], properties: {
          color: {},
          position: {},
          width: {},
          height: {}
        } },
        ltc_1: { value: null },
        ltc_2: { value: null }
      },
      points: {
        diffuse: { value: /* @__PURE__ */ new Color(16777215) },
        opacity: { value: 1 },
        size: { value: 1 },
        scale: { value: 1 },
        map: { value: null },
        alphaMap: { value: null },
        alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        alphaTest: { value: 0 },
        uvTransform: { value: /* @__PURE__ */ new Matrix3() }
      },
      sprite: {
        diffuse: { value: /* @__PURE__ */ new Color(16777215) },
        opacity: { value: 1 },
        center: { value: /* @__PURE__ */ new Vector2(0.5, 0.5) },
        rotation: { value: 0 },
        map: { value: null },
        mapTransform: { value: /* @__PURE__ */ new Matrix3() },
        alphaMap: { value: null },
        alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        alphaTest: { value: 0 }
      }
    };
    ShaderLib = {
      basic: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.common,
          UniformsLib.specularmap,
          UniformsLib.envmap,
          UniformsLib.aomap,
          UniformsLib.lightmap,
          UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.meshbasic_vert,
        fragmentShader: ShaderChunk.meshbasic_frag
      },
      lambert: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.common,
          UniformsLib.specularmap,
          UniformsLib.envmap,
          UniformsLib.aomap,
          UniformsLib.lightmap,
          UniformsLib.emissivemap,
          UniformsLib.bumpmap,
          UniformsLib.normalmap,
          UniformsLib.displacementmap,
          UniformsLib.fog,
          UniformsLib.lights,
          {
            emissive: { value: /* @__PURE__ */ new Color(0) }
          }
        ]),
        vertexShader: ShaderChunk.meshlambert_vert,
        fragmentShader: ShaderChunk.meshlambert_frag
      },
      phong: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.common,
          UniformsLib.specularmap,
          UniformsLib.envmap,
          UniformsLib.aomap,
          UniformsLib.lightmap,
          UniformsLib.emissivemap,
          UniformsLib.bumpmap,
          UniformsLib.normalmap,
          UniformsLib.displacementmap,
          UniformsLib.fog,
          UniformsLib.lights,
          {
            emissive: { value: /* @__PURE__ */ new Color(0) },
            specular: { value: /* @__PURE__ */ new Color(1118481) },
            shininess: { value: 30 }
          }
        ]),
        vertexShader: ShaderChunk.meshphong_vert,
        fragmentShader: ShaderChunk.meshphong_frag
      },
      standard: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.common,
          UniformsLib.envmap,
          UniformsLib.aomap,
          UniformsLib.lightmap,
          UniformsLib.emissivemap,
          UniformsLib.bumpmap,
          UniformsLib.normalmap,
          UniformsLib.displacementmap,
          UniformsLib.roughnessmap,
          UniformsLib.metalnessmap,
          UniformsLib.fog,
          UniformsLib.lights,
          {
            emissive: { value: /* @__PURE__ */ new Color(0) },
            roughness: { value: 1 },
            metalness: { value: 0 },
            envMapIntensity: { value: 1 }
          }
        ]),
        vertexShader: ShaderChunk.meshphysical_vert,
        fragmentShader: ShaderChunk.meshphysical_frag
      },
      toon: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.common,
          UniformsLib.aomap,
          UniformsLib.lightmap,
          UniformsLib.emissivemap,
          UniformsLib.bumpmap,
          UniformsLib.normalmap,
          UniformsLib.displacementmap,
          UniformsLib.gradientmap,
          UniformsLib.fog,
          UniformsLib.lights,
          {
            emissive: { value: /* @__PURE__ */ new Color(0) }
          }
        ]),
        vertexShader: ShaderChunk.meshtoon_vert,
        fragmentShader: ShaderChunk.meshtoon_frag
      },
      matcap: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.common,
          UniformsLib.bumpmap,
          UniformsLib.normalmap,
          UniformsLib.displacementmap,
          UniformsLib.fog,
          {
            matcap: { value: null }
          }
        ]),
        vertexShader: ShaderChunk.meshmatcap_vert,
        fragmentShader: ShaderChunk.meshmatcap_frag
      },
      points: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.points,
          UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.points_vert,
        fragmentShader: ShaderChunk.points_frag
      },
      dashed: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.common,
          UniformsLib.fog,
          {
            scale: { value: 1 },
            dashSize: { value: 1 },
            totalSize: { value: 2 }
          }
        ]),
        vertexShader: ShaderChunk.linedashed_vert,
        fragmentShader: ShaderChunk.linedashed_frag
      },
      depth: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.common,
          UniformsLib.displacementmap
        ]),
        vertexShader: ShaderChunk.depth_vert,
        fragmentShader: ShaderChunk.depth_frag
      },
      normal: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.common,
          UniformsLib.bumpmap,
          UniformsLib.normalmap,
          UniformsLib.displacementmap,
          {
            opacity: { value: 1 }
          }
        ]),
        vertexShader: ShaderChunk.meshnormal_vert,
        fragmentShader: ShaderChunk.meshnormal_frag
      },
      sprite: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.sprite,
          UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.sprite_vert,
        fragmentShader: ShaderChunk.sprite_frag
      },
      background: {
        uniforms: {
          uvTransform: { value: /* @__PURE__ */ new Matrix3() },
          t2D: { value: null },
          backgroundIntensity: { value: 1 }
        },
        vertexShader: ShaderChunk.background_vert,
        fragmentShader: ShaderChunk.background_frag
      },
      backgroundCube: {
        uniforms: {
          envMap: { value: null },
          flipEnvMap: { value: -1 },
          backgroundBlurriness: { value: 0 },
          backgroundIntensity: { value: 1 },
          backgroundRotation: { value: /* @__PURE__ */ new Matrix3() }
        },
        vertexShader: ShaderChunk.backgroundCube_vert,
        fragmentShader: ShaderChunk.backgroundCube_frag
      },
      cube: {
        uniforms: {
          tCube: { value: null },
          tFlip: { value: -1 },
          opacity: { value: 1 }
        },
        vertexShader: ShaderChunk.cube_vert,
        fragmentShader: ShaderChunk.cube_frag
      },
      equirect: {
        uniforms: {
          tEquirect: { value: null }
        },
        vertexShader: ShaderChunk.equirect_vert,
        fragmentShader: ShaderChunk.equirect_frag
      },
      distanceRGBA: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.common,
          UniformsLib.displacementmap,
          {
            referencePosition: { value: /* @__PURE__ */ new Vector3() },
            nearDistance: { value: 1 },
            farDistance: { value: 1e3 }
          }
        ]),
        vertexShader: ShaderChunk.distanceRGBA_vert,
        fragmentShader: ShaderChunk.distanceRGBA_frag
      },
      shadow: {
        uniforms: /* @__PURE__ */ mergeUniforms([
          UniformsLib.lights,
          UniformsLib.fog,
          {
            color: { value: /* @__PURE__ */ new Color(0) },
            opacity: { value: 1 }
          }
        ]),
        vertexShader: ShaderChunk.shadow_vert,
        fragmentShader: ShaderChunk.shadow_frag
      }
    };
    ShaderLib.physical = {
      uniforms: /* @__PURE__ */ mergeUniforms([
        ShaderLib.standard.uniforms,
        {
          clearcoat: { value: 0 },
          clearcoatMap: { value: null },
          clearcoatMapTransform: { value: /* @__PURE__ */ new Matrix3() },
          clearcoatNormalMap: { value: null },
          clearcoatNormalMapTransform: { value: /* @__PURE__ */ new Matrix3() },
          clearcoatNormalScale: { value: /* @__PURE__ */ new Vector2(1, 1) },
          clearcoatRoughness: { value: 0 },
          clearcoatRoughnessMap: { value: null },
          clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
          dispersion: { value: 0 },
          iridescence: { value: 0 },
          iridescenceMap: { value: null },
          iridescenceMapTransform: { value: /* @__PURE__ */ new Matrix3() },
          iridescenceIOR: { value: 1.3 },
          iridescenceThicknessMinimum: { value: 100 },
          iridescenceThicknessMaximum: { value: 400 },
          iridescenceThicknessMap: { value: null },
          iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
          sheen: { value: 0 },
          sheenColor: { value: /* @__PURE__ */ new Color(0) },
          sheenColorMap: { value: null },
          sheenColorMapTransform: { value: /* @__PURE__ */ new Matrix3() },
          sheenRoughness: { value: 1 },
          sheenRoughnessMap: { value: null },
          sheenRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
          transmission: { value: 0 },
          transmissionMap: { value: null },
          transmissionMapTransform: { value: /* @__PURE__ */ new Matrix3() },
          transmissionSamplerSize: { value: /* @__PURE__ */ new Vector2() },
          transmissionSamplerMap: { value: null },
          thickness: { value: 0 },
          thicknessMap: { value: null },
          thicknessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
          attenuationDistance: { value: 0 },
          attenuationColor: { value: /* @__PURE__ */ new Color(0) },
          specularColor: { value: /* @__PURE__ */ new Color(1, 1, 1) },
          specularColorMap: { value: null },
          specularColorMapTransform: { value: /* @__PURE__ */ new Matrix3() },
          specularIntensity: { value: 1 },
          specularIntensityMap: { value: null },
          specularIntensityMapTransform: { value: /* @__PURE__ */ new Matrix3() },
          anisotropyVector: { value: /* @__PURE__ */ new Vector2() },
          anisotropyMap: { value: null },
          anisotropyMapTransform: { value: /* @__PURE__ */ new Matrix3() }
        }
      ]),
      vertexShader: ShaderChunk.meshphysical_vert,
      fragmentShader: ShaderChunk.meshphysical_frag
    };
    _rgb = { r: 0, b: 0, g: 0 };
    _e1$1 = /* @__PURE__ */ new Euler();
    _m1$12 = /* @__PURE__ */ new Matrix4();
    LOD_MIN = 4;
    EXTRA_LOD_SIGMA = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582];
    MAX_SAMPLES = 20;
    _flatCamera = /* @__PURE__ */ new OrthographicCamera();
    _clearColor = /* @__PURE__ */ new Color();
    _oldTarget = null;
    _oldActiveCubeFace = 0;
    _oldActiveMipmapLevel = 0;
    _oldXrEnabled = false;
    PHI = (1 + Math.sqrt(5)) / 2;
    INV_PHI = 1 / PHI;
    _axisDirections = [
      /* @__PURE__ */ new Vector3(-PHI, INV_PHI, 0),
      /* @__PURE__ */ new Vector3(PHI, INV_PHI, 0),
      /* @__PURE__ */ new Vector3(-INV_PHI, 0, PHI),
      /* @__PURE__ */ new Vector3(INV_PHI, 0, PHI),
      /* @__PURE__ */ new Vector3(0, PHI, -INV_PHI),
      /* @__PURE__ */ new Vector3(0, PHI, INV_PHI),
      /* @__PURE__ */ new Vector3(-1, 1, -1),
      /* @__PURE__ */ new Vector3(1, 1, -1),
      /* @__PURE__ */ new Vector3(-1, 1, 1),
      /* @__PURE__ */ new Vector3(1, 1, 1)
    ];
    _origin = /* @__PURE__ */ new Vector3();
    PMREMGenerator = class {
      /**
       * Constructs a new PMREM generator.
       *
       * @param {WebGLRenderer} renderer - The renderer.
       */
      constructor(renderer) {
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
      }
      /**
       * Generates a PMREM from a supplied Scene, which can be faster than using an
       * image if networking bandwidth is low. Optional sigma specifies a blur radius
       * in radians to be applied to the scene before PMREM generation. Optional near
       * and far planes ensure the scene is rendered in its entirety.
       *
       * @param {Scene} scene - The scene to be captured.
       * @param {number} [sigma=0] - The blur radius in radians.
       * @param {number} [near=0.1] - The near plane distance.
       * @param {number} [far=100] - The far plane distance.
       * @param {Object} [options={}] - The configuration options.
       * @param {number} [options.size=256] - The texture size of the PMREM.
       * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
       * @return {WebGLRenderTarget} The resulting PMREM.
       */
      fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        const {
          size = 256,
          position = _origin
        } = options;
        _oldTarget = this._renderer.getRenderTarget();
        _oldActiveCubeFace = this._renderer.getActiveCubeFace();
        _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        _oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(size);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
        if (sigma > 0) {
          this._blur(cubeUVRenderTarget, 0, 0, sigma);
        }
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
      }
      /**
       * Generates a PMREM from an equirectangular texture, which can be either LDR
       * or HDR. The ideal input image size is 1k (1024 x 512),
       * as this matches best with the 256 x 256 cubemap output.
       *
       * @param {Texture} equirectangular - The equirectangular texture to be converted.
       * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
       * @return {WebGLRenderTarget} The resulting PMREM.
       */
      fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
      }
      /**
       * Generates a PMREM from an cubemap texture, which can be either LDR
       * or HDR. The ideal input cube size is 256 x 256,
       * as this matches best with the 256 x 256 cubemap output.
       *
       * @param {Texture} cubemap - The cubemap texture to be converted.
       * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
       * @return {WebGLRenderTarget} The resulting PMREM.
       */
      fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
      }
      /**
       * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
       * your texture's network fetch for increased concurrency.
       */
      compileCubemapShader() {
        if (this._cubemapMaterial === null) {
          this._cubemapMaterial = _getCubemapMaterial();
          this._compileMaterial(this._cubemapMaterial);
        }
      }
      /**
       * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
       * your texture's network fetch for increased concurrency.
       */
      compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
          this._equirectMaterial = _getEquirectMaterial();
          this._compileMaterial(this._equirectMaterial);
        }
      }
      /**
       * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
       * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
       * one of them will cause any others to also become unusable.
       */
      dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
      }
      // private interface
      _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
      }
      _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for (let i = 0; i < this._lodPlanes.length; i++) {
          this._lodPlanes[i].dispose();
        }
      }
      _cleanup(outputTarget) {
        this._renderer.setRenderTarget(_oldTarget, _oldActiveCubeFace, _oldActiveMipmapLevel);
        this._renderer.xr.enabled = _oldXrEnabled;
        outputTarget.scissorTest = false;
        _setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
      }
      _fromTexture(texture, renderTarget) {
        if (texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping) {
          this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        } else {
          this._setSize(texture.image.width / 4);
        }
        _oldTarget = this._renderer.getRenderTarget();
        _oldActiveCubeFace = this._renderer.getActiveCubeFace();
        _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        _oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
      }
      _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 16 * 7);
        const height = 4 * this._cubeSize;
        const params = {
          magFilter: LinearFilter,
          minFilter: LinearFilter,
          generateMipmaps: false,
          type: HalfFloatType,
          format: RGBAFormat,
          colorSpace: LinearSRGBColorSpace,
          depthBuffer: false
        };
        const cubeUVRenderTarget = _createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
          if (this._pingPongRenderTarget !== null) {
            this._dispose();
          }
          this._pingPongRenderTarget = _createRenderTarget(width, height, params);
          const { _lodMax } = this;
          ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = _createPlanes(_lodMax));
          this._blurMaterial = _getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
      }
      _compileMaterial(material) {
        const tmpMesh = new Mesh(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, _flatCamera);
      }
      _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
        const fov2 = 90;
        const aspect2 = 1;
        const cubeCamera = new PerspectiveCamera(fov2, aspect2, near, far);
        const upSign = [1, -1, 1, 1, 1, 1];
        const forwardSign = [1, 1, 1, -1, -1, -1];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor(_clearColor);
        renderer.toneMapping = NoToneMapping;
        renderer.autoClear = false;
        const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        if (reversedDepthBuffer) {
          renderer.setRenderTarget(cubeUVRenderTarget);
          renderer.clearDepth();
          renderer.setRenderTarget(null);
        }
        const backgroundMaterial = new MeshBasicMaterial({
          name: "PMREM.Background",
          side: BackSide,
          depthWrite: false,
          depthTest: false
        });
        const backgroundBox = new Mesh(new BoxGeometry(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
          if (background.isColor) {
            backgroundMaterial.color.copy(background);
            scene.background = null;
            useSolidColor = true;
          }
        } else {
          backgroundMaterial.color.copy(_clearColor);
          useSolidColor = true;
        }
        for (let i = 0; i < 6; i++) {
          const col = i % 3;
          if (col === 0) {
            cubeCamera.up.set(0, upSign[i], 0);
            cubeCamera.position.set(position.x, position.y, position.z);
            cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
          } else if (col === 1) {
            cubeCamera.up.set(0, 0, upSign[i]);
            cubeCamera.position.set(position.x, position.y, position.z);
            cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
          } else {
            cubeCamera.up.set(0, upSign[i], 0);
            cubeCamera.position.set(position.x, position.y, position.z);
            cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
          }
          const size = this._cubeSize;
          _setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
          renderer.setRenderTarget(cubeUVRenderTarget);
          if (useSolidColor) {
            renderer.render(backgroundBox, cubeCamera);
          }
          renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
      }
      _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping;
        if (isCubeTexture) {
          if (this._cubemapMaterial === null) {
            this._cubemapMaterial = _getCubemapMaterial();
          }
          this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else {
          if (this._equirectMaterial === null) {
            this._equirectMaterial = _getEquirectMaterial();
          }
        }
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new Mesh(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        const size = this._cubeSize;
        _setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, _flatCamera);
      }
      _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodPlanes.length;
        for (let i = 1; i < n; i++) {
          const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
          const poleAxis = _axisDirections[(n - i - 1) % _axisDirections.length];
          this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
      }
      /**
       * This is a two-pass Gaussian blur for a cubemap. Normally this is done
       * vertically and horizontally, but this breaks down on a cube. Here we apply
       * the blur latitudinally (around the poles), and then longitudinally (towards
       * the poles) to approximate the orthogonally-separable blur. It is least
       * accurate at the poles, but still does a decent job.
       *
       * @private
       * @param {WebGLRenderTarget} cubeUVRenderTarget
       * @param {number} lodIn
       * @param {number} lodOut
       * @param {number} sigma
       * @param {Vector3} [poleAxis]
       */
      _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(
          cubeUVRenderTarget,
          pingPongRenderTarget,
          lodIn,
          lodOut,
          sigma,
          "latitudinal",
          poleAxis
        );
        this._halfBlur(
          pingPongRenderTarget,
          cubeUVRenderTarget,
          lodOut,
          lodOut,
          sigma,
          "longitudinal",
          poleAxis
        );
      }
      _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") {
          console.error(
            "blur direction must be either latitudinal or longitudinal!"
          );
        }
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new Mesh(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES;
        if (samples > MAX_SAMPLES) {
          console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${MAX_SAMPLES}`);
        }
        const weights = [];
        let sum = 0;
        for (let i = 0; i < MAX_SAMPLES; ++i) {
          const x2 = i / sigmaPixels;
          const weight = Math.exp(-x2 * x2 / 2);
          weights.push(weight);
          if (i === 0) {
            sum += weight;
          } else if (i < samples) {
            sum += 2 * weight;
          }
        }
        for (let i = 0; i < weights.length; i++) {
          weights[i] = weights[i] / sum;
        }
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) {
          blurUniforms["poleAxis"].value = poleAxis;
        }
        const { _lodMax } = this;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        _setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, _flatCamera);
      }
    };
    emptyTexture = /* @__PURE__ */ new Texture();
    emptyShadowTexture = /* @__PURE__ */ new DepthTexture(1, 1);
    emptyArrayTexture = /* @__PURE__ */ new DataArrayTexture();
    empty3dTexture = /* @__PURE__ */ new Data3DTexture();
    emptyCubeTexture = /* @__PURE__ */ new CubeTexture();
    arrayCacheF32 = [];
    arrayCacheI32 = [];
    mat4array = new Float32Array(16);
    mat3array = new Float32Array(9);
    mat2array = new Float32Array(4);
    SingleUniform = class {
      constructor(id, activeInfo, addr) {
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = getSingularSetter(activeInfo.type);
      }
    };
    PureArrayUniform = class {
      constructor(id, activeInfo, addr) {
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = getPureArraySetter(activeInfo.type);
      }
    };
    StructuredUniform = class {
      constructor(id) {
        this.id = id;
        this.seq = [];
        this.map = {};
      }
      setValue(gl, value, textures) {
        const seq = this.seq;
        for (let i = 0, n = seq.length; i !== n; ++i) {
          const u = seq[i];
          u.setValue(gl, value[u.id], textures);
        }
      }
    };
    RePathPart = /(\w+)(\])?(\[|\.)?/g;
    WebGLUniforms = class {
      constructor(gl, program) {
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for (let i = 0; i < n; ++i) {
          const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
          parseUniform(info, addr, this);
        }
      }
      setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== void 0) u.setValue(gl, value, textures);
      }
      setOptional(gl, object, name) {
        const v = object[name];
        if (v !== void 0) this.setValue(gl, name, v);
      }
      static upload(gl, seq, values, textures) {
        for (let i = 0, n = seq.length; i !== n; ++i) {
          const u = seq[i], v = values[u.id];
          if (v.needsUpdate !== false) {
            u.setValue(gl, v.value, textures);
          }
        }
      }
      static seqWithValue(seq, values) {
        const r = [];
        for (let i = 0, n = seq.length; i !== n; ++i) {
          const u = seq[i];
          if (u.id in values) r.push(u);
        }
        return r;
      }
    };
    COMPLETION_STATUS_KHR = 37297;
    programIdCount = 0;
    _m0 = /* @__PURE__ */ new Matrix3();
    _v0 = /* @__PURE__ */ new Vector3();
    includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
    shaderChunkMap = /* @__PURE__ */ new Map();
    unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
    _id = 0;
    WebGLShaderCache = class {
      constructor() {
        this.shaderCache = /* @__PURE__ */ new Map();
        this.materialCache = /* @__PURE__ */ new Map();
      }
      update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
          materialShaders.add(vertexShaderStage);
          vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
          materialShaders.add(fragmentShaderStage);
          fragmentShaderStage.usedTimes++;
        }
        return this;
      }
      remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders) {
          shaderStage.usedTimes--;
          if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
      }
      getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
      }
      getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
      }
      dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
      }
      _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === void 0) {
          set = /* @__PURE__ */ new Set();
          cache.set(material, set);
        }
        return set;
      }
      _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === void 0) {
          stage = new WebGLShaderStage(code);
          cache.set(code, stage);
        }
        return stage;
      }
    };
    WebGLShaderStage = class {
      constructor(code) {
        this.id = _id++;
        this.code = code;
        this.usedTimes = 0;
      }
    };
    nextVersion = 0;
    vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
    fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
    reversedFuncs = {
      [NeverDepth]: AlwaysDepth,
      [LessDepth]: GreaterDepth,
      [EqualDepth]: NotEqualDepth,
      [LessEqualDepth]: GreaterEqualDepth,
      [AlwaysDepth]: NeverDepth,
      [GreaterDepth]: LessDepth,
      [NotEqualDepth]: EqualDepth,
      [GreaterEqualDepth]: LessEqualDepth
    };
    _occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
    _occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
    WebXRDepthSensing = class {
      /**
       * Constructs a new depth sensing module.
       */
      constructor() {
        this.texture = null;
        this.mesh = null;
        this.depthNear = 0;
        this.depthFar = 0;
      }
      /**
       * Inits the depth sensing module
       *
       * @param {XRWebGLDepthInformation} depthData - The XR depth data.
       * @param {XRRenderState} renderState - The XR render state.
       */
      init(depthData, renderState) {
        if (this.texture === null) {
          const texture = new ExternalTexture(depthData.texture);
          if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
            this.depthNear = depthData.depthNear;
            this.depthFar = depthData.depthFar;
          }
          this.texture = texture;
        }
      }
      /**
       * Returns a plane mesh that visualizes the depth texture.
       *
       * @param {ArrayCamera} cameraXR - The XR camera.
       * @return {?Mesh} The plane mesh.
       */
      getMesh(cameraXR) {
        if (this.texture !== null) {
          if (this.mesh === null) {
            const viewport = cameraXR.cameras[0].viewport;
            const material = new ShaderMaterial({
              vertexShader: _occlusion_vertex,
              fragmentShader: _occlusion_fragment,
              uniforms: {
                depthColor: { value: this.texture },
                depthWidth: { value: viewport.z },
                depthHeight: { value: viewport.w }
              }
            });
            this.mesh = new Mesh(new PlaneGeometry(20, 20), material);
          }
        }
        return this.mesh;
      }
      /**
       * Resets the module
       */
      reset() {
        this.texture = null;
        this.mesh = null;
      }
      /**
       * Returns a texture representing the depth of the user's environment.
       *
       * @return {?ExternalTexture} The depth texture.
       */
      getDepthTexture() {
        return this.texture;
      }
    };
    WebXRManager = class extends EventDispatcher {
      /**
       * Constructs a new WebGL renderer.
       *
       * @param {WebGLRenderer} renderer - The renderer.
       * @param {WebGL2RenderingContext} gl - The rendering context.
       */
      constructor(renderer, gl) {
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        let foveation = 1;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const supportsGlBinding = typeof XRWebGLBinding !== "undefined";
        const depthSensing = new WebXRDepthSensing();
        const cameraAccessTextures = {};
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new Vector2();
        let currentPixelRatio = null;
        const cameraL = new PerspectiveCamera();
        cameraL.viewport = new Vector4();
        const cameraR = new PerspectiveCamera();
        cameraR.viewport = new Vector4();
        const cameras = [cameraL, cameraR];
        const cameraXR = new ArrayCamera();
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
          let controller = controllers[index];
          if (controller === void 0) {
            controller = new WebXRController();
            controllers[index] = controller;
          }
          return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
          let controller = controllers[index];
          if (controller === void 0) {
            controller = new WebXRController();
            controllers[index] = controller;
          }
          return controller.getGripSpace();
        };
        this.getHand = function(index) {
          let controller = controllers[index];
          if (controller === void 0) {
            controller = new WebXRController();
            controllers[index] = controller;
          }
          return controller.getHandSpace();
        };
        function onSessionEvent(event) {
          const controllerIndex = controllerInputSources.indexOf(event.inputSource);
          if (controllerIndex === -1) {
            return;
          }
          const controller = controllers[controllerIndex];
          if (controller !== void 0) {
            controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
            controller.dispatchEvent({ type: event.type, data: event.inputSource });
          }
        }
        function onSessionEnd() {
          session.removeEventListener("select", onSessionEvent);
          session.removeEventListener("selectstart", onSessionEvent);
          session.removeEventListener("selectend", onSessionEvent);
          session.removeEventListener("squeeze", onSessionEvent);
          session.removeEventListener("squeezestart", onSessionEvent);
          session.removeEventListener("squeezeend", onSessionEvent);
          session.removeEventListener("end", onSessionEnd);
          session.removeEventListener("inputsourceschange", onInputSourcesChange);
          for (let i = 0; i < controllers.length; i++) {
            const inputSource = controllerInputSources[i];
            if (inputSource === null) continue;
            controllerInputSources[i] = null;
            controllers[i].disconnect(inputSource);
          }
          _currentDepthNear = null;
          _currentDepthFar = null;
          depthSensing.reset();
          for (const key in cameraAccessTextures) {
            delete cameraAccessTextures[key];
          }
          renderer.setRenderTarget(initialRenderTarget);
          glBaseLayer = null;
          glProjLayer = null;
          glBinding = null;
          session = null;
          newRenderTarget = null;
          animation.stop();
          scope.isPresenting = false;
          renderer.setPixelRatio(currentPixelRatio);
          renderer.setSize(currentSize.width, currentSize.height, false);
          scope.dispatchEvent({ type: "sessionend" });
        }
        this.setFramebufferScaleFactor = function(value) {
          framebufferScaleFactor = value;
          if (scope.isPresenting === true) {
            console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
          }
        };
        this.setReferenceSpaceType = function(value) {
          referenceSpaceType = value;
          if (scope.isPresenting === true) {
            console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
          }
        };
        this.getReferenceSpace = function() {
          return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
          customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
          return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
          if (glBinding === null && supportsGlBinding) {
            glBinding = new XRWebGLBinding(session, gl);
          }
          return glBinding;
        };
        this.getFrame = function() {
          return xrFrame;
        };
        this.getSession = function() {
          return session;
        };
        this.setSession = async function(value) {
          session = value;
          if (session !== null) {
            initialRenderTarget = renderer.getRenderTarget();
            session.addEventListener("select", onSessionEvent);
            session.addEventListener("selectstart", onSessionEvent);
            session.addEventListener("selectend", onSessionEvent);
            session.addEventListener("squeeze", onSessionEvent);
            session.addEventListener("squeezestart", onSessionEvent);
            session.addEventListener("squeezeend", onSessionEvent);
            session.addEventListener("end", onSessionEnd);
            session.addEventListener("inputsourceschange", onInputSourcesChange);
            if (attributes.xrCompatible !== true) {
              await gl.makeXRCompatible();
            }
            currentPixelRatio = renderer.getPixelRatio();
            renderer.getSize(currentSize);
            const supportsLayers = supportsGlBinding && "createProjectionLayer" in XRWebGLBinding.prototype;
            if (!supportsLayers) {
              const layerInit = {
                antialias: attributes.antialias,
                alpha: true,
                depth: attributes.depth,
                stencil: attributes.stencil,
                framebufferScaleFactor
              };
              glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
              session.updateRenderState({ baseLayer: glBaseLayer });
              renderer.setPixelRatio(1);
              renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
              newRenderTarget = new WebGLRenderTarget(
                glBaseLayer.framebufferWidth,
                glBaseLayer.framebufferHeight,
                {
                  format: RGBAFormat,
                  type: UnsignedByteType,
                  colorSpace: renderer.outputColorSpace,
                  stencilBuffer: attributes.stencil,
                  resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                  resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                }
              );
            } else {
              let depthFormat = null;
              let depthType = null;
              let glDepthFormat = null;
              if (attributes.depth) {
                glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                depthFormat = attributes.stencil ? DepthStencilFormat : DepthFormat;
                depthType = attributes.stencil ? UnsignedInt248Type : UnsignedIntType;
              }
              const projectionlayerInit = {
                colorFormat: gl.RGBA8,
                depthFormat: glDepthFormat,
                scaleFactor: framebufferScaleFactor
              };
              glBinding = this.getBinding();
              glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
              session.updateRenderState({ layers: [glProjLayer] });
              renderer.setPixelRatio(1);
              renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
              newRenderTarget = new WebGLRenderTarget(
                glProjLayer.textureWidth,
                glProjLayer.textureHeight,
                {
                  format: RGBAFormat,
                  type: UnsignedByteType,
                  depthTexture: new DepthTexture(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, void 0, void 0, void 0, void 0, void 0, void 0, depthFormat),
                  stencilBuffer: attributes.stencil,
                  colorSpace: renderer.outputColorSpace,
                  samples: attributes.antialias ? 4 : 0,
                  resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                  resolveStencilBuffer: glProjLayer.ignoreDepthValues === false
                }
              );
            }
            newRenderTarget.isXRRenderTarget = true;
            this.setFoveation(foveation);
            customReferenceSpace = null;
            referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
            animation.setContext(session);
            animation.start();
            scope.isPresenting = true;
            scope.dispatchEvent({ type: "sessionstart" });
          }
        };
        this.getEnvironmentBlendMode = function() {
          if (session !== null) {
            return session.environmentBlendMode;
          }
        };
        this.getDepthTexture = function() {
          return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
          for (let i = 0; i < event.removed.length; i++) {
            const inputSource = event.removed[i];
            const index = controllerInputSources.indexOf(inputSource);
            if (index >= 0) {
              controllerInputSources[index] = null;
              controllers[index].disconnect(inputSource);
            }
          }
          for (let i = 0; i < event.added.length; i++) {
            const inputSource = event.added[i];
            let controllerIndex = controllerInputSources.indexOf(inputSource);
            if (controllerIndex === -1) {
              for (let i2 = 0; i2 < controllers.length; i2++) {
                if (i2 >= controllerInputSources.length) {
                  controllerInputSources.push(inputSource);
                  controllerIndex = i2;
                  break;
                } else if (controllerInputSources[i2] === null) {
                  controllerInputSources[i2] = inputSource;
                  controllerIndex = i2;
                  break;
                }
              }
              if (controllerIndex === -1) break;
            }
            const controller = controllers[controllerIndex];
            if (controller) {
              controller.connect(inputSource);
            }
          }
        }
        const cameraLPos = new Vector3();
        const cameraRPos = new Vector3();
        function setProjectionFromUnion(camera, cameraL2, cameraR2) {
          cameraLPos.setFromMatrixPosition(cameraL2.matrixWorld);
          cameraRPos.setFromMatrixPosition(cameraR2.matrixWorld);
          const ipd = cameraLPos.distanceTo(cameraRPos);
          const projL = cameraL2.projectionMatrix.elements;
          const projR = cameraR2.projectionMatrix.elements;
          const near = projL[14] / (projL[10] - 1);
          const far = projL[14] / (projL[10] + 1);
          const topFov = (projL[9] + 1) / projL[5];
          const bottomFov = (projL[9] - 1) / projL[5];
          const leftFov = (projL[8] - 1) / projL[0];
          const rightFov = (projR[8] + 1) / projR[0];
          const left = near * leftFov;
          const right = near * rightFov;
          const zOffset = ipd / (-leftFov + rightFov);
          const xOffset = zOffset * -leftFov;
          cameraL2.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
          camera.translateX(xOffset);
          camera.translateZ(zOffset);
          camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
          camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
          if (projL[10] === -1) {
            camera.projectionMatrix.copy(cameraL2.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraL2.projectionMatrixInverse);
          } else {
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
          }
        }
        function updateCamera(camera, parent) {
          if (parent === null) {
            camera.matrixWorld.copy(camera.matrix);
          } else {
            camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
          }
          camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
          if (session === null) return;
          let depthNear = camera.near;
          let depthFar = camera.far;
          if (depthSensing.texture !== null) {
            if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
            if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
          }
          cameraXR.near = cameraR.near = cameraL.near = depthNear;
          cameraXR.far = cameraR.far = cameraL.far = depthFar;
          if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
            session.updateRenderState({
              depthNear: cameraXR.near,
              depthFar: cameraXR.far
            });
            _currentDepthNear = cameraXR.near;
            _currentDepthFar = cameraXR.far;
          }
          cameraXR.layers.mask = camera.layers.mask | 6;
          cameraL.layers.mask = cameraXR.layers.mask & 3;
          cameraR.layers.mask = cameraXR.layers.mask & 5;
          const parent = camera.parent;
          const cameras2 = cameraXR.cameras;
          updateCamera(cameraXR, parent);
          for (let i = 0; i < cameras2.length; i++) {
            updateCamera(cameras2[i], parent);
          }
          if (cameras2.length === 2) {
            setProjectionFromUnion(cameraXR, cameraL, cameraR);
          } else {
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
          }
          updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR2, parent) {
          if (parent === null) {
            camera.matrix.copy(cameraXR2.matrixWorld);
          } else {
            camera.matrix.copy(parent.matrixWorld);
            camera.matrix.invert();
            camera.matrix.multiply(cameraXR2.matrixWorld);
          }
          camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
          camera.updateMatrixWorld(true);
          camera.projectionMatrix.copy(cameraXR2.projectionMatrix);
          camera.projectionMatrixInverse.copy(cameraXR2.projectionMatrixInverse);
          if (camera.isPerspectiveCamera) {
            camera.fov = RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
            camera.zoom = 1;
          }
        }
        this.getCamera = function() {
          return cameraXR;
        };
        this.getFoveation = function() {
          if (glProjLayer === null && glBaseLayer === null) {
            return void 0;
          }
          return foveation;
        };
        this.setFoveation = function(value) {
          foveation = value;
          if (glProjLayer !== null) {
            glProjLayer.fixedFoveation = value;
          }
          if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== void 0) {
            glBaseLayer.fixedFoveation = value;
          }
        };
        this.hasDepthSensing = function() {
          return depthSensing.texture !== null;
        };
        this.getDepthSensingMesh = function() {
          return depthSensing.getMesh(cameraXR);
        };
        this.getCameraTexture = function(xrCamera) {
          return cameraAccessTextures[xrCamera];
        };
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
          pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
          xrFrame = frame;
          if (pose !== null) {
            const views = pose.views;
            if (glBaseLayer !== null) {
              renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
              renderer.setRenderTarget(newRenderTarget);
            }
            let cameraXRNeedsUpdate = false;
            if (views.length !== cameraXR.cameras.length) {
              cameraXR.cameras.length = 0;
              cameraXRNeedsUpdate = true;
            }
            for (let i = 0; i < views.length; i++) {
              const view = views[i];
              let viewport = null;
              if (glBaseLayer !== null) {
                viewport = glBaseLayer.getViewport(view);
              } else {
                const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                viewport = glSubImage.viewport;
                if (i === 0) {
                  renderer.setRenderTargetTextures(
                    newRenderTarget,
                    glSubImage.colorTexture,
                    glSubImage.depthStencilTexture
                  );
                  renderer.setRenderTarget(newRenderTarget);
                }
              }
              let camera = cameras[i];
              if (camera === void 0) {
                camera = new PerspectiveCamera();
                camera.layers.enable(i);
                camera.viewport = new Vector4();
                cameras[i] = camera;
              }
              camera.matrix.fromArray(view.transform.matrix);
              camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
              camera.projectionMatrix.fromArray(view.projectionMatrix);
              camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
              camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
              if (i === 0) {
                cameraXR.matrix.copy(camera.matrix);
                cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
              }
              if (cameraXRNeedsUpdate === true) {
                cameraXR.cameras.push(camera);
              }
            }
            const enabledFeatures = session.enabledFeatures;
            const gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes("depth-sensing") && session.depthUsage == "gpu-optimized";
            if (gpuDepthSensingEnabled && supportsGlBinding) {
              glBinding = scope.getBinding();
              const depthData = glBinding.getDepthInformation(views[0]);
              if (depthData && depthData.isValid && depthData.texture) {
                depthSensing.init(depthData, session.renderState);
              }
            }
            const cameraAccessEnabled = enabledFeatures && enabledFeatures.includes("camera-access");
            if (cameraAccessEnabled && supportsGlBinding) {
              renderer.state.unbindTexture();
              glBinding = scope.getBinding();
              for (let i = 0; i < views.length; i++) {
                const camera = views[i].camera;
                if (camera) {
                  let cameraTex = cameraAccessTextures[camera];
                  if (!cameraTex) {
                    cameraTex = new ExternalTexture();
                    cameraAccessTextures[camera] = cameraTex;
                  }
                  const glTexture = glBinding.getCameraImage(camera);
                  cameraTex.sourceTexture = glTexture;
                }
              }
            }
          }
          for (let i = 0; i < controllers.length; i++) {
            const inputSource = controllerInputSources[i];
            const controller = controllers[i];
            if (inputSource !== null && controller !== void 0) {
              controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
          }
          if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
          if (frame.detectedPlanes) {
            scope.dispatchEvent({ type: "planesdetected", data: frame });
          }
          xrFrame = null;
        }
        const animation = new WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
          onAnimationFrameCallback = callback;
        };
        this.dispose = function() {
        };
      }
    };
    _e1 = /* @__PURE__ */ new Euler();
    _m12 = /* @__PURE__ */ new Matrix4();
    WebGLRenderer = class {
      /**
       * Constructs a new WebGL renderer.
       *
       * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
       */
      constructor(parameters = {}) {
        const {
          canvas: canvas2 = createCanvasElement(),
          context = null,
          depth = true,
          stencil = false,
          alpha = false,
          antialias = false,
          premultipliedAlpha = true,
          preserveDrawingBuffer = false,
          powerPreference = "default",
          failIfMajorPerformanceCaveat = false,
          reversedDepthBuffer = false
        } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
          if (typeof WebGLRenderingContext !== "undefined" && context instanceof WebGLRenderingContext) {
            throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
          }
          _alpha = context.getContextAttributes().alpha;
        } else {
          _alpha = alpha;
        }
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        const renderListStack = [];
        const renderStateStack = [];
        this.domElement = canvas2;
        this.debug = {
          /**
           * Enables error checking and reporting when shader programs are being compiled.
           * @type {boolean}
           */
          checkShaderErrors: true,
          /**
           * Callback for custom error reporting.
           * @type {?Function}
           */
          onShaderError: null
        };
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        this.sortObjects = true;
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        this.toneMapping = NoToneMapping;
        this.toneMappingExposure = 1;
        this.transmissionResolutionScale = 1;
        const _this = this;
        let _isContextLost = false;
        this._outputColorSpace = SRGBColorSpace;
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new Vector4();
        const _currentScissor = new Vector4();
        let _currentScissorTest = null;
        const _currentClearColor = new Color(0);
        let _currentClearAlpha = 0;
        let _width = canvas2.width;
        let _height = canvas2.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new Vector4(0, 0, _width, _height);
        const _scissor = new Vector4(0, 0, _width, _height);
        let _scissorTest = false;
        const _frustum = new Frustum();
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        const _projScreenMatrix2 = new Matrix4();
        const _vector3 = new Vector3();
        const _vector4 = new Vector4();
        const _emptyScene = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: true };
        let _renderBackground = false;
        function getTargetPixelRatio() {
          return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        let _gl = context;
        function getContext(contextName, contextAttributes) {
          return canvas2.getContext(contextName, contextAttributes);
        }
        try {
          const contextAttributes = {
            alpha: true,
            depth,
            stencil,
            antialias,
            premultipliedAlpha,
            preserveDrawingBuffer,
            powerPreference,
            failIfMajorPerformanceCaveat
          };
          if ("setAttribute" in canvas2) canvas2.setAttribute("data-engine", `three.js r${REVISION}`);
          canvas2.addEventListener("webglcontextlost", onContextLost, false);
          canvas2.addEventListener("webglcontextrestored", onContextRestore, false);
          canvas2.addEventListener("webglcontextcreationerror", onContextCreationError, false);
          if (_gl === null) {
            const contextName = "webgl2";
            _gl = getContext(contextName, contextAttributes);
            if (_gl === null) {
              if (getContext(contextName)) {
                throw new Error("Error creating WebGL context with your selected attributes.");
              } else {
                throw new Error("Error creating WebGL context.");
              }
            }
          }
        } catch (error) {
          console.error("THREE.WebGLRenderer: " + error.message);
          throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
          extensions = new WebGLExtensions(_gl);
          extensions.init();
          utils = new WebGLUtils(_gl, extensions);
          capabilities = new WebGLCapabilities(_gl, extensions, parameters, utils);
          state = new WebGLState(_gl, extensions);
          if (capabilities.reversedDepthBuffer && reversedDepthBuffer) {
            state.buffers.depth.setReversed(true);
          }
          info = new WebGLInfo(_gl);
          properties = new WebGLProperties();
          textures = new WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
          cubemaps = new WebGLCubeMaps(_this);
          cubeuvmaps = new WebGLCubeUVMaps(_this);
          attributes = new WebGLAttributes(_gl);
          bindingStates = new WebGLBindingStates(_gl, attributes);
          geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
          objects = new WebGLObjects(_gl, geometries, attributes, info);
          morphtargets = new WebGLMorphtargets(_gl, capabilities, textures);
          clipping = new WebGLClipping(properties);
          programCache = new WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
          materials = new WebGLMaterials(_this, properties);
          renderLists = new WebGLRenderLists();
          renderStates = new WebGLRenderStates(extensions);
          background = new WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
          shadowMap = new WebGLShadowMap(_this, objects, capabilities);
          uniformsGroups = new WebGLUniformsGroups(_gl, info, capabilities, state);
          bufferRenderer = new WebGLBufferRenderer(_gl, extensions, info);
          indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions, info);
          info.programs = programCache.programs;
          _this.capabilities = capabilities;
          _this.extensions = extensions;
          _this.properties = properties;
          _this.renderLists = renderLists;
          _this.shadowMap = shadowMap;
          _this.state = state;
          _this.info = info;
        }
        initGLContext();
        const xr = new WebXRManager(_this, _gl);
        this.xr = xr;
        this.getContext = function() {
          return _gl;
        };
        this.getContextAttributes = function() {
          return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
          const extension = extensions.get("WEBGL_lose_context");
          if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
          const extension = extensions.get("WEBGL_lose_context");
          if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
          return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
          if (value === void 0) return;
          _pixelRatio = value;
          this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
          return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
          if (xr.isPresenting) {
            console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
            return;
          }
          _width = width;
          _height = height;
          canvas2.width = Math.floor(width * _pixelRatio);
          canvas2.height = Math.floor(height * _pixelRatio);
          if (updateStyle === true) {
            canvas2.style.width = width + "px";
            canvas2.style.height = height + "px";
          }
          this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
          return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
          _width = width;
          _height = height;
          _pixelRatio = pixelRatio;
          canvas2.width = Math.floor(width * pixelRatio);
          canvas2.height = Math.floor(height * pixelRatio);
          this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
          return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
          return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
          if (x.isVector4) {
            _viewport.set(x.x, x.y, x.z, x.w);
          } else {
            _viewport.set(x, y, width, height);
          }
          state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        this.getScissor = function(target) {
          return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
          if (x.isVector4) {
            _scissor.set(x.x, x.y, x.z, x.w);
          } else {
            _scissor.set(x, y, width, height);
          }
          state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        this.getScissorTest = function() {
          return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
          state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
          _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
          _transparentSort = method;
        };
        this.getClearColor = function(target) {
          return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
          background.setClearColor(...arguments);
        };
        this.getClearAlpha = function() {
          return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
          background.setClearAlpha(...arguments);
        };
        this.clear = function(color = true, depth2 = true, stencil2 = true) {
          let bits = 0;
          if (color) {
            let isIntegerFormat = false;
            if (_currentRenderTarget !== null) {
              const targetFormat = _currentRenderTarget.texture.format;
              isIntegerFormat = targetFormat === RGBAIntegerFormat || targetFormat === RGIntegerFormat || targetFormat === RedIntegerFormat;
            }
            if (isIntegerFormat) {
              const targetType = _currentRenderTarget.texture.type;
              const isUnsignedType = targetType === UnsignedByteType || targetType === UnsignedIntType || targetType === UnsignedShortType || targetType === UnsignedInt248Type || targetType === UnsignedShort4444Type || targetType === UnsignedShort5551Type;
              const clearColor = background.getClearColor();
              const a = background.getClearAlpha();
              const r = clearColor.r;
              const g = clearColor.g;
              const b = clearColor.b;
              if (isUnsignedType) {
                uintClearColor[0] = r;
                uintClearColor[1] = g;
                uintClearColor[2] = b;
                uintClearColor[3] = a;
                _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
              } else {
                intClearColor[0] = r;
                intClearColor[1] = g;
                intClearColor[2] = b;
                intClearColor[3] = a;
                _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
              }
            } else {
              bits |= _gl.COLOR_BUFFER_BIT;
            }
          }
          if (depth2) {
            bits |= _gl.DEPTH_BUFFER_BIT;
          }
          if (stencil2) {
            bits |= _gl.STENCIL_BUFFER_BIT;
            this.state.buffers.stencil.setMask(4294967295);
          }
          _gl.clear(bits);
        };
        this.clearColor = function() {
          this.clear(true, false, false);
        };
        this.clearDepth = function() {
          this.clear(false, true, false);
        };
        this.clearStencil = function() {
          this.clear(false, false, true);
        };
        this.dispose = function() {
          canvas2.removeEventListener("webglcontextlost", onContextLost, false);
          canvas2.removeEventListener("webglcontextrestored", onContextRestore, false);
          canvas2.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
          background.dispose();
          renderLists.dispose();
          renderStates.dispose();
          properties.dispose();
          cubemaps.dispose();
          cubeuvmaps.dispose();
          objects.dispose();
          bindingStates.dispose();
          uniformsGroups.dispose();
          programCache.dispose();
          xr.dispose();
          xr.removeEventListener("sessionstart", onXRSessionStart);
          xr.removeEventListener("sessionend", onXRSessionEnd);
          animation.stop();
        };
        function onContextLost(event) {
          event.preventDefault();
          console.log("THREE.WebGLRenderer: Context Lost.");
          _isContextLost = true;
        }
        function onContextRestore() {
          console.log("THREE.WebGLRenderer: Context Restored.");
          _isContextLost = false;
          const infoAutoReset = info.autoReset;
          const shadowMapEnabled = shadowMap.enabled;
          const shadowMapAutoUpdate = shadowMap.autoUpdate;
          const shadowMapNeedsUpdate = shadowMap.needsUpdate;
          const shadowMapType = shadowMap.type;
          initGLContext();
          info.autoReset = infoAutoReset;
          shadowMap.enabled = shadowMapEnabled;
          shadowMap.autoUpdate = shadowMapAutoUpdate;
          shadowMap.needsUpdate = shadowMapNeedsUpdate;
          shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
          console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
        }
        function onMaterialDispose(event) {
          const material = event.target;
          material.removeEventListener("dispose", onMaterialDispose);
          deallocateMaterial(material);
        }
        function deallocateMaterial(material) {
          releaseMaterialProgramReferences(material);
          properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
          const programs = properties.get(material).programs;
          if (programs !== void 0) {
            programs.forEach(function(program) {
              programCache.releaseProgram(program);
            });
            if (material.isShaderMaterial) {
              programCache.releaseShaderCache(material);
            }
          }
        }
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
          if (scene === null) scene = _emptyScene;
          const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
          const program = setProgram(camera, scene, geometry, material, object);
          state.setMaterial(material, frontFaceCW);
          let index = geometry.index;
          let rangeFactor = 1;
          if (material.wireframe === true) {
            index = geometries.getWireframeAttribute(geometry);
            if (index === void 0) return;
            rangeFactor = 2;
          }
          const drawRange = geometry.drawRange;
          const position = geometry.attributes.position;
          let drawStart = drawRange.start * rangeFactor;
          let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
          if (group !== null) {
            drawStart = Math.max(drawStart, group.start * rangeFactor);
            drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
          }
          if (index !== null) {
            drawStart = Math.max(drawStart, 0);
            drawEnd = Math.min(drawEnd, index.count);
          } else if (position !== void 0 && position !== null) {
            drawStart = Math.max(drawStart, 0);
            drawEnd = Math.min(drawEnd, position.count);
          }
          const drawCount = drawEnd - drawStart;
          if (drawCount < 0 || drawCount === Infinity) return;
          bindingStates.setup(object, material, program, geometry, index);
          let attribute;
          let renderer = bufferRenderer;
          if (index !== null) {
            attribute = attributes.get(index);
            renderer = indexedBufferRenderer;
            renderer.setIndex(attribute);
          }
          if (object.isMesh) {
            if (material.wireframe === true) {
              state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
              renderer.setMode(_gl.LINES);
            } else {
              renderer.setMode(_gl.TRIANGLES);
            }
          } else if (object.isLine) {
            let lineWidth = material.linewidth;
            if (lineWidth === void 0) lineWidth = 1;
            state.setLineWidth(lineWidth * getTargetPixelRatio());
            if (object.isLineSegments) {
              renderer.setMode(_gl.LINES);
            } else if (object.isLineLoop) {
              renderer.setMode(_gl.LINE_LOOP);
            } else {
              renderer.setMode(_gl.LINE_STRIP);
            }
          } else if (object.isPoints) {
            renderer.setMode(_gl.POINTS);
          } else if (object.isSprite) {
            renderer.setMode(_gl.TRIANGLES);
          }
          if (object.isBatchedMesh) {
            if (object._multiDrawInstances !== null) {
              warnOnce("THREE.WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.");
              renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
            } else {
              if (!extensions.get("WEBGL_multi_draw")) {
                const starts = object._multiDrawStarts;
                const counts = object._multiDrawCounts;
                const drawCount2 = object._multiDrawCount;
                const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                const uniforms = properties.get(material).currentProgram.getUniforms();
                for (let i = 0; i < drawCount2; i++) {
                  uniforms.setValue(_gl, "_gl_DrawID", i);
                  renderer.render(starts[i] / bytesPerElement, counts[i]);
                }
              } else {
                renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
              }
            }
          } else if (object.isInstancedMesh) {
            renderer.renderInstances(drawStart, drawCount, object.count);
          } else if (geometry.isInstancedBufferGeometry) {
            const maxInstanceCount = geometry._maxInstanceCount !== void 0 ? geometry._maxInstanceCount : Infinity;
            const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
            renderer.renderInstances(drawStart, drawCount, instanceCount);
          } else {
            renderer.render(drawStart, drawCount);
          }
        };
        function prepareMaterial(material, scene, object) {
          if (material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false) {
            material.side = BackSide;
            material.needsUpdate = true;
            getProgram(material, scene, object);
            material.side = FrontSide;
            material.needsUpdate = true;
            getProgram(material, scene, object);
            material.side = DoubleSide;
          } else {
            getProgram(material, scene, object);
          }
        }
        this.compile = function(scene, camera, targetScene = null) {
          if (targetScene === null) targetScene = scene;
          currentRenderState = renderStates.get(targetScene);
          currentRenderState.init(camera);
          renderStateStack.push(currentRenderState);
          targetScene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
              currentRenderState.pushLight(object);
              if (object.castShadow) {
                currentRenderState.pushShadow(object);
              }
            }
          });
          if (scene !== targetScene) {
            scene.traverseVisible(function(object) {
              if (object.isLight && object.layers.test(camera.layers)) {
                currentRenderState.pushLight(object);
                if (object.castShadow) {
                  currentRenderState.pushShadow(object);
                }
              }
            });
          }
          currentRenderState.setupLights();
          const materials2 = /* @__PURE__ */ new Set();
          scene.traverse(function(object) {
            if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) {
              return;
            }
            const material = object.material;
            if (material) {
              if (Array.isArray(material)) {
                for (let i = 0; i < material.length; i++) {
                  const material2 = material[i];
                  prepareMaterial(material2, targetScene, object);
                  materials2.add(material2);
                }
              } else {
                prepareMaterial(material, targetScene, object);
                materials2.add(material);
              }
            }
          });
          currentRenderState = renderStateStack.pop();
          return materials2;
        };
        this.compileAsync = function(scene, camera, targetScene = null) {
          const materials2 = this.compile(scene, camera, targetScene);
          return new Promise((resolve) => {
            function checkMaterialsReady() {
              materials2.forEach(function(material) {
                const materialProperties = properties.get(material);
                const program = materialProperties.currentProgram;
                if (program.isReady()) {
                  materials2.delete(material);
                }
              });
              if (materials2.size === 0) {
                resolve(scene);
                return;
              }
              setTimeout(checkMaterialsReady, 10);
            }
            if (extensions.get("KHR_parallel_shader_compile") !== null) {
              checkMaterialsReady();
            } else {
              setTimeout(checkMaterialsReady, 10);
            }
          });
        };
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
          if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
          animation.stop();
        }
        function onXRSessionEnd() {
          animation.start();
        }
        const animation = new WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== "undefined") animation.setContext(self);
        this.setAnimationLoop = function(callback) {
          onAnimationFrameCallback = callback;
          xr.setAnimationLoop(callback);
          callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener("sessionstart", onXRSessionStart);
        xr.addEventListener("sessionend", onXRSessionEnd);
        this.render = function(scene, camera) {
          if (camera !== void 0 && camera.isCamera !== true) {
            console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            return;
          }
          if (_isContextLost === true) return;
          if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
          if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
          if (xr.enabled === true && xr.isPresenting === true) {
            if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
            camera = xr.getCamera();
          }
          if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
          currentRenderState = renderStates.get(scene, renderStateStack.length);
          currentRenderState.init(camera);
          renderStateStack.push(currentRenderState);
          _projScreenMatrix2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
          _frustum.setFromProjectionMatrix(_projScreenMatrix2, WebGLCoordinateSystem, camera.reversedDepth);
          _localClippingEnabled = this.localClippingEnabled;
          _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
          currentRenderList = renderLists.get(scene, renderListStack.length);
          currentRenderList.init();
          renderListStack.push(currentRenderList);
          if (xr.enabled === true && xr.isPresenting === true) {
            const depthSensingMesh = _this.xr.getDepthSensingMesh();
            if (depthSensingMesh !== null) {
              projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
          }
          projectObject(scene, camera, 0, _this.sortObjects);
          currentRenderList.finish();
          if (_this.sortObjects === true) {
            currentRenderList.sort(_opaqueSort, _transparentSort);
          }
          _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
          if (_renderBackground) {
            background.addToRenderList(currentRenderList, scene);
          }
          this.info.render.frame++;
          if (_clippingEnabled === true) clipping.beginShadows();
          const shadowsArray = currentRenderState.state.shadowsArray;
          shadowMap.render(shadowsArray, scene, camera);
          if (_clippingEnabled === true) clipping.endShadows();
          if (this.info.autoReset === true) this.info.reset();
          const opaqueObjects = currentRenderList.opaque;
          const transmissiveObjects = currentRenderList.transmissive;
          currentRenderState.setupLights();
          if (camera.isArrayCamera) {
            const cameras = camera.cameras;
            if (transmissiveObjects.length > 0) {
              for (let i = 0, l = cameras.length; i < l; i++) {
                const camera2 = cameras[i];
                renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
              }
            }
            if (_renderBackground) background.render(scene);
            for (let i = 0, l = cameras.length; i < l; i++) {
              const camera2 = cameras[i];
              renderScene(currentRenderList, scene, camera2, camera2.viewport);
            }
          } else {
            if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
            if (_renderBackground) background.render(scene);
            renderScene(currentRenderList, scene, camera);
          }
          if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
            textures.updateMultisampleRenderTarget(_currentRenderTarget);
            textures.updateRenderTargetMipmap(_currentRenderTarget);
          }
          if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
          bindingStates.resetDefaultState();
          _currentMaterialId = -1;
          _currentCamera = null;
          renderStateStack.pop();
          if (renderStateStack.length > 0) {
            currentRenderState = renderStateStack[renderStateStack.length - 1];
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
          } else {
            currentRenderState = null;
          }
          renderListStack.pop();
          if (renderListStack.length > 0) {
            currentRenderList = renderListStack[renderListStack.length - 1];
          } else {
            currentRenderList = null;
          }
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
          if (object.visible === false) return;
          const visible = object.layers.test(camera.layers);
          if (visible) {
            if (object.isGroup) {
              groupOrder = object.renderOrder;
            } else if (object.isLOD) {
              if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) {
              currentRenderState.pushLight(object);
              if (object.castShadow) {
                currentRenderState.pushShadow(object);
              }
            } else if (object.isSprite) {
              if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                if (sortObjects) {
                  _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
                }
                const geometry = objects.update(object);
                const material = object.material;
                if (material.visible) {
                  currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                }
              }
            } else if (object.isMesh || object.isLine || object.isPoints) {
              if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                const geometry = objects.update(object);
                const material = object.material;
                if (sortObjects) {
                  if (object.boundingSphere !== void 0) {
                    if (object.boundingSphere === null) object.computeBoundingSphere();
                    _vector4.copy(object.boundingSphere.center);
                  } else {
                    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                    _vector4.copy(geometry.boundingSphere.center);
                  }
                  _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
                }
                if (Array.isArray(material)) {
                  const groups = geometry.groups;
                  for (let i = 0, l = groups.length; i < l; i++) {
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    if (groupMaterial && groupMaterial.visible) {
                      currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                    }
                  }
                } else if (material.visible) {
                  currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                }
              }
            }
          }
          const children = object.children;
          for (let i = 0, l = children.length; i < l; i++) {
            projectObject(children[i], camera, groupOrder, sortObjects);
          }
        }
        function renderScene(currentRenderList2, scene, camera, viewport) {
          const opaqueObjects = currentRenderList2.opaque;
          const transmissiveObjects = currentRenderList2.transmissive;
          const transparentObjects = currentRenderList2.transparent;
          currentRenderState.setupLightsView(camera);
          if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
          if (viewport) state.viewport(_currentViewport.copy(viewport));
          if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
          if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
          if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
          state.buffers.depth.setTest(true);
          state.buffers.depth.setMask(true);
          state.buffers.color.setMask(true);
          state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
          const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
          if (overrideMaterial !== null) {
            return;
          }
          if (currentRenderState.state.transmissionRenderTarget[camera.id] === void 0) {
            currentRenderState.state.transmissionRenderTarget[camera.id] = new WebGLRenderTarget(1, 1, {
              generateMipmaps: true,
              type: extensions.has("EXT_color_buffer_half_float") || extensions.has("EXT_color_buffer_float") ? HalfFloatType : UnsignedByteType,
              minFilter: LinearMipmapLinearFilter,
              samples: 4,
              stencilBuffer: stencil,
              resolveDepthBuffer: false,
              resolveStencilBuffer: false,
              colorSpace: ColorManagement.workingColorSpace
            });
          }
          const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
          const activeViewport = camera.viewport || _currentViewport;
          transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
          const currentRenderTarget = _this.getRenderTarget();
          const currentActiveCubeFace = _this.getActiveCubeFace();
          const currentActiveMipmapLevel = _this.getActiveMipmapLevel();
          _this.setRenderTarget(transmissionRenderTarget);
          _this.getClearColor(_currentClearColor);
          _currentClearAlpha = _this.getClearAlpha();
          if (_currentClearAlpha < 1) _this.setClearColor(16777215, 0.5);
          _this.clear();
          if (_renderBackground) background.render(scene);
          const currentToneMapping = _this.toneMapping;
          _this.toneMapping = NoToneMapping;
          const currentCameraViewport = camera.viewport;
          if (camera.viewport !== void 0) camera.viewport = void 0;
          currentRenderState.setupLightsView(camera);
          if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
          renderObjects(opaqueObjects, scene, camera);
          textures.updateMultisampleRenderTarget(transmissionRenderTarget);
          textures.updateRenderTargetMipmap(transmissionRenderTarget);
          if (extensions.has("WEBGL_multisampled_render_to_texture") === false) {
            let renderTargetNeedsUpdate = false;
            for (let i = 0, l = transmissiveObjects.length; i < l; i++) {
              const renderItem = transmissiveObjects[i];
              const object = renderItem.object;
              const geometry = renderItem.geometry;
              const material = renderItem.material;
              const group = renderItem.group;
              if (material.side === DoubleSide && object.layers.test(camera.layers)) {
                const currentSide = material.side;
                material.side = BackSide;
                material.needsUpdate = true;
                renderObject(object, scene, camera, geometry, material, group);
                material.side = currentSide;
                material.needsUpdate = true;
                renderTargetNeedsUpdate = true;
              }
            }
            if (renderTargetNeedsUpdate === true) {
              textures.updateMultisampleRenderTarget(transmissionRenderTarget);
              textures.updateRenderTargetMipmap(transmissionRenderTarget);
            }
          }
          _this.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
          _this.setClearColor(_currentClearColor, _currentClearAlpha);
          if (currentCameraViewport !== void 0) camera.viewport = currentCameraViewport;
          _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
          const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
          for (let i = 0, l = renderList.length; i < l; i++) {
            const renderItem = renderList[i];
            const object = renderItem.object;
            const geometry = renderItem.geometry;
            const group = renderItem.group;
            let material = renderItem.material;
            if (material.allowOverride === true && overrideMaterial !== null) {
              material = overrideMaterial;
            }
            if (object.layers.test(camera.layers)) {
              renderObject(object, scene, camera, geometry, material, group);
            }
          }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
          object.onBeforeRender(_this, scene, camera, geometry, material, group);
          object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
          object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
          material.onBeforeRender(_this, scene, camera, geometry, object, group);
          if (material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false) {
            material.side = BackSide;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = FrontSide;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = DoubleSide;
          } else {
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
          }
          object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
          if (scene.isScene !== true) scene = _emptyScene;
          const materialProperties = properties.get(material);
          const lights = currentRenderState.state.lights;
          const shadowsArray = currentRenderState.state.shadowsArray;
          const lightsStateVersion = lights.state.version;
          const parameters2 = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
          const programCacheKey = programCache.getProgramCacheKey(parameters2);
          let programs = materialProperties.programs;
          materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
          materialProperties.fog = scene.fog;
          materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
          materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
          if (programs === void 0) {
            material.addEventListener("dispose", onMaterialDispose);
            programs = /* @__PURE__ */ new Map();
            materialProperties.programs = programs;
          }
          let program = programs.get(programCacheKey);
          if (program !== void 0) {
            if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
              updateCommonMaterialProperties(material, parameters2);
              return program;
            }
          } else {
            parameters2.uniforms = programCache.getUniforms(material);
            material.onBeforeCompile(parameters2, _this);
            program = programCache.acquireProgram(parameters2, programCacheKey);
            programs.set(programCacheKey, program);
            materialProperties.uniforms = parameters2.uniforms;
          }
          const uniforms = materialProperties.uniforms;
          if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {
            uniforms.clippingPlanes = clipping.uniform;
          }
          updateCommonMaterialProperties(material, parameters2);
          materialProperties.needsLights = materialNeedsLights(material);
          materialProperties.lightsStateVersion = lightsStateVersion;
          if (materialProperties.needsLights) {
            uniforms.ambientLightColor.value = lights.state.ambient;
            uniforms.lightProbe.value = lights.state.probe;
            uniforms.directionalLights.value = lights.state.directional;
            uniforms.directionalLightShadows.value = lights.state.directionalShadow;
            uniforms.spotLights.value = lights.state.spot;
            uniforms.spotLightShadows.value = lights.state.spotShadow;
            uniforms.rectAreaLights.value = lights.state.rectArea;
            uniforms.ltc_1.value = lights.state.rectAreaLTC1;
            uniforms.ltc_2.value = lights.state.rectAreaLTC2;
            uniforms.pointLights.value = lights.state.point;
            uniforms.pointLightShadows.value = lights.state.pointShadow;
            uniforms.hemisphereLights.value = lights.state.hemi;
            uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
            uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
            uniforms.spotShadowMap.value = lights.state.spotShadowMap;
            uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
            uniforms.spotLightMap.value = lights.state.spotLightMap;
            uniforms.pointShadowMap.value = lights.state.pointShadowMap;
            uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
          }
          materialProperties.currentProgram = program;
          materialProperties.uniformsList = null;
          return program;
        }
        function getUniformList(materialProperties) {
          if (materialProperties.uniformsList === null) {
            const progUniforms = materialProperties.currentProgram.getUniforms();
            materialProperties.uniformsList = WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
          }
          return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters2) {
          const materialProperties = properties.get(material);
          materialProperties.outputColorSpace = parameters2.outputColorSpace;
          materialProperties.batching = parameters2.batching;
          materialProperties.batchingColor = parameters2.batchingColor;
          materialProperties.instancing = parameters2.instancing;
          materialProperties.instancingColor = parameters2.instancingColor;
          materialProperties.instancingMorph = parameters2.instancingMorph;
          materialProperties.skinning = parameters2.skinning;
          materialProperties.morphTargets = parameters2.morphTargets;
          materialProperties.morphNormals = parameters2.morphNormals;
          materialProperties.morphColors = parameters2.morphColors;
          materialProperties.morphTargetsCount = parameters2.morphTargetsCount;
          materialProperties.numClippingPlanes = parameters2.numClippingPlanes;
          materialProperties.numIntersection = parameters2.numClipIntersection;
          materialProperties.vertexAlphas = parameters2.vertexAlphas;
          materialProperties.vertexTangents = parameters2.vertexTangents;
          materialProperties.toneMapping = parameters2.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
          if (scene.isScene !== true) scene = _emptyScene;
          textures.resetTextureUnits();
          const fog = scene.fog;
          const environment = material.isMeshStandardMaterial ? scene.environment : null;
          const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace;
          const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
          const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
          const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
          const morphTargets = !!geometry.morphAttributes.position;
          const morphNormals = !!geometry.morphAttributes.normal;
          const morphColors = !!geometry.morphAttributes.color;
          let toneMapping = NoToneMapping;
          if (material.toneMapped) {
            if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) {
              toneMapping = _this.toneMapping;
            }
          }
          const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
          const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
          const materialProperties = properties.get(material);
          const lights = currentRenderState.state.lights;
          if (_clippingEnabled === true) {
            if (_localClippingEnabled === true || camera !== _currentCamera) {
              const useCache = camera === _currentCamera && material.id === _currentMaterialId;
              clipping.setState(material, camera, useCache);
            }
          }
          let needsProgramChange = false;
          if (material.version === materialProperties.__version) {
            if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) {
              needsProgramChange = true;
            } else if (materialProperties.outputColorSpace !== colorSpace) {
              needsProgramChange = true;
            } else if (object.isBatchedMesh && materialProperties.batching === false) {
              needsProgramChange = true;
            } else if (!object.isBatchedMesh && materialProperties.batching === true) {
              needsProgramChange = true;
            } else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) {
              needsProgramChange = true;
            } else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) {
              needsProgramChange = true;
            } else if (object.isInstancedMesh && materialProperties.instancing === false) {
              needsProgramChange = true;
            } else if (!object.isInstancedMesh && materialProperties.instancing === true) {
              needsProgramChange = true;
            } else if (object.isSkinnedMesh && materialProperties.skinning === false) {
              needsProgramChange = true;
            } else if (!object.isSkinnedMesh && materialProperties.skinning === true) {
              needsProgramChange = true;
            } else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) {
              needsProgramChange = true;
            } else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) {
              needsProgramChange = true;
            } else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) {
              needsProgramChange = true;
            } else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) {
              needsProgramChange = true;
            } else if (materialProperties.envMap !== envMap) {
              needsProgramChange = true;
            } else if (material.fog === true && materialProperties.fog !== fog) {
              needsProgramChange = true;
            } else if (materialProperties.numClippingPlanes !== void 0 && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) {
              needsProgramChange = true;
            } else if (materialProperties.vertexAlphas !== vertexAlphas) {
              needsProgramChange = true;
            } else if (materialProperties.vertexTangents !== vertexTangents) {
              needsProgramChange = true;
            } else if (materialProperties.morphTargets !== morphTargets) {
              needsProgramChange = true;
            } else if (materialProperties.morphNormals !== morphNormals) {
              needsProgramChange = true;
            } else if (materialProperties.morphColors !== morphColors) {
              needsProgramChange = true;
            } else if (materialProperties.toneMapping !== toneMapping) {
              needsProgramChange = true;
            } else if (materialProperties.morphTargetsCount !== morphTargetsCount) {
              needsProgramChange = true;
            }
          } else {
            needsProgramChange = true;
            materialProperties.__version = material.version;
          }
          let program = materialProperties.currentProgram;
          if (needsProgramChange === true) {
            program = getProgram(material, scene, object);
          }
          let refreshProgram = false;
          let refreshMaterial = false;
          let refreshLights = false;
          const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
          if (state.useProgram(program.program)) {
            refreshProgram = true;
            refreshMaterial = true;
            refreshLights = true;
          }
          if (material.id !== _currentMaterialId) {
            _currentMaterialId = material.id;
            refreshMaterial = true;
          }
          if (refreshProgram || _currentCamera !== camera) {
            const reversedDepthBuffer2 = state.buffers.depth.getReversed();
            if (reversedDepthBuffer2 && camera.reversedDepth !== true) {
              camera._reversedDepth = true;
              camera.updateProjectionMatrix();
            }
            p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
            p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
            const uCamPos = p_uniforms.map.cameraPosition;
            if (uCamPos !== void 0) {
              uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
            }
            if (capabilities.logarithmicDepthBuffer) {
              p_uniforms.setValue(
                _gl,
                "logDepthBufFC",
                2 / (Math.log(camera.far + 1) / Math.LN2)
              );
            }
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) {
              p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
            }
            if (_currentCamera !== camera) {
              _currentCamera = camera;
              refreshMaterial = true;
              refreshLights = true;
            }
          }
          if (object.isSkinnedMesh) {
            p_uniforms.setOptional(_gl, object, "bindMatrix");
            p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
            const skeleton = object.skeleton;
            if (skeleton) {
              if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
              p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
            }
          }
          if (object.isBatchedMesh) {
            p_uniforms.setOptional(_gl, object, "batchingTexture");
            p_uniforms.setValue(_gl, "batchingTexture", object._matricesTexture, textures);
            p_uniforms.setOptional(_gl, object, "batchingIdTexture");
            p_uniforms.setValue(_gl, "batchingIdTexture", object._indirectTexture, textures);
            p_uniforms.setOptional(_gl, object, "batchingColorTexture");
            if (object._colorsTexture !== null) {
              p_uniforms.setValue(_gl, "batchingColorTexture", object._colorsTexture, textures);
            }
          }
          const morphAttributes = geometry.morphAttributes;
          if (morphAttributes.position !== void 0 || morphAttributes.normal !== void 0 || morphAttributes.color !== void 0) {
            morphtargets.update(object, geometry, program);
          }
          if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
            materialProperties.receiveShadow = object.receiveShadow;
            p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
          }
          if (material.isMeshGouraudMaterial && material.envMap !== null) {
            m_uniforms.envMap.value = envMap;
            m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
          }
          if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) {
            m_uniforms.envMapIntensity.value = scene.environmentIntensity;
          }
          if (refreshMaterial) {
            p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
            if (materialProperties.needsLights) {
              markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
            }
            if (fog && material.fog === true) {
              materials.refreshFogUniforms(m_uniforms, fog);
            }
            materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
            WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
          }
          if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
            WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            material.uniformsNeedUpdate = false;
          }
          if (material.isSpriteMaterial) {
            p_uniforms.setValue(_gl, "center", object.center);
          }
          p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
          p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
          p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
          if (material.isShaderMaterial || material.isRawShaderMaterial) {
            const groups = material.uniformsGroups;
            for (let i = 0, l = groups.length; i < l; i++) {
              const group = groups[i];
              uniformsGroups.update(group, program);
              uniformsGroups.bind(group, program);
            }
          }
          return program;
        }
        function markUniformsLightsNeedsUpdate(uniforms, value) {
          uniforms.ambientLightColor.needsUpdate = value;
          uniforms.lightProbe.needsUpdate = value;
          uniforms.directionalLights.needsUpdate = value;
          uniforms.directionalLightShadows.needsUpdate = value;
          uniforms.pointLights.needsUpdate = value;
          uniforms.pointLightShadows.needsUpdate = value;
          uniforms.spotLights.needsUpdate = value;
          uniforms.spotLightShadows.needsUpdate = value;
          uniforms.rectAreaLights.needsUpdate = value;
          uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
          return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
          return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
          return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
          return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
          const renderTargetProperties = properties.get(renderTarget);
          renderTargetProperties.__autoAllocateDepthBuffer = renderTarget.resolveDepthBuffer === false;
          if (renderTargetProperties.__autoAllocateDepthBuffer === false) {
            renderTargetProperties.__useRenderToTexture = false;
          }
          properties.get(renderTarget.texture).__webglTexture = colorTexture;
          properties.get(renderTarget.depthTexture).__webglTexture = renderTargetProperties.__autoAllocateDepthBuffer ? void 0 : depthTexture;
          renderTargetProperties.__hasExternalTextures = true;
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
          const renderTargetProperties = properties.get(renderTarget);
          renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
          renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === void 0;
        };
        const _scratchFrameBuffer = _gl.createFramebuffer();
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
          _currentRenderTarget = renderTarget;
          _currentActiveCubeFace = activeCubeFace;
          _currentActiveMipmapLevel = activeMipmapLevel;
          let useDefaultFramebuffer = true;
          let framebuffer = null;
          let isCube = false;
          let isRenderTarget3D = false;
          if (renderTarget) {
            const renderTargetProperties = properties.get(renderTarget);
            if (renderTargetProperties.__useDefaultFramebuffer !== void 0) {
              state.bindFramebuffer(_gl.FRAMEBUFFER, null);
              useDefaultFramebuffer = false;
            } else if (renderTargetProperties.__webglFramebuffer === void 0) {
              textures.setupRenderTarget(renderTarget);
            } else if (renderTargetProperties.__hasExternalTextures) {
              textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
            } else if (renderTarget.depthBuffer) {
              const depthTexture = renderTarget.depthTexture;
              if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) {
                  throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
                }
                textures.setupDepthRenderbuffer(renderTarget);
              }
            }
            const texture = renderTarget.texture;
            if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) {
              isRenderTarget3D = true;
            }
            const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget) {
              if (Array.isArray(__webglFramebuffer[activeCubeFace])) {
                framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
              } else {
                framebuffer = __webglFramebuffer[activeCubeFace];
              }
              isCube = true;
            } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) {
              framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
            } else {
              if (Array.isArray(__webglFramebuffer)) {
                framebuffer = __webglFramebuffer[activeMipmapLevel];
              } else {
                framebuffer = __webglFramebuffer;
              }
            }
            _currentViewport.copy(renderTarget.viewport);
            _currentScissor.copy(renderTarget.scissor);
            _currentScissorTest = renderTarget.scissorTest;
          } else {
            _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
            _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
            _currentScissorTest = _scissorTest;
          }
          if (activeMipmapLevel !== 0) {
            framebuffer = _scratchFrameBuffer;
          }
          const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
          if (framebufferBound && useDefaultFramebuffer) {
            state.drawBuffers(renderTarget, framebuffer);
          }
          state.viewport(_currentViewport);
          state.scissor(_currentScissor);
          state.setScissorTest(_currentScissorTest);
          if (isCube) {
            const textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
          } else if (isRenderTarget3D) {
            const layer = activeCubeFace;
            for (let i = 0; i < renderTarget.textures.length; i++) {
              const textureProperties = properties.get(renderTarget.textures[i]);
              _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, textureProperties.__webglTexture, activeMipmapLevel, layer);
            }
          } else if (renderTarget !== null && activeMipmapLevel !== 0) {
            const textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
          }
          _currentMaterialId = -1;
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
          if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            return;
          }
          let framebuffer = properties.get(renderTarget).__webglFramebuffer;
          if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== void 0) {
            framebuffer = framebuffer[activeCubeFaceIndex];
          }
          if (framebuffer) {
            state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            try {
              const texture = renderTarget.textures[textureIndex];
              const textureFormat = texture.format;
              const textureType = texture.type;
              if (!capabilities.textureFormatReadable(textureFormat)) {
                console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                return;
              }
              if (!capabilities.textureTypeReadable(textureType)) {
                console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                return;
              }
              if (x >= 0 && x <= renderTarget.width - width && (y >= 0 && y <= renderTarget.height - height)) {
                if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
              }
            } finally {
              const framebuffer2 = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
              state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer2);
            }
          }
        };
        this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
          if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
          }
          let framebuffer = properties.get(renderTarget).__webglFramebuffer;
          if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== void 0) {
            framebuffer = framebuffer[activeCubeFaceIndex];
          }
          if (framebuffer) {
            if (x >= 0 && x <= renderTarget.width - width && (y >= 0 && y <= renderTarget.height - height)) {
              state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
              const texture = renderTarget.textures[textureIndex];
              const textureFormat = texture.format;
              const textureType = texture.type;
              if (!capabilities.textureFormatReadable(textureFormat)) {
                throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
              }
              if (!capabilities.textureTypeReadable(textureType)) {
                throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
              }
              const glBuffer = _gl.createBuffer();
              _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
              _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
              if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
              _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
              const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
              state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
              const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
              _gl.flush();
              await probeAsync(_gl, sync, 4);
              _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
              _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
              _gl.deleteBuffer(glBuffer);
              _gl.deleteSync(sync);
              return buffer;
            } else {
              throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
            }
          }
        };
        this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
          const levelScale = Math.pow(2, -level);
          const width = Math.floor(texture.image.width * levelScale);
          const height = Math.floor(texture.image.height * levelScale);
          const x = position !== null ? position.x : 0;
          const y = position !== null ? position.y : 0;
          textures.setTexture2D(texture, 0);
          _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
          state.unbindTexture();
        };
        const _srcFramebuffer = _gl.createFramebuffer();
        const _dstFramebuffer = _gl.createFramebuffer();
        this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = null) {
          if (dstLevel === null) {
            if (srcLevel !== 0) {
              warnOnce("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.");
              dstLevel = srcLevel;
              srcLevel = 0;
            } else {
              dstLevel = 0;
            }
          }
          let width, height, depth2, minX, minY, minZ;
          let dstX, dstY, dstZ;
          const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
          if (srcRegion !== null) {
            width = srcRegion.max.x - srcRegion.min.x;
            height = srcRegion.max.y - srcRegion.min.y;
            depth2 = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
            minX = srcRegion.min.x;
            minY = srcRegion.min.y;
            minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
          } else {
            const levelScale = Math.pow(2, -srcLevel);
            width = Math.floor(image.width * levelScale);
            height = Math.floor(image.height * levelScale);
            if (srcTexture.isDataArrayTexture) {
              depth2 = image.depth;
            } else if (srcTexture.isData3DTexture) {
              depth2 = Math.floor(image.depth * levelScale);
            } else {
              depth2 = 1;
            }
            minX = 0;
            minY = 0;
            minZ = 0;
          }
          if (dstPosition !== null) {
            dstX = dstPosition.x;
            dstY = dstPosition.y;
            dstZ = dstPosition.z;
          } else {
            dstX = 0;
            dstY = 0;
            dstZ = 0;
          }
          const glFormat = utils.convert(dstTexture.format);
          const glType = utils.convert(dstTexture.type);
          let glTarget;
          if (dstTexture.isData3DTexture) {
            textures.setTexture3D(dstTexture, 0);
            glTarget = _gl.TEXTURE_3D;
          } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
            textures.setTexture2DArray(dstTexture, 0);
            glTarget = _gl.TEXTURE_2D_ARRAY;
          } else {
            textures.setTexture2D(dstTexture, 0);
            glTarget = _gl.TEXTURE_2D;
          }
          _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
          _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
          _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
          const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
          const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
          const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
          const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
          const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
          _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
          _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
          _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
          _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
          _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
          const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
          const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
          if (srcTexture.isDepthTexture) {
            const srcTextureProperties = properties.get(srcTexture);
            const dstTextureProperties = properties.get(dstTexture);
            const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
            const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
            for (let i = 0; i < depth2; i++) {
              if (isSrc3D) {
                _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
              }
              _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
          } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
            const srcTextureProperties = properties.get(srcTexture);
            const dstTextureProperties = properties.get(dstTexture);
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
            for (let i = 0; i < depth2; i++) {
              if (isSrc3D) {
                _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i);
              } else {
                _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
              }
              if (isDst3D) {
                _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i);
              } else {
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
              }
              if (srcLevel !== 0) {
                _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
              } else if (isDst3D) {
                _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
              } else {
                _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
              }
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
          } else {
            if (isDst3D) {
              if (srcTexture.isDataTexture || srcTexture.isData3DTexture) {
                _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, glType, image.data);
              } else if (dstTexture.isCompressedArrayTexture) {
                _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, image.data);
              } else {
                _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, glType, image);
              }
            } else {
              if (srcTexture.isDataTexture) {
                _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
              } else if (srcTexture.isCompressedTexture) {
                _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
              } else {
                _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
              }
            }
          }
          _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
          _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
          _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
          _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
          _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
          if (dstLevel === 0 && dstTexture.generateMipmaps) {
            _gl.generateMipmap(glTarget);
          }
          state.unbindTexture();
        };
        this.initRenderTarget = function(target) {
          if (properties.get(target).__webglFramebuffer === void 0) {
            textures.setupRenderTarget(target);
          }
        };
        this.initTexture = function(texture) {
          if (texture.isCubeTexture) {
            textures.setTextureCube(texture, 0);
          } else if (texture.isData3DTexture) {
            textures.setTexture3D(texture, 0);
          } else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) {
            textures.setTexture2DArray(texture, 0);
          } else {
            textures.setTexture2D(texture, 0);
          }
          state.unbindTexture();
        };
        this.resetState = function() {
          _currentActiveCubeFace = 0;
          _currentActiveMipmapLevel = 0;
          _currentRenderTarget = null;
          state.reset();
          bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== "undefined") {
          __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
        }
      }
      /**
       * Defines the coordinate system of the renderer.
       *
       * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
       *
       * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
       * @default WebGLCoordinateSystem
       * @readonly
       */
      get coordinateSystem() {
        return WebGLCoordinateSystem;
      }
      /**
       * Defines the output color space of the renderer.
       *
       * @type {SRGBColorSpace|LinearSRGBColorSpace}
       * @default SRGBColorSpace
       */
      get outputColorSpace() {
        return this._outputColorSpace;
      }
      set outputColorSpace(colorSpace) {
        this._outputColorSpace = colorSpace;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = ColorManagement._getDrawingBufferColorSpace(colorSpace);
        gl.unpackColorSpace = ColorManagement._getUnpackColorSpace();
      }
    };
  }
});

// site/vendor/addons/controls/OrbitControls.js
function onPointerDown(event) {
  if (this.enabled === false) return;
  if (this._pointers.length === 0) {
    this.domElement.setPointerCapture(event.pointerId);
    this.domElement.addEventListener("pointermove", this._onPointerMove);
    this.domElement.addEventListener("pointerup", this._onPointerUp);
  }
  if (this._isTrackingPointer(event)) return;
  this._addPointer(event);
  if (event.pointerType === "touch") {
    this._onTouchStart(event);
  } else {
    this._onMouseDown(event);
  }
}
function onPointerMove(event) {
  if (this.enabled === false) return;
  if (event.pointerType === "touch") {
    this._onTouchMove(event);
  } else {
    this._onMouseMove(event);
  }
}
function onPointerUp(event) {
  this._removePointer(event);
  switch (this._pointers.length) {
    case 0:
      this.domElement.releasePointerCapture(event.pointerId);
      this.domElement.removeEventListener("pointermove", this._onPointerMove);
      this.domElement.removeEventListener("pointerup", this._onPointerUp);
      this.dispatchEvent(_endEvent);
      this.state = _STATE.NONE;
      break;
    case 1:
      const pointerId = this._pointers[0];
      const position = this._pointerPositions[pointerId];
      this._onTouchStart({ pointerId, pageX: position.x, pageY: position.y });
      break;
  }
}
function onMouseDown(event) {
  let mouseAction;
  switch (event.button) {
    case 0:
      mouseAction = this.mouseButtons.LEFT;
      break;
    case 1:
      mouseAction = this.mouseButtons.MIDDLE;
      break;
    case 2:
      mouseAction = this.mouseButtons.RIGHT;
      break;
    default:
      mouseAction = -1;
  }
  switch (mouseAction) {
    case MOUSE.DOLLY:
      if (this.enableZoom === false) return;
      this._handleMouseDownDolly(event);
      this.state = _STATE.DOLLY;
      break;
    case MOUSE.ROTATE:
      if (event.ctrlKey || event.metaKey || event.shiftKey) {
        if (this.enablePan === false) return;
        this._handleMouseDownPan(event);
        this.state = _STATE.PAN;
      } else {
        if (this.enableRotate === false) return;
        this._handleMouseDownRotate(event);
        this.state = _STATE.ROTATE;
      }
      break;
    case MOUSE.PAN:
      if (event.ctrlKey || event.metaKey || event.shiftKey) {
        if (this.enableRotate === false) return;
        this._handleMouseDownRotate(event);
        this.state = _STATE.ROTATE;
      } else {
        if (this.enablePan === false) return;
        this._handleMouseDownPan(event);
        this.state = _STATE.PAN;
      }
      break;
    default:
      this.state = _STATE.NONE;
  }
  if (this.state !== _STATE.NONE) {
    this.dispatchEvent(_startEvent);
  }
}
function onMouseMove(event) {
  switch (this.state) {
    case _STATE.ROTATE:
      if (this.enableRotate === false) return;
      this._handleMouseMoveRotate(event);
      break;
    case _STATE.DOLLY:
      if (this.enableZoom === false) return;
      this._handleMouseMoveDolly(event);
      break;
    case _STATE.PAN:
      if (this.enablePan === false) return;
      this._handleMouseMovePan(event);
      break;
  }
}
function onMouseWheel(event) {
  if (this.enabled === false || this.enableZoom === false || this.state !== _STATE.NONE) return;
  event.preventDefault();
  this.dispatchEvent(_startEvent);
  this._handleMouseWheel(this._customWheelEvent(event));
  this.dispatchEvent(_endEvent);
}
function onKeyDown(event) {
  if (this.enabled === false) return;
  this._handleKeyDown(event);
}
function onTouchStart(event) {
  this._trackPointer(event);
  switch (this._pointers.length) {
    case 1:
      switch (this.touches.ONE) {
        case TOUCH.ROTATE:
          if (this.enableRotate === false) return;
          this._handleTouchStartRotate(event);
          this.state = _STATE.TOUCH_ROTATE;
          break;
        case TOUCH.PAN:
          if (this.enablePan === false) return;
          this._handleTouchStartPan(event);
          this.state = _STATE.TOUCH_PAN;
          break;
        default:
          this.state = _STATE.NONE;
      }
      break;
    case 2:
      switch (this.touches.TWO) {
        case TOUCH.DOLLY_PAN:
          if (this.enableZoom === false && this.enablePan === false) return;
          this._handleTouchStartDollyPan(event);
          this.state = _STATE.TOUCH_DOLLY_PAN;
          break;
        case TOUCH.DOLLY_ROTATE:
          if (this.enableZoom === false && this.enableRotate === false) return;
          this._handleTouchStartDollyRotate(event);
          this.state = _STATE.TOUCH_DOLLY_ROTATE;
          break;
        default:
          this.state = _STATE.NONE;
      }
      break;
    default:
      this.state = _STATE.NONE;
  }
  if (this.state !== _STATE.NONE) {
    this.dispatchEvent(_startEvent);
  }
}
function onTouchMove(event) {
  this._trackPointer(event);
  switch (this.state) {
    case _STATE.TOUCH_ROTATE:
      if (this.enableRotate === false) return;
      this._handleTouchMoveRotate(event);
      this.update();
      break;
    case _STATE.TOUCH_PAN:
      if (this.enablePan === false) return;
      this._handleTouchMovePan(event);
      this.update();
      break;
    case _STATE.TOUCH_DOLLY_PAN:
      if (this.enableZoom === false && this.enablePan === false) return;
      this._handleTouchMoveDollyPan(event);
      this.update();
      break;
    case _STATE.TOUCH_DOLLY_ROTATE:
      if (this.enableZoom === false && this.enableRotate === false) return;
      this._handleTouchMoveDollyRotate(event);
      this.update();
      break;
    default:
      this.state = _STATE.NONE;
  }
}
function onContextMenu(event) {
  if (this.enabled === false) return;
  event.preventDefault();
}
function interceptControlDown(event) {
  if (event.key === "Control") {
    this._controlActive = true;
    const document2 = this.domElement.getRootNode();
    document2.addEventListener("keyup", this._interceptControlUp, { passive: true, capture: true });
  }
}
function interceptControlUp(event) {
  if (event.key === "Control") {
    this._controlActive = false;
    const document2 = this.domElement.getRootNode();
    document2.removeEventListener("keyup", this._interceptControlUp, { passive: true, capture: true });
  }
}
var _changeEvent, _startEvent, _endEvent, _ray, _plane, _TILT_LIMIT, _v, _twoPI, _STATE, _EPS, OrbitControls;
var init_OrbitControls = __esm({
  "site/vendor/addons/controls/OrbitControls.js"() {
    init_three_module();
    _changeEvent = { type: "change" };
    _startEvent = { type: "start" };
    _endEvent = { type: "end" };
    _ray = new Ray();
    _plane = new Plane();
    _TILT_LIMIT = Math.cos(70 * MathUtils.DEG2RAD);
    _v = new Vector3();
    _twoPI = 2 * Math.PI;
    _STATE = {
      NONE: -1,
      ROTATE: 0,
      DOLLY: 1,
      PAN: 2,
      TOUCH_ROTATE: 3,
      TOUCH_PAN: 4,
      TOUCH_DOLLY_PAN: 5,
      TOUCH_DOLLY_ROTATE: 6
    };
    _EPS = 1e-6;
    OrbitControls = class extends Controls {
      /**
       * Constructs a new controls instance.
       *
       * @param {Object3D} object - The object that is managed by the controls.
       * @param {?HTMLDOMElement} domElement - The HTML element used for event listeners.
       */
      constructor(object, domElement = null) {
        super(object, domElement);
        this.state = _STATE.NONE;
        this.target = new Vector3();
        this.cursor = new Vector3();
        this.minDistance = 0;
        this.maxDistance = Infinity;
        this.minZoom = 0;
        this.maxZoom = Infinity;
        this.minTargetRadius = 0;
        this.maxTargetRadius = Infinity;
        this.minPolarAngle = 0;
        this.maxPolarAngle = Math.PI;
        this.minAzimuthAngle = -Infinity;
        this.maxAzimuthAngle = Infinity;
        this.enableDamping = false;
        this.dampingFactor = 0.05;
        this.enableZoom = true;
        this.zoomSpeed = 1;
        this.enableRotate = true;
        this.rotateSpeed = 1;
        this.keyRotateSpeed = 1;
        this.enablePan = true;
        this.panSpeed = 1;
        this.screenSpacePanning = true;
        this.keyPanSpeed = 7;
        this.zoomToCursor = false;
        this.autoRotate = false;
        this.autoRotateSpeed = 2;
        this.keys = { LEFT: "ArrowLeft", UP: "ArrowUp", RIGHT: "ArrowRight", BOTTOM: "ArrowDown" };
        this.mouseButtons = { LEFT: MOUSE.ROTATE, MIDDLE: MOUSE.DOLLY, RIGHT: MOUSE.PAN };
        this.touches = { ONE: TOUCH.ROTATE, TWO: TOUCH.DOLLY_PAN };
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.zoom0 = this.object.zoom;
        this._domElementKeyEvents = null;
        this._lastPosition = new Vector3();
        this._lastQuaternion = new Quaternion();
        this._lastTargetPosition = new Vector3();
        this._quat = new Quaternion().setFromUnitVectors(object.up, new Vector3(0, 1, 0));
        this._quatInverse = this._quat.clone().invert();
        this._spherical = new Spherical();
        this._sphericalDelta = new Spherical();
        this._scale = 1;
        this._panOffset = new Vector3();
        this._rotateStart = new Vector2();
        this._rotateEnd = new Vector2();
        this._rotateDelta = new Vector2();
        this._panStart = new Vector2();
        this._panEnd = new Vector2();
        this._panDelta = new Vector2();
        this._dollyStart = new Vector2();
        this._dollyEnd = new Vector2();
        this._dollyDelta = new Vector2();
        this._dollyDirection = new Vector3();
        this._mouse = new Vector2();
        this._performCursorZoom = false;
        this._pointers = [];
        this._pointerPositions = {};
        this._controlActive = false;
        this._onPointerMove = onPointerMove.bind(this);
        this._onPointerDown = onPointerDown.bind(this);
        this._onPointerUp = onPointerUp.bind(this);
        this._onContextMenu = onContextMenu.bind(this);
        this._onMouseWheel = onMouseWheel.bind(this);
        this._onKeyDown = onKeyDown.bind(this);
        this._onTouchStart = onTouchStart.bind(this);
        this._onTouchMove = onTouchMove.bind(this);
        this._onMouseDown = onMouseDown.bind(this);
        this._onMouseMove = onMouseMove.bind(this);
        this._interceptControlDown = interceptControlDown.bind(this);
        this._interceptControlUp = interceptControlUp.bind(this);
        if (this.domElement !== null) {
          this.connect(this.domElement);
        }
        this.update();
      }
      connect(element) {
        super.connect(element);
        this.domElement.addEventListener("pointerdown", this._onPointerDown);
        this.domElement.addEventListener("pointercancel", this._onPointerUp);
        this.domElement.addEventListener("contextmenu", this._onContextMenu);
        this.domElement.addEventListener("wheel", this._onMouseWheel, { passive: false });
        const document2 = this.domElement.getRootNode();
        document2.addEventListener("keydown", this._interceptControlDown, { passive: true, capture: true });
        this.domElement.style.touchAction = "none";
      }
      disconnect() {
        this.domElement.removeEventListener("pointerdown", this._onPointerDown);
        this.domElement.removeEventListener("pointermove", this._onPointerMove);
        this.domElement.removeEventListener("pointerup", this._onPointerUp);
        this.domElement.removeEventListener("pointercancel", this._onPointerUp);
        this.domElement.removeEventListener("wheel", this._onMouseWheel);
        this.domElement.removeEventListener("contextmenu", this._onContextMenu);
        this.stopListenToKeyEvents();
        const document2 = this.domElement.getRootNode();
        document2.removeEventListener("keydown", this._interceptControlDown, { capture: true });
        this.domElement.style.touchAction = "auto";
      }
      dispose() {
        this.disconnect();
      }
      /**
       * Get the current vertical rotation, in radians.
       *
       * @return {number} The current vertical rotation, in radians.
       */
      getPolarAngle() {
        return this._spherical.phi;
      }
      /**
       * Get the current horizontal rotation, in radians.
       *
       * @return {number} The current horizontal rotation, in radians.
       */
      getAzimuthalAngle() {
        return this._spherical.theta;
      }
      /**
       * Returns the distance from the camera to the target.
       *
       * @return {number} The distance from the camera to the target.
       */
      getDistance() {
        return this.object.position.distanceTo(this.target);
      }
      /**
       * Adds key event listeners to the given DOM element.
       * `window` is a recommended argument for using this method.
       *
       * @param {HTMLDOMElement} domElement - The DOM element
       */
      listenToKeyEvents(domElement) {
        domElement.addEventListener("keydown", this._onKeyDown);
        this._domElementKeyEvents = domElement;
      }
      /**
       * Removes the key event listener previously defined with `listenToKeyEvents()`.
       */
      stopListenToKeyEvents() {
        if (this._domElementKeyEvents !== null) {
          this._domElementKeyEvents.removeEventListener("keydown", this._onKeyDown);
          this._domElementKeyEvents = null;
        }
      }
      /**
       * Save the current state of the controls. This can later be recovered with `reset()`.
       */
      saveState() {
        this.target0.copy(this.target);
        this.position0.copy(this.object.position);
        this.zoom0 = this.object.zoom;
      }
      /**
       * Reset the controls to their state from either the last time the `saveState()`
       * was called, or the initial state.
       */
      reset() {
        this.target.copy(this.target0);
        this.object.position.copy(this.position0);
        this.object.zoom = this.zoom0;
        this.object.updateProjectionMatrix();
        this.dispatchEvent(_changeEvent);
        this.update();
        this.state = _STATE.NONE;
      }
      update(deltaTime = null) {
        const position = this.object.position;
        _v.copy(position).sub(this.target);
        _v.applyQuaternion(this._quat);
        this._spherical.setFromVector3(_v);
        if (this.autoRotate && this.state === _STATE.NONE) {
          this._rotateLeft(this._getAutoRotationAngle(deltaTime));
        }
        if (this.enableDamping) {
          this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor;
          this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor;
        } else {
          this._spherical.theta += this._sphericalDelta.theta;
          this._spherical.phi += this._sphericalDelta.phi;
        }
        let min = this.minAzimuthAngle;
        let max = this.maxAzimuthAngle;
        if (isFinite(min) && isFinite(max)) {
          if (min < -Math.PI) min += _twoPI;
          else if (min > Math.PI) min -= _twoPI;
          if (max < -Math.PI) max += _twoPI;
          else if (max > Math.PI) max -= _twoPI;
          if (min <= max) {
            this._spherical.theta = Math.max(min, Math.min(max, this._spherical.theta));
          } else {
            this._spherical.theta = this._spherical.theta > (min + max) / 2 ? Math.max(min, this._spherical.theta) : Math.min(max, this._spherical.theta);
          }
        }
        this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi));
        this._spherical.makeSafe();
        if (this.enableDamping === true) {
          this.target.addScaledVector(this._panOffset, this.dampingFactor);
        } else {
          this.target.add(this._panOffset);
        }
        this.target.sub(this.cursor);
        this.target.clampLength(this.minTargetRadius, this.maxTargetRadius);
        this.target.add(this.cursor);
        let zoomChanged = false;
        if (this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera) {
          this._spherical.radius = this._clampDistance(this._spherical.radius);
        } else {
          const prevRadius = this._spherical.radius;
          this._spherical.radius = this._clampDistance(this._spherical.radius * this._scale);
          zoomChanged = prevRadius != this._spherical.radius;
        }
        _v.setFromSpherical(this._spherical);
        _v.applyQuaternion(this._quatInverse);
        position.copy(this.target).add(_v);
        this.object.lookAt(this.target);
        if (this.enableDamping === true) {
          this._sphericalDelta.theta *= 1 - this.dampingFactor;
          this._sphericalDelta.phi *= 1 - this.dampingFactor;
          this._panOffset.multiplyScalar(1 - this.dampingFactor);
        } else {
          this._sphericalDelta.set(0, 0, 0);
          this._panOffset.set(0, 0, 0);
        }
        if (this.zoomToCursor && this._performCursorZoom) {
          let newRadius = null;
          if (this.object.isPerspectiveCamera) {
            const prevRadius = _v.length();
            newRadius = this._clampDistance(prevRadius * this._scale);
            const radiusDelta = prevRadius - newRadius;
            this.object.position.addScaledVector(this._dollyDirection, radiusDelta);
            this.object.updateMatrixWorld();
            zoomChanged = !!radiusDelta;
          } else if (this.object.isOrthographicCamera) {
            const mouseBefore = new Vector3(this._mouse.x, this._mouse.y, 0);
            mouseBefore.unproject(this.object);
            const prevZoom = this.object.zoom;
            this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
            this.object.updateProjectionMatrix();
            zoomChanged = prevZoom !== this.object.zoom;
            const mouseAfter = new Vector3(this._mouse.x, this._mouse.y, 0);
            mouseAfter.unproject(this.object);
            this.object.position.sub(mouseAfter).add(mouseBefore);
            this.object.updateMatrixWorld();
            newRadius = _v.length();
          } else {
            console.warn("WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled.");
            this.zoomToCursor = false;
          }
          if (newRadius !== null) {
            if (this.screenSpacePanning) {
              this.target.set(0, 0, -1).transformDirection(this.object.matrix).multiplyScalar(newRadius).add(this.object.position);
            } else {
              _ray.origin.copy(this.object.position);
              _ray.direction.set(0, 0, -1).transformDirection(this.object.matrix);
              if (Math.abs(this.object.up.dot(_ray.direction)) < _TILT_LIMIT) {
                this.object.lookAt(this.target);
              } else {
                _plane.setFromNormalAndCoplanarPoint(this.object.up, this.target);
                _ray.intersectPlane(_plane, this.target);
              }
            }
          }
        } else if (this.object.isOrthographicCamera) {
          const prevZoom = this.object.zoom;
          this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
          if (prevZoom !== this.object.zoom) {
            this.object.updateProjectionMatrix();
            zoomChanged = true;
          }
        }
        this._scale = 1;
        this._performCursorZoom = false;
        if (zoomChanged || this._lastPosition.distanceToSquared(this.object.position) > _EPS || 8 * (1 - this._lastQuaternion.dot(this.object.quaternion)) > _EPS || this._lastTargetPosition.distanceToSquared(this.target) > _EPS) {
          this.dispatchEvent(_changeEvent);
          this._lastPosition.copy(this.object.position);
          this._lastQuaternion.copy(this.object.quaternion);
          this._lastTargetPosition.copy(this.target);
          return true;
        }
        return false;
      }
      _getAutoRotationAngle(deltaTime) {
        if (deltaTime !== null) {
          return _twoPI / 60 * this.autoRotateSpeed * deltaTime;
        } else {
          return _twoPI / 60 / 60 * this.autoRotateSpeed;
        }
      }
      _getZoomScale(delta) {
        const normalizedDelta = Math.abs(delta * 0.01);
        return Math.pow(0.95, this.zoomSpeed * normalizedDelta);
      }
      _rotateLeft(angle) {
        this._sphericalDelta.theta -= angle;
      }
      _rotateUp(angle) {
        this._sphericalDelta.phi -= angle;
      }
      _panLeft(distance, objectMatrix) {
        _v.setFromMatrixColumn(objectMatrix, 0);
        _v.multiplyScalar(-distance);
        this._panOffset.add(_v);
      }
      _panUp(distance, objectMatrix) {
        if (this.screenSpacePanning === true) {
          _v.setFromMatrixColumn(objectMatrix, 1);
        } else {
          _v.setFromMatrixColumn(objectMatrix, 0);
          _v.crossVectors(this.object.up, _v);
        }
        _v.multiplyScalar(distance);
        this._panOffset.add(_v);
      }
      // deltaX and deltaY are in pixels; right and down are positive
      _pan(deltaX, deltaY) {
        const element = this.domElement;
        if (this.object.isPerspectiveCamera) {
          const position = this.object.position;
          _v.copy(position).sub(this.target);
          let targetDistance = _v.length();
          targetDistance *= Math.tan(this.object.fov / 2 * Math.PI / 180);
          this._panLeft(2 * deltaX * targetDistance / element.clientHeight, this.object.matrix);
          this._panUp(2 * deltaY * targetDistance / element.clientHeight, this.object.matrix);
        } else if (this.object.isOrthographicCamera) {
          this._panLeft(deltaX * (this.object.right - this.object.left) / this.object.zoom / element.clientWidth, this.object.matrix);
          this._panUp(deltaY * (this.object.top - this.object.bottom) / this.object.zoom / element.clientHeight, this.object.matrix);
        } else {
          console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.");
          this.enablePan = false;
        }
      }
      _dollyOut(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) {
          this._scale /= dollyScale;
        } else {
          console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
          this.enableZoom = false;
        }
      }
      _dollyIn(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) {
          this._scale *= dollyScale;
        } else {
          console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
          this.enableZoom = false;
        }
      }
      _updateZoomParameters(x, y) {
        if (!this.zoomToCursor) {
          return;
        }
        this._performCursorZoom = true;
        const rect = this.domElement.getBoundingClientRect();
        const dx = x - rect.left;
        const dy = y - rect.top;
        const w = rect.width;
        const h = rect.height;
        this._mouse.x = dx / w * 2 - 1;
        this._mouse.y = -(dy / h) * 2 + 1;
        this._dollyDirection.set(this._mouse.x, this._mouse.y, 1).unproject(this.object).sub(this.object.position).normalize();
      }
      _clampDistance(dist) {
        return Math.max(this.minDistance, Math.min(this.maxDistance, dist));
      }
      //
      // event callbacks - update the object state
      //
      _handleMouseDownRotate(event) {
        this._rotateStart.set(event.clientX, event.clientY);
      }
      _handleMouseDownDolly(event) {
        this._updateZoomParameters(event.clientX, event.clientX);
        this._dollyStart.set(event.clientX, event.clientY);
      }
      _handleMouseDownPan(event) {
        this._panStart.set(event.clientX, event.clientY);
      }
      _handleMouseMoveRotate(event) {
        this._rotateEnd.set(event.clientX, event.clientY);
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft(_twoPI * this._rotateDelta.x / element.clientHeight);
        this._rotateUp(_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
        this.update();
      }
      _handleMouseMoveDolly(event) {
        this._dollyEnd.set(event.clientX, event.clientY);
        this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart);
        if (this._dollyDelta.y > 0) {
          this._dollyOut(this._getZoomScale(this._dollyDelta.y));
        } else if (this._dollyDelta.y < 0) {
          this._dollyIn(this._getZoomScale(this._dollyDelta.y));
        }
        this._dollyStart.copy(this._dollyEnd);
        this.update();
      }
      _handleMouseMovePan(event) {
        this._panEnd.set(event.clientX, event.clientY);
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
        this.update();
      }
      _handleMouseWheel(event) {
        this._updateZoomParameters(event.clientX, event.clientY);
        if (event.deltaY < 0) {
          this._dollyIn(this._getZoomScale(event.deltaY));
        } else if (event.deltaY > 0) {
          this._dollyOut(this._getZoomScale(event.deltaY));
        }
        this.update();
      }
      _handleKeyDown(event) {
        let needsUpdate = false;
        switch (event.code) {
          case this.keys.UP:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
              if (this.enableRotate) {
                this._rotateUp(_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
              }
            } else {
              if (this.enablePan) {
                this._pan(0, this.keyPanSpeed);
              }
            }
            needsUpdate = true;
            break;
          case this.keys.BOTTOM:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
              if (this.enableRotate) {
                this._rotateUp(-_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
              }
            } else {
              if (this.enablePan) {
                this._pan(0, -this.keyPanSpeed);
              }
            }
            needsUpdate = true;
            break;
          case this.keys.LEFT:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
              if (this.enableRotate) {
                this._rotateLeft(_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
              }
            } else {
              if (this.enablePan) {
                this._pan(this.keyPanSpeed, 0);
              }
            }
            needsUpdate = true;
            break;
          case this.keys.RIGHT:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
              if (this.enableRotate) {
                this._rotateLeft(-_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
              }
            } else {
              if (this.enablePan) {
                this._pan(-this.keyPanSpeed, 0);
              }
            }
            needsUpdate = true;
            break;
        }
        if (needsUpdate) {
          event.preventDefault();
          this.update();
        }
      }
      _handleTouchStartRotate(event) {
        if (this._pointers.length === 1) {
          this._rotateStart.set(event.pageX, event.pageY);
        } else {
          const position = this._getSecondPointerPosition(event);
          const x = 0.5 * (event.pageX + position.x);
          const y = 0.5 * (event.pageY + position.y);
          this._rotateStart.set(x, y);
        }
      }
      _handleTouchStartPan(event) {
        if (this._pointers.length === 1) {
          this._panStart.set(event.pageX, event.pageY);
        } else {
          const position = this._getSecondPointerPosition(event);
          const x = 0.5 * (event.pageX + position.x);
          const y = 0.5 * (event.pageY + position.y);
          this._panStart.set(x, y);
        }
      }
      _handleTouchStartDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyStart.set(0, distance);
      }
      _handleTouchStartDollyPan(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enablePan) this._handleTouchStartPan(event);
      }
      _handleTouchStartDollyRotate(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enableRotate) this._handleTouchStartRotate(event);
      }
      _handleTouchMoveRotate(event) {
        if (this._pointers.length == 1) {
          this._rotateEnd.set(event.pageX, event.pageY);
        } else {
          const position = this._getSecondPointerPosition(event);
          const x = 0.5 * (event.pageX + position.x);
          const y = 0.5 * (event.pageY + position.y);
          this._rotateEnd.set(x, y);
        }
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft(_twoPI * this._rotateDelta.x / element.clientHeight);
        this._rotateUp(_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
      }
      _handleTouchMovePan(event) {
        if (this._pointers.length === 1) {
          this._panEnd.set(event.pageX, event.pageY);
        } else {
          const position = this._getSecondPointerPosition(event);
          const x = 0.5 * (event.pageX + position.x);
          const y = 0.5 * (event.pageY + position.y);
          this._panEnd.set(x, y);
        }
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
      }
      _handleTouchMoveDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyEnd.set(0, distance);
        this._dollyDelta.set(0, Math.pow(this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed));
        this._dollyOut(this._dollyDelta.y);
        this._dollyStart.copy(this._dollyEnd);
        const centerX = (event.pageX + position.x) * 0.5;
        const centerY = (event.pageY + position.y) * 0.5;
        this._updateZoomParameters(centerX, centerY);
      }
      _handleTouchMoveDollyPan(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enablePan) this._handleTouchMovePan(event);
      }
      _handleTouchMoveDollyRotate(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enableRotate) this._handleTouchMoveRotate(event);
      }
      // pointers
      _addPointer(event) {
        this._pointers.push(event.pointerId);
      }
      _removePointer(event) {
        delete this._pointerPositions[event.pointerId];
        for (let i = 0; i < this._pointers.length; i++) {
          if (this._pointers[i] == event.pointerId) {
            this._pointers.splice(i, 1);
            return;
          }
        }
      }
      _isTrackingPointer(event) {
        for (let i = 0; i < this._pointers.length; i++) {
          if (this._pointers[i] == event.pointerId) return true;
        }
        return false;
      }
      _trackPointer(event) {
        let position = this._pointerPositions[event.pointerId];
        if (position === void 0) {
          position = new Vector2();
          this._pointerPositions[event.pointerId] = position;
        }
        position.set(event.pageX, event.pageY);
      }
      _getSecondPointerPosition(event) {
        const pointerId = event.pointerId === this._pointers[0] ? this._pointers[1] : this._pointers[0];
        return this._pointerPositions[pointerId];
      }
      //
      _customWheelEvent(event) {
        const mode = event.deltaMode;
        const newEvent = {
          clientX: event.clientX,
          clientY: event.clientY,
          deltaY: event.deltaY
        };
        switch (mode) {
          case 1:
            newEvent.deltaY *= 16;
            break;
          case 2:
            newEvent.deltaY *= 100;
            break;
        }
        if (event.ctrlKey && !this._controlActive) {
          newEvent.deltaY *= 10;
        }
        return newEvent;
      }
    };
  }
});

// site/vendor/addons/environments/RoomEnvironment.js
function createAreaLightMaterial(intensity) {
  const material = new MeshLambertMaterial({
    color: 0,
    emissive: 16777215,
    emissiveIntensity: intensity
  });
  return material;
}
var RoomEnvironment;
var init_RoomEnvironment = __esm({
  "site/vendor/addons/environments/RoomEnvironment.js"() {
    init_three_module();
    RoomEnvironment = class extends Scene {
      constructor() {
        super();
        const geometry = new BoxGeometry();
        geometry.deleteAttribute("uv");
        const roomMaterial = new MeshStandardMaterial({ side: BackSide });
        const boxMaterial = new MeshStandardMaterial();
        const mainLight = new PointLight(16777215, 900, 28, 2);
        mainLight.position.set(0.418, 16.199, 0.3);
        this.add(mainLight);
        const room = new Mesh(geometry, roomMaterial);
        room.position.set(-0.757, 13.219, 0.717);
        room.scale.set(31.713, 28.305, 28.591);
        this.add(room);
        const boxes = new InstancedMesh(geometry, boxMaterial, 6);
        const transform = new Object3D();
        transform.position.set(-10.906, 2.009, 1.846);
        transform.rotation.set(0, -0.195, 0);
        transform.scale.set(2.328, 7.905, 4.651);
        transform.updateMatrix();
        boxes.setMatrixAt(0, transform.matrix);
        transform.position.set(-5.607, -0.754, -0.758);
        transform.rotation.set(0, 0.994, 0);
        transform.scale.set(1.97, 1.534, 3.955);
        transform.updateMatrix();
        boxes.setMatrixAt(1, transform.matrix);
        transform.position.set(6.167, 0.857, 7.803);
        transform.rotation.set(0, 0.561, 0);
        transform.scale.set(3.927, 6.285, 3.687);
        transform.updateMatrix();
        boxes.setMatrixAt(2, transform.matrix);
        transform.position.set(-2.017, 0.018, 6.124);
        transform.rotation.set(0, 0.333, 0);
        transform.scale.set(2.002, 4.566, 2.064);
        transform.updateMatrix();
        boxes.setMatrixAt(3, transform.matrix);
        transform.position.set(2.291, -0.756, -2.621);
        transform.rotation.set(0, -0.286, 0);
        transform.scale.set(1.546, 1.552, 1.496);
        transform.updateMatrix();
        boxes.setMatrixAt(4, transform.matrix);
        transform.position.set(-2.193, -0.369, -5.547);
        transform.rotation.set(0, 0.516, 0);
        transform.scale.set(3.875, 3.487, 2.986);
        transform.updateMatrix();
        boxes.setMatrixAt(5, transform.matrix);
        this.add(boxes);
        const light1 = new Mesh(geometry, createAreaLightMaterial(50));
        light1.position.set(-16.116, 14.37, 8.208);
        light1.scale.set(0.1, 2.428, 2.739);
        this.add(light1);
        const light2 = new Mesh(geometry, createAreaLightMaterial(50));
        light2.position.set(-16.109, 18.021, -8.207);
        light2.scale.set(0.1, 2.425, 2.751);
        this.add(light2);
        const light3 = new Mesh(geometry, createAreaLightMaterial(17));
        light3.position.set(14.904, 12.198, -1.832);
        light3.scale.set(0.15, 4.265, 6.331);
        this.add(light3);
        const light4 = new Mesh(geometry, createAreaLightMaterial(43));
        light4.position.set(-0.462, 8.89, 14.52);
        light4.scale.set(4.38, 5.441, 0.088);
        this.add(light4);
        const light5 = new Mesh(geometry, createAreaLightMaterial(20));
        light5.position.set(3.235, 11.486, -12.541);
        light5.scale.set(2.5, 2, 0.1);
        this.add(light5);
        const light6 = new Mesh(geometry, createAreaLightMaterial(100));
        light6.position.set(0, 20, 0);
        light6.scale.set(1, 0.1, 1);
        this.add(light6);
      }
      /**
       * Frees internal resources. This method should be called
       * when the environment is no longer required.
       */
      dispose() {
        const resources = /* @__PURE__ */ new Set();
        this.traverse((object) => {
          if (object.isMesh) {
            resources.add(object.geometry);
            resources.add(object.material);
          }
        });
        for (const resource of resources) {
          resource.dispose();
        }
      }
    };
  }
});

// site/geometry.js
function ropeLevels(dimensions = DIMENSIONS) {
  const low = dimensions.baseHeight + 0.15, high = dimensions.height - 0.24;
  return [low, (low + high) / 2, high].map((value) => Number(value.toFixed(3)));
}
function markingAreas(dimensions = DIMENSIONS) {
  const ratio = dimensions.baseHeight / DIMENSIONS.baseHeight;
  return {
    sides: { width: dimensions.outside - 2 * dimensions.baseHeight - 0.15, bottom: 0.07 * ratio, height: 0.515 * ratio },
    posts: { angle: 2.3, bottom: dimensions.baseHeight, height: dimensions.height - 0.18 - dimensions.baseHeight },
    floor: { width: dimensions.inside - 0.2, height: dimensions.inside - 0.2 }
  };
}
function createBaseBeamGeometry(dimensions = DIMENSIONS) {
  const radius = baseRadius(dimensions), length = dimensions.outside - dimensions.postDiameter;
  const geometry = new CylinderGeometry(radius, radius, length, 128, 1, false);
  geometry.rotateZ(Math.PI / 2);
  geometry.scale(1, dimensions.baseHeight / (2 * radius), 1);
  return geometry;
}
function postHemHeight(angle, dimensions = DIMENSIONS) {
  const outwardAngle = Math.abs(Math.atan2(Math.sin(angle), Math.cos(angle)));
  const joinAngle = 3 * Math.PI / 4;
  return 0.025 + (dimensions.baseHeight - 0.025) * Math.sin(Math.min(outwardAngle, joinAngle) * 2 / 3);
}
function postFootRadius(height, dimensions = DIMENSIONS) {
  const POST_RADIUS = dimensions.postDiameter / 2;
  return height < POST_RADIUS ? Math.sqrt(Math.max(0, POST_RADIUS ** 2 - (height - POST_RADIUS) ** 2)) : POST_RADIUS;
}
function createPostGeometry(dimensions = DIMENSIONS) {
  const POST_RADIUS = dimensions.postDiameter / 2, top = dimensions.height;
  const columns = 128, lowerRows = 48, bodyRows = 64, positions = [], uv = [], indices = [];
  const footArc = POST_RADIUS * Math.PI / 2;
  const arcAt = (y) => y < POST_RADIUS ? POST_RADIUS * Math.acos(1 - y / POST_RADIUS) : footArc + y - POST_RADIUS;
  const heightAt = (s) => s < footArc ? POST_RADIUS * (1 - Math.cos(s / POST_RADIUS)) : POST_RADIUS + s - footArc;
  const cap = [[top - 0.1, POST_RADIUS * 0.98], [top - 0.045, POST_RADIUS * 0.89], [top - 0.012, POST_RADIUS * 0.65], [top, 0]];
  const rows = lowerRows + bodyRows + cap.length;
  for (let row = 0; row <= rows; row++) for (let i = 0; i <= columns; i++) {
    const angle = i === columns ? 0 : i / columns * Math.PI * 2, hem = postHemHeight(angle, dimensions);
    let y, radius;
    if (row <= lowerRows) {
      y = heightAt(arcAt(hem) * row / lowerRows);
      radius = postFootRadius(y, dimensions);
    } else if (row <= lowerRows + bodyRows) {
      const t = (row - lowerRows) / bodyRows;
      y = heightAt(arcAt(hem) + (arcAt(top - 0.18) - arcAt(hem)) * t * t);
      radius = postFootRadius(y, dimensions);
    } else [y, radius] = cap[row - lowerRows - bodyRows - 1];
    positions.push(radius * Math.sin(angle), y, radius * Math.cos(angle));
    uv.push(i / columns, y / dimensions.height);
    if (row < rows && i < columns) {
      const a = row * (columns + 1) + i, b = a + columns + 1;
      indices.push(a, a + 1, b, a + 1, b + 1, b);
    }
  }
  const geometry = makeGeometry(positions, uv, indices);
  const lowerIndexCount = lowerRows * columns * 6;
  geometry.addGroup(0, lowerIndexCount, 1);
  geometry.addGroup(lowerIndexCount, indices.length - lowerIndexCount, 0);
  geometry.userData = { seamRow: lowerRows, columns, rows, integratedBase: true };
  const normals = geometry.getAttribute("normal");
  const vertices = geometry.getAttribute("position");
  for (let i = 0; i < vertices.count; i++) {
    const y = vertices.getY(i);
    if (y >= POST_RADIUS) continue;
    const normal = new Vector3(vertices.getX(i), y - POST_RADIUS, vertices.getZ(i)).normalize();
    normals.setXYZ(i, normal.x, normal.y, normal.z);
  }
  for (let row = 0; row <= rows; row++) {
    const first = row * (columns + 1), last = first + columns;
    const n = new Vector3().fromBufferAttribute(normals, first).add(new Vector3().fromBufferAttribute(normals, last)).normalize();
    if (row === 0) n.set(0, -1, 0);
    if (row === rows) n.set(0, 1, 0);
    normals.setXYZ(first, n.x, n.y, n.z);
    normals.setXYZ(last, n.x, n.y, n.z);
  }
  return geometry;
}
function makeGeometry(positions, uv, indices) {
  const g = new BufferGeometry();
  g.setAttribute("position", new Float32BufferAttribute(positions, 3));
  g.setAttribute("uv", new Float32BufferAttribute(uv, 2));
  g.setIndex(indices);
  g.computeVertexNormals();
  return g;
}
function createApronDecalGeometry(dimensions = DIMENSIONS) {
  const rows = 32, positions = [], uv = [], indices = [], radius = baseRadius(dimensions), halfHeight = dimensions.baseHeight / 2, outer = (dimensions.outside - BASE_CLEARANCE) / 2;
  const area = markingAreas(dimensions).sides;
  for (let j = 0; j <= rows; j++) {
    const v = j / rows, y = area.bottom + v * area.height, dy = Math.abs(y - halfHeight), flat = halfHeight - radius;
    const z = outer - radius + Math.sqrt(Math.max(0, radius * radius - Math.max(0, dy - flat) ** 2)) + 6e-3;
    for (let i = 0; i < 2; i++) {
      positions.push((i - 0.5) * area.width, y, z);
      uv.push(i, v);
    }
    if (j < rows) {
      const a = j * 2;
      indices.push(a, a + 1, a + 2, a + 1, a + 3, a + 2);
    }
  }
  return makeGeometry(positions, uv, indices);
}
function ropeFramePoint(corner, height, dimensions = DIMENSIONS) {
  return new Vector3(corner.x * dimensions.inside / 2, height, corner.z * dimensions.inside / 2);
}
function ropeAnchorPoint(corner, height, dimensions = DIMENSIONS) {
  const center = (dimensions.outside - dimensions.postDiameter) / 2, POST_RADIUS = dimensions.postDiameter / 2;
  return new Vector3(corner.x * center, height, corner.z * center).addScaledVector(new Vector3(-corner.x, 0, -corner.z).normalize(), POST_RADIUS + 0.04);
}
function patchGeometry(height, dimensions, originHeight = 0) {
  const POST_RADIUS = dimensions.postDiameter / 2;
  const segments = 12, positions = [], uv = [], indices = [], radius = POST_RADIUS + 5e-3;
  for (let j = 0; j < 2; j++) for (let i = 0; i <= segments; i++) {
    const u = i / segments, theta = (u - 0.5) * 0.36, y = height + (j - 0.5) * 0.11;
    positions.push(Math.sin(theta) * radius, y, Math.cos(theta) * radius);
    uv.push(u, (y + originHeight) / dimensions.height);
    if (j === 0 && i < segments) {
      const a = i, b = i + segments + 1;
      indices.push(a, a + 1, b, a + 1, b + 1, b);
    }
  }
  return makeGeometry(positions, uv, indices);
}
function straightWebbing(start, end, width, material, name, thickness = 5e-3) {
  const direction = end.clone().sub(start), mesh = new Mesh(new BoxGeometry(direction.length(), width, thickness), material);
  mesh.position.copy(start).add(end).multiplyScalar(0.5);
  mesh.quaternion.setFromUnitVectors(new Vector3(1, 0, 0), direction.clone().normalize());
  mesh.castShadow = true;
  mesh.name = name;
  mesh.userData = { start: start.toArray(), end: end.toArray(), width };
  return mesh;
}
function curvedWebbing(points, width, material, name) {
  const curve = new CatmullRomCurve3(points.map((p) => new Vector3(...p))), segments = 28, positions = [], uv = [], indices = [];
  for (let j = 0; j <= segments; j++) {
    const p = curve.getPoint(j / segments);
    for (let i = 0; i < 2; i++) {
      positions.push(p.x + (i - 0.5) * width, p.y, p.z);
      uv.push(i, j / segments);
    }
    if (j < segments) {
      const a = j * 2;
      indices.push(a, a + 1, a + 2, a + 1, a + 3, a + 2);
    }
  }
  const g = makeGeometry(positions, uv, indices), mesh = new Mesh(g, material);
  mesh.name = name;
  mesh.castShadow = true;
  return mesh;
}
function createRopeAssembly(ropeMaterials, spacerMaterial, postMaterials, dimensions = DIMENSIONS) {
  const ROPE_LEVELS2 = ropeLevels(dimensions), POST_RADIUS = dimensions.postDiameter / 2;
  const assembly = new Group();
  assembly.name = "three-inset-webbing-rails";
  const center = (dimensions.outside - dimensions.postDiameter) / 2;
  CORNERS.forEach((corner, index) => {
    const angle = Math.atan2(-corner.x, -corner.z);
    ROPE_LEVELS2.forEach((height, level) => {
      const material = ropeMaterials[level], anchor = new Group();
      anchor.position.set(corner.x * center, height, corner.z * center);
      anchor.rotation.y = angle;
      anchor.name = "knotted-post-attachment";
      const patch = new Mesh(patchGeometry(0, dimensions, height), postMaterials[index]);
      patch.name = "welded-pvc-patch";
      anchor.add(patch);
      const loop = curvedWebbing([[0, -0.024, POST_RADIUS + 5e-3], [0, -0.022, POST_RADIUS + 0.024], [0, 0, POST_RADIUS + 0.043], [0, 0.022, POST_RADIUS + 0.024], [0, 0.024, POST_RADIUS + 5e-3]], 0.022, material, "sewn-strap-loop");
      anchor.add(loop);
      const knot = curvedWebbing([[0, 0.021, POST_RADIUS + 0.024], [0, 0.012, POST_RADIUS + 0.054], [0, -8e-3, POST_RADIUS + 0.052], [0, -0.022, POST_RADIUS + 0.024], [0, 2e-3, POST_RADIUS + 0.014], [0, 0.015, POST_RADIUS + 0.042]], 0.036, material, "flat-strap-knot");
      anchor.add(knot);
      const tail = curvedWebbing([[0, -7e-3, POST_RADIUS + 0.032], [0, -0.047, POST_RADIUS + 0.049], [0, -0.091, POST_RADIUS + 0.055]], 0.026, material, "short-tie-tail");
      anchor.add(tail);
      assembly.add(anchor);
      const from = ropeAnchorPoint(corner, height, dimensions), to = ropeFramePoint(corner, height, dimensions);
      const link = straightWebbing(from, to, ROPE_WIDTH, material, "diagonal-corner-tie");
      link.userData.corner = index;
      link.userData.level = level;
      assembly.add(link);
    });
  });
  const sides = [[0, 3], [3, 2], [2, 1], [1, 0]];
  sides.forEach(([startIndex, endIndex], side) => {
    ROPE_LEVELS2.forEach((height, level) => {
      const start = ropeFramePoint(CORNERS[startIndex], height, dimensions), end = ropeFramePoint(CORNERS[endIndex], height, dimensions);
      const strap = straightWebbing(start, end, ROPE_WIDTH, ropeMaterials[level], "flat-rope");
      strap.userData.side = side;
      strap.userData.level = level;
      strap.userData.height = height;
      assembly.add(strap);
    });
    for (const fraction of [0.28, 0.72]) {
      const start = ropeFramePoint(CORNERS[startIndex], 0, dimensions), end = ropeFramePoint(CORNERS[endIndex], 0, dimensions), point = start.clone().lerp(end, fraction);
      const height = ROPE_LEVELS2.at(-1) - ROPE_LEVELS2[0] + ROPE_WIDTH;
      const spacer = new Mesh(new BoxGeometry(0.03, height, 7e-3), spacerMaterial);
      spacer.position.copy(point);
      spacer.position.y = (ROPE_LEVELS2[0] + ROPE_LEVELS2.at(-1)) / 2;
      spacer.rotation.y = Math.atan2(-(end.z - start.z), end.x - start.x);
      spacer.name = "rope-only-spacer";
      spacer.castShadow = true;
      assembly.add(spacer);
    }
  });
  CORNERS.forEach((corner) => {
    const p = ropeFramePoint(corner, 0, dimensions), height = ROPE_LEVELS2.at(-1) - ROPE_LEVELS2[0] + ROPE_WIDTH;
    const strap = new Mesh(new BoxGeometry(0.025, height, 7e-3), spacerMaterial);
    strap.position.set(p.x, (ROPE_LEVELS2[0] + ROPE_LEVELS2.at(-1)) / 2, p.z);
    strap.rotation.y = Math.atan2(corner.x, corner.z);
    strap.name = "inset-corner-strap";
    strap.castShadow = true;
    assembly.add(strap);
  });
  return assembly;
}
function createPostDecalGeometry(dimensions = DIMENSIONS) {
  const POST_RADIUS = dimensions.postDiameter / 2;
  const columns = 32, positions = [], uv = [], indices = [], radius = POST_RADIUS + 6e-3;
  const area = markingAreas(dimensions).posts;
  for (let j = 0; j < 2; j++) for (let i = 0; i <= columns; i++) {
    const u = i / columns, angle = (u - 0.5) * area.angle;
    positions.push(Math.sin(angle) * radius, area.bottom + j * area.height, Math.cos(angle) * radius);
    uv.push(u, j);
    if (j === 0 && i < columns) {
      const a = i, b = i + columns + 1;
      indices.push(a, a + 1, b, a + 1, b + 1, b);
    }
  }
  return makeGeometry(positions, uv, indices);
}
var BASE_CLEARANCE, ROPE_WIDTH, baseRadius, BASE_RADIUS, ROPE_LEVELS, ROPE_FRAME_HALF, MARKING_AREAS;
var init_geometry = __esm({
  "site/geometry.js"() {
    init_three_module();
    init_config();
    BASE_CLEARANCE = 2e-3;
    ROPE_WIDTH = 0.05;
    baseRadius = (dimensions = DIMENSIONS) => dimensions.baseHeight / 2 - BASE_CLEARANCE / 2;
    BASE_RADIUS = baseRadius();
    ROPE_LEVELS = Object.freeze(ropeLevels());
    ROPE_FRAME_HALF = DIMENSIONS.inside / 2;
    MARKING_AREAS = Object.freeze(markingAreas());
  }
});

// site/marking-layout.js
function clampPosition(position, rect, width, height) {
  const margin = 8e-3;
  const halfX = rect.width / width / 2, halfY = rect.height / height / 2;
  return { x: clamp2(position.x, halfX + margin, 1 - halfX - margin), y: clamp2(position.y, halfY + margin, 1 - halfY - margin) };
}
function movedPosition(rect, fromUV, toUV, width, height) {
  return clampPosition({ x: (rect.x + rect.width / 2) / width + toUV.x - fromUV.x, y: (rect.y + rect.height / 2) / height - (toUV.y - fromUV.y) }, rect, width, height);
}
function hitElement(elements, uv, width, height) {
  const x = uv.x * width, y = (1 - uv.y) * height;
  for (const element of [...elements].reverse()) {
    const r = element.rect, padding = Math.max(3, width * 3e-3);
    if (x >= r.x - padding && x <= r.x + r.width + padding && y >= r.y - padding && y <= r.y + r.height + padding) return element;
  }
  return null;
}
function textRun(text, font, maxWidth, maxHeight, measure) {
  if (!text.trim()) return null;
  const base = measure(text, font), size = Math.min(maxHeight, 100 * maxWidth / Math.max(1, base.width));
  const fittedFont = font.replace("100px", `${size}px`), metrics = measure(text, fittedFont);
  return { text, font: fittedFont, width: metrics.width, height: metrics.ascent + metrics.descent, ascent: metrics.ascent, descent: metrics.descent };
}
function layoutMarkings(config2, target, width, height, logo2, positions = {}, measure) {
  const suffix = target[0].toUpperCase() + target.slice(1);
  const hasLogo = Boolean(logo2 && config2["logo" + suffix]);
  const hasText = Boolean(config2["text" + suffix] && (config2.text.trim() || config2.subtext.trim()));
  const elements = [], textScale = config2.textSize / 100, logoScale = config2.logoSize / 100;
  let logoElement = null, textElement = null;
  if (hasLogo) {
    const maxWidth = Math.min(width * 0.96, width * (target === "sides" ? 0.28 : target === "posts" ? 0.6 : 0.58) * logoScale);
    const maxHeight = Math.min(height * 0.96, height * (target === "sides" ? 0.73 : hasText ? 0.52 : 0.66) * logoScale);
    const scale = Math.min(maxWidth / logo2.width, maxHeight / logo2.height);
    logoElement = { kind: "logo", rect: { x: 0, y: 0, width: logo2.width * scale, height: logo2.height * scale }, center: { x: 0.5, y: target === "sides" || !hasText ? 0.5 : 0.34 } };
    elements.push(logoElement);
  }
  if (hasText) {
    const maxWidth = Math.min(width * 0.94, width * (target === "sides" ? 0.66 : target === "posts" ? 0.82 : 0.7) * textScale);
    const mainHeight = height * (target === "sides" ? 0.36 : 0.12) * textScale, subHeight = height * (target === "sides" ? 0.15 : 0.046) * textScale;
    const runs = [textRun(config2.text, FONTS[config2.font], maxWidth, mainHeight, measure), textRun(config2.subtext, "500 100px Arial, sans-serif", maxWidth, subHeight, measure)].filter(Boolean);
    const gap = height * (target === "sides" ? 0.09 : 0.04), textWidth = Math.max(...runs.map((run) => run.width)), textHeight = runs.reduce((sum, run) => sum + run.height, 0) + gap * (runs.length - 1);
    textElement = { kind: "text", runs, gap, rect: { x: 0, y: 0, width: textWidth, height: textHeight }, center: { x: 0.5, y: target === "sides" || !hasLogo ? 0.5 : 0.8 } };
    elements.push(textElement);
  }
  if (target === "sides" && logoElement && textElement) {
    const gap = width * 0.035, totalWidth = logoElement.rect.width + gap + textElement.rect.width;
    logoElement.center.x = ((width - totalWidth) / 2 + logoElement.rect.width / 2) / width;
    textElement.center.x = ((width - totalWidth) / 2 + logoElement.rect.width + gap + textElement.rect.width / 2) / width;
  }
  for (const element of elements) {
    const center = clampPosition(positions[element.kind] || element.center, element.rect, width, height);
    element.rect.x = center.x * width - element.rect.width / 2;
    element.rect.y = center.y * height - element.rect.height / 2;
  }
  return elements;
}
var FONTS, clamp2;
var init_marking_layout = __esm({
  "site/marking-layout.js"() {
    FONTS = { sport: "900 100px Arial, sans-serif", classic: "bold 100px Georgia, serif", condensed: "900 100px Impact, Arial Narrow, sans-serif" };
    clamp2 = (value, min, max) => Math.min(max, Math.max(min, value));
  }
});

// site/marking-editor.js
var SIDE_LABELS, visibleInTree, MarkingEditor;
var init_marking_editor = __esm({
  "site/marking-editor.js"() {
    init_three_module();
    init_config();
    init_geometry();
    init_marking_layout();
    SIDE_LABELS = ["Côté avant", "Côté droit", "Côté arrière", "Côté gauche"];
    visibleInTree = (object) => {
      for (let node = object; node; node = node.parent) if (!node.visible) return false;
      return true;
    };
    MarkingEditor = class {
      constructor({ ring, camera, controls, canvas: canvas2, anisotropy = 4, onChange, dimensions = DIMENSIONS }) {
        Object.assign(this, { ring, camera, controls, canvas: canvas2, onChange });
        this.areas = markingAreas(dimensions);
        this.surfaces = [];
        this.selection = null;
        this.drag = null;
        this.logo = null;
        this.raycaster = new Raycaster();
        this.pointer = new Vector2();
        const apronGeometry = createApronDecalGeometry(dimensions), postGeometry = createPostDecalGeometry(dimensions);
        for (let i = 0; i < 4; i++) {
          const surface = this.createSurface(`side-${i}`, "sides", SIDE_LABELS[i], 2048, Math.round(2048 * this.areas.sides.height / this.areas.sides.width), apronGeometry, anisotropy);
          surface.mesh.rotation.y = i * Math.PI / 2;
        }
        const postCenter = (dimensions.outside - dimensions.postDiameter) / 2;
        CORNERS.forEach((corner, i) => {
          const surface = this.createSurface(`post-${i}`, "posts", `Totem ${corner.label.toLowerCase()}`, 640, Math.round(640 * this.areas.posts.height / (dimensions.postDiameter / 2 * this.areas.posts.angle)), postGeometry, anisotropy);
          surface.mesh.position.set(corner.x * postCenter, 0, corner.z * postCenter);
          surface.mesh.rotation.y = Math.atan2(corner.x, corner.z);
        });
        const floor = this.createSurface("floor-0", "floor", "Tapis", 1536, 1536, new PlaneGeometry(this.areas.floor.width, this.areas.floor.height), anisotropy);
        floor.mesh.rotation.x = -Math.PI / 2;
        floor.mesh.position.y = 0.03;
        this.listeners = [];
        for (const [type, handler] of [["pointerdown", this.pointerDown], ["pointermove", this.pointerMove], ["pointerup", this.pointerUp], ["pointercancel", this.pointerCancel], ["lostpointercapture", this.pointerCancel], ["pointerleave", this.pointerLeave], ["keydown", this.keyDown]]) {
          const listener = handler.bind(this);
          canvas2.addEventListener(type, listener, true);
          this.listeners.push([type, listener]);
        }
      }
      createSurface(id, target, label, width, height, geometry, anisotropy) {
        const canvas2 = document.createElement("canvas");
        canvas2.width = width;
        canvas2.height = height;
        const texture = new CanvasTexture(canvas2);
        texture.colorSpace = SRGBColorSpace;
        texture.anisotropy = anisotropy;
        const material = new MeshStandardMaterial({ map: texture, transparent: true, depthWrite: false, roughness: 0.88, metalness: 0, envMapIntensity: 0.3, polygonOffset: true, polygonOffsetFactor: -2 });
        const mesh = new Mesh(geometry, material);
        mesh.renderOrder = 3;
        mesh.userData.markingSurface = id;
        this.ring.add(mesh);
        const surface = { id, target, label, canvas: canvas2, texture, material, mesh, elements: [] };
        this.surfaces.push(surface);
        return surface;
      }
      update(config2, logo2) {
        if (this.drag && (config2 !== this.config || logo2 !== this.logo)) this.endDrag(true);
        const logoChanged = this.logo !== logo2;
        this.config = config2;
        this.logo = logo2;
        const common2 = JSON.stringify([config2.text, config2.subtext, config2.textColor, config2.font, config2.textSize, config2.logoSize, config2.textSides, config2.textPosts, config2.textFloor, config2.logoSides, config2.logoPosts, config2.logoFloor, config2.floorVisible]);
        for (const surface of this.surfaces) {
          const signature = common2 + JSON.stringify(config2.markingPositions[surface.id] || {});
          if (signature !== surface.signature || logoChanged) {
            surface.signature = signature;
            this.draw(surface);
          }
        }
        if (this.selection) {
          const surface = this.selectedSurface();
          if (!surface.mesh.visible || !surface.elements.some((e) => e.kind === this.selection.element)) this.select(null);
        }
      }
      draw(surface) {
        const ctx = surface.canvas.getContext("2d"), w = surface.canvas.width, h = surface.canvas.height;
        ctx.clearRect(0, 0, w, h);
        ctx.textAlign = "left";
        ctx.textBaseline = "alphabetic";
        const measure = (text, font) => {
          ctx.font = font;
          const m = ctx.measureText(text), size = Number(font.match(/([\d.]+)px/)[1]);
          return { width: m.width, ascent: m.actualBoundingBoxAscent || size * 0.75, descent: m.actualBoundingBoxDescent || size * 0.2 };
        };
        surface.elements = layoutMarkings(this.config, surface.target, w, h, this.logo, this.config.markingPositions[surface.id] || {}, measure);
        surface.mesh.visible = surface.elements.length > 0 && (surface.target !== "floor" || this.config.floorVisible);
        for (const element of surface.elements) {
          const r = element.rect;
          if (element.kind === "logo") ctx.drawImage(this.logo, r.x, r.y, r.width, r.height);
          else {
            ctx.fillStyle = this.config.textColor;
            ctx.textAlign = "center";
            let y = r.y;
            for (const run of element.runs) {
              ctx.font = run.font;
              ctx.fillText(run.text, r.x + r.width / 2, y + run.ascent);
              y += run.height + element.gap;
            }
          }
        }
        if (!this.suppressOutline && this.selection?.surface === surface.id) {
          const element = surface.elements.find((e) => e.kind === this.selection.element);
          if (element) {
            const r = element.rect, line = Math.max(2, w / 600), handle = Math.max(8, w / 170);
            ctx.save();
            ctx.lineWidth = line;
            ctx.strokeStyle = "#b88b35";
            ctx.setLineDash([line * 3, line * 2]);
            ctx.strokeRect(r.x, r.y, r.width, r.height);
            ctx.setLineDash([]);
            ctx.fillStyle = "#ffffff";
            for (const x of [r.x, r.x + r.width]) for (const y of [r.y, r.y + r.height]) {
              ctx.fillRect(x - handle / 2, y - handle / 2, handle, handle);
              ctx.strokeRect(x - handle / 2, y - handle / 2, handle, handle);
            }
            ctx.restore();
          }
        }
        surface.texture.needsUpdate = true;
      }
      selectedSurface() {
        return this.surfaces.find((surface) => surface.id === this.selection?.surface);
      }
      notify(moved = false) {
        const surface = this.selectedSurface();
        this.onChange?.({ selection: surface ? { ...this.selection, label: `${this.selection.element === "logo" ? "Logo" : "Texte"} · ${surface.label}` } : null, moved, dragging: Boolean(this.drag) });
      }
      select(selection) {
        const old = this.selectedSurface();
        this.selection = selection;
        if (old) this.draw(old);
        const next = this.selectedSurface();
        if (next && next !== old) this.draw(next);
        this.notify();
      }
      setRay(event) {
        const rect = this.canvas.getBoundingClientRect();
        if (!rect.width || !rect.height) return false;
        this.pointer.set((event.clientX - rect.left) / rect.width * 2 - 1, -(event.clientY - rect.top) / rect.height * 2 + 1);
        this.ring.updateWorldMatrix(true, true);
        this.camera.updateWorldMatrix(true, false);
        this.raycaster.setFromCamera(this.pointer, this.camera);
        return true;
      }
      pick(event) {
        if (!this.setRay(event)) return null;
        const hits = this.raycaster.intersectObject(this.ring, true);
        for (const hit of hits) {
          if (!visibleInTree(hit.object)) continue;
          const id = hit.object.userData.markingSurface;
          if (id) {
            const surface = this.surfaces.find((s) => s.id === id), element = hitElement(surface.elements, hit.uv, surface.canvas.width, surface.canvas.height);
            if (element) return { surface, element, hit };
          } else return null;
        }
        return null;
      }
      pointerDown(event) {
        if (event.button !== 0 || event.isPrimary === false || event.altKey || this.drag) return;
        const picked = this.pick(event);
        if (!picked) {
          this.select(null);
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        this.canvas.focus({ preventScroll: true });
        const { surface, element, hit } = picked;
        const previous = this.config.markingPositions[surface.id]?.[element.kind];
        const normal = this.camera.getWorldDirection(new Vector3()).negate();
        this.drag = { pointerId: event.pointerId, surface, element: element.kind, startUV: hit.uv.clone(), startRect: { ...element.rect }, previous: previous ? { ...previous } : null, plane: new Plane().setFromNormalAndCoplanarPoint(normal, hit.point), controlsEnabled: this.controls.enabled };
        this.controls.enabled = false;
        this.controls.autoRotate = false;
        this.canvas.setPointerCapture(event.pointerId);
        this.canvas.style.cursor = "grabbing";
        this.select({ surface: surface.id, element: element.kind });
      }
      dragUV(event) {
        if (!this.setRay(event)) return null;
        const surface = this.drag.surface, hit = this.raycaster.intersectObject(surface.mesh, false)[0];
        if (hit) return hit.uv;
        const point = this.raycaster.ray.intersectPlane(this.drag.plane, new Vector3());
        if (!point) return null;
        const local = surface.mesh.worldToLocal(point), area = this.areas[surface.target];
        if (surface.target === "sides") return new Vector2(local.x / area.width + 0.5, (local.y - area.bottom) / area.height);
        if (surface.target === "posts") return new Vector2(Math.atan2(local.x, local.z) / area.angle + 0.5, (local.y - area.bottom) / area.height);
        return new Vector2(local.x / area.width + 0.5, local.y / area.height + 0.5);
      }
      pointerMove(event) {
        if (this.drag) {
          if (event.pointerId !== this.drag.pointerId) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const uv = this.dragUV(event);
          if (!uv) return;
          const { surface, startUV, startRect } = this.drag;
          this.place(movedPosition(startRect, startUV, uv, surface.canvas.width, surface.canvas.height));
        } else if (event.buttons === 0) {
          this.canvas.style.cursor = this.pick(event) ? "move" : "grab";
        }
      }
      place(position) {
        const surface = this.selectedSurface();
        if (!surface) return;
        const element = surface.elements.find((e) => e.kind === this.selection.element);
        if (!element) return;
        const next = clampPosition(position, element.rect, surface.canvas.width, surface.canvas.height);
        const positions = this.config.markingPositions;
        positions[surface.id] = { ...positions[surface.id], [element.kind]: next };
        this.draw(surface);
        surface.signature = null;
        this.notify(true);
      }
      nudge(x, y) {
        const surface = this.selectedSurface(), element = surface?.elements.find((e) => e.kind === this.selection.element);
        if (!element) return;
        const r = element.rect;
        this.place({ x: (r.x + r.width / 2) / surface.canvas.width + x, y: (r.y + r.height / 2) / surface.canvas.height + y });
      }
      resetSelected() {
        const surface = this.selectedSurface();
        if (!surface) return;
        const positions = this.config.markingPositions[surface.id];
        if (positions) {
          delete positions[this.selection.element];
          if (!Object.keys(positions).length) delete this.config.markingPositions[surface.id];
        }
        this.draw(surface);
        surface.signature = null;
        this.notify(true);
      }
      endDrag(cancel = false) {
        const drag = this.drag;
        if (!drag) return;
        this.drag = null;
        if (cancel) {
          const positions = this.config.markingPositions[drag.surface.id] || {};
          if (drag.previous) positions[drag.element] = drag.previous;
          else delete positions[drag.element];
          if (Object.keys(positions).length) this.config.markingPositions[drag.surface.id] = positions;
          else delete this.config.markingPositions[drag.surface.id];
          this.draw(drag.surface);
          drag.surface.signature = null;
        }
        this.controls.enabled = drag.controlsEnabled;
        this.canvas.style.cursor = "move";
        if (this.canvas.hasPointerCapture(drag.pointerId)) this.canvas.releasePointerCapture(drag.pointerId);
        this.notify(cancel);
      }
      pointerUp(event) {
        if (this.drag && event.pointerId === this.drag.pointerId) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.endDrag();
        }
      }
      pointerCancel(event) {
        if (this.drag && event.pointerId === this.drag.pointerId) this.endDrag(true);
      }
      pointerLeave() {
        if (!this.drag) this.canvas.style.cursor = "grab";
      }
      keyDown(event) {
        if (event.key === "Escape" && this.selection) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.drag) this.endDrag(true);
          else this.select(null);
          return;
        }
        if (!this.selection || !["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(event.key)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const step = event.shiftKey ? 0.02 : 5e-3;
        this.nudge(event.key === "ArrowLeft" ? -step : event.key === "ArrowRight" ? step : 0, event.key === "ArrowUp" ? -step : event.key === "ArrowDown" ? step : 0);
      }
      outlineVisible(visible) {
        this.suppressOutline = !visible;
        const surface = this.selectedSurface();
        if (surface) this.draw(surface);
      }
      dispose() {
        this.endDrag(true);
        for (const [type, listener] of this.listeners) this.canvas.removeEventListener(type, listener, true);
        for (const surface of this.surfaces) {
          surface.texture.dispose();
          surface.material.dispose();
        }
      }
    };
  }
});

// site/dimensions.js
function ringMeasurements(dimensions = DIMENSIONS) {
  const half = dimensions.outside / 2, inside = dimensions.inside / 2, corner = (dimensions.outside - dimensions.postDiameter) / 2;
  const outside = formatMetres(dimensions.outside), opening = formatMetres(dimensions.inside), height = Math.round(dimensions.height * 100), section = Math.round(dimensions.baseHeight * 100), diameter = Math.round(dimensions.postDiameter * 100), low = ropeLevels(dimensions)[0];
  return [
    { id: "outside", label: `${outside} m`, description: `Extérieur : ${outside} × ${outside} m`, from: [-half, 0.04, half + 0.425], to: [half, 0.04, half + 0.425], anchors: [[-half, dimensions.baseHeight / 2, corner], [half, dimensions.baseHeight / 2, corner]], labelAt: [0, 0.03, half + 0.645] },
    { id: "ropes", label: `${opening} m`, description: `Entre les cordes : ${opening} × ${opening} m`, from: [-inside, low + 0.12, 0], to: [inside, low + 0.12, 0], anchors: [[-inside, low, 0], [inside, low, 0]], labelAt: [0, low + 0.3, 0] },
    { id: "height", label: `${height} cm`, description: `Hauteur des totems : ${height} cm`, from: [half + 0.405, 0, corner], to: [half + 0.405, dimensions.height, corner], anchors: [[corner, 0, corner], [corner, dimensions.height, corner]], labelAt: [half + 0.795, dimensions.height / 2 + 0.05, corner] },
    { id: "post-section", label: `Ø ${diameter} cm`, description: `Diamètre des totems : ${diameter} cm`, from: [-half, dimensions.height + 0.22, corner], to: [-corner + dimensions.postDiameter / 2, dimensions.height + 0.22, corner], anchors: [[-half, dimensions.height - 0.18, corner], [-corner + dimensions.postDiameter / 2, dimensions.height - 0.18, corner]], labelAt: [-corner, dimensions.height + 0.44, corner] },
    { id: "beam-section", label: `${section} cm`, description: `Section des boudins : ${section} cm`, from: [-half - 0.405, 0, 1], to: [-half - 0.405, dimensions.baseHeight, 1], anchors: [[-corner, 0, 1], [-corner, dimensions.baseHeight, 1]], labelAt: [-half - 0.765, dimensions.baseHeight / 2 + 0.055, 1] }
  ];
}
function dimensionSegments(measurement) {
  const a = new Vector3(...measurement.from), b = new Vector3(...measurement.to);
  const direction = b.clone().sub(a).normalize();
  const perpendicular = Math.abs(direction.y) > 0.5 ? new Vector3(1, 0, 0) : new Vector3(0, 1, 0);
  const points = [a, b];
  measurement.anchors.forEach((anchor, index) => points.push(new Vector3(...anchor), index === 0 ? a : b));
  for (const [end, sign] of [[a, 1], [b, -1]]) for (const side of [-1, 1]) points.push(end, end.clone().addScaledVector(direction, 0.095 * sign).addScaledVector(perpendicular, 0.042 * side));
  return points;
}
var RING_MEASUREMENTS, RingDimensions;
var init_dimensions = __esm({
  "site/dimensions.js"() {
    init_three_module();
    init_config();
    init_geometry();
    RING_MEASUREMENTS = Object.freeze(ringMeasurements());
    RingDimensions = class {
      constructor(scene, dimensions = DIMENSIONS) {
        this.group = new Group();
        this.group.name = "ring-dimensions";
        this.group.visible = false;
        scene.add(this.group);
        this.labels = [];
        this.textures = [];
        this.lineMaterial = new LineBasicMaterial({ color: "#60717d", transparent: true, opacity: 0.88, depthTest: false, depthWrite: false, toneMapped: false });
        for (const measurement of ringMeasurements(dimensions)) {
          const geometry = new BufferGeometry().setFromPoints(dimensionSegments(measurement));
          const lines = new LineSegments(geometry, this.lineMaterial);
          lines.renderOrder = 10;
          this.group.add(lines);
          const canvas2 = document.createElement("canvas"), ctx = canvas2.getContext("2d");
          ctx.font = "600 42px Arial, sans-serif";
          canvas2.width = Math.ceil(ctx.measureText(measurement.label).width + 36);
          canvas2.height = 72;
          ctx.fillStyle = "rgba(255,255,255,.96)";
          ctx.fillRect(0, 0, canvas2.width, canvas2.height);
          ctx.strokeStyle = "#c7d0d6";
          ctx.lineWidth = 3;
          ctx.strokeRect(1.5, 1.5, canvas2.width - 3, canvas2.height - 3);
          ctx.font = "600 42px Arial, sans-serif";
          ctx.fillStyle = "#344451";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(measurement.label, canvas2.width / 2, canvas2.height / 2 + 1);
          const texture = new CanvasTexture(canvas2);
          texture.colorSpace = SRGBColorSpace;
          this.textures.push(texture);
          const material = new SpriteMaterial({ map: texture, transparent: true, depthTest: false, depthWrite: false, toneMapped: false });
          const sprite = new Sprite(material);
          sprite.position.set(...measurement.labelAt);
          sprite.renderOrder = 11;
          sprite.userData = { pixelWidth: canvas2.width / 3, pixelHeight: 24 };
          this.group.add(sprite);
          this.labels.push(sprite);
        }
      }
      set visible(value) {
        this.group.visible = value;
      }
      get visible() {
        return this.group.visible;
      }
      update(camera, viewportHeight) {
        if (!this.visible || !viewportHeight) return;
        camera.updateMatrixWorld(true);
        for (const label of this.labels) {
          const distance = -label.getWorldPosition(new Vector3()).applyMatrix4(camera.matrixWorldInverse).z;
          const worldPerPixel = 2 * Math.tan(MathUtils.degToRad(camera.fov / 2)) * distance / viewportHeight;
          label.scale.set(label.userData.pixelWidth * worldPerPixel, label.userData.pixelHeight * worldPerPixel, 1);
        }
      }
      dispose() {
        this.group.removeFromParent();
        this.group.children.forEach((child) => {
          if (child.isLineSegments) child.geometry.dispose();
        });
        this.textures.forEach((texture) => texture.dispose());
        this.labels.forEach((label) => label.material.dispose());
        this.lineMaterial.dispose();
      }
    };
  }
});

// site/scene.js
var scene_exports = {};
__export(scene_exports, {
  RingViewer: () => RingViewer
});
function canvas(width, height) {
  const c = document.createElement("canvas");
  c.width = width;
  c.height = height;
  return c;
}
var COMPARISON_SCALE, RingViewer;
var init_scene = __esm({
  "site/scene.js"() {
    init_three_module();
    init_OrbitControls();
    init_RoomEnvironment();
    init_config();
    init_geometry();
    init_marking_editor();
    init_dimensions();
    init_post_finish();
    COMPARISON_SCALE = Math.max(...Object.values(RING_MODELS).map((model) => model.outside)) / DIMENSIONS.outside;
    RingViewer = class {
      constructor(container, config2) {
        this.container = container;
        this.config = config2;
        this.logo = null;
        this.disposed = false;
        this.dirty = true;
        this.currentView = "front";
        this.renderer = new WebGLRenderer({ antialias: true, alpha: false, preserveDrawingBuffer: true, powerPreference: "high-performance" });
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = PCFSoftShadowMap;
        this.renderer.outputColorSpace = SRGBColorSpace;
        this.renderer.toneMapping = NeutralToneMapping;
        this.renderer.toneMappingExposure = 0.92;
        this.renderer.domElement.setAttribute("aria-label", "Ring 3D interactif. Faites glisser un texte ou un logo pour le déplacer ; glissez à côté pour tourner. Les flèches déplacent le marquage sélectionné. Échap annule le déplacement ou quitte la sélection.");
        this.renderer.domElement.tabIndex = 0;
        container.appendChild(this.renderer.domElement);
        this.scene = new Scene();
        this.scene.background = new Color("#edf0f2");
        this.camera = new PerspectiveCamera(35, 1, 0.1, 80);
        this.camera.position.set(0.7, 3.2, 12.8);
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.target.set(0, 0.65, 0);
        this.controls.enableDamping = true;
        this.controls.dampingFactor = 0.075;
        this.controls.enablePan = false;
        this.controls.minDistance = 5.5;
        this.controls.maxDistance = 22;
        this.controls.maxPolarAngle = Math.PI / 2 - 0.035;
        this.controls.minPolarAngle = 0.025;
        this.controls.autoRotateSpeed = 0.9;
        this.controls.addEventListener("change", () => {
          this.dirty = true;
        });
        const pmrem = new PMREMGenerator(this.renderer), room = new RoomEnvironment();
        this.environment = pmrem.fromScene(room, 0.04);
        this.scene.environment = this.environment.texture;
        room.dispose();
        pmrem.dispose();
        this.scene.add(new HemisphereLight(16777215, 9475227, 1.45));
        const key = new DirectionalLight(16777215, 2.7);
        key.position.set(-3, 9, 5);
        key.castShadow = true;
        key.shadow.mapSize.set(2048, 2048);
        key.shadow.camera.left = -5;
        key.shadow.camera.right = 5;
        key.shadow.camera.top = 5;
        key.shadow.camera.bottom = -5;
        key.shadow.camera.far = 25;
        key.shadow.normalBias = 0.024;
        key.shadow.bias = -15e-5;
        key.shadow.radius = 4;
        this.scene.add(key);
        const fill = new DirectionalLight(16777215, 0.45);
        fill.position.set(5, 4, -5);
        this.scene.add(fill);
        const ground = new Mesh(new PlaneGeometry(150, 150), new MeshStandardMaterial({ color: "#edf0f2", roughness: 0.95 }));
        ground.rotation.x = -Math.PI / 2;
        ground.position.y = -0.025;
        ground.receiveShadow = true;
        this.scene.add(ground);
        this.buildRing(config2);
        this.renderer.domElement.addEventListener("keydown", (event) => {
          if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "+", "-"].includes(event.key)) {
            event.preventDefault();
            if (event.key === "+" || event.key === "-") this.zoom(event.key === "+" ? 1 : -1);
            else {
              const offset = this.camera.position.clone().sub(this.controls.target), s = new Spherical().setFromVector3(offset);
              if (event.key === "ArrowLeft") s.theta -= 0.12;
              if (event.key === "ArrowRight") s.theta += 0.12;
              if (event.key === "ArrowUp") s.phi = Math.max(0.03, s.phi - 0.1);
              if (event.key === "ArrowDown") s.phi = Math.min(Math.PI / 2 - 0.04, s.phi + 0.1);
              this.camera.position.copy(this.controls.target).add(new Vector3().setFromSpherical(s));
              this.controls.update();
            }
          }
        });
        this.renderer.domElement.addEventListener("webglcontextlost", (event) => {
          event.preventDefault();
          container.dispatchEvent(new CustomEvent("viewererror", { bubbles: true, detail: "L’aperçu 3D a été interrompu. Rechargez la page pour le rétablir." }));
        });
        this.resizeObserver = new ResizeObserver(() => this.resize());
        this.resizeObserver.observe(container);
        this.resize();
        this.update(config2);
        this.clock = new Clock();
        this.animate();
      }
      buildRing(config2) {
        this.model = config2.model;
        this.dimensions = ringDimensions(config2.model);
        this.cornerSignature = null;
        const dimensions = this.dimensions;
        this.ring = new Group();
        this.scene.add(this.ring);
        this.materials = [];
        this.textures = [];
        this.pvc = new MeshPhysicalMaterial({ color: config2.baseColor, roughness: 0.84, metalness: 0, clearcoat: 0, clearcoatRoughness: 0.9, specularIntensity: 0.28, envMapIntensity: 0.2 });
        this.materials.push(this.pvc);
        const center = (dimensions.outside - dimensions.baseHeight) / 2;
        const beamGeo = createBaseBeamGeometry(dimensions);
        for (let i = 0; i < 4; i++) {
          const group = new Group();
          group.rotation.y = i * Math.PI / 2;
          const mesh = new Mesh(beamGeo, this.pvc);
          mesh.position.set(0, dimensions.baseHeight / 2, center);
          mesh.castShadow = true;
          mesh.receiveShadow = true;
          group.add(mesh);
          this.ring.add(group);
        }
        this.floorMaterial = new MeshStandardMaterial({ color: config2.floorColor, roughness: 0.91, metalness: 0 });
        this.floor = new Mesh(new BoxGeometry(dimensions.outside - 2 * dimensions.baseHeight, 0.025, dimensions.outside - 2 * dimensions.baseHeight), this.floorMaterial);
        this.floor.position.y = 0.014;
        this.floor.receiveShadow = true;
        this.ring.add(this.floor);
        this.materials.push(this.floorMaterial);
        this.posts = [];
        this.postCanvases = [];
        this.postMaterials = [];
        const postGeo = createPostGeometry(dimensions), postCenter = (dimensions.outside - dimensions.postDiameter) / 2;
        for (const corner of CORNERS) {
          const c = canvas(64, 1024), map = new CanvasTexture(c);
          map.colorSpace = SRGBColorSpace;
          map.anisotropy = 4;
          const material = new MeshPhysicalMaterial({ map, roughness: 0.84, clearcoat: 0, clearcoatRoughness: 0.9, specularIntensity: 0.28, envMapIntensity: 0.2 });
          const mesh = new Mesh(postGeo, [material, this.pvc]);
          mesh.position.set(corner.x * postCenter, 0, corner.z * postCenter);
          mesh.rotation.y = Math.atan2(corner.x, corner.z);
          mesh.castShadow = true;
          mesh.receiveShadow = true;
          this.ring.add(mesh);
          this.posts.push(mesh);
          this.postMaterials.push(material);
          this.postCanvases.push(c);
          this.textures.push(map);
          this.materials.push(material);
        }
        this.ropeMaterials = config2.ropeColors.map((color) => new MeshStandardMaterial({ color, roughness: 0.92, side: DoubleSide }));
        this.spacerMaterial = new MeshStandardMaterial({ color: config2.spacerColor, roughness: 0.92, side: DoubleSide });
        this.materials.push(...this.ropeMaterials, this.spacerMaterial);
        this.ropes = createRopeAssembly(this.ropeMaterials, this.spacerMaterial, this.postMaterials, dimensions);
        this.ring.add(this.ropes);
        this.markingEditor = new MarkingEditor({ dimensions, ring: this.ring, camera: this.camera, controls: this.controls, canvas: this.renderer.domElement, anisotropy: Math.min(8, this.renderer.capabilities.getMaxAnisotropy()), onChange: (detail) => {
          this.dirty = true;
          this.container.dispatchEvent(new CustomEvent("markingchange", { detail }));
        } });
        this.dimensionsOverlay = new RingDimensions(this.scene, dimensions);
      }
      disposeRing() {
        this.markingEditor.select(null);
        this.markingEditor.dispose();
        this.dimensionsOverlay.dispose();
        const geometries = /* @__PURE__ */ new Set();
        this.ring.traverse((item) => {
          if (item.geometry) geometries.add(item.geometry);
        });
        geometries.forEach((geometry) => geometry.dispose());
        this.materials.forEach((material) => material.dispose());
        this.textures.forEach((texture) => texture.dispose());
        this.ring.removeFromParent();
      }
      fittedDistance() {
        return Math.max(this.currentView === "front" ? 9.8 : 10.7, (this.currentView === "front" ? 13.6 : 15) / this.camera.aspect) * (this.config.dimensionsVisible ? 1.34 : 1) * COMPARISON_SCALE;
      }
      resize() {
        const w = this.container.clientWidth, h = this.container.clientHeight;
        if (!w || !h) return;
        this.renderer.setSize(w, h);
        this.camera.aspect = w / h;
        this.camera.updateProjectionMatrix();
        const fitDistance = this.fittedDistance();
        this.controls.maxDistance = Math.max(22, fitDistance * 1.5);
        const offset = this.camera.position.clone().sub(this.controls.target);
        offset.multiplyScalar(this.fitDistance ? fitDistance / this.fitDistance : fitDistance / offset.length());
        this.camera.position.copy(this.controls.target).add(offset);
        this.fitDistance = fitDistance;
        this.controls.update();
        this.dirty = true;
      }
      update(config2, logo2 = this.logo) {
        this.config = config2;
        this.logo = logo2;
        const modelChanged = config2.model !== this.model;
        if (modelChanged) {
          this.disposeRing();
          this.buildRing(config2);
        }
        this.pvc.color.set(config2.baseColor);
        this.floorMaterial.color.set(config2.floorColor);
        this.floor.visible = config2.floorVisible;
        this.ropeMaterials.forEach((material, index) => material.color.set(config2.ropeColors[index]));
        this.spacerMaterial.color.set(config2.spacerColor);
        const cornerSignature = JSON.stringify([config2.cornerColors, config2.totemStripes, config2.baseColor]);
        if (cornerSignature !== this.cornerSignature) {
          this.postCanvases.forEach((c, index) => {
            paintPost(c, config2, index, this.dimensions);
            this.postMaterials[index].map.needsUpdate = true;
          });
          this.cornerSignature = cornerSignature;
        }
        this.markingEditor.update(config2, logo2);
        if (modelChanged || this.dimensionsOverlay.visible !== config2.dimensionsVisible) {
          this.dimensionsOverlay.visible = config2.dimensionsVisible;
          this.resize();
        }
        this.dirty = true;
      }
      view(name) {
        this.currentView = name;
        this.controls.autoRotate = false;
        const views = { perspective: [9, 6.75, 10], front: [0.7, 2.55, 12.8], top: [0, 14, 0.025] };
        this.controls.target.set(0, name === "top" ? 0 : 0.65, 0);
        this.fitDistance = this.fittedDistance();
        this.controls.maxDistance = Math.max(22, this.fitDistance * 1.5);
        this.camera.position.copy(this.controls.target).add(new Vector3(...views[name] || views.perspective).setLength(this.fitDistance || 14));
        this.controls.update();
        this.dirty = true;
      }
      zoom(direction) {
        const delta = this.camera.position.clone().sub(this.controls.target);
        const distance = MathUtils.clamp(delta.length() * (direction > 0 ? 0.86 : 1.16), this.controls.minDistance, this.controls.maxDistance);
        this.camera.position.copy(this.controls.target).add(delta.setLength(distance));
        this.controls.update();
        this.dirty = true;
      }
      rotate(enabled) {
        this.controls.autoRotate = enabled;
        this.dirty = true;
      }
      animate() {
        if (this.disposed) return;
        this.frame = requestAnimationFrame(() => this.animate());
        const delta = Math.min(this.clock.getDelta(), 0.05);
        const changed = this.markingEditor.drag ? false : this.controls.update(delta);
        if (this.dirty || changed || this.controls.autoRotate) {
          this.dimensionsOverlay.update(this.camera, this.container.clientHeight);
          this.renderer.render(this.scene, this.camera);
          this.dirty = false;
        }
      }
      async exportImage() {
        this.markingEditor.outlineVisible(false);
        try {
          this.renderer.render(this.scene, this.camera);
          return await new Promise((resolve, reject) => this.renderer.domElement.toBlob((blob) => blob ? resolve(blob) : reject(new Error("Export indisponible.")), "image/png"));
        } finally {
          this.markingEditor.outlineVisible(true);
          this.dirty = true;
        }
      }
      dispose() {
        this.disposed = true;
        cancelAnimationFrame(this.frame);
        this.resizeObserver.disconnect();
        this.disposeRing();
        this.controls.dispose();
        const geometries = /* @__PURE__ */ new Set();
        this.scene.traverse((item) => {
          if (item.geometry) geometries.add(item.geometry);
        });
        geometries.forEach((g) => g.dispose());
        this.environment.dispose();
        this.renderer.dispose();
      }
    };
  }
});

// site/app.js
init_config();
init_post_finish();
var config = freshConfig();
var viewer = null;
var logo = null;
var logoName = "";
var activeTab = "colors";
var activeCorner = 0;
var activeRope = 2;
var autoRotate = false;
var logoRequest = 0;
var individualRopes = false;
var $ = (selector, root = document) => root.querySelector(selector);
var icon = (name, cls = "") => `<i data-lucide="${name}" class="${cls}" aria-hidden="true"></i>`;
function icons() {
  window.lucide?.createIcons({ attrs: { "stroke-width": 1.6 } });
}
function colorRow(label, key, value, description = "") {
  return `<div class="color-row"><div><label for="${key}">${label}</label>${description ? `<p>${description}</p>` : ""}</div><div class="color-control"><input type="color" id="${key}" data-key="${key}" value="${value}" aria-label="${label}"><span data-hex="${key}">${value.toUpperCase()}</span></div></div>`;
}
function check(label, key, checked) {
  return `<label class="check"><input type="checkbox" data-key="${key}" ${checked ? "checked" : ""}><span>${label}</span></label>`;
}
function slider(label, key, value, min = 40, max = 140) {
  return `<div class="slider-heading"><label for="${key}">${label}</label><output for="${key}" data-output="${key}">${value} %</output></div><input class="range" type="range" id="${key}" data-key="${key}" min="${min}" max="${max}" value="${value}">`;
}
var colorName = (value) => STANDARD_COLORS.find((color) => color.value.toLowerCase() === value.toLowerCase())?.name || "Personnalisée";
function palette(key, label) {
  return `<div class="palette-heading"><span data-color-label="${key}">${label}</span><strong data-color-name="${key}"></strong></div><div class="standard-palette" data-palette-group="${key}" role="group" aria-label="${label}">${STANDARD_COLORS.map((color) => `<button type="button" class="color-swatch" data-palette="${key}" data-color="${color.value}" aria-label="${label} : ${color.name}" aria-pressed="false"><span class="swatch-dot" style="--swatch:${color.value}"></span><span data-swatch-label>${color.name}</span></button>`).join("")}</div>`;
}
var app = $("#app");
app.innerHTML = `
  <header class="topbar">
    <a class="brand" href="./" aria-label="Esprit Boxe, accueil du configurateur"><strong>ESPRIT BOXE<span>FOR THE GLORY</span></strong><span class="brand-divider"></span><span class="studio-name">RING<br><b>STUDIO</b></span></a>
    <div class="header-center">CONFIGURATEUR 3D</div>
    <div class="header-actions"><button class="icon-button" id="reset" title="Réinitialiser la personnalisation" aria-label="Réinitialiser la personnalisation">${icon("rotate-ccw")}</button><button class="primary-button" id="export" disabled>${icon("download")}<span>Exporter la vue</span></button></div>
  </header>
  <main class="workspace">
    <section class="stage" aria-label="Aperçu de votre ring">
      <div class="stage-heading"><span class="eyebrow" id="model-heading">ESPRIT BOXE · MODÈLE L</span><h1>Ring gonflable</h1><p>Personnalisez. Faites-le vôtre.</p></div>
      <div class="view-options"><label class="dimensions-toggle" title="${dimensionsDescription(config.model)}"><input type="checkbox" id="dimensionsVisible" data-key="dimensionsVisible" aria-describedby="dimensions-description"><span>Dimensions</span></label></div><span class="sr-only" id="dimensions-description">${dimensionsDescription(config.model)}</span>
      <div id="viewer"><div class="loading" id="loading"><span class="loading-ring"></span><span>Préparation de votre ring…</span></div></div>
      <div class="stage-footer"><div class="view-controls"><div class="view-segment" aria-label="Angle de vue"><button data-view="perspective" aria-pressed="false" title="Vue perspective">${icon("box")}<span>3D</span></button><button data-view="front" class="selected" aria-pressed="true" title="Vue de face">${icon("panel-top")}<span>Face</span></button><button data-view="top" aria-pressed="false" title="Vue de dessus">${icon("scan")}<span>Dessus</span></button></div><div class="zoom-controls"><button id="zoom-out" aria-label="Dézoomer">${icon("minus")}</button><button id="zoom-in" aria-label="Zoomer">${icon("plus")}</button></div><button id="rotate" class="rotate-button" aria-label="Activer la rotation automatique" aria-pressed="false" title="Rotation automatique">${icon("rotate-3d")}</button></div><p class="gesture">${icon("mouse-pointer-2")}<span>Glissez un marquage pour le déplacer · À côté pour tourner</span></p></div>
    </section>
    <aside class="panel" aria-label="Personnalisation du ring">
      <div class="panel-heading"><div><span class="eyebrow">VOTRE CRÉATION</span><h2>Votre ring.</h2></div><span class="step-pill">EN DIRECT</span></div>
      <div class="model-choice"><span id="model-label">Taille du ring · extérieur</span><div class="model-selector" role="group" aria-labelledby="model-label">${Object.entries(RING_MODELS).map(([model, dimensions]) => `<button type="button" data-model="${model}" aria-label="${dimensionsDescription(model)}" title="${dimensionsDescription(model)}" aria-pressed="${config.model === model}"><strong>${model}</strong><span>${formatMetres(dimensions.outside)} m</span></button>`).join("")}</div></div>
      <div class="tabs" role="tablist" aria-label="Options de personnalisation"><button id="colors-tab" role="tab" aria-selected="true" aria-controls="colors-panel" data-tab="colors" tabindex="0"><span class="tab-number">1</span>Couleurs</button><button id="branding-tab" role="tab" aria-selected="false" aria-controls="branding-panel" data-tab="branding" tabindex="-1"><span class="tab-number">2</span>Texte & logo</button></div>
      <div class="panel-scroll">
        <div id="colors-panel" role="tabpanel" aria-labelledby="colors-tab">
          <details class="color-accordion" data-color-group id="group-base" open><summary><span>Boudins du ring</span><span class="group-value" id="base-summary"></span>${icon("chevron-down")}</summary><div class="accordion-content">${palette("baseColor", "Couleur des boudins")}</div></details>
          <details class="color-accordion" data-color-group id="group-totems"><summary><span>Totems de coin</span><span class="summary-chips">${[0, 1, 2, 3].map((index) => `<i data-summary-corner="${index}"></i>`).join("")}</span>${icon("chevron-down")}</summary><div class="accordion-content"><div class="totem-finish">${check("Stries", "totemStripes", config.totemStripes)}<p class="small-note" id="stripes-note" hidden>Le bas des quatre totems reprend la couleur des boudins. Personnalisez la partie haute de chaque coin.</p></div><div class="corner-grid" role="group" aria-label="Totem à personnaliser">${[1, 2, 0, 3].map((index) => `<button class="color-target" data-edit-corner="${index}" aria-pressed="false"><span class="target-chip"></span><span>${CORNERS[index].label}<small data-corner-name="${index}"></small></span></button>`).join("")}</div><p class="small-note" id="corner-hint">Choisissez le coin à colorer.</p>${palette("cornerColors", "Couleur du totem")}</div></details>
          <details class="color-accordion" data-color-group id="group-ropes"><summary><span>Cordes</span><span class="group-value" id="ropes-summary"></span>${icon("chevron-down")}</summary><div class="accordion-content"><label class="check"><input type="checkbox" id="individual-ropes"><span>Régler chaque corde séparément</span></label><div class="rope-targets" id="rope-targets" role="group" aria-label="Corde à personnaliser" hidden>${[[2, "Haute"], [1, "Milieu"], [0, "Basse"]].map(([index, label]) => `<button class="color-target" data-edit-rope="${index}" aria-pressed="false"><span class="target-chip"></span><span>${label}<small data-rope-name="${index}"></small></span></button>`).join("")}</div>${palette("ropeColors", "Couleur des cordes")}<button class="apply-ropes" id="apply-all-ropes" hidden>Appliquer aux trois cordes</button><details class="advanced-options"><summary>Couleur des entre-cordes</summary><div class="field row-field"><label for="spacerColor">Sangles verticales</label><select id="spacerColor" data-key="spacerColor">${STANDARD_COLORS.map((color) => `<option value="${color.value}">${color.name}</option>`).join("")}</select></div></details></div></details>
          <details class="color-accordion" data-color-group id="group-floor"><summary><span>Tapis au sol</span><span class="group-value" id="floor-summary">Sans tapis</span>${icon("chevron-down")}</summary><div class="accordion-content">${check("Ajouter un tapis", "floorVisible", config.floorVisible)}<div id="floor-color-row" hidden>${colorRow("Couleur du tapis", "floorColor", config.floorColor)}</div></div></details>
        </div>
        <div id="branding-panel" role="tabpanel" aria-labelledby="branding-tab" hidden>
          <div class="drag-guidance">${icon("move")}<p>Glissez votre texte ou logo sur le ring pour le placer.</p></div>
          <div id="placement-editor" class="placement-editor" hidden><p id="selection-title" aria-live="polite"></p><div class="placement-actions"><div class="nudge-buttons" role="group" aria-label="Ajuster la position du marquage"><button data-nudge="left" aria-label="Déplacer vers la gauche">${icon("arrow-left")}</button><button data-nudge="up" aria-label="Déplacer vers le haut">${icon("arrow-up")}</button><button data-nudge="down" aria-label="Déplacer vers le bas">${icon("arrow-down")}</button><button data-nudge="right" aria-label="Déplacer vers la droite">${icon("arrow-right")}</button></div><button id="reset-position">${icon("undo-2")}<span>Recentrer</span></button></div></div>
          <section class="control-section"><h3>Votre texte</h3><div class="field"><div class="field-label"><label for="text">Texte sur le ring</label><span><output id="text-count">11</output>/40</span></div><input type="text" id="text" data-key="text" maxlength="40" value="${config.text}" placeholder="Nom de votre club ou événement" autocomplete="off"></div><details class="advanced-options" id="text-advanced"><summary>Style, taille et emplacements</summary><div class="field"><label for="subtext">Deuxième ligne <span class="optional">facultatif</span></label><input type="text" id="subtext" data-key="subtext" maxlength="60" value="${config.subtext}" placeholder="Votre devise" autocomplete="off"></div><div class="field row-field"><label for="font">Style d’écriture</label><select id="font" data-key="font"><option value="sport">Sport</option><option value="condensed">Condensé</option><option value="classic">Classique</option></select></div>${colorRow("Couleur du texte", "textColor", config.textColor)}<h4>Afficher le texte sur</h4><div class="placement-options">${check("Les 4 côtés", "textSides", true)}${check("Les 4 totems", "textPosts", false)}${check("Le tapis", "textFloor", false)}</div>${slider("Taille du texte", "textSize", 100)}</details><p class="small-note" id="floor-marking-note" hidden>Ajoutez un tapis dans « Couleurs » pour afficher le marquage au sol.</p></section>
          <section class="control-section"><h3>Votre logo</h3><input type="file" id="logo-file" accept="image/png,image/jpeg,image/webp" hidden><button class="upload-zone" id="upload-logo">${icon("image-plus")}<strong>Importer votre logo</strong><span>PNG, JPG ou WebP · 8 Mo max.</span></button><div class="uploaded-logo" id="uploaded-logo" hidden><img id="logo-preview" alt="Votre logo importé"><div><strong id="logo-filename"></strong><button class="text-button" id="replace-logo">Remplacer le logo</button></div><button class="icon-button" id="remove-logo" aria-label="Retirer le logo">${icon("x")}</button></div><p class="small-note" id="upload-tip">Idéalement un PNG avec un fond transparent.</p><p class="field-error" id="upload-error" role="alert" hidden></p><div id="logo-options" hidden><details class="advanced-options"><summary>Taille et emplacements du logo</summary><h4>Afficher le logo sur</h4><div class="placement-options">${check("Les 4 côtés", "logoSides", true)}${check("Les 4 totems", "logoPosts", false)}${check("Le tapis", "logoFloor", false)}</div>${slider("Taille du logo", "logoSize", 100)}</details></div></section>
        </div>
      </div>
      <div class="panel-bottom"><button class="primary-button" id="continue-editor"><span id="continue-label">Ajouter mon texte et mon logo</span>${icon("arrow-right")}</button><p>Simulation à valider avant fabrication.</p></div>
    </aside>
  </main>
  <div class="toast" id="toast" role="status" aria-live="polite" hidden></div>

`;
icons();
function toast(message) {
  const el = $("#toast");
  el.textContent = message;
  el.hidden = false;
  clearTimeout(toast.timer);
  toast.timer = setTimeout(() => el.hidden = true, 4200);
}
var updateFrame;
function scheduleUpdate() {
  cancelAnimationFrame(updateFrame);
  updateFrame = requestAnimationFrame(() => viewer?.update(config, logo));
  syncLabels();
}
function applyPatch(patch) {
  Object.assign(config, validatePatch(patch));
  if (patch.ropeColors && new Set(config.ropeColors).size > 1) individualRopes = true;
  syncControls();
  scheduleUpdate();
}
function cornerPreview(index) {
  if (!config.totemStripes) return config.cornerColors[index];
  const d = ringDimensions(config.model), upper = (1 - d.baseHeight / d.height) * 100, step = upper / 4;
  const color = hasPostStripes(config, index) ? config.cornerColors[index] : STRIPE_WHITE;
  return `linear-gradient(to bottom,${STRIPE_WHITE} 0 ${step}%,${color} ${step}% ${2 * step}%,${STRIPE_WHITE} ${2 * step}% ${3 * step}%,${color} ${3 * step}% ${upper}%,${config.baseColor} ${upper}% 100%)`;
}
function syncPalettes() {
  const selected = { baseColor: config.baseColor, cornerColors: config.totemStripes && !hasPostStripes(config, activeCorner) ? STRIPE_WHITE : config.cornerColors[activeCorner], ropeColors: config.ropeColors[activeRope] };
  const cornerLabel = config.totemStripes ? "Couleur des stries" : "Couleur du totem";
  document.querySelectorAll("[data-palette]").forEach((el) => {
    el.setAttribute("aria-pressed", String(el.dataset.color.toLowerCase() === selected[el.dataset.palette].toLowerCase()));
    if (el.dataset.palette === "cornerColors") {
      const name = config.totemStripes && el.dataset.color === STRIPE_WHITE ? "Sans stries" : colorName(el.dataset.color);
      $("[data-swatch-label]", el).textContent = name;
      el.setAttribute("aria-label", `${cornerLabel} : ${name}`);
    }
  });
  document.querySelectorAll("[data-color-name]").forEach((el) => el.textContent = el.dataset.colorName === "cornerColors" && config.totemStripes && !hasPostStripes(config, activeCorner) ? "Sans stries" : colorName(selected[el.dataset.colorName]));
  for (const [type, values, active] of [["corner", config.cornerColors, activeCorner], ["rope", config.ropeColors, activeRope]]) {
    document.querySelectorAll(`[data-edit-${type}]`).forEach((el) => {
      const index = Number(el.dataset[type === "corner" ? "editCorner" : "editRope"]);
      el.setAttribute("aria-pressed", String(index === active));
      $(".target-chip", el).style.background = type === "corner" ? cornerPreview(index) : values[index];
      $(`[data-${type}-name]`, el).textContent = type === "corner" && config.totemStripes ? hasPostStripes(config, index) ? `${colorName(values[index])} · Stries` : "Haut blanc" : colorName(values[index]);
    });
  }
  $("#apply-all-ropes").disabled = config.ropeColors.every((color) => color === config.ropeColors[activeRope]);
  $("#apply-all-ropes").hidden = !individualRopes;
  $("#rope-targets").hidden = !individualRopes;
  $("#individual-ropes").checked = individualRopes;
  $("#base-summary").textContent = colorName(config.baseColor);
  $("#ropes-summary").textContent = new Set(config.ropeColors).size === 1 ? colorName(config.ropeColors[0]) : "Par corde";
  $("#floor-summary").textContent = config.floorVisible ? "Avec tapis" : "Sans tapis";
  document.querySelectorAll("[data-summary-corner]").forEach((el) => el.style.background = cornerPreview(Number(el.dataset.summaryCorner)));
  $("#stripes-note").hidden = !config.totemStripes;
  $('[data-color-label="cornerColors"]').textContent = cornerLabel;
  $('[data-palette-group="cornerColors"]').setAttribute("aria-label", cornerLabel);
  $("#corner-hint").textContent = config.totemStripes ? "Choisissez un coin, puis la couleur de ses deux bandes. « Sans stries » garde le haut blanc." : "Choisissez le coin à colorer.";
}
function syncLabels() {
  syncPalettes();
  $("#model-heading").textContent = `ESPRIT BOXE · MODÈLE ${config.model}`;
  const description = dimensionsDescription(config.model);
  $("#dimensions-description").textContent = description;
  $(".dimensions-toggle").title = description;
  document.querySelectorAll("[data-model]").forEach((button) => button.setAttribute("aria-pressed", String(button.dataset.model === config.model)));
  document.querySelectorAll("[data-hex]").forEach((el) => el.textContent = config[el.dataset.hex].toUpperCase());
  document.querySelectorAll("[data-output]").forEach((el) => el.value = config[el.dataset.output] + " %");
  $("#text-count").textContent = config.text.length;
  $("#floor-color-row").hidden = !config.floorVisible;
  $("#floorColor").disabled = !config.floorVisible;
  $("#floor-marking-note").hidden = config.floorVisible || !config.logoFloor && !config.textFloor;
}
function syncControls() {
  document.querySelectorAll("[data-key]").forEach((el) => {
    const value = config[el.dataset.key];
    if (el.type === "checkbox") el.checked = value;
    else el.value = value;
  });
  syncLabels();
}
document.addEventListener("input", (event) => {
  const el = event.target;
  if (el.dataset.key) {
    const value = el.type === "checkbox" ? el.checked : el.type === "range" ? Number(el.value) : el.value;
    try {
      Object.assign(config, validatePatch({ [el.dataset.key]: value }));
    } catch {
      return;
    }
    if (value === true && ["textFloor", "logoFloor"].includes(el.dataset.key)) {
      config.floorVisible = true;
      $('[data-key="floorVisible"]').checked = true;
    }
    scheduleUpdate();
  }
});
document.addEventListener("click", (event) => {
  const button = event.target.closest("button");
  if (!button) return;
  if (button.dataset.model) {
    applyPatch({ model: button.dataset.model });
    return;
  }
  if (button.dataset.editCorner !== void 0) {
    activeCorner = Number(button.dataset.editCorner);
    syncPalettes();
  }
  if (button.dataset.editRope !== void 0) {
    activeRope = Number(button.dataset.editRope);
    syncPalettes();
  }
  if (button.dataset.palette) {
    const key = button.dataset.palette;
    let value = button.dataset.color;
    if (key === "ropeColors" && !individualRopes) {
      applyPatch({ ropeColors: Array(3).fill(value), spacerColor: value });
      return;
    }
    if (key !== "baseColor") {
      value = [...config[key]];
      value[key === "cornerColors" ? activeCorner : activeRope] = button.dataset.color;
    }
    applyPatch({ [key]: value });
  }
});
$("#apply-all-ropes").addEventListener("click", () => {
  individualRopes = false;
  applyPatch({ ropeColors: Array(3).fill(config.ropeColors[activeRope]) });
});
$("#individual-ropes").addEventListener("change", (event) => {
  individualRopes = event.target.checked;
  if (!individualRopes) applyPatch({ ropeColors: Array(3).fill(config.ropeColors[activeRope]) });
  else syncPalettes();
});
document.querySelectorAll("[data-color-group]").forEach((group) => group.addEventListener("toggle", () => {
  if (group.open) document.querySelectorAll("[data-color-group]").forEach((other) => {
    if (other !== group) other.open = false;
  });
}));
$("#continue-editor").addEventListener("click", () => {
  if (activeTab === "colors") {
    setTab("branding");
    $("#text").focus();
  } else $("#export").click();
});
$("#text").addEventListener("focus", (event) => {
  if (event.target.value === "VOTRE TEXTE") event.target.select();
});
function syncNextButton() {
  $("#continue-label").textContent = activeTab === "colors" ? "Ajouter mon texte et mon logo" : "Exporter mon visuel";
  $("#continue-editor").disabled = activeTab === "branding" && (!viewer || $("#export").disabled);
}
function setTab(name) {
  activeTab = name;
  document.querySelectorAll("[data-tab]").forEach((el) => {
    const selected = el.dataset.tab === name;
    el.setAttribute("aria-selected", String(selected));
    el.tabIndex = selected ? 0 : -1;
  });
  $("#colors-panel").hidden = name !== "colors";
  $("#branding-panel").hidden = name !== "branding";
  $(".panel-scroll").scrollTop = 0;
  syncNextButton();
}
document.querySelectorAll("[data-tab]").forEach((button) => {
  button.addEventListener("click", () => setTab(button.dataset.tab));
  button.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.preventDefault();
      const next = activeTab === "colors" ? "branding" : "colors";
      setTab(next);
      $(`[data-tab="${next}"]`).focus();
    }
  });
});
function setRotate(value) {
  autoRotate = value;
  viewer?.rotate(value);
  $("#rotate").setAttribute("aria-pressed", String(value));
  $("#rotate").setAttribute("aria-label", value ? "Arrêter la rotation automatique" : "Activer la rotation automatique");
}
function setView(name) {
  viewer?.view(name);
  setRotate(false);
  document.querySelectorAll("[data-view]").forEach((el) => {
    el.classList.toggle("selected", el.dataset.view === name);
    el.setAttribute("aria-pressed", String(el.dataset.view === name));
  });
}
document.querySelectorAll("[data-view]").forEach((button) => button.addEventListener("click", () => setView(button.dataset.view)));
$("#zoom-in").addEventListener("click", () => viewer?.zoom(1));
$("#zoom-out").addEventListener("click", () => viewer?.zoom(-1));
$("#rotate").addEventListener("click", () => setRotate(!autoRotate));
async function importLogo(file) {
  const request = ++logoRequest;
  $("#upload-error").hidden = true;
  if (!file) return;
  if (!["image/png", "image/jpeg", "image/webp"].includes(file.type)) {
    showUploadError("Choisissez une image PNG, JPG ou WebP.");
    return;
  }
  if (file.size > 8 * 1024 * 1024) {
    showUploadError("Le fichier dépasse 8 Mo. Utilisez une image plus légère.");
    return;
  }
  const objectUrl = URL.createObjectURL(file), img = new Image();
  try {
    img.src = objectUrl;
    await img.decode();
    if (request !== logoRequest) return;
    if (img.width * img.height > 24e6) throw new Error("L’image est trop grande. Réduisez-la à moins de 24 mégapixels.");
    logo = img;
    logoName = file.name;
    const previewCanvas = document.createElement("canvas"), scale = Math.min(1, 160 / Math.max(img.width, img.height));
    previewCanvas.width = Math.max(1, Math.round(img.width * scale));
    previewCanvas.height = Math.max(1, Math.round(img.height * scale));
    previewCanvas.getContext("2d").drawImage(img, 0, 0, previewCanvas.width, previewCanvas.height);
    $("#logo-preview").src = previewCanvas.toDataURL("image/png");
    $("#logo-filename").textContent = logoName;
    $("#upload-logo").hidden = true;
    $("#uploaded-logo").hidden = false;
    $("#logo-options").hidden = false;
    $("#upload-tip").hidden = true;
    scheduleUpdate();
    toast("Votre logo est appliqué au ring.");
  } catch (error) {
    if (request === logoRequest) showUploadError(error.message.includes("mégapixels") ? error.message : "Cette image ne peut pas être ouverte. Essayez un autre fichier.");
  } finally {
    URL.revokeObjectURL(objectUrl);
    $("#logo-file").value = "";
  }
}
function showUploadError(message) {
  $("#upload-error").textContent = message;
  $("#upload-error").hidden = false;
}
function removeLogo() {
  logoRequest++;
  logo = null;
  logoName = "";
  $("#logo-preview").removeAttribute("src");
  $("#upload-logo").hidden = false;
  $("#uploaded-logo").hidden = true;
  $("#logo-options").hidden = true;
  $("#upload-tip").hidden = false;
  $("#upload-error").hidden = true;
  $("#logo-file").value = "";
  scheduleUpdate();
}
$("#upload-logo").addEventListener("click", () => $("#logo-file").click());
$("#replace-logo").addEventListener("click", () => $("#logo-file").click());
$("#logo-file").addEventListener("change", (event) => importLogo(event.target.files[0]));
$("#remove-logo").addEventListener("click", removeLogo);
var upload = $("#upload-logo");
for (const name of ["dragenter", "dragover"]) upload.addEventListener(name, (event) => {
  event.preventDefault();
  upload.classList.add("dragging");
});
for (const name of ["dragleave", "drop"]) upload.addEventListener(name, (event) => {
  event.preventDefault();
  upload.classList.remove("dragging");
  if (name === "drop") importLogo(event.dataTransfer.files[0]);
});
$("#reset").addEventListener("click", () => {
  viewer?.markingEditor.select(null);
  config = { ...freshConfig(), model: config.model };
  individualRopes = false;
  activeCorner = 0;
  activeRope = 2;
  removeLogo();
  syncControls();
  setView("front");
  setTab("colors");
  $("#group-base").open = true;
  document.querySelectorAll(".advanced-options").forEach((el) => el.open = false);
  scheduleUpdate();
  toast("La personnalisation a été réinitialisée.");
});
$("#export").addEventListener("click", async () => {
  if (!viewer) return;
  const button = $("#export");
  button.disabled = true;
  syncNextButton();
  try {
    const blob = await viewer.exportImage(), url = URL.createObjectURL(blob), a = document.createElement("a");
    a.href = url;
    a.download = `esprit-boxe-ring-${config.model.toLowerCase()}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 15e3);
    toast("L’image de votre ring est prête.");
  } catch {
    toast("L’export a échoué. Réessayez.");
  } finally {
    button.disabled = false;
    syncNextButton();
  }
});
function viewerError(message) {
  $("#loading")?.remove();
  const error = document.createElement("div");
  error.className = "viewer-error";
  const text = document.createElement("p");
  text.textContent = message;
  const button = document.createElement("button");
  button.className = "primary-button";
  button.textContent = "Recharger l’aperçu";
  button.addEventListener("click", () => location.reload());
  error.append(text, button);
  $("#viewer").appendChild(error);
  $("#export").disabled = true;
  syncNextButton();
}
$("#viewer").addEventListener("viewererror", (event) => viewerError(event.detail));
$("#viewer").addEventListener("markingchange", (event) => {
  const { selection, dragging } = event.detail;
  $("#placement-editor").hidden = !selection;
  const label = selection?.label || "";
  if ($("#selection-title").textContent !== label) $("#selection-title").textContent = label;
  if (selection && activeTab !== "branding") setTab("branding");
  if (dragging) setRotate(false);
});
$("#reset-position").addEventListener("click", () => viewer?.markingEditor.resetSelected());
document.querySelectorAll("[data-nudge]").forEach((button) => button.addEventListener("click", () => {
  const delta = { left: [-0.01, 0], right: [0.01, 0], up: [0, -0.01], down: [0, 0.01] }[button.dataset.nudge];
  viewer?.markingEditor.nudge(...delta);
}));
try {
  const { RingViewer: RingViewer2 } = await Promise.resolve().then(() => (init_scene(), scene_exports));
  viewer = new RingViewer2($("#viewer"), config);
  $("#loading").remove();
  $("#export").disabled = false;
} catch (error) {
  console.error("Ring viewer initialization failed:", error);
  viewerError("La 3D n’est pas disponible dans ce navigateur. Activez l’accélération graphique ou ouvrez ce configurateur dans un navigateur récent.");
}
syncControls();
syncNextButton();
var lifecycle = new AbortController();
window.addEventListener("pagehide", () => {
  lifecycle.abort();
  viewer?.dispose();
}, { once: true });
if (document.modelContext?.registerTool) {
  const schema = { type: "object", properties: { model: { type: "string", enum: Object.keys(RING_MODELS) }, baseColor: { type: "string", pattern: "^#[0-9a-fA-F]{6}$" }, ropeColors: { type: "array", items: { type: "string", pattern: "^#[0-9a-fA-F]{6}$" }, minItems: 3, maxItems: 3 }, spacerColor: { type: "string", pattern: "^#[0-9a-fA-F]{6}$" }, floorColor: { type: "string", pattern: "^#[0-9a-fA-F]{6}$" }, textColor: { type: "string", pattern: "^#[0-9a-fA-F]{6}$" }, cornerColors: { type: "array", items: { type: "string", pattern: "^#[0-9a-fA-F]{6}$" }, minItems: 4, maxItems: 4 }, text: { type: "string", maxLength: 40 }, subtext: { type: "string", maxLength: 60 }, font: { enum: ["sport", "classic", "condensed"] }, markingPositions: { type: "object", patternProperties: { "^(?:(?:side|post)-[0-3]|floor-0)$": { type: "object", properties: { logo: { type: "object", properties: { x: { type: "number", minimum: 0, maximum: 1 }, y: { type: "number", minimum: 0, maximum: 1 } }, required: ["x", "y"], additionalProperties: false }, text: { type: "object", properties: { x: { type: "number", minimum: 0, maximum: 1 }, y: { type: "number", minimum: 0, maximum: 1 } }, required: ["x", "y"], additionalProperties: false } }, additionalProperties: false } }, additionalProperties: false }, totemStripes: { type: "boolean" }, floorVisible: { type: "boolean" }, dimensionsVisible: { type: "boolean" }, textSides: { type: "boolean" }, textPosts: { type: "boolean" }, textFloor: { type: "boolean" }, logoSides: { type: "boolean" }, logoPosts: { type: "boolean" }, logoFloor: { type: "boolean" }, textSize: { type: "number", minimum: 40, maximum: 140 }, logoSize: { type: "number", minimum: 40, maximum: 140 } }, additionalProperties: false };
  for (const tool of [
    { name: "read_ring_configuration", title: "Lire la personnalisation du ring", description: "Lire le modèle Enfant, L ou XL, ses dimensions, les couleurs, l’option Stries, les textes et les emplacements de marquage actuellement visibles.", inputSchema: { type: "object", properties: {}, additionalProperties: false }, annotations: { readOnlyHint: true, untrustedContentHint: true }, execute: () => ({ configuration: structuredClone(config), logoImported: Boolean(logo), dimensions: ringDimensions(config.model), availableModels: RING_MODELS, standardColors: STANDARD_COLORS, ropeOrder: ["basse", "milieu", "haute"] }) },
    { name: "configure_ring", title: "Personnaliser le ring", description: "Choisir le modèle Enfant, L ou XL et modifier les couleurs, l’option Stries des totems, les textes et les emplacements dans le configurateur visible. Le logo est importé par le client depuis le bouton dédié. Ne commande et ne transmet rien.", inputSchema: schema, annotations: { readOnlyHint: false, untrustedContentHint: true }, execute: async (input) => {
      const patch = validatePatch(input);
      applyPatch(patch);
      await new Promise((resolve) => requestAnimationFrame(resolve));
      return { configuration: structuredClone(config), logoImported: Boolean(logo) };
    } }
  ]) {
    try {
      Promise.resolve(document.modelContext.registerTool(tool, { signal: lifecycle.signal })).catch(() => {
      });
    } catch {
    }
  }
}
